
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eiJsc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $02927f635aa89319$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $5AbTJ = parcelRequire("5AbTJ");

var $dLzIQ = parcelRequire("dLzIQ");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $02927f635aa89319$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $khO3w.fg)('platform_dst_lozenge_fg') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5AbTJ.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dLzIQ.default), {
        ...props
    }));
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$02927f635aa89319$var$Lozenge.displayName = 'Lozenge';
var $02927f635aa89319$export$2e2bcd8739ae039 = $02927f635aa89319$var$Lozenge;

});
parcelRegister("5AbTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d5f21aebb76d05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $lL6cf = parcelRequire("lL6cf");
const $a7d5f21aebb76d05$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    'text.bold.default': "_syaz15cr",
    'text.bold.inprogress': "_syaz15cr",
    'text.bold.moved': "_syazal3n",
    'text.bold.new': "_syaz15cr",
    'text.bold.removed': "_syaz15cr",
    'text.bold.success': "_syaz15cr",
    'text.subtle.default': "_syazjjyb",
    'text.subtle.inprogress': "_syaz1lpn",
    'text.subtle.moved': "_syaz1tm6",
    'text.subtle.new': "_syaz1mvf",
    'text.subtle.removed': "_syaz1ick",
    'text.subtle.success': "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
const $a7d5f21aebb76d05$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
const $a7d5f21aebb76d05$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $a7d5f21aebb76d05$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhk1w7a",
    'bg.subtle.inprogress': "_bfhk1w7a",
    'bg.subtle.moved': "_bfhk1w7a",
    'bg.subtle.new': "_bfhk1w7a",
    'bg.subtle.removed': "_bfhk1w7a",
    'bg.subtle.success': "_bfhk1w7a",
    'border.subtle.default': "_19it14mp",
    'border.subtle.inprogress': "_19it1cy7",
    'border.subtle.moved': "_19itzi1n",
    'border.subtle.new': "_19it1apr",
    'border.subtle.removed': "_19itoa5t",
    'border.subtle.success': "_19it1am1",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syaz1fxt",
    'text.bold': "_syazwwip"
};
const $a7d5f21aebb76d05$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $a7d5f21aebb76d05$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $5uXOq.useMemo)(()=>$a7d5f21aebb76d05$var$appearanceTypes.includes(appearance) ? appearance : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $khO3w.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $a7d5f21aebb76d05$var$stylesNew.container,
            $a7d5f21aebb76d05$var$stylesNew[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && !(0, $khO3w.fg)('visual-refresh_drop_5') && $a7d5f21aebb76d05$var$stylesNew[`border.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $khO3w.fg)('visual-refresh_drop_5') && $a7d5f21aebb76d05$var$stylesNew[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && (0, $khO3w.fg)('visual-refresh_drop_5') && $a7d5f21aebb76d05$var$stylesNew.containerSubtle
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $a7d5f21aebb76d05$var$stylesNew.text,
                (0, $khO3w.fg)('platform-lozenge-custom-letterspacing') && $a7d5f21aebb76d05$var$stylesNew.customLetterspacing,
                $a7d5f21aebb76d05$var$stylesNew[`text.${appearanceStyle}`]
            ]),
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
        as: "span",
        backgroundColor: $a7d5f21aebb76d05$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $a7d5f21aebb76d05$var$stylesOld.container,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            style: {
                color: style?.color,
                // to negate paddingInline specified on Box above
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`,
            className: (0, $bwpsq.default)([
                $a7d5f21aebb76d05$var$stylesOldUnbounded.text,
                (0, $khO3w.fg)('platform-lozenge-custom-letterspacing') && $a7d5f21aebb76d05$var$stylesOldUnbounded.customLetterspacing,
                $a7d5f21aebb76d05$var$stylesOld[`text.${appearanceStyle}.${appearanceType}`]
            ]),
            children: children
        })
    });
});
$a7d5f21aebb76d05$var$Lozenge.displayName = 'Lozenge';
var $a7d5f21aebb76d05$export$2e2bcd8739ae039 = $a7d5f21aebb76d05$var$Lozenge;

});

parcelRegister("dLzIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fce05b2c49a9242$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $khO3w = parcelRequire("khO3w");

var $hCfTW = parcelRequire("hCfTW");
var $2qiW1 = parcelRequire("2qiW1");
function $4fce05b2c49a9242$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4fce05b2c49a9242$var$baseStylesOld = (0, $2qiW1.xcss)({
    display: 'inline-flex',
    borderRadius: 'border.radius',
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden'
});
const $4fce05b2c49a9242$var$styles = {
    container: {
        name: "1s8rs5f",
        styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
    },
    containerSubtle: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: {
                name: "1007ca",
                styles: "background-color:#DDDEE1"
            },
            inprogress: {
                name: "5nwhd8",
                styles: "background-color:#8FB8F6"
            },
            moved: {
                name: "1v45608",
                styles: "background-color:#F9C84E"
            },
            new: {
                name: "1ra4w2w",
                styles: "background-color:#D8A0F7"
            },
            removed: {
                name: "1y25gsq",
                styles: "background-color:#FD9891"
            },
            success: {
                name: "2bpbki",
                styles: "background-color:#B3DF72"
            }
        },
        subtle: {
            default: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            inprogress: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            moved: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            new: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            removed: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            },
            success: {
                name: "1v09iay",
                styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    },
    border: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                border: `1px solid #94C748`
            })
        }
    },
    outline: {
        subtle: {
            default: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #B7B9BE`
            }),
            inprogress: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #669DF1`
            }),
            moved: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #FCA700`
            }),
            new: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #C97CF4`
            }),
            removed: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #F87168`
            }),
            success: /*#__PURE__*/ (0, $f8Sb3.css)({
                outline: `1px solid #94C748`
            })
        }
    },
    text: {
        subtle: {
            name: "nws7uq",
            styles: "color:var(--ds-text, #172B4D)"
        },
        bold: {
            name: "14qj9ca",
            styles: "color:#292A2E"
        }
    }
};
const $4fce05b2c49a9242$var$textStyles = {
    name: "zdgrwm",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
};
const $4fce05b2c49a9242$var$customLetterspacingStyles = {
    name: "gkoibw",
    styles: "letter-spacing:0.165px"
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $4fce05b2c49a9242$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = appearance in $4fce05b2c49a9242$var$styles.background[appearanceStyle] ? appearance : 'default';
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    if ((0, $khO3w.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        css: [
            $4fce05b2c49a9242$var$styles.container,
            $4fce05b2c49a9242$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === 'subtle' && !(0, $khO3w.fg)('visual-refresh_drop_5') && $4fce05b2c49a9242$var$styles.border.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $khO3w.fg)('visual-refresh_drop_5') && $4fce05b2c49a9242$var$styles.outline.subtle[appearanceType],
            appearanceStyle === 'subtle' && (0, $khO3w.fg)('visual-refresh_drop_5') && $4fce05b2c49a9242$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $4fce05b2c49a9242$var$textStyles,
            (0, $khO3w.fg)('platform-lozenge-custom-letterspacing') && $4fce05b2c49a9242$var$customLetterspacingStyles,
            $4fce05b2c49a9242$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
    const appearanceTypeOld = appearance in $4fce05b2c49a9242$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hCfTW.default), {
        as: "span",
        backgroundColor: $4fce05b2c49a9242$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style?.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        paddingInline: "space.050",
        xcss: $4fce05b2c49a9242$var$baseStylesOld,
        testId: testId
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            $4fce05b2c49a9242$var$textStyles,
            (0, $khO3w.fg)('platform-lozenge-custom-letterspacing') && $4fce05b2c49a9242$var$customLetterspacingStyles,
            $4fce05b2c49a9242$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style?.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`
    }, children));
});
$4fce05b2c49a9242$var$Lozenge.displayName = 'Lozenge';
var $4fce05b2c49a9242$export$2e2bcd8739ae039 = $4fce05b2c49a9242$var$Lozenge;
const $4fce05b2c49a9242$var$backgroundColorsOld = {
    bold: {
        default: 'color.background.neutral.bold',
        inprogress: 'color.background.information.bold',
        moved: 'color.background.warning.bold',
        new: 'color.background.discovery.bold',
        removed: 'color.background.danger.bold',
        success: 'color.background.success.bold'
    },
    subtle: {
        default: 'color.background.neutral',
        inprogress: 'color.background.information',
        moved: 'color.background.warning',
        new: 'color.background.discovery',
        removed: 'color.background.danger',
        success: 'color.background.success'
    }
};
const $4fce05b2c49a9242$var$textColorsOld = {
    bold: {
        default: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        inprogress: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        moved: {
            name: "tgubtb",
            styles: "color:var(--ds-text-warning-inverse, #172B4D)"
        },
        new: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        removed: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        },
        success: {
            name: "1wvsb8v",
            styles: "color:var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        default: {
            name: "kmxsjg",
            styles: "color:var(--ds-text-subtle, #42526E)"
        },
        inprogress: {
            name: "3j31nl",
            styles: "color:var(--ds-text-information, #0052CC)"
        },
        moved: {
            name: "1g2i1rp",
            styles: "color:var(--ds-text-warning, #974F0C)"
        },
        new: {
            name: "3juofh",
            styles: "color:var(--ds-text-discovery, #403294)"
        },
        removed: {
            name: "18zo14t",
            styles: "color:var(--ds-text-danger, #DE350B)"
        },
        success: {
            name: "1ychrch",
            styles: "color:var(--ds-text-success, #006644)"
        }
    }
};

});
parcelRegister("hCfTW", function(module, exports) {

$parcel$export(module.exports, "Box", () => $d3bdc85665d8d0dc$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $d3bdc85665d8d0dc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $8q8Pm = parcelRequire("8q8Pm");

var $4QIJ8 = parcelRequire("4QIJ8");

var $2qiW1 = parcelRequire("2qiW1");
function $d3bdc85665d8d0dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d3bdc85665d8d0dc$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2qiW1.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $d3bdc85665d8d0dc$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4QIJ8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4QIJ8.isSurfaceColorToken)(backgroundColor) && (0, $4QIJ8.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4QIJ8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4QIJ8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4QIJ8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4QIJ8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4QIJ8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4QIJ8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4QIJ8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8q8Pm.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d3bdc85665d8d0dc$export$2e2bcd8739ae039 = $d3bdc85665d8d0dc$export$e71c4d32a2263218;
const $d3bdc85665d8d0dc$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("2qiW1", function(module, exports) {

$parcel$export(module.exports, "tokensMap", () => $118506b95f180d94$export$9a199fbafee0014e);
$parcel$export(module.exports, "parseXcss", () => $118506b95f180d94$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $118506b95f180d94$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4QIJ8 = parcelRequire("4QIJ8");

var $6cAn5 = parcelRequire("6cAn5");
const $118506b95f180d94$export$9a199fbafee0014e = {
    backgroundColor: (0, $4QIJ8.backgroundColorMap),
    blockSize: (0, $4QIJ8.dimensionMap),
    borderBlockColor: (0, $4QIJ8.borderColorMap),
    borderBlockEndColor: (0, $4QIJ8.borderColorMap),
    borderBlockEndWidth: (0, $4QIJ8.borderWidthMap),
    borderBlockStartColor: (0, $4QIJ8.borderColorMap),
    borderBlockStartWidth: (0, $4QIJ8.borderWidthMap),
    borderBlockWidth: (0, $4QIJ8.borderWidthMap),
    borderBottomColor: (0, $4QIJ8.borderColorMap),
    borderBottomLeftRadius: (0, $4QIJ8.borderRadiusMap),
    borderBottomRightRadius: (0, $4QIJ8.borderRadiusMap),
    borderBottomWidth: (0, $4QIJ8.borderWidthMap),
    borderColor: (0, $4QIJ8.borderColorMap),
    borderEndEndRadius: (0, $4QIJ8.borderRadiusMap),
    borderEndStartRadius: (0, $4QIJ8.borderRadiusMap),
    borderInlineColor: (0, $4QIJ8.borderColorMap),
    borderInlineEndColor: (0, $4QIJ8.borderColorMap),
    borderInlineEndWidth: (0, $4QIJ8.borderWidthMap),
    borderInlineStartColor: (0, $4QIJ8.borderColorMap),
    borderInlineStartWidth: (0, $4QIJ8.borderWidthMap),
    borderInlineWidth: (0, $4QIJ8.borderWidthMap),
    borderLeftColor: (0, $4QIJ8.borderColorMap),
    borderLeftWidth: (0, $4QIJ8.borderWidthMap),
    borderRadius: (0, $4QIJ8.borderRadiusMap),
    borderRightColor: (0, $4QIJ8.borderColorMap),
    borderRightWidth: (0, $4QIJ8.borderWidthMap),
    borderStartEndRadius: (0, $4QIJ8.borderRadiusMap),
    borderStartStartRadius: (0, $4QIJ8.borderRadiusMap),
    borderTopColor: (0, $4QIJ8.borderColorMap),
    borderTopLeftRadius: (0, $4QIJ8.borderRadiusMap),
    borderTopRightRadius: (0, $4QIJ8.borderRadiusMap),
    borderTopWidth: (0, $4QIJ8.borderWidthMap),
    borderWidth: (0, $4QIJ8.borderWidthMap),
    bottom: (0, $4QIJ8.allSpaceMap),
    boxShadow: (0, $4QIJ8.shadowMap),
    color: (0, $4QIJ8.textColorMap),
    columnGap: (0, $4QIJ8.positiveSpaceMap),
    font: (0, $4QIJ8.fontMap),
    fontFamily: (0, $4QIJ8.fontFamilyMap),
    fontWeight: (0, $4QIJ8.fontWeightMap),
    gap: (0, $4QIJ8.positiveSpaceMap),
    height: (0, $4QIJ8.dimensionMap),
    inlineSize: (0, $4QIJ8.dimensionMap),
    inset: (0, $4QIJ8.allSpaceMap),
    insetBlock: (0, $4QIJ8.allSpaceMap),
    insetBlockEnd: (0, $4QIJ8.allSpaceMap),
    insetBlockStart: (0, $4QIJ8.allSpaceMap),
    insetInline: (0, $4QIJ8.allSpaceMap),
    insetInlineEnd: (0, $4QIJ8.allSpaceMap),
    insetInlineStart: (0, $4QIJ8.allSpaceMap),
    left: (0, $4QIJ8.allSpaceMap),
    margin: (0, $4QIJ8.allSpaceMap),
    marginBlock: (0, $4QIJ8.allSpaceMap),
    marginBlockEnd: (0, $4QIJ8.allSpaceMap),
    marginBlockStart: (0, $4QIJ8.allSpaceMap),
    marginBottom: (0, $4QIJ8.allSpaceMap),
    marginInline: (0, $4QIJ8.allSpaceMap),
    marginInlineEnd: (0, $4QIJ8.allSpaceMap),
    marginInlineStart: (0, $4QIJ8.allSpaceMap),
    marginLeft: (0, $4QIJ8.allSpaceMap),
    marginRight: (0, $4QIJ8.allSpaceMap),
    marginTop: (0, $4QIJ8.allSpaceMap),
    maxBlockSize: (0, $4QIJ8.dimensionMap),
    maxHeight: (0, $4QIJ8.dimensionMap),
    maxInlineSize: (0, $4QIJ8.dimensionMap),
    maxWidth: (0, $4QIJ8.dimensionMap),
    minBlockSize: (0, $4QIJ8.dimensionMap),
    minHeight: (0, $4QIJ8.dimensionMap),
    minInlineSize: (0, $4QIJ8.dimensionMap),
    minWidth: (0, $4QIJ8.dimensionMap),
    opacity: (0, $4QIJ8.opacityMap),
    outlineColor: (0, $4QIJ8.borderColorMap),
    outlineOffset: (0, $4QIJ8.allSpaceMap),
    outlineWidth: (0, $4QIJ8.borderWidthMap),
    padding: (0, $4QIJ8.positiveSpaceMap),
    paddingBlock: (0, $4QIJ8.positiveSpaceMap),
    paddingBlockEnd: (0, $4QIJ8.positiveSpaceMap),
    paddingBlockStart: (0, $4QIJ8.positiveSpaceMap),
    paddingBottom: (0, $4QIJ8.positiveSpaceMap),
    paddingInline: (0, $4QIJ8.positiveSpaceMap),
    paddingInlineEnd: (0, $4QIJ8.positiveSpaceMap),
    paddingInlineStart: (0, $4QIJ8.positiveSpaceMap),
    paddingLeft: (0, $4QIJ8.positiveSpaceMap),
    paddingRight: (0, $4QIJ8.positiveSpaceMap),
    paddingTop: (0, $4QIJ8.positiveSpaceMap),
    right: (0, $4QIJ8.allSpaceMap),
    rowGap: (0, $4QIJ8.positiveSpaceMap),
    top: (0, $4QIJ8.allSpaceMap),
    width: (0, $4QIJ8.dimensionMap),
    zIndex: (0, $4QIJ8.layerMap)
};
const $118506b95f180d94$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $118506b95f180d94$var$isSafeEnvToThrow = ()=>typeof $6cAn5 === 'object' && typeof $6cAn5.env === 'object' && false;
const $118506b95f180d94$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $118506b95f180d94$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $118506b95f180d94$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($118506b95f180d94$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $118506b95f180d94$var$safeSelectors.test(key)) {
            styleObj[key] = $118506b95f180d94$var$transformStyles(value);
            return;
        }
        if ($118506b95f180d94$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($118506b95f180d94$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $118506b95f180d94$export$9a199fbafee0014e)) return;
        const tokenValue = $118506b95f180d94$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $118506b95f180d94$var$baseXcss = (style)=>{
    const transformedStyles = $118506b95f180d94$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$118506b95f180d94$var$uniqueSymbol]: /*#__PURE__*/ (0, $f8Sb3.css)(transformedStyles)
    };
}; /**
    * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
    * to supported both Emotion and Compiled styles until we've fully migrated
    * to Compiled.
    *
    * @private
    * @deprecated
    */ 
const $118506b95f180d94$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $118506b95f180d94$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$118506b95f180d94$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $118506b95f180d94$export$f6c783d06584602c(style) {
    return $118506b95f180d94$var$baseXcss(style);
}

});




parcelRegister("aTuet", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $020bf9c62207cb0f$var$_react = $020bf9c62207cb0f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $020bf9c62207cb0f$var$_peopleGroup = $020bf9c62207cb0f$var$_interopRequireDefault((parcelRequire("9rubZ")));

var $020bf9c62207cb0f$var$_peopleGroup2 = $020bf9c62207cb0f$var$_interopRequireDefault((parcelRequire("6AkSF")));
function $020bf9c62207cb0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $020bf9c62207cb0f$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $020bf9c62207cb0f$var$_react.default.createElement($020bf9c62207cb0f$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $020bf9c62207cb0f$var$_peopleGroup2.default
    }, props));
$020bf9c62207cb0f$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $020bf9c62207cb0f$var$_default = module.exports.default = $020bf9c62207cb0f$var$PeopleGroupIcon;

});
parcelRegister("9rubZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6dfe0e3d9a621cb0$var$_react = $6dfe0e3d9a621cb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6dfe0e3d9a621cb0$var$_baseNew = $6dfe0e3d9a621cb0$var$_interopRequireDefault((parcelRequire("dznjK")));
function $6dfe0e3d9a621cb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6dfe0e3d9a621cb0$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $6dfe0e3d9a621cb0$var$_react.default.createElement($6dfe0e3d9a621cb0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$6dfe0e3d9a621cb0$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $6dfe0e3d9a621cb0$var$_default = module.exports.default = $6dfe0e3d9a621cb0$var$PeopleGroupIcon;

});

parcelRegister("6AkSF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cb64d5705c02f86$var$_react = $4cb64d5705c02f86$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $4cb64d5705c02f86$var$_peopleGroup = $4cb64d5705c02f86$var$_interopRequireDefault((parcelRequire("9rubZ")));
function $4cb64d5705c02f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4cb64d5705c02f86$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $4cb64d5705c02f86$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $4cb64d5705c02f86$var$_peopleGroup.default
    }));
$4cb64d5705c02f86$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $4cb64d5705c02f86$var$_default = module.exports.default = $4cb64d5705c02f86$var$PeopleGroupIcon;

});


parcelRegister("erSIM", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", () => $c0ea197a36cd3cde$export$c4b5b1f965d8b3eb);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $c0ea197a36cd3cde$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $c0ea197a36cd3cde$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        svg: $c0ea197a36cd3cde$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("7iEOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e72cdc18d2ac42$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7ofFE = parcelRequire("7ofFE");

var $9YCGA = parcelRequire("9YCGA");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $54e72cdc18d2ac42$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $5uXOq.useState)((0, $7ofFE.default)());
    (0, $5uXOq.useEffect)(()=>{
        const observer = new (0, $9YCGA.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $54e72cdc18d2ac42$export$2e2bcd8739ae039 = $54e72cdc18d2ac42$var$useThemeObserver;

});
parcelRegister("7ofFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca041bcb30998e39$export$2e2bcd8739ae039);

var $c4e8W = parcelRequire("c4e8W");

var $jsxjA = parcelRequire("jsxjA");

var $jOwDM = parcelRequire("jOwDM");
const $ca041bcb30998e39$var$isThemeColorMode = (colorMode)=>{
    return (0, $jsxjA.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $ca041bcb30998e39$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $c4e8W.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $c4e8W.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $jOwDM.themeStringToObject)(theme),
        ...$ca041bcb30998e39$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $ca041bcb30998e39$export$2e2bcd8739ae039 = $ca041bcb30998e39$var$getGlobalTheme;

});
parcelRegister("jsxjA", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $d45346175c4a3107$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $d45346175c4a3107$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeIdsWithOverrides", () => $d45346175c4a3107$export$92ba366331403db2);
$parcel$export(module.exports, "themeStateDefaults", () => $d45346175c4a3107$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $d45346175c4a3107$export$2e2bcd8739ae039);

var $khO3w = parcelRequire("khO3w");
const $d45346175c4a3107$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ const $d45346175c4a3107$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
const $d45346175c4a3107$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $d45346175c4a3107$var$themeOverrideIds = [];
const $d45346175c4a3107$export$92ba366331403db2 = [
    ...$d45346175c4a3107$export$7d43e72a58e3283f,
    ...$d45346175c4a3107$var$themeOverrideIds
];
const $d45346175c4a3107$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $d45346175c4a3107$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: ()=>{
        if ((0, $khO3w.fg)('platform-default-typography-modernized')) return 'typography-modernized';
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var $d45346175c4a3107$export$2e2bcd8739ae039 = $d45346175c4a3107$var$themeConfig;

});

parcelRegister("jOwDM", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $815c865472a0f7d4$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $815c865472a0f7d4$export$62c37ab81302621a);

var $jsxjA = parcelRequire("jsxjA");
const $815c865472a0f7d4$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $815c865472a0f7d4$var$customThemeOptions = 'UNSAFE_themeOptions';
const $815c865472a0f7d4$var$isThemeKind = (themeKind)=>{
    return $815c865472a0f7d4$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $815c865472a0f7d4$var$isThemeIds = (themeId)=>{
    return (0, $jsxjA.themeIds).find((id)=>id === themeId) !== undefined;
};
const $815c865472a0f7d4$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $815c865472a0f7d4$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $815c865472a0f7d4$var$isColorMode(id)) themeObject[kind] = id;
        if ($815c865472a0f7d4$var$isThemeKind(kind) && $815c865472a0f7d4$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $815c865472a0f7d4$var$customThemeOptions) try {
            themeObject[$815c865472a0f7d4$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $815c865472a0f7d4$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $815c865472a0f7d4$var$isColorMode(id) || // custom theme state
        kind === $815c865472a0f7d4$var$customThemeOptions && typeof id === 'object' || // other theme states
        $815c865472a0f7d4$var$isThemeKind(kind) && typeof id === 'string' && $815c865472a0f7d4$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("9YCGA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d1ed769bfa70790$export$2e2bcd8739ae039);

var $c4e8W = parcelRequire("c4e8W");

var $7ofFE = parcelRequire("7ofFE");
class $9d1ed769bfa70790$export$2e2bcd8739ae039 {
    static{
        this.observer = null;
    }
    static{
        this.callbacks = new Set();
    }
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $9d1ed769bfa70790$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$9d1ed769bfa70790$export$2e2bcd8739ae039.observer) {
            $9d1ed769bfa70790$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $7ofFE.default)();
                $9d1ed769bfa70790$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $9d1ed769bfa70790$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $c4e8W.THEME_DATA_ATTRIBUTE),
                    (0, $c4e8W.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $9d1ed769bfa70790$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($9d1ed769bfa70790$export$2e2bcd8739ae039.callbacks.size === 0 && $9d1ed769bfa70790$export$2e2bcd8739ae039.observer) {
            $9d1ed769bfa70790$export$2e2bcd8739ae039.observer.disconnect();
            $9d1ed769bfa70790$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("2sApg", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", () => $da2b95a3b081989a$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $da2b95a3b081989a$export$793fba32aed8942a);
const $da2b95a3b081989a$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $da2b95a3b081989a$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};
const $da2b95a3b081989a$export$31d7044b7540a6d8 = $da2b95a3b081989a$export$438460117ae6b7ee;

});

parcelRegister("jAjMG", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $36c6ce14bc1ad1fc$export$362a25f017e2bc8a);
$parcel$export(module.exports, "getColorsFromAppearance", () => $36c6ce14bc1ad1fc$export$bbacc3980e0f3029);
$parcel$export(module.exports, "getColorsForLoom", () => $36c6ce14bc1ad1fc$export$7818df200941dbbf);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $36c6ce14bc1ad1fc$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $3568e170f1ea17d7$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $3568e170f1ea17d7$export$215b7063051591f1);
            iconColor = (0, $3568e170f1ea17d7$export$215b7063051591f1);
            textColor = `var(--ds-text, ${0, $3568e170f1ea17d7$export$7d61b15e0da132af})`;
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $3568e170f1ea17d7$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $3568e170f1ea17d7$export$7090862dc3038a9f);
            iconGradientStop = (0, $3568e170f1ea17d7$export$d6447c357493214f);
            iconColor = (0, $3568e170f1ea17d7$export$d6447c357493214f);
            textColor = (0, $3568e170f1ea17d7$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $3568e170f1ea17d7$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $36c6ce14bc1ad1fc$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $3568e170f1ea17d7$export$29a4f05edc054374);
            textColor = (0, $3568e170f1ea17d7$export$29a4f05edc054374);
            atlassianLogoTextColor = (0, $3568e170f1ea17d7$export$29a4f05edc054374);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
const $36c6ce14bc1ad1fc$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = $36c6ce14bc1ad1fc$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    let textColor = $36c6ce14bc1ad1fc$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
var $3568e170f1ea17d7$exports = {};

$parcel$export($3568e170f1ea17d7$exports, "R50", () => $3568e170f1ea17d7$export$4b84fd0e2c617bd);
$parcel$export($3568e170f1ea17d7$exports, "R75", () => $3568e170f1ea17d7$export$b34b069eff244586);
$parcel$export($3568e170f1ea17d7$exports, "R100", () => $3568e170f1ea17d7$export$be802dd0d8b57f35);
$parcel$export($3568e170f1ea17d7$exports, "R200", () => $3568e170f1ea17d7$export$60847d42f9da92a6);
$parcel$export($3568e170f1ea17d7$exports, "R300", () => $3568e170f1ea17d7$export$4a7404f376229999);
$parcel$export($3568e170f1ea17d7$exports, "R400", () => $3568e170f1ea17d7$export$2010d0fb4295b346);
$parcel$export($3568e170f1ea17d7$exports, "R500", () => $3568e170f1ea17d7$export$2837b5a1a71d5c02);
$parcel$export($3568e170f1ea17d7$exports, "Y50", () => $3568e170f1ea17d7$export$8d9596b529bbb9cf);
$parcel$export($3568e170f1ea17d7$exports, "Y75", () => $3568e170f1ea17d7$export$41060a744ab0b7ae);
$parcel$export($3568e170f1ea17d7$exports, "Y100", () => $3568e170f1ea17d7$export$1cc05bbbf340e559);
$parcel$export($3568e170f1ea17d7$exports, "Y200", () => $3568e170f1ea17d7$export$5aae31392d72caaa);
$parcel$export($3568e170f1ea17d7$exports, "Y300", () => $3568e170f1ea17d7$export$c6930421db9fa514);
$parcel$export($3568e170f1ea17d7$exports, "Y400", () => $3568e170f1ea17d7$export$59619663aa6500fb);
$parcel$export($3568e170f1ea17d7$exports, "Y500", () => $3568e170f1ea17d7$export$874739ea9e379ab6);
$parcel$export($3568e170f1ea17d7$exports, "G50", () => $3568e170f1ea17d7$export$8a6341c32b6a3ee6);
$parcel$export($3568e170f1ea17d7$exports, "G75", () => $3568e170f1ea17d7$export$69a3bf21b9686c2b);
$parcel$export($3568e170f1ea17d7$exports, "G100", () => $3568e170f1ea17d7$export$afbce1382ec95f73);
$parcel$export($3568e170f1ea17d7$exports, "G200", () => $3568e170f1ea17d7$export$747d86715d4175de);
$parcel$export($3568e170f1ea17d7$exports, "G300", () => $3568e170f1ea17d7$export$940e1f69e873f202);
$parcel$export($3568e170f1ea17d7$exports, "G400", () => $3568e170f1ea17d7$export$a49394138f7b8e85);
$parcel$export($3568e170f1ea17d7$exports, "G500", () => $3568e170f1ea17d7$export$6fa04827ac68a4fb);
$parcel$export($3568e170f1ea17d7$exports, "B50", () => $3568e170f1ea17d7$export$226de0355ed012f8);
$parcel$export($3568e170f1ea17d7$exports, "B75", () => $3568e170f1ea17d7$export$8c13c2ee36917869);
$parcel$export($3568e170f1ea17d7$exports, "B100", () => $3568e170f1ea17d7$export$ecfc1dff386a3e7a);
$parcel$export($3568e170f1ea17d7$exports, "B200", () => $3568e170f1ea17d7$export$215b7063051591f1);
$parcel$export($3568e170f1ea17d7$exports, "B300", () => $3568e170f1ea17d7$export$e62e8919cca44969);
$parcel$export($3568e170f1ea17d7$exports, "B400", () => $3568e170f1ea17d7$export$b3de0ae08da2ce64);
$parcel$export($3568e170f1ea17d7$exports, "B500", () => $3568e170f1ea17d7$export$a6ee3d71bc067634);
$parcel$export($3568e170f1ea17d7$exports, "B600", () => $3568e170f1ea17d7$export$67f15409e87642a1);
$parcel$export($3568e170f1ea17d7$exports, "B700", () => $3568e170f1ea17d7$export$f0539dbc42dbb067);
$parcel$export($3568e170f1ea17d7$exports, "P50", () => $3568e170f1ea17d7$export$363e4475840015bb);
$parcel$export($3568e170f1ea17d7$exports, "P75", () => $3568e170f1ea17d7$export$4b0a4417ed59760f);
$parcel$export($3568e170f1ea17d7$exports, "P100", () => $3568e170f1ea17d7$export$6011520a64d9a187);
$parcel$export($3568e170f1ea17d7$exports, "P200", () => $3568e170f1ea17d7$export$a7175d4e9206bc80);
$parcel$export($3568e170f1ea17d7$exports, "P300", () => $3568e170f1ea17d7$export$b48405b95304b5a1);
$parcel$export($3568e170f1ea17d7$exports, "P400", () => $3568e170f1ea17d7$export$c71e4279dd54a18d);
$parcel$export($3568e170f1ea17d7$exports, "P500", () => $3568e170f1ea17d7$export$147899de772240ec);
$parcel$export($3568e170f1ea17d7$exports, "T50", () => $3568e170f1ea17d7$export$2cf711fe14c66f06);
$parcel$export($3568e170f1ea17d7$exports, "T75", () => $3568e170f1ea17d7$export$7a8f4d33f6f9772c);
$parcel$export($3568e170f1ea17d7$exports, "T100", () => $3568e170f1ea17d7$export$776c9c497ef08533);
$parcel$export($3568e170f1ea17d7$exports, "T200", () => $3568e170f1ea17d7$export$69cb3ca10c1e330e);
$parcel$export($3568e170f1ea17d7$exports, "T300", () => $3568e170f1ea17d7$export$9dc1ef0f3f48059b);
$parcel$export($3568e170f1ea17d7$exports, "T400", () => $3568e170f1ea17d7$export$7c835c78b6fcdef8);
$parcel$export($3568e170f1ea17d7$exports, "T500", () => $3568e170f1ea17d7$export$6036577f95c3877e);
$parcel$export($3568e170f1ea17d7$exports, "N0", () => $3568e170f1ea17d7$export$29a4f05edc054374);
$parcel$export($3568e170f1ea17d7$exports, "N10", () => $3568e170f1ea17d7$export$e655ef011c4aa1a2);
$parcel$export($3568e170f1ea17d7$exports, "N20", () => $3568e170f1ea17d7$export$9fdfb749e33cdf97);
$parcel$export($3568e170f1ea17d7$exports, "N30", () => $3568e170f1ea17d7$export$3e51e8f1440314ba);
$parcel$export($3568e170f1ea17d7$exports, "N40", () => $3568e170f1ea17d7$export$1ce2d1575d444ceb);
$parcel$export($3568e170f1ea17d7$exports, "N50", () => $3568e170f1ea17d7$export$8754fc7e6d8b3000);
$parcel$export($3568e170f1ea17d7$exports, "N60", () => $3568e170f1ea17d7$export$c2e91cbeada39b8b);
$parcel$export($3568e170f1ea17d7$exports, "N70", () => $3568e170f1ea17d7$export$5f71e19f3a7ad9de);
$parcel$export($3568e170f1ea17d7$exports, "N80", () => $3568e170f1ea17d7$export$eaa8c8a70ac22806);
$parcel$export($3568e170f1ea17d7$exports, "N90", () => $3568e170f1ea17d7$export$7c87d337fb91a97d);
$parcel$export($3568e170f1ea17d7$exports, "N100", () => $3568e170f1ea17d7$export$d6447c357493214f);
$parcel$export($3568e170f1ea17d7$exports, "N200", () => $3568e170f1ea17d7$export$f563ee71e9ee74cd);
$parcel$export($3568e170f1ea17d7$exports, "N300", () => $3568e170f1ea17d7$export$e2ef2124cf4024b1);
$parcel$export($3568e170f1ea17d7$exports, "N400", () => $3568e170f1ea17d7$export$eece5f492e429f08);
$parcel$export($3568e170f1ea17d7$exports, "N500", () => $3568e170f1ea17d7$export$c39c0fe0f26207ae);
$parcel$export($3568e170f1ea17d7$exports, "N600", () => $3568e170f1ea17d7$export$7090862dc3038a9f);
$parcel$export($3568e170f1ea17d7$exports, "N700", () => $3568e170f1ea17d7$export$ad0bacf983b7ddaa);
$parcel$export($3568e170f1ea17d7$exports, "N800", () => $3568e170f1ea17d7$export$7d61b15e0da132af);
$parcel$export($3568e170f1ea17d7$exports, "N900", () => $3568e170f1ea17d7$export$fbda843f0a27fe96);
$parcel$export($3568e170f1ea17d7$exports, "N10A", () => $3568e170f1ea17d7$export$791e57b27ca738ef);
$parcel$export($3568e170f1ea17d7$exports, "N20A", () => $3568e170f1ea17d7$export$8d43898f60b96a82);
$parcel$export($3568e170f1ea17d7$exports, "N30A", () => $3568e170f1ea17d7$export$920c0d5c49070351);
$parcel$export($3568e170f1ea17d7$exports, "N40A", () => $3568e170f1ea17d7$export$46987b49aab6d1a8);
$parcel$export($3568e170f1ea17d7$exports, "N50A", () => $3568e170f1ea17d7$export$7d3359664e8bb0e5);
$parcel$export($3568e170f1ea17d7$exports, "N60A", () => $3568e170f1ea17d7$export$d2d3bedfb276cac0);
$parcel$export($3568e170f1ea17d7$exports, "N70A", () => $3568e170f1ea17d7$export$6e5e7499ff054f6d);
$parcel$export($3568e170f1ea17d7$exports, "N80A", () => $3568e170f1ea17d7$export$59264b346c877fa7);
$parcel$export($3568e170f1ea17d7$exports, "N90A", () => $3568e170f1ea17d7$export$d092757d7c64925c);
$parcel$export($3568e170f1ea17d7$exports, "N100A", () => $3568e170f1ea17d7$export$486ab785e4bac3c6);
$parcel$export($3568e170f1ea17d7$exports, "N200A", () => $3568e170f1ea17d7$export$fba592bbc6419fea);
$parcel$export($3568e170f1ea17d7$exports, "N300A", () => $3568e170f1ea17d7$export$13609db0e6812ab8);
$parcel$export($3568e170f1ea17d7$exports, "N400A", () => $3568e170f1ea17d7$export$fbae4efaa892d883);
$parcel$export($3568e170f1ea17d7$exports, "N500A", () => $3568e170f1ea17d7$export$f13946d26f440ce6);
$parcel$export($3568e170f1ea17d7$exports, "N600A", () => $3568e170f1ea17d7$export$19f58225ac52a306);
$parcel$export($3568e170f1ea17d7$exports, "N700A", () => $3568e170f1ea17d7$export$6384f09da70e7b62);
$parcel$export($3568e170f1ea17d7$exports, "N800A", () => $3568e170f1ea17d7$export$d0dccc730683edc2);
$parcel$export($3568e170f1ea17d7$exports, "DN900", () => $3568e170f1ea17d7$export$2f6319cf7d736c2a);
$parcel$export($3568e170f1ea17d7$exports, "DN800", () => $3568e170f1ea17d7$export$95126bc8884d6634);
$parcel$export($3568e170f1ea17d7$exports, "DN700", () => $3568e170f1ea17d7$export$8338d8c35d44ff1);
$parcel$export($3568e170f1ea17d7$exports, "DN600", () => $3568e170f1ea17d7$export$5368d76ae4fbbda7);
$parcel$export($3568e170f1ea17d7$exports, "DN500", () => $3568e170f1ea17d7$export$9f0a771d16ec8d36);
$parcel$export($3568e170f1ea17d7$exports, "DN400", () => $3568e170f1ea17d7$export$abcf8c38338b4aa5);
$parcel$export($3568e170f1ea17d7$exports, "DN300", () => $3568e170f1ea17d7$export$97e81faa16a182c7);
$parcel$export($3568e170f1ea17d7$exports, "DN200", () => $3568e170f1ea17d7$export$bfe21c59123ecf33);
$parcel$export($3568e170f1ea17d7$exports, "DN100", () => $3568e170f1ea17d7$export$ee82aa2ea6a1558);
$parcel$export($3568e170f1ea17d7$exports, "DN90", () => $3568e170f1ea17d7$export$682927c6ed76be02);
$parcel$export($3568e170f1ea17d7$exports, "DN80", () => $3568e170f1ea17d7$export$91fd9994c5be9757);
$parcel$export($3568e170f1ea17d7$exports, "DN70", () => $3568e170f1ea17d7$export$d281fbfe3cff2df6);
$parcel$export($3568e170f1ea17d7$exports, "DN60", () => $3568e170f1ea17d7$export$3902c91d8b98a753);
$parcel$export($3568e170f1ea17d7$exports, "DN50", () => $3568e170f1ea17d7$export$8e8133c1ba5845b5);
$parcel$export($3568e170f1ea17d7$exports, "DN40", () => $3568e170f1ea17d7$export$33ff357f6620b39);
$parcel$export($3568e170f1ea17d7$exports, "DN30", () => $3568e170f1ea17d7$export$633847cf062b69e0);
$parcel$export($3568e170f1ea17d7$exports, "DN20", () => $3568e170f1ea17d7$export$9776a6e503bdbf76);
$parcel$export($3568e170f1ea17d7$exports, "DN10", () => $3568e170f1ea17d7$export$6c813d5160dff5db);
$parcel$export($3568e170f1ea17d7$exports, "DN0", () => $3568e170f1ea17d7$export$3d4f271a500072a);
$parcel$export($3568e170f1ea17d7$exports, "DN800A", () => $3568e170f1ea17d7$export$fe151285c22759ec);
$parcel$export($3568e170f1ea17d7$exports, "DN700A", () => $3568e170f1ea17d7$export$a101c6190d0da34);
$parcel$export($3568e170f1ea17d7$exports, "DN600A", () => $3568e170f1ea17d7$export$4b16f52932fda51);
$parcel$export($3568e170f1ea17d7$exports, "DN500A", () => $3568e170f1ea17d7$export$a74bcd7b9845b0d8);
$parcel$export($3568e170f1ea17d7$exports, "DN400A", () => $3568e170f1ea17d7$export$9209c179316d1751);
$parcel$export($3568e170f1ea17d7$exports, "DN300A", () => $3568e170f1ea17d7$export$88f55133f636c8dd);
$parcel$export($3568e170f1ea17d7$exports, "DN200A", () => $3568e170f1ea17d7$export$51126f85d1009512);
$parcel$export($3568e170f1ea17d7$exports, "DN100A", () => $3568e170f1ea17d7$export$a069b547bd23af78);
$parcel$export($3568e170f1ea17d7$exports, "DN90A", () => $3568e170f1ea17d7$export$40cce05af3b2600a);
$parcel$export($3568e170f1ea17d7$exports, "DN80A", () => $3568e170f1ea17d7$export$b78942185925a0d);
$parcel$export($3568e170f1ea17d7$exports, "DN70A", () => $3568e170f1ea17d7$export$e058fb44b8eaafca);
$parcel$export($3568e170f1ea17d7$exports, "DN60A", () => $3568e170f1ea17d7$export$92b0b8de26920c18);
$parcel$export($3568e170f1ea17d7$exports, "DN50A", () => $3568e170f1ea17d7$export$67564f7459d3fc9e);
$parcel$export($3568e170f1ea17d7$exports, "DN40A", () => $3568e170f1ea17d7$export$77868e1ca884ffa3);
$parcel$export($3568e170f1ea17d7$exports, "DN30A", () => $3568e170f1ea17d7$export$2afd71d7d3ea2cd5);
$parcel$export($3568e170f1ea17d7$exports, "DN20A", () => $3568e170f1ea17d7$export$f2a0acaab9972c70);
$parcel$export($3568e170f1ea17d7$exports, "DN10A", () => $3568e170f1ea17d7$export$9ab70e67d6475361);
$parcel$export($3568e170f1ea17d7$exports, "T30", () => $3568e170f1ea17d7$export$d2adc5dedf09fced);
$parcel$export($3568e170f1ea17d7$exports, "L50", () => $3568e170f1ea17d7$export$f51762073d2bb381);
$parcel$export($3568e170f1ea17d7$exports, "L75", () => $3568e170f1ea17d7$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $3568e170f1ea17d7$export$4b84fd0e2c617bd = '#FFEBE6';
const $3568e170f1ea17d7$export$b34b069eff244586 = '#FFBDAD';
const $3568e170f1ea17d7$export$be802dd0d8b57f35 = '#FF8F73';
const $3568e170f1ea17d7$export$60847d42f9da92a6 = '#FF7452';
const $3568e170f1ea17d7$export$4a7404f376229999 = '#FF5630';
const $3568e170f1ea17d7$export$2010d0fb4295b346 = '#DE350B';
const $3568e170f1ea17d7$export$2837b5a1a71d5c02 = '#BF2600';
const $3568e170f1ea17d7$export$8d9596b529bbb9cf = '#FFFAE6';
const $3568e170f1ea17d7$export$41060a744ab0b7ae = '#FFF0B3';
const $3568e170f1ea17d7$export$1cc05bbbf340e559 = '#FFE380';
const $3568e170f1ea17d7$export$5aae31392d72caaa = '#FFC400';
const $3568e170f1ea17d7$export$c6930421db9fa514 = '#FFAB00';
const $3568e170f1ea17d7$export$59619663aa6500fb = '#FF991F';
const $3568e170f1ea17d7$export$874739ea9e379ab6 = '#FF8B00';
const $3568e170f1ea17d7$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3568e170f1ea17d7$export$69a3bf21b9686c2b = '#ABF5D1';
const $3568e170f1ea17d7$export$afbce1382ec95f73 = '#79F2C0';
const $3568e170f1ea17d7$export$747d86715d4175de = '#57D9A3';
const $3568e170f1ea17d7$export$940e1f69e873f202 = '#36B37E';
const $3568e170f1ea17d7$export$a49394138f7b8e85 = '#00875A';
const $3568e170f1ea17d7$export$6fa04827ac68a4fb = '#006644';
const $3568e170f1ea17d7$export$226de0355ed012f8 = '#DEEBFF';
const $3568e170f1ea17d7$export$8c13c2ee36917869 = '#B3D4FF';
const $3568e170f1ea17d7$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3568e170f1ea17d7$export$215b7063051591f1 = '#2684FF';
const $3568e170f1ea17d7$export$e62e8919cca44969 = '#0065FF';
const $3568e170f1ea17d7$export$b3de0ae08da2ce64 = '#0052CC';
const $3568e170f1ea17d7$export$a6ee3d71bc067634 = '#0747A6';
const $3568e170f1ea17d7$export$67f15409e87642a1 = '#669DF1';
const $3568e170f1ea17d7$export$f0539dbc42dbb067 = '#8FB8F6';
const $3568e170f1ea17d7$export$363e4475840015bb = '#EAE6FF';
const $3568e170f1ea17d7$export$4b0a4417ed59760f = '#C0B6F2';
const $3568e170f1ea17d7$export$6011520a64d9a187 = '#998DD9';
const $3568e170f1ea17d7$export$a7175d4e9206bc80 = '#8777D9';
const $3568e170f1ea17d7$export$b48405b95304b5a1 = '#6554C0';
const $3568e170f1ea17d7$export$c71e4279dd54a18d = '#5243AA';
const $3568e170f1ea17d7$export$147899de772240ec = '#403294';
const $3568e170f1ea17d7$export$2cf711fe14c66f06 = '#E6FCFF';
const $3568e170f1ea17d7$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3568e170f1ea17d7$export$776c9c497ef08533 = '#79E2F2';
const $3568e170f1ea17d7$export$69cb3ca10c1e330e = '#00C7E6';
const $3568e170f1ea17d7$export$9dc1ef0f3f48059b = '#00B8D9';
const $3568e170f1ea17d7$export$7c835c78b6fcdef8 = '#00A3BF';
const $3568e170f1ea17d7$export$6036577f95c3877e = '#008DA6';
const $3568e170f1ea17d7$export$29a4f05edc054374 = '#FFFFFF';
const $3568e170f1ea17d7$export$e655ef011c4aa1a2 = '#FAFBFC';
const $3568e170f1ea17d7$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3568e170f1ea17d7$export$3e51e8f1440314ba = '#EBECF0';
const $3568e170f1ea17d7$export$1ce2d1575d444ceb = '#DFE1E6';
const $3568e170f1ea17d7$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3568e170f1ea17d7$export$c2e91cbeada39b8b = '#B3BAC5';
const $3568e170f1ea17d7$export$5f71e19f3a7ad9de = '#A5ADBA';
const $3568e170f1ea17d7$export$eaa8c8a70ac22806 = '#97A0AF';
const $3568e170f1ea17d7$export$7c87d337fb91a97d = '#8993A4';
const $3568e170f1ea17d7$export$d6447c357493214f = '#7A869A';
const $3568e170f1ea17d7$export$f563ee71e9ee74cd = '#6B778C';
const $3568e170f1ea17d7$export$e2ef2124cf4024b1 = '#5E6C84';
const $3568e170f1ea17d7$export$eece5f492e429f08 = '#505F79';
const $3568e170f1ea17d7$export$c39c0fe0f26207ae = '#42526E';
const $3568e170f1ea17d7$export$7090862dc3038a9f = '#344563';
const $3568e170f1ea17d7$export$ad0bacf983b7ddaa = '#253858';
const $3568e170f1ea17d7$export$7d61b15e0da132af = '#172B4D';
const $3568e170f1ea17d7$export$fbda843f0a27fe96 = '#091E42';
const $3568e170f1ea17d7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $3568e170f1ea17d7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $3568e170f1ea17d7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $3568e170f1ea17d7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $3568e170f1ea17d7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $3568e170f1ea17d7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $3568e170f1ea17d7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $3568e170f1ea17d7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $3568e170f1ea17d7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $3568e170f1ea17d7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $3568e170f1ea17d7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $3568e170f1ea17d7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $3568e170f1ea17d7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $3568e170f1ea17d7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $3568e170f1ea17d7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $3568e170f1ea17d7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $3568e170f1ea17d7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $3568e170f1ea17d7$export$2f6319cf7d736c2a = '#E6EDFA';
const $3568e170f1ea17d7$export$95126bc8884d6634 = '#DCE5F5';
const $3568e170f1ea17d7$export$8338d8c35d44ff1 = '#CED9EB';
const $3568e170f1ea17d7$export$5368d76ae4fbbda7 = '#B8C7E0';
const $3568e170f1ea17d7$export$9f0a771d16ec8d36 = '#ABBBD6';
const $3568e170f1ea17d7$export$abcf8c38338b4aa5 = '#9FB0CC';
const $3568e170f1ea17d7$export$97e81faa16a182c7 = '#8C9CB8';
const $3568e170f1ea17d7$export$bfe21c59123ecf33 = '#7988A3';
const $3568e170f1ea17d7$export$ee82aa2ea6a1558 = '#67758F';
const $3568e170f1ea17d7$export$682927c6ed76be02 = '#56637A';
const $3568e170f1ea17d7$export$91fd9994c5be9757 = '#455166';
const $3568e170f1ea17d7$export$d281fbfe3cff2df6 = '#3B475C';
const $3568e170f1ea17d7$export$3902c91d8b98a753 = '#313D52';
const $3568e170f1ea17d7$export$8e8133c1ba5845b5 = '#283447';
const $3568e170f1ea17d7$export$33ff357f6620b39 = '#202B3D';
const $3568e170f1ea17d7$export$633847cf062b69e0 = '#1B2638';
const $3568e170f1ea17d7$export$9776a6e503bdbf76 = '#121A29';
const $3568e170f1ea17d7$export$6c813d5160dff5db = '#0E1624';
const $3568e170f1ea17d7$export$3d4f271a500072a = '#0D1424';
const $3568e170f1ea17d7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $3568e170f1ea17d7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $3568e170f1ea17d7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $3568e170f1ea17d7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $3568e170f1ea17d7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $3568e170f1ea17d7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $3568e170f1ea17d7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $3568e170f1ea17d7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $3568e170f1ea17d7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $3568e170f1ea17d7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $3568e170f1ea17d7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $3568e170f1ea17d7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $3568e170f1ea17d7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $3568e170f1ea17d7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $3568e170f1ea17d7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $3568e170f1ea17d7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $3568e170f1ea17d7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $3568e170f1ea17d7$export$d2adc5dedf09fced = '#292A2E';
const $3568e170f1ea17d7$export$f51762073d2bb381 = '#94C748';
const $3568e170f1ea17d7$export$95e26d54def96891 = '#B3DF72';


parcelRegister("9Y1hm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1578f4fe425d0577$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1578f4fe425d0577$var$CSS_VAR_COLOR = '--logo-color';
const $1578f4fe425d0577$var$CSS_VAR_FILL = '--logo-fill';
const $1578f4fe425d0577$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xsmall: "_4t3i7vkz",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $1578f4fe425d0577$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$1578f4fe425d0577$var$CSS_VAR_COLOR]: iconColor,
            [$1578f4fe425d0577$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $bwpsq.default)([
            $1578f4fe425d0577$var$styles.root,
            shouldApplyStopColor && $1578f4fe425d0577$var$styles.stop,
            size && $1578f4fe425d0577$var$styles[size]
        ])
    });
};
var $1578f4fe425d0577$export$2e2bcd8739ae039 = $1578f4fe425d0577$var$Wrapper;

});


parcelRegister("jq9p4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e237bd55a18349d4$var$_react = $e237bd55a18349d4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $e237bd55a18349d4$var$_peopleGroup = $e237bd55a18349d4$var$_interopRequireDefault((parcelRequire("9rubZ")));
function $e237bd55a18349d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e237bd55a18349d4$var$PeopleIcon = (props)=>/*#__PURE__*/ $e237bd55a18349d4$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $e237bd55a18349d4$var$_peopleGroup.default
    }));
$e237bd55a18349d4$var$PeopleIcon.displayName = 'PeopleIcon';
var $e237bd55a18349d4$var$_default = module.exports.default = $e237bd55a18349d4$var$PeopleIcon;

});

parcelRegister("geGxZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd1ef51dd010eed1$var$_react = $bd1ef51dd010eed1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $bd1ef51dd010eed1$var$_dashboard = $bd1ef51dd010eed1$var$_interopRequireDefault((parcelRequire("beo2i")));
function $bd1ef51dd010eed1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bd1ef51dd010eed1$var$ActivityIcon = (props)=>/*#__PURE__*/ $bd1ef51dd010eed1$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $bd1ef51dd010eed1$var$_dashboard.default
    }));
$bd1ef51dd010eed1$var$ActivityIcon.displayName = 'ActivityIcon';
var $bd1ef51dd010eed1$var$_default = module.exports.default = $bd1ef51dd010eed1$var$ActivityIcon;

});
parcelRegister("beo2i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4502f1006918f00802afd208dfed8019>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82d3a58c25bb39bd$var$_react = $82d3a58c25bb39bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $82d3a58c25bb39bd$var$_baseNew = $82d3a58c25bb39bd$var$_interopRequireDefault((parcelRequire("dznjK")));
function $82d3a58c25bb39bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82d3a58c25bb39bd$var$DashboardIcon = (props)=>/*#__PURE__*/ $82d3a58c25bb39bd$var$_react.default.createElement($82d3a58c25bb39bd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$82d3a58c25bb39bd$var$DashboardIcon.displayName = 'DashboardIcon';
var $82d3a58c25bb39bd$var$_default = module.exports.default = $82d3a58c25bb39bd$var$DashboardIcon;

});


parcelRegister("jHuix", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e57989055976262b$var$_react = $e57989055976262b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $e57989055976262b$var$_app = $e57989055976262b$var$_interopRequireDefault((parcelRequire("kmzMI")));
function $e57989055976262b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e57989055976262b$var$AddonIcon = (props)=>/*#__PURE__*/ $e57989055976262b$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
    }, props, {
        newIcon: $e57989055976262b$var$_app.default
    }));
$e57989055976262b$var$AddonIcon.displayName = 'AddonIcon';
var $e57989055976262b$var$_default = module.exports.default = $e57989055976262b$var$AddonIcon;

});
parcelRegister("kmzMI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c18dea19497efa81c490b216a2f8ff9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed319ecf0a3a9542$var$_react = $ed319ecf0a3a9542$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed319ecf0a3a9542$var$_baseNew = $ed319ecf0a3a9542$var$_interopRequireDefault((parcelRequire("dznjK")));
function $ed319ecf0a3a9542$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed319ecf0a3a9542$var$AppIcon = (props)=>/*#__PURE__*/ $ed319ecf0a3a9542$var$_react.default.createElement($ed319ecf0a3a9542$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.257 1.779a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zM8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$ed319ecf0a3a9542$var$AppIcon.displayName = 'AppIcon';
var $ed319ecf0a3a9542$var$_default = module.exports.default = $ed319ecf0a3a9542$var$AppIcon;

});


parcelRegister("8ONtg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66b95e27516c7d6f$var$_react = $66b95e27516c7d6f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $66b95e27516c7d6f$var$_appSwitcher = $66b95e27516c7d6f$var$_interopRequireDefault((parcelRequire("8cCze")));
function $66b95e27516c7d6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66b95e27516c7d6f$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $66b95e27516c7d6f$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $66b95e27516c7d6f$var$_appSwitcher.default
    }));
$66b95e27516c7d6f$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $66b95e27516c7d6f$var$_default = module.exports.default = $66b95e27516c7d6f$var$AppSwitcherIcon;

});
parcelRegister("8cCze", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f8d5c5eb1e903c2$var$_react = $5f8d5c5eb1e903c2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5f8d5c5eb1e903c2$var$_baseNew = $5f8d5c5eb1e903c2$var$_interopRequireDefault((parcelRequire("dznjK")));
function $5f8d5c5eb1e903c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f8d5c5eb1e903c2$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $5f8d5c5eb1e903c2$var$_react.default.createElement($5f8d5c5eb1e903c2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5f8d5c5eb1e903c2$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $5f8d5c5eb1e903c2$var$_default = module.exports.default = $5f8d5c5eb1e903c2$var$AppSwitcherIcon;

});


parcelRegister("hXDbC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d13657fbb4008c66$var$_react = $d13657fbb4008c66$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $d13657fbb4008c66$var$_backlog = $d13657fbb4008c66$var$_interopRequireDefault((parcelRequire("kvRuP")));
function $d13657fbb4008c66$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d13657fbb4008c66$var$BacklogIcon = (props)=>/*#__PURE__*/ $d13657fbb4008c66$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.002C5 19 17 19 17 19v-2.002C17 17 5 17 5 17zm-2-2.004C3 15.894 3.895 15 4.994 15h12.012c1.101 0 1.994.898 1.994 1.998v2.004A1.997 1.997 0 0 1 17.006 21H4.994A2 2 0 0 1 3 19.002z"/><path d="M5 15h12v-2H5zm-2-4h16v6H3z"/><path d="M7 11.002C7 11 19 11 19 11V8.998C19 9 7 9 7 9zM5 8.998C5 7.894 5.895 7 6.994 7h12.012C20.107 7 21 7.898 21 8.998v2.004A1.997 1.997 0 0 1 19.006 13H6.994A2 2 0 0 1 5 11.002z"/><path d="M5 5v2h12V5zm-2-.002C3 3.894 3.895 3 4.994 3h12.012C18.107 3 19 3.898 19 4.998V9H3z"/></g></svg>`
    }, props, {
        newIcon: $d13657fbb4008c66$var$_backlog.default
    }));
$d13657fbb4008c66$var$BacklogIcon.displayName = 'BacklogIcon';
var $d13657fbb4008c66$var$_default = module.exports.default = $d13657fbb4008c66$var$BacklogIcon;

});
parcelRegister("kvRuP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eef0331c68a9fc5f$var$_react = $eef0331c68a9fc5f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eef0331c68a9fc5f$var$_baseNew = $eef0331c68a9fc5f$var$_interopRequireDefault((parcelRequire("dznjK")));
function $eef0331c68a9fc5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eef0331c68a9fc5f$var$BacklogIcon = (props)=>/*#__PURE__*/ $eef0331c68a9fc5f$var$_react.default.createElement($eef0331c68a9fc5f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$eef0331c68a9fc5f$var$BacklogIcon.displayName = 'BacklogIcon';
var $eef0331c68a9fc5f$var$_default = module.exports.default = $eef0331c68a9fc5f$var$BacklogIcon;

});


parcelRegister("1TcUy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1604f16073e7ef2c$var$_react = $1604f16073e7ef2c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");
function $1604f16073e7ef2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1604f16073e7ef2c$var$BillingIcon = (props)=>/*#__PURE__*/ $1604f16073e7ef2c$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
    }, props));
$1604f16073e7ef2c$var$BillingIcon.displayName = 'BillingIcon';
var $1604f16073e7ef2c$var$_default = module.exports.default = $1604f16073e7ef2c$var$BillingIcon;

});

parcelRegister("3UmH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d883463871cfbd1$var$_react = $2d883463871cfbd1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $2d883463871cfbd1$var$_board = $2d883463871cfbd1$var$_interopRequireDefault((parcelRequire("j3rn0")));
function $2d883463871cfbd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2d883463871cfbd1$var$BoardIcon = (props)=>/*#__PURE__*/ $2d883463871cfbd1$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props, {
        newIcon: $2d883463871cfbd1$var$_board.default
    }));
$2d883463871cfbd1$var$BoardIcon.displayName = 'BoardIcon';
var $2d883463871cfbd1$var$_default = module.exports.default = $2d883463871cfbd1$var$BoardIcon;

});
parcelRegister("j3rn0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddf38744f2af2ec9$var$_react = $ddf38744f2af2ec9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddf38744f2af2ec9$var$_baseNew = $ddf38744f2af2ec9$var$_interopRequireDefault((parcelRequire("dznjK")));
function $ddf38744f2af2ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddf38744f2af2ec9$var$BoardIcon = (props)=>/*#__PURE__*/ $ddf38744f2af2ec9$var$_react.default.createElement($ddf38744f2af2ec9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ddf38744f2af2ec9$var$BoardIcon.displayName = 'BoardIcon';
var $ddf38744f2af2ec9$var$_default = module.exports.default = $ddf38744f2af2ec9$var$BoardIcon;

});


parcelRegister("az70d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b129acf4842f3fd$var$_react = $7b129acf4842f3fd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $7b129acf4842f3fd$var$_listBulleted = $7b129acf4842f3fd$var$_interopRequireDefault((parcelRequire("9TJnh")));
function $7b129acf4842f3fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b129acf4842f3fd$var$BulletListIcon = (props)=>/*#__PURE__*/ $7b129acf4842f3fd$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $7b129acf4842f3fd$var$_listBulleted.default
    }));
$7b129acf4842f3fd$var$BulletListIcon.displayName = 'BulletListIcon';
var $7b129acf4842f3fd$var$_default = module.exports.default = $7b129acf4842f3fd$var$BulletListIcon;

});
parcelRegister("9TJnh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab638983bc02863ddd58167a8aaa3871>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $734c7287cad1cead$var$_react = $734c7287cad1cead$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $734c7287cad1cead$var$_baseNew = $734c7287cad1cead$var$_interopRequireDefault((parcelRequire("dznjK")));
function $734c7287cad1cead$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $734c7287cad1cead$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $734c7287cad1cead$var$_react.default.createElement($734c7287cad1cead$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 2.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m14 .75H5V2h10zM1 8a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 1 8m14 .75H5v-1.5h10zm-14 4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M15 14H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$734c7287cad1cead$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $734c7287cad1cead$var$_default = module.exports.default = $734c7287cad1cead$var$ListBulletedIcon;

});


parcelRegister("4ESF3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36454c6da689f30a$var$_react = $36454c6da689f30a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $36454c6da689f30a$var$_chevronDown = $36454c6da689f30a$var$_interopRequireDefault((parcelRequire("9Gsrw")));
function $36454c6da689f30a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36454c6da689f30a$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $36454c6da689f30a$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $36454c6da689f30a$var$_chevronDown.default,
        iconType: "utility"
    }));
$36454c6da689f30a$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $36454c6da689f30a$var$_default = module.exports.default = $36454c6da689f30a$var$ChevronDownIcon;

});

parcelRegister("lt5Id", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa10bcb669245368$var$_react = $fa10bcb669245368$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $fa10bcb669245368$var$_chevronRight = $fa10bcb669245368$var$_interopRequireDefault((parcelRequire("ehTA6")));
function $fa10bcb669245368$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa10bcb669245368$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $fa10bcb669245368$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $fa10bcb669245368$var$_chevronRight.default,
        iconType: "utility"
    }));
$fa10bcb669245368$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $fa10bcb669245368$var$_default = module.exports.default = $fa10bcb669245368$var$ChevronRightIcon;

});
parcelRegister("ehTA6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281ba53efaa7c88b789646091262f5f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a66dc47e56cb2023$var$_react = $a66dc47e56cb2023$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a66dc47e56cb2023$var$_baseNew = $a66dc47e56cb2023$var$_interopRequireDefault((parcelRequire("dznjK")));
function $a66dc47e56cb2023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a66dc47e56cb2023$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $a66dc47e56cb2023$var$_react.default.createElement($a66dc47e56cb2023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$a66dc47e56cb2023$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $a66dc47e56cb2023$var$_default = module.exports.default = $a66dc47e56cb2023$var$ChevronRightIcon;

});


parcelRegister("592N2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3beff5031e1e0e70$var$_react = $3beff5031e1e0e70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $3beff5031e1e0e70$var$_creditCard = $3beff5031e1e0e70$var$_interopRequireDefault((parcelRequire("jZYkm")));
function $3beff5031e1e0e70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3beff5031e1e0e70$var$CreditcardFilledIcon = (props)=>/*#__PURE__*/ $3beff5031e1e0e70$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
    }, props, {
        newIcon: $3beff5031e1e0e70$var$_creditCard.default
    }));
$3beff5031e1e0e70$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
var $3beff5031e1e0e70$var$_default = module.exports.default = $3beff5031e1e0e70$var$CreditcardFilledIcon;

});
parcelRegister("jZYkm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f28292afe7cb29$var$_react = $e8f28292afe7cb29$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e8f28292afe7cb29$var$_baseNew = $e8f28292afe7cb29$var$_interopRequireDefault((parcelRequire("dznjK")));
function $e8f28292afe7cb29$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8f28292afe7cb29$var$CreditCardIcon = (props)=>/*#__PURE__*/ $e8f28292afe7cb29$var$_react.default.createElement($e8f28292afe7cb29$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$e8f28292afe7cb29$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $e8f28292afe7cb29$var$_default = module.exports.default = $e8f28292afe7cb29$var$CreditCardIcon;

});


parcelRegister("cYxfb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9724e03332be29db$var$_react = $9724e03332be29db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $9724e03332be29db$var$_crossCircle = $9724e03332be29db$var$_interopRequireDefault((parcelRequire("ca9aW")));
function $9724e03332be29db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9724e03332be29db$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $9724e03332be29db$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $9724e03332be29db$var$_crossCircle.default
    }));
$9724e03332be29db$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $9724e03332be29db$var$_default = module.exports.default = $9724e03332be29db$var$CrossCircleIcon;

});
parcelRegister("ca9aW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8dad8944eac90c26$var$_react = $8dad8944eac90c26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8dad8944eac90c26$var$_baseNew = $8dad8944eac90c26$var$_interopRequireDefault((parcelRequire("dznjK")));
function $8dad8944eac90c26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8dad8944eac90c26$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $8dad8944eac90c26$var$_react.default.createElement($8dad8944eac90c26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$8dad8944eac90c26$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $8dad8944eac90c26$var$_default = module.exports.default = $8dad8944eac90c26$var$CrossCircleIcon;

});


parcelRegister("2Dnrb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1eb16775c04fa98f$var$_react = $1eb16775c04fa98f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $1eb16775c04fa98f$var$_dashboard = $1eb16775c04fa98f$var$_interopRequireDefault((parcelRequire("beo2i")));
function $1eb16775c04fa98f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1eb16775c04fa98f$var$DashboardIcon = (props)=>/*#__PURE__*/ $1eb16775c04fa98f$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
    }, props, {
        newIcon: $1eb16775c04fa98f$var$_dashboard.default
    }));
$1eb16775c04fa98f$var$DashboardIcon.displayName = 'DashboardIcon';
var $1eb16775c04fa98f$var$_default = module.exports.default = $1eb16775c04fa98f$var$DashboardIcon;

});

parcelRegister("7uuO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57433b90947044d7$var$_react = $57433b90947044d7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $57433b90947044d7$var$_add = $57433b90947044d7$var$_interopRequireDefault((parcelRequire("lvnBm")));
function $57433b90947044d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57433b90947044d7$var$EditorAddIcon = (props)=>/*#__PURE__*/ $57433b90947044d7$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $57433b90947044d7$var$_add.default
    }));
$57433b90947044d7$var$EditorAddIcon.displayName = 'EditorAddIcon';
var $57433b90947044d7$var$_default = module.exports.default = $57433b90947044d7$var$EditorAddIcon;

});
parcelRegister("lvnBm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa7eccfef40d9bfa$var$_react = $fa7eccfef40d9bfa$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fa7eccfef40d9bfa$var$_baseNew = $fa7eccfef40d9bfa$var$_interopRequireDefault((parcelRequire("dznjK")));
function $fa7eccfef40d9bfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa7eccfef40d9bfa$var$AddIcon = (props)=>/*#__PURE__*/ $fa7eccfef40d9bfa$var$_react.default.createElement($fa7eccfef40d9bfa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$fa7eccfef40d9bfa$var$AddIcon.displayName = 'AddIcon';
var $fa7eccfef40d9bfa$var$_default = module.exports.default = $fa7eccfef40d9bfa$var$AddIcon;

});


parcelRegister("1TurE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16128b40645486c6$var$_react = $16128b40645486c6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $16128b40645486c6$var$_information = $16128b40645486c6$var$_interopRequireDefault((parcelRequire("k5qp4")));
function $16128b40645486c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $16128b40645486c6$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $16128b40645486c6$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $16128b40645486c6$var$_information.default
    }));
$16128b40645486c6$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $16128b40645486c6$var$_default = module.exports.default = $16128b40645486c6$var$EditorPanelIcon;

});

parcelRegister("b848e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81a3a587d9d540be$var$_react = $81a3a587d9d540be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");
function $81a3a587d9d540be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81a3a587d9d540be$var$EmojiAtlassianIcon = (props)=>/*#__PURE__*/ $81a3a587d9d540be$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
    }, props));
$81a3a587d9d540be$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
var $81a3a587d9d540be$var$_default = module.exports.default = $81a3a587d9d540be$var$EmojiAtlassianIcon;

});

parcelRegister("61Bd0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $462fb2f0f8d944d6$var$_react = $462fb2f0f8d944d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $462fb2f0f8d944d6$var$_filter = $462fb2f0f8d944d6$var$_interopRequireDefault((parcelRequire("64zjN")));
function $462fb2f0f8d944d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $462fb2f0f8d944d6$var$FilterIcon = (props)=>/*#__PURE__*/ $462fb2f0f8d944d6$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
    }, props, {
        newIcon: $462fb2f0f8d944d6$var$_filter.default
    }));
$462fb2f0f8d944d6$var$FilterIcon.displayName = 'FilterIcon';
var $462fb2f0f8d944d6$var$_default = module.exports.default = $462fb2f0f8d944d6$var$FilterIcon;

});
parcelRegister("64zjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e89b7505e55a28f8d68b8d102eb88514>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46be834a03194236$var$_react = $46be834a03194236$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $46be834a03194236$var$_baseNew = $46be834a03194236$var$_interopRequireDefault((parcelRequire("dznjK")));
function $46be834a03194236$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46be834a03194236$var$FilterIcon = (props)=>/*#__PURE__*/ $46be834a03194236$var$_react.default.createElement($46be834a03194236$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-2 5.25H3v-1.5h10zM11 14H5v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$46be834a03194236$var$FilterIcon.displayName = 'FilterIcon';
var $46be834a03194236$var$_default = module.exports.default = $46be834a03194236$var$FilterIcon;

});


parcelRegister("k8Mc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ea99f033ef675568$var$_react = $ea99f033ef675568$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $ea99f033ef675568$var$_folderClosed = $ea99f033ef675568$var$_interopRequireDefault((parcelRequire("fILNN")));
function $ea99f033ef675568$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ea99f033ef675568$var$FolderIcon = (props)=>/*#__PURE__*/ $ea99f033ef675568$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props, {
        newIcon: $ea99f033ef675568$var$_folderClosed.default
    }));
$ea99f033ef675568$var$FolderIcon.displayName = 'FolderIcon';
var $ea99f033ef675568$var$_default = module.exports.default = $ea99f033ef675568$var$FolderIcon;

});
parcelRegister("fILNN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0bcbb1797ade28bc1c80b60f118d24e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7200b9880cb58b0$var$_react = $b7200b9880cb58b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b7200b9880cb58b0$var$_baseNew = $b7200b9880cb58b0$var$_interopRequireDefault((parcelRequire("dznjK")));
function $b7200b9880cb58b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b7200b9880cb58b0$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $b7200b9880cb58b0$var$_react.default.createElement($b7200b9880cb58b0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$b7200b9880cb58b0$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $b7200b9880cb58b0$var$_default = module.exports.default = $b7200b9880cb58b0$var$FolderClosedIcon;

});


parcelRegister("hkwMh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9ddbae6c907c800$var$_react = $c9ddbae6c907c800$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $c9ddbae6c907c800$var$_issues = $c9ddbae6c907c800$var$_interopRequireDefault((parcelRequire("8wVbo")));
function $c9ddbae6c907c800$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c9ddbae6c907c800$var$IssuesIcon = (props)=>/*#__PURE__*/ $c9ddbae6c907c800$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $c9ddbae6c907c800$var$_issues.default
    }));
$c9ddbae6c907c800$var$IssuesIcon.displayName = 'IssuesIcon';
var $c9ddbae6c907c800$var$_default = module.exports.default = $c9ddbae6c907c800$var$IssuesIcon;

});
parcelRegister("8wVbo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::756d4fa5fd77b2680e9e19bf5f6c468d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $635dab2ebceda8cd$var$_react = $635dab2ebceda8cd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $635dab2ebceda8cd$var$_baseNew = $635dab2ebceda8cd$var$_interopRequireDefault((parcelRequire("dznjK")));
function $635dab2ebceda8cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Issues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $635dab2ebceda8cd$var$IssuesIcon = (props)=>/*#__PURE__*/ $635dab2ebceda8cd$var$_react.default.createElement($635dab2ebceda8cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.302.641 1.146.968-3.167 3.75a.75.75 0 0 1-1.146 0L3.552 7.484l1.146-.968 1.01 1.197z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M16 7v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75V7z" clip-rule="evenodd"/>`
    }, props));
$635dab2ebceda8cd$var$IssuesIcon.displayName = 'IssuesIcon';
var $635dab2ebceda8cd$var$_default = module.exports.default = $635dab2ebceda8cd$var$IssuesIcon;

});


parcelRegister("3noC7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27569cdc1b808c40$var$_react = $27569cdc1b808c40$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $27569cdc1b808c40$var$_lightbulb = $27569cdc1b808c40$var$_interopRequireDefault((parcelRequire("4tT4b")));
function $27569cdc1b808c40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $27569cdc1b808c40$var$LightbulbFilledIcon = (props)=>/*#__PURE__*/ $27569cdc1b808c40$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611s.45.907 1 .907h4c.55 0 1-.408 1-.907s.32-1.224.71-1.611c0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4m2.965 15c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1z"/></svg>`
    }, props, {
        newIcon: $27569cdc1b808c40$var$_lightbulb.default
    }));
$27569cdc1b808c40$var$LightbulbFilledIcon.displayName = 'LightbulbFilledIcon';
var $27569cdc1b808c40$var$_default = module.exports.default = $27569cdc1b808c40$var$LightbulbFilledIcon;

});
parcelRegister("4tT4b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff1a0601d1dfa1b068f5f916af0a8fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $343495e9474563b6$var$_react = $343495e9474563b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $343495e9474563b6$var$_baseNew = $343495e9474563b6$var$_interopRequireDefault((parcelRequire("dznjK")));
function $343495e9474563b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $343495e9474563b6$var$LightbulbIcon = (props)=>/*#__PURE__*/ $343495e9474563b6$var$_react.default.createElement($343495e9474563b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a4.5 4.5 0 0 0-2.516 8.232c.545.368 1.002.994 1.016 1.768h3c.014-.774.471-1.4 1.016-1.768A4.5 4.5 0 0 0 8 1.5M9.5 13h-3v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM2 6a6 6 0 1 1 9.355 4.975c-.247.167-.355.385-.355.56V14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2.465c0-.175-.108-.393-.355-.56A6 6 0 0 1 2 6" clip-rule="evenodd"/>`
    }, props));
$343495e9474563b6$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $343495e9474563b6$var$_default = module.exports.default = $343495e9474563b6$var$LightbulbIcon;

});


parcelRegister("c8FIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d6697f7e734eb7a$var$_react = $8d6697f7e734eb7a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $8d6697f7e734eb7a$var$_showMoreHorizontal = $8d6697f7e734eb7a$var$_interopRequireDefault((parcelRequire("9hm3Z")));
function $8d6697f7e734eb7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d6697f7e734eb7a$var$MoreIcon = (props)=>/*#__PURE__*/ $8d6697f7e734eb7a$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $8d6697f7e734eb7a$var$_showMoreHorizontal.default
    }));
$8d6697f7e734eb7a$var$MoreIcon.displayName = 'MoreIcon';
var $8d6697f7e734eb7a$var$_default = module.exports.default = $8d6697f7e734eb7a$var$MoreIcon;

});
parcelRegister("9hm3Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c16d0ef2140d3df$var$_react = $6c16d0ef2140d3df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6c16d0ef2140d3df$var$_baseNew = $6c16d0ef2140d3df$var$_interopRequireDefault((parcelRequire("dznjK")));
function $6c16d0ef2140d3df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c16d0ef2140d3df$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $6c16d0ef2140d3df$var$_react.default.createElement($6c16d0ef2140d3df$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$6c16d0ef2140d3df$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $6c16d0ef2140d3df$var$_default = module.exports.default = $6c16d0ef2140d3df$var$ShowMoreHorizontalIcon;

});


parcelRegister("5gDrk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d5d0a484ea4d526$var$_react = $3d5d0a484ea4d526$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $3d5d0a484ea4d526$var$_notification = $3d5d0a484ea4d526$var$_interopRequireDefault((parcelRequire("kUL65")));
function $3d5d0a484ea4d526$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d5d0a484ea4d526$var$NotificationIcon = (props)=>/*#__PURE__*/ $3d5d0a484ea4d526$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
    }, props, {
        newIcon: $3d5d0a484ea4d526$var$_notification.default
    }));
$3d5d0a484ea4d526$var$NotificationIcon.displayName = 'NotificationIcon';
var $3d5d0a484ea4d526$var$_default = module.exports.default = $3d5d0a484ea4d526$var$NotificationIcon;

});
parcelRegister("kUL65", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f39d921fe5980f4f$var$_react = $f39d921fe5980f4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f39d921fe5980f4f$var$_baseNew = $f39d921fe5980f4f$var$_interopRequireDefault((parcelRequire("dznjK")));
function $f39d921fe5980f4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f39d921fe5980f4f$var$NotificationIcon = (props)=>/*#__PURE__*/ $f39d921fe5980f4f$var$_react.default.createElement($f39d921fe5980f4f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$f39d921fe5980f4f$var$NotificationIcon.displayName = 'NotificationIcon';
var $f39d921fe5980f4f$var$_default = module.exports.default = $f39d921fe5980f4f$var$NotificationIcon;

});


parcelRegister("4g1wN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3199d777c2eae1b9$var$_react = $3199d777c2eae1b9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $3199d777c2eae1b9$var$_notification = $3199d777c2eae1b9$var$_interopRequireDefault((parcelRequire("kUL65")));
function $3199d777c2eae1b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3199d777c2eae1b9$var$NotificationDirectIcon = (props)=>/*#__PURE__*/ $3199d777c2eae1b9$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
    }, props, {
        newIcon: $3199d777c2eae1b9$var$_notification.default
    }));
$3199d777c2eae1b9$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
var $3199d777c2eae1b9$var$_default = module.exports.default = $3199d777c2eae1b9$var$NotificationDirectIcon;

});

parcelRegister("fL3eH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b78dc171f9a9cf03$var$_react = $b78dc171f9a9cf03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $b78dc171f9a9cf03$var$_arrowUpRight = $b78dc171f9a9cf03$var$_interopRequireDefault((parcelRequire("9GjE9")));
function $b78dc171f9a9cf03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b78dc171f9a9cf03$var$OpenIcon = (props)=>/*#__PURE__*/ $b78dc171f9a9cf03$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
    }, props, {
        newIcon: $b78dc171f9a9cf03$var$_arrowUpRight.default
    }));
$b78dc171f9a9cf03$var$OpenIcon.displayName = 'OpenIcon';
var $b78dc171f9a9cf03$var$_default = module.exports.default = $b78dc171f9a9cf03$var$OpenIcon;

});
parcelRegister("9GjE9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa37e7fb05387379200e2a91e20ea76e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70c746b14c07aa9f$var$_react = $70c746b14c07aa9f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $70c746b14c07aa9f$var$_baseNew = $70c746b14c07aa9f$var$_interopRequireDefault((parcelRequire("dznjK")));
function $70c746b14c07aa9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $70c746b14c07aa9f$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $70c746b14c07aa9f$var$_react.default.createElement($70c746b14c07aa9f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$70c746b14c07aa9f$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $70c746b14c07aa9f$var$_default = module.exports.default = $70c746b14c07aa9f$var$ArrowUpRightIcon;

});


parcelRegister("j9fpA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df0ad00135b9c650$var$_react = $df0ad00135b9c650$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $df0ad00135b9c650$var$_page = $df0ad00135b9c650$var$_interopRequireDefault((parcelRequire("bTT6v")));
function $df0ad00135b9c650$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df0ad00135b9c650$var$PageIcon = (props)=>/*#__PURE__*/ $df0ad00135b9c650$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $df0ad00135b9c650$var$_page.default
    }));
$df0ad00135b9c650$var$PageIcon.displayName = 'PageIcon';
var $df0ad00135b9c650$var$_default = module.exports.default = $df0ad00135b9c650$var$PageIcon;

});
parcelRegister("bTT6v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a9f93413ef3662d$var$_react = $8a9f93413ef3662d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8a9f93413ef3662d$var$_baseNew = $8a9f93413ef3662d$var$_interopRequireDefault((parcelRequire("dznjK")));
function $8a9f93413ef3662d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a9f93413ef3662d$var$PageIcon = (props)=>/*#__PURE__*/ $8a9f93413ef3662d$var$_react.default.createElement($8a9f93413ef3662d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$8a9f93413ef3662d$var$PageIcon.displayName = 'PageIcon';
var $8a9f93413ef3662d$var$_default = module.exports.default = $8a9f93413ef3662d$var$PageIcon;

});


parcelRegister("63N9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $469927f2fbb0f817$var$_react = $469927f2fbb0f817$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $469927f2fbb0f817$var$_person = $469927f2fbb0f817$var$_interopRequireDefault((parcelRequire("b7FX8")));
function $469927f2fbb0f817$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $469927f2fbb0f817$var$PersonIcon = (props)=>/*#__PURE__*/ $469927f2fbb0f817$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $469927f2fbb0f817$var$_person.default
    }));
$469927f2fbb0f817$var$PersonIcon.displayName = 'PersonIcon';
var $469927f2fbb0f817$var$_default = module.exports.default = $469927f2fbb0f817$var$PersonIcon;

});
parcelRegister("b7FX8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8190e419ab094083$var$_react = $8190e419ab094083$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8190e419ab094083$var$_baseNew = $8190e419ab094083$var$_interopRequireDefault((parcelRequire("dznjK")));
function $8190e419ab094083$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8190e419ab094083$var$PersonIcon = (props)=>/*#__PURE__*/ $8190e419ab094083$var$_react.default.createElement($8190e419ab094083$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$8190e419ab094083$var$PersonIcon.displayName = 'PersonIcon';
var $8190e419ab094083$var$_default = module.exports.default = $8190e419ab094083$var$PersonIcon;

});


parcelRegister("cxU0q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $922402b50f711957$var$_react = $922402b50f711957$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $922402b50f711957$var$_personAvatar = $922402b50f711957$var$_interopRequireDefault((parcelRequire("luP7Q")));
function $922402b50f711957$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $922402b50f711957$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $922402b50f711957$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $922402b50f711957$var$_personAvatar.default
    }));
$922402b50f711957$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $922402b50f711957$var$_default = module.exports.default = $922402b50f711957$var$PersonCircleIcon;

});
parcelRegister("luP7Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa640ece1242cd9f$var$_react = $fa640ece1242cd9f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fa640ece1242cd9f$var$_baseNew = $fa640ece1242cd9f$var$_interopRequireDefault((parcelRequire("dznjK")));
function $fa640ece1242cd9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fa640ece1242cd9f$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $fa640ece1242cd9f$var$_react.default.createElement($fa640ece1242cd9f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$fa640ece1242cd9f$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $fa640ece1242cd9f$var$_default = module.exports.default = $fa640ece1242cd9f$var$PersonAvatarIcon;

});


parcelRegister("ksMVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee5c60fc69050598$var$_react = $ee5c60fc69050598$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $ee5c60fc69050598$var$_premium = $ee5c60fc69050598$var$_interopRequireDefault((parcelRequire("7R8ss")));
function $ee5c60fc69050598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ee5c60fc69050598$var$PremiumIcon = (props)=>/*#__PURE__*/ $ee5c60fc69050598$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
    }, props, {
        newIcon: $ee5c60fc69050598$var$_premium.default
    }));
$ee5c60fc69050598$var$PremiumIcon.displayName = 'PremiumIcon';
var $ee5c60fc69050598$var$_default = module.exports.default = $ee5c60fc69050598$var$PremiumIcon;

});
parcelRegister("7R8ss", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5b840b36c068d445$var$_react = $5b840b36c068d445$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5b840b36c068d445$var$_baseNew = $5b840b36c068d445$var$_interopRequireDefault((parcelRequire("dznjK")));
function $5b840b36c068d445$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5b840b36c068d445$var$PremiumIcon = (props)=>/*#__PURE__*/ $5b840b36c068d445$var$_react.default.createElement($5b840b36c068d445$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$5b840b36c068d445$var$PremiumIcon.displayName = 'PremiumIcon';
var $5b840b36c068d445$var$_default = module.exports.default = $5b840b36c068d445$var$PremiumIcon;

});


parcelRegister("jXq6Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e877c82f583b44bd$var$_react = $e877c82f583b44bd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $e877c82f583b44bd$var$_questionCircle = $e877c82f583b44bd$var$_interopRequireDefault((parcelRequire("6QXwr")));
function $e877c82f583b44bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e877c82f583b44bd$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $e877c82f583b44bd$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $e877c82f583b44bd$var$_questionCircle.default
    }));
$e877c82f583b44bd$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $e877c82f583b44bd$var$_default = module.exports.default = $e877c82f583b44bd$var$QuestionCircleIcon;

});
parcelRegister("6QXwr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4fd5c54d42a36905$var$_react = $4fd5c54d42a36905$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4fd5c54d42a36905$var$_baseNew = $4fd5c54d42a36905$var$_interopRequireDefault((parcelRequire("dznjK")));
function $4fd5c54d42a36905$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4fd5c54d42a36905$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $4fd5c54d42a36905$var$_react.default.createElement($4fd5c54d42a36905$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$4fd5c54d42a36905$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $4fd5c54d42a36905$var$_default = module.exports.default = $4fd5c54d42a36905$var$QuestionCircleIcon;

});


parcelRegister("cADlN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92a75f017adc3554$var$_react = $92a75f017adc3554$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $92a75f017adc3554$var$_clock = $92a75f017adc3554$var$_interopRequireDefault((parcelRequire("lCsU2")));
function $92a75f017adc3554$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $92a75f017adc3554$var$RecentIcon = (props)=>/*#__PURE__*/ $92a75f017adc3554$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
    }, props, {
        newIcon: $92a75f017adc3554$var$_clock.default
    }));
$92a75f017adc3554$var$RecentIcon.displayName = 'RecentIcon';
var $92a75f017adc3554$var$_default = module.exports.default = $92a75f017adc3554$var$RecentIcon;

});
parcelRegister("lCsU2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92ee1be6e4ceec90ef291a87140cefc4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbd3911a8f1a7cb0$var$_react = $fbd3911a8f1a7cb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fbd3911a8f1a7cb0$var$_baseNew = $fbd3911a8f1a7cb0$var$_interopRequireDefault((parcelRequire("dznjK")));
function $fbd3911a8f1a7cb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fbd3911a8f1a7cb0$var$ClockIcon = (props)=>/*#__PURE__*/ $fbd3911a8f1a7cb0$var$_react.default.createElement($fbd3911a8f1a7cb0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8.75-.36V3.25h-1.5v5.11l2.781 2.226.938-1.172z" clip-rule="evenodd"/>`
    }, props));
$fbd3911a8f1a7cb0$var$ClockIcon.displayName = 'ClockIcon';
var $fbd3911a8f1a7cb0$var$_default = module.exports.default = $fbd3911a8f1a7cb0$var$ClockIcon;

});


parcelRegister("BDPoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $071259d1517d0cab$var$_react = $071259d1517d0cab$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $071259d1517d0cab$var$_roadmap = $071259d1517d0cab$var$_interopRequireDefault((parcelRequire("4H1dp")));
function $071259d1517d0cab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $071259d1517d0cab$var$RoadmapIcon = (props)=>/*#__PURE__*/ $071259d1517d0cab$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 2h10a3 3 0 0 1 0 6H6a3 3 0 1 1 0-6m0 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2zm4 5h8a3 3 0 0 1 0 6h-8a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-4 5h6a3 3 0 0 1 0 6H6a3 3 0 0 1 0-6m0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $071259d1517d0cab$var$_roadmap.default
    }));
$071259d1517d0cab$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $071259d1517d0cab$var$_default = module.exports.default = $071259d1517d0cab$var$RoadmapIcon;

});
parcelRegister("4H1dp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36ac1ee8118d2cb9$var$_react = $36ac1ee8118d2cb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $36ac1ee8118d2cb9$var$_baseNew = $36ac1ee8118d2cb9$var$_interopRequireDefault((parcelRequire("dznjK")));
function $36ac1ee8118d2cb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36ac1ee8118d2cb9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $36ac1ee8118d2cb9$var$_react.default.createElement($36ac1ee8118d2cb9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$36ac1ee8118d2cb9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $36ac1ee8118d2cb9$var$_default = module.exports.default = $36ac1ee8118d2cb9$var$RoadmapIcon;

});


parcelRegister("lGPHF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fca5a0719f4ca990$var$_react = $fca5a0719f4ca990$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $fca5a0719f4ca990$var$_screen = $fca5a0719f4ca990$var$_interopRequireDefault((parcelRequire("95SCX")));
function $fca5a0719f4ca990$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fca5a0719f4ca990$var$ScreenIcon = (props)=>/*#__PURE__*/ $fca5a0719f4ca990$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
    }, props, {
        newIcon: $fca5a0719f4ca990$var$_screen.default
    }));
$fca5a0719f4ca990$var$ScreenIcon.displayName = 'ScreenIcon';
var $fca5a0719f4ca990$var$_default = module.exports.default = $fca5a0719f4ca990$var$ScreenIcon;

});
parcelRegister("95SCX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1698552166bfef93121ec02f2fff1081>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69eef48c16350406$var$_react = $69eef48c16350406$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $69eef48c16350406$var$_baseNew = $69eef48c16350406$var$_interopRequireDefault((parcelRequire("dznjK")));
function $69eef48c16350406$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $69eef48c16350406$var$ScreenIcon = (props)=>/*#__PURE__*/ $69eef48c16350406$var$_react.default.createElement($69eef48c16350406$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$69eef48c16350406$var$ScreenIcon.displayName = 'ScreenIcon';
var $69eef48c16350406$var$_default = module.exports.default = $69eef48c16350406$var$ScreenIcon;

});


parcelRegister("1dhTk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e24e23974812cbf$var$_react = $0e24e23974812cbf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $0e24e23974812cbf$var$_search = $0e24e23974812cbf$var$_interopRequireDefault((parcelRequire("ajK26")));
function $0e24e23974812cbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0e24e23974812cbf$var$SearchIcon = (props)=>/*#__PURE__*/ $0e24e23974812cbf$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
    }, props, {
        newIcon: $0e24e23974812cbf$var$_search.default
    }));
$0e24e23974812cbf$var$SearchIcon.displayName = 'SearchIcon';
var $0e24e23974812cbf$var$_default = module.exports.default = $0e24e23974812cbf$var$SearchIcon;

});
parcelRegister("ajK26", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $782f62ea1a3dd820$var$_react = $782f62ea1a3dd820$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $782f62ea1a3dd820$var$_baseNew = $782f62ea1a3dd820$var$_interopRequireDefault((parcelRequire("dznjK")));
function $782f62ea1a3dd820$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $782f62ea1a3dd820$var$SearchIcon = (props)=>/*#__PURE__*/ $782f62ea1a3dd820$var$_react.default.createElement($782f62ea1a3dd820$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$782f62ea1a3dd820$var$SearchIcon.displayName = 'SearchIcon';
var $782f62ea1a3dd820$var$_default = module.exports.default = $782f62ea1a3dd820$var$SearchIcon;

});


parcelRegister("2EMkH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ef4cf1a60b546be$var$_react = $1ef4cf1a60b546be$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $1ef4cf1a60b546be$var$_settings = $1ef4cf1a60b546be$var$_interopRequireDefault((parcelRequire("35kHP")));
function $1ef4cf1a60b546be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ef4cf1a60b546be$var$SettingsIcon = (props)=>/*#__PURE__*/ $1ef4cf1a60b546be$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
    }, props, {
        newIcon: $1ef4cf1a60b546be$var$_settings.default
    }));
$1ef4cf1a60b546be$var$SettingsIcon.displayName = 'SettingsIcon';
var $1ef4cf1a60b546be$var$_default = module.exports.default = $1ef4cf1a60b546be$var$SettingsIcon;

});
parcelRegister("35kHP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23f1e6797741a668$var$_react = $23f1e6797741a668$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23f1e6797741a668$var$_baseNew = $23f1e6797741a668$var$_interopRequireDefault((parcelRequire("dznjK")));
function $23f1e6797741a668$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23f1e6797741a668$var$SettingsIcon = (props)=>/*#__PURE__*/ $23f1e6797741a668$var$_react.default.createElement($23f1e6797741a668$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$23f1e6797741a668$var$SettingsIcon.displayName = 'SettingsIcon';
var $23f1e6797741a668$var$_default = module.exports.default = $23f1e6797741a668$var$SettingsIcon;

});


parcelRegister("3XbxJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e0fd5ffb307065c$var$_react = $2e0fd5ffb307065c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $2e0fd5ffb307065c$var$_release = $2e0fd5ffb307065c$var$_interopRequireDefault((parcelRequire("lySr6")));
function $2e0fd5ffb307065c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e0fd5ffb307065c$var$ShipIcon = (props)=>/*#__PURE__*/ $2e0fd5ffb307065c$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $2e0fd5ffb307065c$var$_release.default
    }));
$2e0fd5ffb307065c$var$ShipIcon.displayName = 'ShipIcon';
var $2e0fd5ffb307065c$var$_default = module.exports.default = $2e0fd5ffb307065c$var$ShipIcon;

});
parcelRegister("lySr6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1a26e96d639121c034f7ae4d8530108>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb26ffcfb92f1f4c$var$_react = $fb26ffcfb92f1f4c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fb26ffcfb92f1f4c$var$_baseNew = $fb26ffcfb92f1f4c$var$_interopRequireDefault((parcelRequire("dznjK")));
function $fb26ffcfb92f1f4c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb26ffcfb92f1f4c$var$ReleaseIcon = (props)=>/*#__PURE__*/ $fb26ffcfb92f1f4c$var$_react.default.createElement($fb26ffcfb92f1f4c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$fb26ffcfb92f1f4c$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $fb26ffcfb92f1f4c$var$_default = module.exports.default = $fb26ffcfb92f1f4c$var$ReleaseIcon;

});


parcelRegister("eyLM9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9994ce2adbe8123$var$_react = $a9994ce2adbe8123$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $a9994ce2adbe8123$var$_linkExternal = $a9994ce2adbe8123$var$_interopRequireDefault((parcelRequire("1FMGD")));
function $a9994ce2adbe8123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9994ce2adbe8123$var$ShortcutIcon = (props)=>/*#__PURE__*/ $a9994ce2adbe8123$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $a9994ce2adbe8123$var$_linkExternal.default
    }));
$a9994ce2adbe8123$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $a9994ce2adbe8123$var$_default = module.exports.default = $a9994ce2adbe8123$var$ShortcutIcon;

});
parcelRegister("1FMGD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $137f62ec9db8a376$var$_react = $137f62ec9db8a376$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $137f62ec9db8a376$var$_baseNew = $137f62ec9db8a376$var$_interopRequireDefault((parcelRequire("dznjK")));
function $137f62ec9db8a376$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $137f62ec9db8a376$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $137f62ec9db8a376$var$_react.default.createElement($137f62ec9db8a376$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$137f62ec9db8a376$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
var $137f62ec9db8a376$var$_default = module.exports.default = $137f62ec9db8a376$var$LinkExternalIcon;

});


parcelRegister("c80jx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d4679c732350387$var$_react = $8d4679c732350387$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $8d4679c732350387$var$_logIn = $8d4679c732350387$var$_interopRequireDefault((parcelRequire("hDclk")));
function $8d4679c732350387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d4679c732350387$var$SignInIcon = (props)=>/*#__PURE__*/ $8d4679c732350387$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
    }, props, {
        newIcon: $8d4679c732350387$var$_logIn.default
    }));
$8d4679c732350387$var$SignInIcon.displayName = 'SignInIcon';
var $8d4679c732350387$var$_default = module.exports.default = $8d4679c732350387$var$SignInIcon;

});
parcelRegister("hDclk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6da84e11aa1d5b6e9ca710faf282a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd5fa7434f3a46b6$var$_react = $cd5fa7434f3a46b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cd5fa7434f3a46b6$var$_baseNew = $cd5fa7434f3a46b6$var$_interopRequireDefault((parcelRequire("dznjK")));
function $cd5fa7434f3a46b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd5fa7434f3a46b6$var$LogInIcon = (props)=>/*#__PURE__*/ $cd5fa7434f3a46b6$var$_react.default.createElement($cd5fa7434f3a46b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$cd5fa7434f3a46b6$var$LogInIcon.displayName = 'LogInIcon';
var $cd5fa7434f3a46b6$var$_default = module.exports.default = $cd5fa7434f3a46b6$var$LogInIcon;

});


parcelRegister("8PLzY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e7fe63239998e8$var$_react = $66e7fe63239998e8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $66e7fe63239998e8$var$_starUnstarred = $66e7fe63239998e8$var$_interopRequireDefault((parcelRequire("g8yCJ")));
function $66e7fe63239998e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66e7fe63239998e8$var$StarIcon = (props)=>/*#__PURE__*/ $66e7fe63239998e8$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $66e7fe63239998e8$var$_starUnstarred.default
    }));
$66e7fe63239998e8$var$StarIcon.displayName = 'StarIcon';
var $66e7fe63239998e8$var$_default = module.exports.default = $66e7fe63239998e8$var$StarIcon;

});
parcelRegister("g8yCJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79fdc87e6bc8c8ac301f370494c87ace>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $030822116aad019a$var$_react = $030822116aad019a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $030822116aad019a$var$_baseNew = $030822116aad019a$var$_interopRequireDefault((parcelRequire("dznjK")));
function $030822116aad019a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $030822116aad019a$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $030822116aad019a$var$_react.default.createElement($030822116aad019a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$030822116aad019a$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $030822116aad019a$var$_default = module.exports.default = $030822116aad019a$var$StarUnstarredIcon;

});


parcelRegister("gBYa2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c17ec4bf2dee01a9$var$_react = $c17ec4bf2dee01a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $c17ec4bf2dee01a9$var$_starStarred = $c17ec4bf2dee01a9$var$_interopRequireDefault((parcelRequire("bIVtA")));
function $c17ec4bf2dee01a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c17ec4bf2dee01a9$var$StarFilledIcon = (props)=>/*#__PURE__*/ $c17ec4bf2dee01a9$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $c17ec4bf2dee01a9$var$_starStarred.default
    }));
$c17ec4bf2dee01a9$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $c17ec4bf2dee01a9$var$_default = module.exports.default = $c17ec4bf2dee01a9$var$StarFilledIcon;

});
parcelRegister("bIVtA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88906355854c461f$var$_react = $88906355854c461f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $88906355854c461f$var$_baseNew = $88906355854c461f$var$_interopRequireDefault((parcelRequire("dznjK")));
function $88906355854c461f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88906355854c461f$var$StarStarredIcon = (props)=>/*#__PURE__*/ $88906355854c461f$var$_react.default.createElement($88906355854c461f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$88906355854c461f$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $88906355854c461f$var$_default = module.exports.default = $88906355854c461f$var$StarStarredIcon;

});


parcelRegister("5P7lu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43d769d995af0bcc$var$_react = $43d769d995af0bcc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2wX6c = parcelRequire("2wX6c");

var $43d769d995af0bcc$var$_personAvatar = $43d769d995af0bcc$var$_interopRequireDefault((parcelRequire("luP7Q")));
function $43d769d995af0bcc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $43d769d995af0bcc$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $43d769d995af0bcc$var$_react.default.createElement($2wX6c.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $43d769d995af0bcc$var$_personAvatar.default
    }));
$43d769d995af0bcc$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $43d769d995af0bcc$var$_default = module.exports.default = $43d769d995af0bcc$var$UserAvatarCircleIcon;

});

parcelRegister("2jiZv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a0fbc7ac86f2f75c$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $6q45C = parcelRequire("6q45C");
var $2qiW1 = parcelRequire("2qiW1");

var $bJX7j = parcelRequire("bJX7j");

var $5oKDN = parcelRequire("5oKDN");
const $a0fbc7ac86f2f75c$var$headerStyles = null;
const $a0fbc7ac86f2f75c$var$flexStyles = (0, $2qiW1.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $a0fbc7ac86f2f75c$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $5oKDN.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1ezb _85i5pxbi _1q511ejb"
        ]),
        children: shouldShowCloseButton ? // The reason we are putting the close button first in the DOM and then
        // reordering them is to ensure that users of assistive technology get
        // all the context of a modal when initial focus is placed on the close
        // button, since it's the first interactive element.
        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6q45C.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $a0fbc7ac86f2f75c$var$flexStyles,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6q45C.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bJX7j.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6q45C.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    children: children
                })
            ]
        }) : children
    });
};
var $a0fbc7ac86f2f75c$export$2e2bcd8739ae039 = $a0fbc7ac86f2f75c$var$ModalHeader;

});
parcelRegister("6q45C", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0ac536b4b0807b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4QIJ8 = parcelRequire("4QIJ8");

var $2qiW1 = parcelRequire("2qiW1");
function $9e0ac536b4b0807b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9e0ac536b4b0807b$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $9e0ac536b4b0807b$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $9e0ac536b4b0807b$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $9e0ac536b4b0807b$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $9e0ac536b4b0807b$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $9e0ac536b4b0807b$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $2qiW1.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $9e0ac536b4b0807b$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $4QIJ8.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $4QIJ8.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $4QIJ8.spaceStylesMap).rowGap[rowGap],
            alignItems && $9e0ac536b4b0807b$var$alignItemsMap[alignItems],
            direction && $9e0ac536b4b0807b$var$flexDirectionMap[direction],
            justifyContent && $9e0ac536b4b0807b$var$justifyContentMap[justifyContent],
            wrap && $9e0ac536b4b0807b$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$9e0ac536b4b0807b$var$Flex.displayName = 'Flex';
var $9e0ac536b4b0807b$export$2e2bcd8739ae039 = $9e0ac536b4b0807b$var$Flex;

});

parcelRegister("bJX7j", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $8df594a5976d50e6$export$de65de8213222d10);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lPSnc = parcelRequire("lPSnc");

var $ltth1 = parcelRequire("ltth1");
const $8df594a5976d50e6$export$de65de8213222d10 = ({ label: label, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lPSnc.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ltth1))),
        label: label || 'Close Modal',
        onClick: onClick
    });

});
parcelRegister("lPSnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $50bb950d017e23af$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $h6LYg = parcelRequire("h6LYg");

var $fulm9 = parcelRequire("fulm9");

var $dqnDV = parcelRequire("dqnDV");

var $henai = parcelRequire("henai");

var $fq4Zh = parcelRequire("fq4Zh");

var $l8tgK = parcelRequire("l8tgK");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $50bb950d017e23af$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $henai.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fq4Zh.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $henai.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $h6LYg.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fq4Zh.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$50bb950d017e23af$var$IconButton.displayName = 'IconButton';
var $50bb950d017e23af$export$2e2bcd8739ae039 = $50bb950d017e23af$var$IconButton;

});
parcelRegister("h6LYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $730c1ca65f341405$export$2e2bcd8739ae039);
function $730c1ca65f341405$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("fulm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae62a4198135c38$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $cPdSB = parcelRequire("cPdSB");

var $jp7wN = parcelRequire("jp7wN");

var $d5MPO = parcelRequire("d5MPO");

var $6Wgj7 = parcelRequire("6Wgj7");

var $9HBUn = parcelRequire("9HBUn");

var $9Gmev = parcelRequire("9Gmev");
var $fbN4n = parcelRequire("fbN4n");

var $khO3w = parcelRequire("khO3w");

var $8hN1h = parcelRequire("8hN1h");

var $dmUF2 = parcelRequire("dmUF2");

var $iknrn = parcelRequire("iknrn");

var $gONMn = parcelRequire("gONMn");

var $i10Hz = parcelRequire("i10Hz");

var $N4N3J = parcelRequire("N4N3J");

var $9r1u8 = parcelRequire("9r1u8");

var $fRw6u = parcelRequire("fRw6u");
const $2ae62a4198135c38$var$tooltipZIndex = (0, $iknrn.layers).tooltip();
const $2ae62a4198135c38$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
// Inverts motion direction
const $2ae62a4198135c38$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $2ae62a4198135c38$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $2ae62a4198135c38$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $9r1u8.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $jp7wN.default), onHide: onHide = (0, $jp7wN.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
    const tooltipPosition = position === 'mouse' ? mousePosition : position;
    const onShowHandler = (0, $cPdSB.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$2ae62a4198135c38$var$analyticsAttributes
    });
    const onHideHandler = (0, $cPdSB.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$2ae62a4198135c38$var$analyticsAttributes
    });
    const apiRef = (0, $5uXOq.useRef)(null);
    const [state, setState] = (0, $5uXOq.useState)('hide');
    const targetRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $5uXOq.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $6Wgj7.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $6Wgj7.default)(onShowHandler);
    const onHideHandlerStable = (0, $6Wgj7.default)(onHideHandler);
    const delayStable = (0, $6Wgj7.default)(delay);
    const canAppearStable = (0, $6Wgj7.default)(canAppear);
    const hasCalledShowHandler = (0, $5uXOq.useRef)(false);
    const start = (0, $5uXOq.useCallback)((api)=>{
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $5uXOq.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $gONMn.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ apiRef.current?.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $5uXOq.useCallback)((source)=>{
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !canAppearStable.current?.()) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        const api = (0, $i10Hz.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    const hideTooltipOnEsc = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $d5MPO.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (state === 'hide') return 0, $jp7wN.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $fRw6u.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $5uXOq.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = position === 'mouse' ? (event)=>{
        if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $fRw6u.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    const onMouseOverTooltip = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $5uXOq.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        apiRef.current?.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $9HBUn.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && ((0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers') ? shouldRenderTooltipChildren : true),
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $N4N3J.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = `${testId}--container`;
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $5uXOq.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent,
        children: typeof content === 'function' ? content({}) : content
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
            // attribute back into the tooltipTriggerProps and make it required
            // instead of optional in `types`
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    children({
                        ...tooltipTriggerProps,
                        'aria-describedby': tooltipIdForHiddenContent,
                        ref: setDirectRef
                    }),
                    hiddenContent
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)(CastTargetContainer, {
                ...tooltipTriggerProps,
                ref: setImplicitRefFromChildren,
                /**
     * TODO: Why is role="presentation" added?
     * - Is it only to "remove" the `Container` from screen readers?
     * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
     * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
     */ role: "presentation",
                children: [
                    children,
                    hiddenContent
                ]
            }),
            shouldRenderTooltipPopup ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dmUF2.default), {
                zIndex: $2ae62a4198135c38$var$tooltipZIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hN1h.Popper), {
                    placement: tooltipPosition,
                    referenceElement: getReferenceElement(),
                    strategy: strategy,
                    children: ({ ref: ref, style: style, update: update, placement: placement })=>{
                        // Invert the entrance and exit directions.
                        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
                        // This gives the effect the tooltip is appearing from the target
                        const direction = position === 'mouse' ? undefined : $2ae62a4198135c38$var$invertedDirection[$2ae62a4198135c38$var$getDirectionFromPlacement(placement)];
                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Gmev.default), {
                            appear: true,
                            children: shouldRenderTooltipChildren && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fbN4n.default), {
                                distance: "constant",
                                entranceDirection: direction,
                                exitDirection: direction,
                                onFinish: onAnimationFinished,
                                duration: state !== 'show-immediate' ? 'medium' : 'none',
                                children: ({ className: className })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
                                        ref: ref,
                                        /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: `Tooltip ${className}`,
                                        style: {
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...style,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                            ...ignoreTooltipPointerEvents && {
                                                pointerEvents: 'none'
                                            }
                                        },
                                        truncate: truncate,
                                        placement: tooltipPosition,
                                        testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                                        onMouseOut: onMouseOut,
                                        onMouseOver: onMouseOverTooltip,
                                        children: typeof content === 'function' ? content({
                                            update: update
                                        }) : content
                                    })
                            })
                        });
                    }
                })
            }) : null
        ]
    });
}
$2ae62a4198135c38$var$Tooltip.displayName = 'Tooltip';
var $2ae62a4198135c38$export$2e2bcd8739ae039 = $2ae62a4198135c38$var$Tooltip;

});
parcelRegister("d5MPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c1d442097d9c62d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

function $5c1d442097d9c62d$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $c80cbc27df0b968e$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $c80cbc27df0b968e$export$390330c10ff2b9a1 = 'ArrowUp';
const $c80cbc27df0b968e$export$a80636c6f41931fe = 'ArrowDown';
const $c80cbc27df0b968e$export$4af703091671bc = 'Home';
const $c80cbc27df0b968e$export$e2bc30913faa5db7 = 'End';
const $c80cbc27df0b968e$export$10f6869ed0a7d75b = 'Tab';
const $c80cbc27df0b968e$export$8152f929a25a0ff4 = 'Enter';
const $c80cbc27df0b968e$export$e51a3576c045c8d5 = 'Space';
const $c80cbc27df0b968e$export$2bb790b9008907b4 = 'Escape';


parcelRegister("6Wgj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7e1329a573c982$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $3b7e1329a573c982$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("9HBUn", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $3702b1b3c1ac17fc$export$469bb693f11edc7f);

var $5uXOq = parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $86pCB = parcelRequire("86pCB");

var $6mqnT = parcelRequire("6mqnT");
function $3702b1b3c1ac17fc$export$469bb693f11edc7f({ isOpen: isOpen, onClose: onClose }) {
    const context = (0, $5uXOq.useContext)((0, $86pCB.OpenLayerObserverContext));
    const namespace = (0, $6mqnT.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) return;
        /**
		 * Increments the layer count when the component mounts or becomes visible.
		 *
		 * Returns a cleanup function to decrement the layer count when the component unmounts or becomes hidden.
		 */ if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function cleanup() {
            context.decrement();
        };
    }, [
        context,
        isOpen,
        namespace
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Registers the `onClose` callback with the OpenLayerObserver.
		 */ if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) return;
        if (context === null) return;
        if (!isOpen) /**
			 * If the layer is not open, we are not registering the `onClose` callback.
			 * This is important to prevent the `onClose` from being called for layers that
			 * are not open.
			 *
			 * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
			 * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
			 */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("86pCB", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", () => $7c895a70d853a445$export$5fbf4d7fae6cdc00);

var $5uXOq = parcelRequire("5uXOq");
const $7c895a70d853a445$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});

parcelRegister("6mqnT", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $7f351fa75bb05c41$export$1d57e79091cc3046);

var $5uXOq = parcelRequire("5uXOq");

var $ukFB3 = parcelRequire("ukFB3");
function $7f351fa75bb05c41$export$1d57e79091cc3046() {
    const namespace = (0, $5uXOq.useContext)((0, $ukFB3.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("ukFB3", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $8e0bfef96e0ca1b2$export$644a49f3b8c50fcd);

var $5uXOq = parcelRequire("5uXOq");
const $8e0bfef96e0ca1b2$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("gONMn", function(module, exports) {

$parcel$export(module.exports, "register", () => $516465184561645a$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $cBeZP = parcelRequire("cBeZP");
const $516465184561645a$var$registrations = new Set();
let $516465184561645a$var$cleanupEndEventListeners = null;
function $516465184561645a$var$onDragStart() {
    if ($516465184561645a$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $516465184561645a$var$cleanupEndEventListeners = (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragend',
            listener: $516465184561645a$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $516465184561645a$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $516465184561645a$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($516465184561645a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $516465184561645a$var$onDragEnd() {
    $516465184561645a$var$cleanupEndEventListeners?.();
    $516465184561645a$var$cleanupEndEventListeners = null;
    const clone = Array.from($516465184561645a$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $516465184561645a$var$bindStartEvents() {
    return (0, $cBeZP.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $516465184561645a$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $516465184561645a$var$onDragStart
        }
    ]);
}
let $516465184561645a$var$cleanupStartEventListeners = null;
function $516465184561645a$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$516465184561645a$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $516465184561645a$var$cleanupStartEventListeners = $516465184561645a$var$bindStartEvents();
    $516465184561645a$var$registrations.add(registration);
    /**
	 * The reasoning for this behavior is so that if a tooltip mounts during
	 * a drag it can still be suppressed.
	 *
	 * We use a separate callback instead of onDragStart to avoid infinite loops.
	 */ registration.onRegister({
        isDragging: $516465184561645a$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $516465184561645a$var$registrations.delete(registration);
        if ($516465184561645a$var$registrations.size === 0) {
            $516465184561645a$var$cleanupStartEventListeners?.();
            $516465184561645a$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("i10Hz", function(module, exports) {

$parcel$export(module.exports, "show", () => $0574f391895c4131$export$57bf213be019eeb0);

var $jmWF4 = parcelRequire("jmWF4");
let $0574f391895c4131$var$active = null;
function $0574f391895c4131$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($0574f391895c4131$var$active && $0574f391895c4131$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $jmWF4.clearScheduled)();
            $0574f391895c4131$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $jmWF4.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $jmWF4.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $jmWF4.scheduleTimeout)(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        const showImmediately = Boolean($0574f391895c4131$var$active && $0574f391895c4131$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($0574f391895c4131$var$active) {
            (0, $jmWF4.clearScheduled)();
            $0574f391895c4131$var$active.entry.hide({
                isImmediate: true
            });
            $0574f391895c4131$var$active.entry.done();
            $0574f391895c4131$var$active = null;
        }
        // this tooltip is now the active tooltip
        $0574f391895c4131$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $jmWF4.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("jmWF4", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", () => $74b06e011b0c5428$export$eaf678f6f93f5250);
$parcel$export(module.exports, "scheduleTimeout", () => $74b06e011b0c5428$export$5f4d6617421d489b);
let $74b06e011b0c5428$var$delayId = null;
function $74b06e011b0c5428$export$eaf678f6f93f5250() {
    if ($74b06e011b0c5428$var$delayId != null) {
        window.clearTimeout($74b06e011b0c5428$var$delayId);
        $74b06e011b0c5428$var$delayId = null;
    }
}
function $74b06e011b0c5428$export$5f4d6617421d489b(fn, delay) {
    $74b06e011b0c5428$export$eaf678f6f93f5250();
    $74b06e011b0c5428$var$delayId = window.setTimeout(()=>{
        $74b06e011b0c5428$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("N4N3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $44768f752df9a8f1$export$2e2bcd8739ae039);

var $lDwZR = parcelRequire("lDwZR");
function $44768f752df9a8f1$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $lDwZR.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("lDwZR", function(module, exports) {

$parcel$export(module.exports, "useId", () => $6a47c79edf97af2c$export$f680877a34711e37);
$parcel$export(module.exports, "IdProvider", () => $6a47c79edf97af2c$export$6be90bcb437e928f);
$parcel$export(module.exports, "useIdSeed", () => $6a47c79edf97af2c$export$6ee17796e3d70de2);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $khO3w = parcelRequire("khO3w");
// @ts-ignore - useId is not accessible in React 16
const $6a47c79edf97af2c$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useId ?? undefined;
function $6a47c79edf97af2c$export$f680877a34711e37() {
    if ($6a47c79edf97af2c$var$react18UseId && (0, $khO3w.fg)('platform-dst-react-18-use-id')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $6a47c79edf97af2c$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return `uid${(0, $22Gxp.useUID)()}`;
}
const $6a47c79edf97af2c$export$6be90bcb437e928f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$6a47c79edf97af2c$export$f680877a34711e37()}${postfix}`;
    (0, $5uXOq.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $6a47c79edf97af2c$export$6ee17796e3d70de2() {
    if ($6a47c79edf97af2c$var$react18UseId && (0, $khO3w.fg)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const uid = $6a47c79edf97af2c$var$react18UseId();
        return (id)=>`${uid}-${id.toString()}`;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $22Gxp.useUIDSeed)();
}

});


parcelRegister("9r1u8", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ed08fa623fe45e$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fl93h = parcelRequire("fl93h");
const $98ed08fa623fe45e$var$baseStyles = null;
const $98ed08fa623fe45e$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $98ed08fa623fe45e$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fl93h.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkgkf6 _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        children: children
    });
});
$98ed08fa623fe45e$var$TooltipContainer.displayName = 'TooltipContainer';
var $98ed08fa623fe45e$export$2e2bcd8739ae039 = $98ed08fa623fe45e$var$TooltipContainer;

});
parcelRegister("fl93h", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d3eb7f9391ad4a9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iknrn = parcelRequire("iknrn");
const $6d3eb7f9391ad4a9$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
const $6d3eb7f9391ad4a9$var$primitiveStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    zindex: `var(${$6d3eb7f9391ad4a9$var$VAR_PRIMITIVE_ZINDEX})`,
    cursor: `default`
});
/**
 * The lower level component for rendering a tooltip.
 */ const $6d3eb7f9391ad4a9$var$TooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
    const styleWithZIndex = {
        ...style,
        [$6d3eb7f9391ad4a9$var$VAR_PRIMITIVE_ZINDEX]: (0, $iknrn.layers).tooltip()
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: styleWithZIndex,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line jsx-a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        css: $6d3eb7f9391ad4a9$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$6d3eb7f9391ad4a9$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $6d3eb7f9391ad4a9$export$2e2bcd8739ae039 = $6d3eb7f9391ad4a9$var$TooltipPrimitive;

});


parcelRegister("fRw6u", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", () => $86d033fe8fdc6ce5$export$642213d516a9b928);
function $86d033fe8fdc6ce5$export$642213d516a9b928(mouseCoordinates) {
    const safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    const getBoundingClientRect = ()=>({
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        });
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("henai", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a830fc1a129639$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $jmVNy = parcelRequire("jmVNy");

var $h6LYg = parcelRequire("h6LYg");

var $kTRe2 = parcelRequire("kTRe2");

var $lDwZR = parcelRequire("lDwZR");

var $khO3w = parcelRequire("khO3w");

var $b1nnO = parcelRequire("b1nnO");

var $dqnDV = parcelRequire("dqnDV");

var $8IgIP = parcelRequire("8IgIP");

var $7EAkm = parcelRequire("7EAkm");

var $4vN53 = parcelRequire("4vN53");
const $37a830fc1a129639$var$LOADING_LABEL = ', Loading';
const $37a830fc1a129639$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1caa _syaz1lh4 _aetrglyw _irr31caa _30l31lh4 _1di61caa _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhk1w7a _y4ti12x7 _bozg12x7"
};
const $37a830fc1a129639$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $37a830fc1a129639$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $37a830fc1a129639$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $37a830fc1a129639$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $37a830fc1a129639$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $37a830fc1a129639$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $37a830fc1a129639$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $37a830fc1a129639$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $5uXOq.useRef)(null);
    const splitButtonContext = (0, $8IgIP.useSplitButtonContext)();
    const loadingLabelId = (0, $lDwZR.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $khO3w.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $kTRe2.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1nnO.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $h6LYg.default)([
            localRef,
            ref
        ]),
        xcss: (0, $jmVNy.cx)($37a830fc1a129639$var$styles.base, appearance === 'default' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $37a830fc1a129639$var$defaultStyles.rootRefreshed : $37a830fc1a129639$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $37a830fc1a129639$var$defaultStyles.interactiveRefreshed : $37a830fc1a129639$var$defaultStyles.interactive), appearance === 'primary' && $37a830fc1a129639$var$primaryStyles.root, appearance === 'primary' && isInteractive && $37a830fc1a129639$var$primaryStyles.interactive, appearance === 'warning' && $37a830fc1a129639$var$warningStyles.root, appearance === 'warning' && isInteractive && $37a830fc1a129639$var$warningStyles.interactive, appearance === 'danger' && $37a830fc1a129639$var$dangerStyles.root, appearance === 'danger' && isInteractive && $37a830fc1a129639$var$dangerStyles.interactive, appearance === 'discovery' && $37a830fc1a129639$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $37a830fc1a129639$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $37a830fc1a129639$var$subtleStyles.rootRefreshed : $37a830fc1a129639$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $37a830fc1a129639$var$subtleStyles.interactiveRefreshed : $37a830fc1a129639$var$subtleStyles.interactive), $37a830fc1a129639$var$styles.linkDecorationUnset, isSelected && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $37a830fc1a129639$var$selectedStyles.rootRefreshed : $37a830fc1a129639$var$selectedStyles.root), isSelected && isSplitButton && $37a830fc1a129639$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $37a830fc1a129639$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $37a830fc1a129639$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $37a830fc1a129639$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $37a830fc1a129639$var$selectedStyles.discovery, isDisabled && $37a830fc1a129639$var$styles.disabled, isCircle && !isSplitButton && $37a830fc1a129639$var$styles.circle, spacing === 'compact' && $37a830fc1a129639$var$styles.spacingCompact, hasIconBefore && $37a830fc1a129639$var$styles.buttonIconBefore, shouldFitContainer && $37a830fc1a129639$var$styles.fullWidth, hasIconAfter && $37a830fc1a129639$var$styles.buttonIconAfter, isIconButton && $37a830fc1a129639$var$styles.iconButton, isIconButton && spacing === 'compact' && $37a830fc1a129639$var$styles.iconButtonCompact, isLoading && $37a830fc1a129639$var$styles.loading, isSplitButton && $37a830fc1a129639$var$styles.splitButton, isNavigationSplitButton && $37a830fc1a129639$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$37a830fc1a129639$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $7EAkm.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8IgIP.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    className: (0, $bwpsq.default)([
                        $37a830fc1a129639$var$styles.loadingOverlay
                    ]),
                    children: (0, $4vN53.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                    id: loadingLabelId,
                    children: $37a830fc1a129639$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $37a830fc1a129639$export$2e2bcd8739ae039 = $37a830fc1a129639$var$ButtonBase;

});
parcelRegister("8IgIP", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", () => $1443c3440857a401$export$4b86304b2c0d7e71);
$parcel$export(module.exports, "useSplitButtonContext", () => $1443c3440857a401$export$47e2c6fdb142d947);

var $5uXOq = parcelRequire("5uXOq");
const $1443c3440857a401$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $1443c3440857a401$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $5uXOq.useContext)($1443c3440857a401$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("7EAkm", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a373121f0f8598$export$2e2bcd8739ae039);
function $50a373121f0f8598$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $50a373121f0f8598$var$tabKeyCode = 9;
function $50a373121f0f8598$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $50a373121f0f8598$var$tabKeyCode) return;
    $50a373121f0f8598$var$abort(event);
}
function $50a373121f0f8598$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $50a373121f0f8598$var$abort,
        onMouseUpCapture: $50a373121f0f8598$var$abort,
        onKeyDownCapture: $50a373121f0f8598$var$onKey,
        onKeyUpCapture: $50a373121f0f8598$var$onKey,
        onTouchStartCapture: $50a373121f0f8598$var$abort,
        onTouchEndCapture: $50a373121f0f8598$var$abort,
        onPointerDownCapture: $50a373121f0f8598$var$abort,
        onPointerUpCapture: $50a373121f0f8598$var$abort,
        onClickCapture: $50a373121f0f8598$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $50a373121f0f8598$var$abort
    } : events;
}

});

parcelRegister("4vN53", function(module, exports) {

$parcel$export(module.exports, "default", () => $0742b0ab838463a5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bYK7l = parcelRequire("bYK7l");
function $0742b0ab838463a5$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $0742b0ab838463a5$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $0742b0ab838463a5$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bYK7l.default), {
        size: $0742b0ab838463a5$var$getIconSpacing(spacing),
        appearance: $0742b0ab838463a5$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("fq4Zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6e5b228f08ba2b$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $3b6e5b228f08ba2b$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $3b6e5b228f08ba2b$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $3b6e5b228f08ba2b$var$styles.common,
            type === 'text' && $3b6e5b228f08ba2b$var$styles.text,
            type === 'icon' && $3b6e5b228f08ba2b$var$styles.icon,
            isLoading && $3b6e5b228f08ba2b$var$styles.fade,
            position === 'before' && $3b6e5b228f08ba2b$var$styles.beforeIcon,
            position === 'after' && $3b6e5b228f08ba2b$var$styles.afterIcon
        ]),
        children: children
    });
};
var $3b6e5b228f08ba2b$export$2e2bcd8739ae039 = $3b6e5b228f08ba2b$var$Content;

});

parcelRegister("l8tgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $32d892444b45a552$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
function $32d892444b45a552$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $32d892444b45a552$var$IconRenderer = ({ icon: Icon })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: $32d892444b45a552$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: "",
            color: 'currentColor'
        })
    });
};
var $32d892444b45a552$export$2e2bcd8739ae039 = $32d892444b45a552$var$IconRenderer;

});



parcelRegister("5oKDN", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $af57e8052fd90c5a$export$33ffd74ebf07f060);

var $5uXOq = parcelRequire("5uXOq");

var $3U7bF = parcelRequire("3U7bF");
const $af57e8052fd90c5a$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $5uXOq.useContext)((0, $3U7bF.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});
parcelRegister("3U7bF", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $209c658d84e1b804$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ScrollContext", () => $209c658d84e1b804$export$dece24112a937f92);

var $5uXOq = parcelRequire("5uXOq");
const $209c658d84e1b804$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $209c658d84e1b804$export$dece24112a937f92 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});



parcelRegister("hBjV7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8cb311418f7eaeb2$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4sTj2 = parcelRequire("4sTj2");

var $cAvVA = parcelRequire("cAvVA");

var $5oKDN = parcelRequire("5oKDN");
const $8cb311418f7eaeb2$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
const $8cb311418f7eaeb2$var$iconStyles = null;
const $8cb311418f7eaeb2$var$titleStyles = null;
const $8cb311418f7eaeb2$var$textStyles = null;
const $8cb311418f7eaeb2$var$truncatedTextStyles = null;
const $8cb311418f7eaeb2$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($4sTj2))) : (0, (/*@__PURE__*/$parcel$interopDefault($cAvVA)));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
            label: appearance,
            color: $8cb311418f7eaeb2$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $8cb311418f7eaeb2$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $5oKDN.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $2OMIu.jsx)($8cb311418f7eaeb2$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $8cb311418f7eaeb2$export$2e2bcd8739ae039 = $8cb311418f7eaeb2$var$ModalTitle;

});

parcelRegister("loUTB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $73f69bea05e9c2d3$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $2alJM = parcelRequire("2alJM");

var $khO3w = parcelRequire("khO3w");

var $5oKDN = parcelRequire("5oKDN");

var $44JOF = parcelRequire("44JOF");

var $5lx6W = parcelRequire("5lx6W");
const $73f69bea05e9c2d3$var$bodyStyles = null;
const $73f69bea05e9c2d3$var$fontStyles = null;
/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */ const $73f69bea05e9c2d3$var$bodyScrollStyles = null;
/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */ const $73f69bea05e9c2d3$var$viewportScrollStyles = null;
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $73f69bea05e9c2d3$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $5oKDN.useModal)();
    const shouldScrollInViewport = (0, $5lx6W.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            "_18zr1ejb",
            (0, $khO3w.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44JOF.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                "data-testid": testId,
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug",
                    "_1rjc1bk5 _18zr1ejb",
                    (0, $khO3w.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
                ]),
                children: children
            })
        })
    });
};
var $73f69bea05e9c2d3$export$2e2bcd8739ae039 = $73f69bea05e9c2d3$var$ModalBody;

});
parcelRegister("44JOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7049209744b8923e$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $h6LYg = parcelRequire("h6LYg");

var $jp7wN = parcelRequire("jp7wN");

var $cAB5B = parcelRequire("cAB5B");

var $dqeuE = parcelRequire("dqeuE");
const $7049209744b8923e$var$keylineColor = "var(--ds-border, #091E4224)";
const $7049209744b8923e$var$baseStyles = null;
const $7049209744b8923e$var$keylineHeight = 2;
const $7049209744b8923e$var$topKeylineStyles = null;
const $7049209744b8923e$var$bottomKeylineStyles = null;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $7049209744b8923e$var$ScrollContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5uXOq.useEffect)(()=>{
        const schedule = (0, $7nRxN.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $cAB5B.default)((0, $7nRxN.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $7049209744b8923e$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $7049209744b8923e$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $5uXOq.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $cBeZP.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $jp7wN.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqeuE.default), {
        isInset: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            // tabindex is allowed here so that keyboard users can scroll content
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, $h6LYg.default)([
                ref,
                scrollableRef
            ]),
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
                showTopKeyline && "_mqm2v2xi",
                showBottomKeyline && "_179rv2xi"
            ]),
            children: children
        })
    });
});
$7049209744b8923e$var$ScrollContainer.displayName = 'ScrollContainer';
var $7049209744b8923e$export$2e2bcd8739ae039 = $7049209744b8923e$var$ScrollContainer;

});
parcelRegister("cAB5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81d57822af845d9$export$2e2bcd8739ae039);

var $1BWFr = parcelRequire("1BWFr");
function $b81d57822af845d9$export$2e2bcd8739ae039(callback) {
    const ref = (0, $1BWFr.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("1BWFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $70435478b9c3d245$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $70435478b9c3d245$var$uniqueReferencedValue = {};
function $70435478b9c3d245$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $5uXOq.useRef)($70435478b9c3d245$var$uniqueReferencedValue);
    if (ref.current === $70435478b9c3d245$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});



parcelRegister("5lx6W", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffa640ac53ca4cdd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3U7bF = parcelRequire("3U7bF");
function $ffa640ac53ca4cdd$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $5uXOq.useContext)((0, $3U7bF.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("19Isv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1036d507ff980912$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5oKDN = parcelRequire("5oKDN");
const $1036d507ff980912$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $1036d507ff980912$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $5oKDN.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1ezb _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $1036d507ff980912$export$2e2bcd8739ae039 = $1036d507ff980912$var$ModalFooter;

});

parcelRegister("slv6L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::182e7300aed0f8931ea6d6a6afcdcbad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05534b3d54b1a351$var$_react = $05534b3d54b1a351$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $05534b3d54b1a351$var$_page = $05534b3d54b1a351$var$_interopRequireDefault((parcelRequire("bTT6v")));

var $05534b3d54b1a351$var$_page2 = $05534b3d54b1a351$var$_interopRequireDefault((parcelRequire("j9fpA")));
function $05534b3d54b1a351$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "PageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05534b3d54b1a351$var$PageIcon = (props)=>/*#__PURE__*/ $05534b3d54b1a351$var$_react.default.createElement($05534b3d54b1a351$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $05534b3d54b1a351$var$_page2.default
    }, props));
$05534b3d54b1a351$var$PageIcon.Name = 'PageIconMigration';
var $05534b3d54b1a351$var$_default = module.exports.default = $05534b3d54b1a351$var$PageIcon;

});

parcelRegister("5PDwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b45e518b48d5990d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9Gmev = parcelRequire("9Gmev");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $b45e518b48d5990d$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Gmev.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $b45e518b48d5990d$export$2e2bcd8739ae039 = $b45e518b48d5990d$var$ModalTransition;

});

parcelRegister("9ywyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7de381103f3c337$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jmVNy = parcelRequire("jmVNy");

var $khO3w = parcelRequire("khO3w");

var $g8Dn0 = parcelRequire("g8Dn0");
var $lL6cf = parcelRequire("lL6cf");
const $b7de381103f3c337$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b18uv _4fpr8stv _5goinqa1 _f8pj14q2 _9oik18uv _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm18uv _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu18uv _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b18uv _4fprglyw _5goinqa1 _f8pj1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu18uv _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b18uv _4fpr8stv _5goinqa1 _f8pj15cr _9oik18uv _1bnxglyw _jf4cnqa1 _30l315cr _1nrm18uv _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n4jp4b _kqswh2mm _152ttb3r"
};
const $b7de381103f3c337$var$iconStyles = null;
const $b7de381103f3c337$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8Dn0.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: (0, $jmVNy.cx)(appearance === 'default' && $b7de381103f3c337$var$styles.defaultAppearance, appearance === 'subtle' && $b7de381103f3c337$var$styles.subtleAppearance, appearance === 'inverse' && $b7de381103f3c337$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $b7de381103f3c337$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lL6cf.default), {
                as: "span",
                xcss: $b7de381103f3c337$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $khO3w.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $bwpsq.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $b7de381103f3c337$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)($b7de381103f3c337$var$LinkWithoutRef);
var $b7de381103f3c337$export$2e2bcd8739ae039 = $b7de381103f3c337$var$Link;

});
parcelRegister("g8Dn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded5489df9d1f256$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $3joPi = parcelRequire("3joPi");

var $2Kcun = parcelRequire("2Kcun");

var $lpIMO = parcelRequire("lpIMO");

var $jp7wN = parcelRequire("jp7wN");

var $lDwZR = parcelRequire("lDwZR");

var $d1YtU = parcelRequire("d1YtU");

var $dqnDV = parcelRequire("dqnDV");

var $aSR2y = parcelRequire("aSR2y");
const $ded5489df9d1f256$var$styles = {
    root: "_4bfu18uv _1hms8stv _ajmmnqa1 _vchhusvi"
};
const $ded5489df9d1f256$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ded5489df9d1f256$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $ded5489df9d1f256$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $jp7wN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lDwZR.useId)();
    const onClick = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $lpIMO.default)();
    const isExternal = typeof href === 'string' && $ded5489df9d1f256$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ded5489df9d1f256$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $aSR2y.default // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $DEWI6.cx)($ded5489df9d1f256$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $ded5489df9d1f256$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($ded5489df9d1f256$var$AnchorNoRef);
var $ded5489df9d1f256$export$2e2bcd8739ae039 = $ded5489df9d1f256$var$Anchor;

});
parcelRegister("lpIMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5b345a79e222f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6AhdF = parcelRequire("6AhdF");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $e4c5b345a79e222f$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $5uXOq.useContext)((0, $6AhdF.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
};
var $e4c5b345a79e222f$export$2e2bcd8739ae039 = $e4c5b345a79e222f$var$useRouterLink;

});
parcelRegister("6AhdF", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", () => $b0c07149c9ee9265$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $b0c07149c9ee9265$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $b0c07149c9ee9265$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $5uXOq.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b0c07149c9ee9265$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b0c07149c9ee9265$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $b0c07149c9ee9265$export$2e2bcd8739ae039 = $b0c07149c9ee9265$var$RouterLinkProvider;

});




parcelRegister("7ogii", function(module, exports) {

$parcel$export(module.exports, "default", () => $5497d0be0e286634$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $lL6cf = parcelRequire("lL6cf");
var $cuCEQ = parcelRequire("cuCEQ");

const $5497d0be0e286634$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $5497d0be0e286634$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $5497d0be0e286634$var$textStyles = {
    root: "_11c82smr _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _593818uv _7hxb18uv _9m7f18uv _rfqo18uv _qfs118uv _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $5497d0be0e286634$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $5497d0be0e286634$var$tokenBackgroundColors = {
    warning: `var(--ds-background-warning-bold, ${(0, $3568e170f1ea17d7$export$c6930421db9fa514)})`,
    error: `var(--ds-background-danger-bold, ${(0, $3568e170f1ea17d7$export$2010d0fb4295b346)})`,
    announcement: `var(--ds-background-neutral-bold, ${(0, $3568e170f1ea17d7$export$c39c0fe0f26207ae)})`
};
const $5497d0be0e286634$var$tokenTextColors = {
    warning: `var(--ds-text-warning-inverse, ${(0, $3568e170f1ea17d7$export$ad0bacf983b7ddaa)})`,
    error: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
    announcement: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`
};
const $5497d0be0e286634$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $5497d0be0e286634$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $5497d0be0e286634$var$Banner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $5497d0be0e286634$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
        xcss: $5497d0be0e286634$var$containerStyles.root,
        backgroundColor: $5497d0be0e286634$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cuCEQ.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $5497d0be0e286634$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
                    as: "span",
                    xcss: $5497d0be0e286634$var$iconWrapperStyles.root,
                    style: {
                        fill: $5497d0be0e286634$var$tokenBackgroundColors[appearanceType],
                        color: $5497d0be0e286634$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: {
                        [$5497d0be0e286634$var$CSS_VAR_TEXT_COLOR]: $5497d0be0e286634$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $bwpsq.default)([
                        $5497d0be0e286634$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $5497d0be0e286634$export$2e2bcd8739ae039 = $5497d0be0e286634$var$Banner;

});

parcelRegister("erWS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9158fe61b401d088$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $2Kcun = parcelRequire("2Kcun");

var $jp7wN = parcelRequire("jp7wN");

var $9rqOj = parcelRequire("9rqOj");
var $3n0aQ = parcelRequire("3n0aQ");

var $khO3w = parcelRequire("khO3w");

var $3sau9 = parcelRequire("3sau9");
var $8hN1h = parcelRequire("8hN1h");
var $d5yM6 = parcelRequire("d5yM6");

var $3NjBD = parcelRequire("3NjBD");

var $HEllr = parcelRequire("HEllr");
const $9158fe61b401d088$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $9158fe61b401d088$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $9158fe61b401d088$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $3n0aQ.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $3n0aQ.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {});
};
const $9158fe61b401d088$var$InlineDialog = /*#__PURE__*/ (0, $5uXOq.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $jp7wN.default), onContentClick: onContentClick = (0, $jp7wN.default), onContentFocus: onContentFocus = (0, $jp7wN.default), onClose: providedOnClose = (0, $jp7wN.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $5uXOq.useRef)(null);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const onClose = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $5uXOq.useRef)(onClose);
    (0, $5uXOq.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $5uXOq.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($9158fe61b401d088$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hN1h.Popper), {
        placement: placement,
        strategy: strategy,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $HEllr.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3sau9.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d5yM6.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3NjBD.default), {
                        innerRef: (node)=>{
                            triggerRef.current = node;
                            if (typeof ref === 'function') ref(node);
                            else ref.current = node;
                        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                        },
                        hasNodeResolver: !(0, $khO3w.fg)('platform_design_system_team_portal_logic_r18_fix'),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9rqOj.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $2OMIu.jsx)($9158fe61b401d088$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9158fe61b401d088$export$2e2bcd8739ae039 = $9158fe61b401d088$var$InlineDialog;

});
parcelRegister("9rqOj", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $553a851f1081e4ef$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $553a851f1081e4ef$export$48b383b280e20440);
$parcel$export(module.exports, "Layering", () => $553a851f1081e4ef$export$7c885f891c940977);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");

var $khO3w = parcelRequire("khO3w");
const $553a851f1081e4ef$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
const $553a851f1081e4ef$export$48b383b280e20440 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $jp7wN.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $553a851f1081e4ef$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)($553a851f1081e4ef$export$48b383b280e20440);
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const id = (0, $5uXOq.useRef)((0, $khO3w.fg)('layering-top-level-use-array') ? Math.random().toString(36) : '');
    if (!(0, $khO3w.fg)('layering-top-level-use-array')) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    if (!(0, $khO3w.fg)('layering-top-level-use-array')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    if ((0, $khO3w.fg)('layering-top-level-use-array')) // Remove eslint error on FG cleanup
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const safeLayerList = layerList?.current;
        const safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return ()=>{
            const index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($553a851f1081e4ef$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel,
        children: children
    });
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $553a851f1081e4ef$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $5uXOq.useRef)(0);
    const layerList = (0, $5uXOq.useRef)([]);
    const value = (0, $5uXOq.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            },
            ...(0, $khO3w.fg)('layering-top-level-use-array') ? {
                layerList: layerList
            } : {}
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($553a851f1081e4ef$export$48b383b280e20440.Provider, {
        value: value,
        children: children
    });
};
const $553a851f1081e4ef$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $5uXOq.useContext)($553a851f1081e4ef$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)($553a851f1081e4ef$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $2OMIu.jsx)($553a851f1081e4ef$var$LayeringProvider, {
        children: content
    });
};

});

parcelRegister("3n0aQ", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $8e5f924779c8e415$export$4a4bf067ea9e7886);
$parcel$export(module.exports, "useLayering", () => $8e5f924779c8e415$export$c8b4d54e03dee6ed);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $khO3w = parcelRequire("khO3w");

var $9rqOj = parcelRequire("9rqOj");
const $8e5f924779c8e415$var$ESCAPE = 'Escape';
function $8e5f924779c8e415$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $5uXOq.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $8e5f924779c8e415$export$c8b4d54e03dee6ed();
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $8e5f924779c8e415$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $5uXOq.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $8e5f924779c8e415$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $5uXOq.useContext)((0, $9rqOj.LevelContext));
    const { topLevelRef: topLevelRef, layerList: layerList } = (0, $5uXOq.useContext)((0, $9rqOj.TopLevelContext));
    const isLayerDisabled = (0, $5uXOq.useCallback)(()=>{
        if ((0, $khO3w.fg)('layering-top-level-use-array')) return (layerList?.current?.length ?? 0) !== currentLevel;
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef,
        layerList
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        ...(0, $khO3w.fg)('layering-top-level-use-array') ? {
            layerList: layerList
        } : {}
    };
}

});

parcelRegister("3NjBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c8d53c472c45dac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $8c8d53c472c45dac$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: (node)=>{
            innerRef(node?.firstElementChild);
        },
        children: children
    });
};
var $8c8d53c472c45dac$export$2e2bcd8739ae039 = $8c8d53c472c45dac$var$NodeResolverWrapper;

});

parcelRegister("HEllr", function(module, exports) {

$parcel$export(module.exports, "Container", () => $5769d29c08ad895c$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $5769d29c08ad895c$var$CSS_THEME_BACKGROUND = '--theme-background';
const $5769d29c08ad895c$var$CSS_THEME_COLOR = '--theme-color';
const $5769d29c08ad895c$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $5769d29c08ad895c$var$containerStyles = null;
const $5769d29c08ad895c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$5769d29c08ad895c$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            [$5769d29c08ad895c$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $3568e170f1ea17d7$export$fbda843f0a27fe96)})`,
            [$5769d29c08ad895c$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $3568e170f1ea17d7$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $3568e170f1ea17d7$export$d2d3bedfb276cac0)}`})`,
            ...style
        },
        className: (0, $bwpsq.default)([
            "_11q7gluh _2rko1sit _vchh18uv _p12flti4 _c71llti4 _1pbyowjs _16qs1r44 _syazjslb _85i5pxbi _1q51pxbi _y4ti1ejb _bozg1ejb _nt751r31 _49pcglyw _1hvw1o36"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});


parcelRegister("5HgTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bcd9d19a4757ff8$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ao4Ml = parcelRequire("ao4Ml");

var $2alJM = parcelRequire("2alJM");

var $2Kcun = parcelRequire("2Kcun");

var $gv6Px = parcelRequire("gv6Px");

var $jp7wN = parcelRequire("jp7wN");

var $9rqOj = parcelRequire("9rqOj");

var $fbN4n = parcelRequire("fbN4n");

var $dmUF2 = parcelRequire("dmUF2");

var $iknrn = parcelRequire("iknrn");

var $dbZCR = parcelRequire("dbZCR");

var $aSbkJ = parcelRequire("aSbkJ");

var $i8hzI = parcelRequire("i8hzI");
const $9bcd9d19a4757ff8$var$fillScreenStyles = null;
const $9bcd9d19a4757ff8$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
     // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; /**
    * __Modal wrapper__
    *
    * A modal wrapper displays content that requires user interaction, in a layer above the page.
    * This component is primary container for other modal components.
    *
    * - [Examples](https://atlassian.design/components/modal-dialog/examples)
    * - [Code](https://atlassian.design/components/modal-dialog/code)
    * - [Usage](https://atlassian.design/components/modal-dialog/usage)
    */ 
const $9bcd9d19a4757ff8$var$ModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $jp7wN.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
    const calculatedStackIndex = (0, $aSbkJ.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $jp7wN.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $5uXOq.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $5uXOq.useCallback)((element)=>$9bcd9d19a4757ff8$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $i8hzI.default)();
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gv6Px.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dbZCR.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9rqOj.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dmUF2.default), {
            zIndex: (0, $iknrn.layers).modal(),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fbN4n.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $bwpsq.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2alJM.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $9bcd9d19a4757ff8$export$2e2bcd8739ae039 = $9bcd9d19a4757ff8$var$ModalWrapper;

});
parcelRegister("gv6Px", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eb0b587d76e476e$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2Kcun = parcelRequire("2Kcun");

var $jp7wN = parcelRequire("jp7wN");
const $1eb0b587d76e476e$var$packageName = "platform-pkg";
const $1eb0b587d76e476e$var$packageVersion = "0.0.0-use.local";
const $1eb0b587d76e476e$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $1eb0b587d76e476e$var$packageName,
    packageVersion: $1eb0b587d76e476e$var$packageVersion
};
const $1eb0b587d76e476e$var$baseStyles = null;
const $1eb0b587d76e476e$var$shouldAllowClickThroughStyles = null;
const $1eb0b587d76e476e$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $1eb0b587d76e476e$var$Blanket = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $jp7wN.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $5uXOq.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$1eb0b587d76e476e$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $5uXOq.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $5uXOq.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhku5cu _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk18uv"
        ]),
        children: children
    });
}));
$1eb0b587d76e476e$var$Blanket.displayName = 'Blanket';
var $1eb0b587d76e476e$export$2e2bcd8739ae039 = $1eb0b587d76e476e$var$Blanket;

});

parcelRegister("dbZCR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37a5968e57cbba8$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h6LYg = parcelRequire("h6LYg");

var $kTRe2 = parcelRequire("kTRe2");

var $lDwZR = parcelRequire("lDwZR");

var $3n0aQ = parcelRequire("3n0aQ");

var $fbN4n = parcelRequire("fbN4n");

var $4Yk3s = parcelRequire("4Yk3s");

var $3U7bF = parcelRequire("3U7bF");

var $6JUXI = parcelRequire("6JUXI");

var $iGrjn = parcelRequire("iGrjn");

var $i3KLs = parcelRequire("i3KLs");

var $5knB0 = parcelRequire("5knB0");

var $613wb = parcelRequire("613wb");

var $htb4h = parcelRequire("htb4h");
const $c37a5968e57cbba8$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $c37a5968e57cbba8$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _epkx1sit _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r"
};
const $c37a5968e57cbba8$var$viewportScrollStyles = null;
const $c37a5968e57cbba8$var$bodyScrollStyles = null;
const $c37a5968e57cbba8$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId } = props;
    const id = (0, $lDwZR.useId)();
    const titleId = `modal-dialog-title-${id}`;
    (0, $5uXOq.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $4Yk3s.combine)((0, $iGrjn.disableDraggingToCrossOriginIFramesForElement)(), (0, $5knB0.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $i3KLs.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $kTRe2.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $6JUXI.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $5uXOq.useMemo)(()=>({
            testId: testId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose
        }), [
        testId,
        titleId,
        onClose,
        hasProvidedOnClose
    ]);
    (0, $3n0aQ.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $3n0aQ.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htb4h.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3U7bF.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3U7bF.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fbN4n.default), {
                    entranceDirection: "bottom",
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $h6LYg.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $613wb.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $613wb.dialogHeight)(height)
                            },
                            className: (0, $bwpsq.default)([
                                $c37a5968e57cbba8$var$dialogStyles.root,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": testId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c37a5968e57cbba8$export$2e2bcd8739ae039 = $c37a5968e57cbba8$var$ModalDialog;

});
parcelRegister("6JUXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $397ba9138512d0ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $397ba9138512d0ac$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $5uXOq.useRef)(null);
    const onMotionFinish = (0, $5uXOq.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("iGrjn", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $7a517135a0480d4c$export$ec28e97c7d8b1b35);

var $cBeZP = parcelRequire("cBeZP");

var $4Yk3s = parcelRequire("4Yk3s");

var $jDeIq = parcelRequire("jDeIq");

var $8Jltf = parcelRequire("8Jltf");
function $7a517135a0480d4c$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $jDeIq.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $4Yk3s.combine)(unbindEvents, unbindMonitor);
}
function $7a517135a0480d4c$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $7a517135a0480d4c$var$api = (0, $8Jltf.makeFixForAdapter)({
    watchForInteractionStart: $7a517135a0480d4c$var$watchForInteractionStart,
    watchForInteractionEnd: $7a517135a0480d4c$var$watchForInteractionEnd
});
function $7a517135a0480d4c$export$ec28e97c7d8b1b35() {
    return $7a517135a0480d4c$var$api.registerUsage();
}

});
parcelRegister("8Jltf", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", () => $24ea25bd7f8a5a6e$export$a74bff2507e6126b);

var $4Yk3s = parcelRequire("4Yk3s");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $24ea25bd7f8a5a6e$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $24ea25bd7f8a5a6e$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $24ea25bd7f8a5a6e$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$24ea25bd7f8a5a6e$var$hasSameOrigin(window.location.href, iframe.src);
}
const $24ea25bd7f8a5a6e$var$registry = new Map();
function $24ea25bd7f8a5a6e$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($24ea25bd7f8a5a6e$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $24ea25bd7f8a5a6e$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $24ea25bd7f8a5a6e$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $24ea25bd7f8a5a6e$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $24ea25bd7f8a5a6e$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $4Yk3s.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $24ea25bd7f8a5a6e$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $24ea25bd7f8a5a6e$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("i3KLs", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $01447a92ef8ce5d1$export$27d79116d3a4e7d5);

var $hqKj2 = parcelRequire("hqKj2");

var $8Jltf = parcelRequire("8Jltf");
function $01447a92ef8ce5d1$var$watchForInteractionStart({ start: start }) {
    return (0, $hqKj2.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $01447a92ef8ce5d1$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $hqKj2.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $01447a92ef8ce5d1$var$api = (0, $8Jltf.makeFixForAdapter)({
    watchForInteractionStart: $01447a92ef8ce5d1$var$watchForInteractionStart,
    watchForInteractionEnd: $01447a92ef8ce5d1$var$watchForInteractionEnd
});
function $01447a92ef8ce5d1$export$27d79116d3a4e7d5() {
    return $01447a92ef8ce5d1$var$api.registerUsage();
}

});

parcelRegister("5knB0", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $2a8f8af8cd98d9d6$export$9c0606fcefb5d1e2);

var $cBeZP = parcelRequire("cBeZP");

var $4Yk3s = parcelRequire("4Yk3s");

var $9IZ5X = parcelRequire("9IZ5X");

var $8Jltf = parcelRequire("8Jltf");
function $2a8f8af8cd98d9d6$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $cBeZP.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $9IZ5X.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $4Yk3s.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $2a8f8af8cd98d9d6$var$watchForInteractionStart({ start: start }) {
    return (0, $cBeZP.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $2a8f8af8cd98d9d6$var$api = (0, $8Jltf.makeFixForAdapter)({
    watchForInteractionStart: $2a8f8af8cd98d9d6$var$watchForInteractionStart,
    watchForInteractionEnd: $2a8f8af8cd98d9d6$var$watchForInteractionEnd
});
function $2a8f8af8cd98d9d6$export$9c0606fcefb5d1e2() {
    return $2a8f8af8cd98d9d6$var$api.registerUsage();
}

});

parcelRegister("613wb", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", () => $875b39454dbbc36f$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogHeight", () => $875b39454dbbc36f$export$ceba93bf0bdd16f2);
const $875b39454dbbc36f$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $875b39454dbbc36f$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = $875b39454dbbc36f$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${$875b39454dbbc36f$export$7e3df82ee760448c.widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $875b39454dbbc36f$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("htb4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c18faefc65daf70$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8xP8U = parcelRequire("8xP8U");
const $4c18faefc65daf70$var$gutter = 60;
const $4c18faefc65daf70$var$maxWidthDimensions = `calc(100vw - ${$4c18faefc65daf70$var$gutter * 2}px)`;
const $4c18faefc65daf70$var$maxHeightDimensions = `calc(100vh - ${$4c18faefc65daf70$var$gutter * 2 - 1}px)`;
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $4c18faefc65daf70$var$positionerStyles = null;
const $4c18faefc65daf70$var$viewportScrollStyles = null;
const $4c18faefc65daf70$var$bodyScrollStyles = null;
const $4c18faefc65daf70$var$stackTransitionStyles = null;
const $4c18faefc65daf70$var$stackTransformStyles = null;
const $4c18faefc65daf70$var$stackIdleStyles = null;
const $4c18faefc65daf70$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $8xP8U.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $bd0d8a12aecb8cfa$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            shouldScrollInViewport ? "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw" : "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw"
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4c18faefc65daf70$export$2e2bcd8739ae039 = $4c18faefc65daf70$var$Positioner;

});
const $bd0d8a12aecb8cfa$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $bd0d8a12aecb8cfa$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $bd0d8a12aecb8cfa$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';



parcelRegister("aSbkJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $586a5b8a0b5a8379$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cAB5B = parcelRequire("cAB5B");

var $kpUo7 = parcelRequire("kpUo7");

var $9MvCQ = parcelRequire("9MvCQ");

var $9Gmev = parcelRequire("9Gmev");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $586a5b8a0b5a8379$var$modalStackRegister = [];
function $586a5b8a0b5a8379$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $9Gmev.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $9MvCQ.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $kpUo7.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $cAB5B.default)(()=>{
        const newStackIndex = $586a5b8a0b5a8379$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        const currentStackIndex = $586a5b8a0b5a8379$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $586a5b8a0b5a8379$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $586a5b8a0b5a8379$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $586a5b8a0b5a8379$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $586a5b8a0b5a8379$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $586a5b8a0b5a8379$var$modalStackRegister.splice(currentStackIndex, 1);
                $586a5b8a0b5a8379$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("kpUo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5180b2a034ac3ed1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $5180b2a034ac3ed1$export$2e2bcd8739ae039(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("9MvCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $695d2ee024a053ec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $695d2ee024a053ec$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $5uXOq.useState)(initialState);
    const valueRef = (0, $5uXOq.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("i8hzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e0ce812778b3f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $e1e0ce812778b3f8$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $e1e0ce812778b3f8$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setScrollTopOffset($e1e0ce812778b3f8$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
        if ($e1e0ce812778b3f8$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return (0, $cBeZP.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("gqw9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $3366079ad64361c3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("h6fcC")).Popup);

var $h6fcC = parcelRequire("h6fcC");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3366079ad64361c3$export$2e2bcd8739ae039 = (0, $h6fcC.Popup);

});
parcelRegister("h6fcC", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $2acb5fa61c209162$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lDwZR = parcelRequire("lDwZR");

var $9rqOj = parcelRequire("9rqOj");

var $9HBUn = parcelRequire("9HBUn");

var $khO3w = parcelRequire("khO3w");

var $3sau9 = parcelRequire("3sau9");
var $d5yM6 = parcelRequire("d5yM6");

var $dmUF2 = parcelRequire("dmUF2");

var $lL6cf = parcelRequire("lL6cf");

var $ea7np = parcelRequire("ea7np");

var $ir37R = parcelRequire("ir37R");

var $hbsaq = parcelRequire("hbsaq");

var $kSudw = parcelRequire("kSudw");
const $2acb5fa61c209162$var$defaultLayer = 400;
const $2acb5fa61c209162$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $2acb5fa61c209162$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $2acb5fa61c209162$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
    const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
    const getMergedTriggerRef = (0, $hbsaq.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $kSudw.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $lDwZR.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $ir37R.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $5uXOq.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $9HBUn.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    const renderPopperWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9rqOj.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ea7np.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3sau9.Manager), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d5yM6.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $khO3w.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $khO3w.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dmUF2.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            }))
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
        xcss: $2acb5fa61c209162$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
});

});
parcelRegister("ea7np", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a87e9d964cbcdf$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3n0aQ = parcelRequire("3n0aQ");

var $khO3w = parcelRequire("khO3w");

var $8hN1h = parcelRequire("8hN1h");

var $eubRM = parcelRequire("eubRM");

var $jzdE3 = parcelRequire("jzdE3");

var $40MqE = parcelRequire("40MqE");
const $63a87e9d964cbcdf$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $63a87e9d964cbcdf$var$fullWidthStyles = null;
const $63a87e9d964cbcdf$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
const $63a87e9d964cbcdf$var$scrollableStyles = null;
const $63a87e9d964cbcdf$var$blanketStyles = null;
const $63a87e9d964cbcdf$var$modalStyles = null;
const $63a87e9d964cbcdf$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
const $63a87e9d964cbcdf$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $bwpsq.default)([
            $63a87e9d964cbcdf$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: ref,
        children: children
    });
});
function $63a87e9d964cbcdf$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $63a87e9d964cbcdf$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
    const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $5uXOq.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $40MqE.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $jzdE3.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $3n0aQ.useLayering)();
    const mergedModifiers = (0, $5uXOq.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hN1h.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = /*#__PURE__*/ (0, $2OMIu.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $bwpsq.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                    (0, $khO3w.fg)('platform-design-system-apply-popup-wrapper-focus') && $63a87e9d964cbcdf$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eubRM.RepositionOnUpdate), {
                    update: update,
                    children: content({
                        update: update,
                        isOpen: isOpen,
                        onClose: onClose,
                        setInitialFocusRef: setInitialFocusRef
                    })
                })
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
                children: [
                    popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            "_1r04idpf _kqsw1n9t _bfhk10xm"
                        ])
                    })
                ]
            });
        }
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63a87e9d964cbcdf$export$2e2bcd8739ae039 = $63a87e9d964cbcdf$var$PopperWrapper;

});
parcelRegister("eubRM", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", () => $7e30eda93f9b60a3$export$51eddd7655ca235a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $7e30eda93f9b60a3$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: children
    });
};

});

parcelRegister("jzdE3", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $7a913527a9d4dd72$export$92dae2778ae88f9d);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jp7wN = parcelRequire("jp7wN");

var $3n0aQ = parcelRequire("3n0aQ");

var $khO3w = parcelRequire("khO3w");

var $4v3Fd = parcelRequire("4v3Fd");

var $62yf4 = parcelRequire("62yf4");
const $7a913527a9d4dd72$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $3n0aQ.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $62yf4.useAnimationFrame)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $jp7wN.default;
        const inIframe = window && window.self !== window.top && (0, $khO3w.fg)('fix-dropdown-close-outside-iframe');
        const closePopup = (event)=>{
            if (onClose) {
                if ((0, $khO3w.fg)('sibling-dropdown-close-issue')) {
                    let currentLevel = null;
                    if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                    currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
                } else onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $khO3w.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if ((0, $khO3w.fg)('design-system-closed-all-when-click-outside')) {
                    if (target instanceof HTMLElement) {
                        const layeredElement = target.closest?.(`[data-ds--level]`);
                        if (layeredElement) {
                            const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                } else return;
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $4v3Fd.isInteractiveElement)(document.activeElement) && (0, $khO3w.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onKeyDown = (event)=>{
            if ((0, $khO3w.fg)('platform_dst_popup-disable-focuslock')) {
                const { key: key, shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                const { key: key } = event;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $cBeZP.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        let unbind = (0, $jp7wN.default);
        if ((0, $khO3w.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $cBeZP.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $cBeZP.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $jp7wN.default);
        unbindBlur = (0, $cBeZP.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $khO3w.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            parentUnbind?.();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("4v3Fd", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $076e5710ae9b8643$export$3dee5e4542c672d9);
const $076e5710ae9b8643$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $076e5710ae9b8643$export$3dee5e4542c672d9 = (element)=>{
    if ($076e5710ae9b8643$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("62yf4", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", () => $9532909203a6543e$export$641fa9c94086b46e);

var $5uXOq = parcelRequire("5uXOq");
const $9532909203a6543e$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $5uXOq.useRef)([]);
    const requestFrame = (0, $5uXOq.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $5uXOq.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $5uXOq.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("40MqE", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", () => $70f77057a1a2b5fe$export$10c5169755ce7bd7);

var $5uXOq = parcelRequire("5uXOq");

var $fGOj2 = parcelRequire("fGOj2");

var $jp7wN = parcelRequire("jp7wN");

var $3n0aQ = parcelRequire("3n0aQ");

var $khO3w = parcelRequire("khO3w");

var $62yf4 = parcelRequire("62yf4");
const $70f77057a1a2b5fe$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $62yf4.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $3n0aQ.useLayering)();
    (0, $5uXOq.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $jp7wN.default;
        if (shouldDisableFocusTrap && (0, $khO3w.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $jp7wN.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($fGOj2)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("ir37R", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", () => $d92ee991f28d1886$export$4065aef1d79a5730);

var $5uXOq = parcelRequire("5uXOq");

var $1Gt8L = parcelRequire("1Gt8L");
function $d92ee991f28d1886$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $1Gt8L.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $5uXOq.useState)(!!mq?.matches);
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("1Gt8L", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $72414b3170d506ad$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $1JJgg = parcelRequire("1JJgg");
const $72414b3170d506ad$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $1JJgg.media).below.xl.replace('@media ', '').trim())
};
const $72414b3170d506ad$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $72414b3170d506ad$var$queries[queryString];
    (0, $5uXOq.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("1JJgg", function(module, exports) {

$parcel$export(module.exports, "media", () => $a68e11eaeff4596d$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $a68e11eaeff4596d$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("hbsaq", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $bd25c5bb3cb8027c$export$7cc5c058dd769dff);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $bd25c5bb3cb8027c$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("kSudw", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $f82c3a3ab6c1a757$export$5d3a2de79e07b376);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");
const $f82c3a3ab6c1a757$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $5uXOq.useState)(()=>(0, $8QpSo.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("9ZbIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbcf12e1d1642e83$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3jDHA = parcelRequire("3jDHA");

var $iI1Rn = parcelRequire("iI1Rn");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $bbcf12e1d1642e83$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI1Rn.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jDHA.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
var $bbcf12e1d1642e83$export$2e2bcd8739ae039 = $bbcf12e1d1642e83$var$Spotlight;

});
parcelRegister("3jDHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4aeced8c54d184c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lv4Ny = parcelRequire("lv4Ny");

var $2alJM = parcelRequire("2alJM");

var $k9tnV = parcelRequire("k9tnV");

var $9rqOj = parcelRequire("9rqOj");

var $khO3w = parcelRequire("khO3w");

var $dmUF2 = parcelRequire("dmUF2");

var $8SrTA = parcelRequire("8SrTA");

var $bzd8m = parcelRequire("bzd8m");

var $ahkPL = parcelRequire("ahkPL");

var $45Saa = parcelRequire("45Saa");

var $i3wqw = parcelRequire("i3wqw");

var $70RAY = parcelRequire("70RAY");
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ class $a4aeced8c54d184c$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $k9tnV.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70RAY.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $dmUF2.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $45Saa.default), {
                            hasNodeResolver: !(0, $khO3w.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SrTA.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8SrTA.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahkPL.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bzd8m.Fade), {
                            hasEntered: isOpen,
                            onExited: onExited,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9rqOj.Layering), {
                                    isDisabled: false,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i3wqw.default), {
                                        testId: `${testId}--dialog`,
                                        actions: this.props.actions,
                                        actionsBeforeElement: this.props.actionsBeforeElement,
                                        children: this.props.children,
                                        dialogPlacement: this.props.dialogPlacement,
                                        dialogWidth: this.props.dialogWidth,
                                        footer: this.props.footer,
                                        header: this.props.header,
                                        heading: this.props.heading,
                                        titleId: this.props.titleId,
                                        label: this.props.label,
                                        headingAfterElement: this.props.headingAfterElement,
                                        image: this.props.image,
                                        targetNode: replacementElement || targetNode,
                                        animationStyles: animationStyles
                                    })
                                })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2alJM))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $lv4Ny.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && (0, $khO3w.fg)('scroll-lock-replacement') && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
var $a4aeced8c54d184c$export$2e2bcd8739ae039 = $a4aeced8c54d184c$var$SpotlightInner;

});
parcelRegister("8SrTA", function(module, exports) {

$parcel$export(module.exports, "ElementBox", () => $883fd49faa6b7526$export$1b6719bd7aff3c00);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $khO3w = parcelRequire("khO3w");
// The minimum interval between position updates in milliseconds
const $883fd49faa6b7526$var$POSITION_UPDATE_INTERVAL = 200;
const $883fd49faa6b7526$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $883fd49faa6b7526$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $5uXOq.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') {
            if ((0, $khO3w.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                setBox($883fd49faa6b7526$var$getElementRect(element));
            }, 0);
            else setBox($883fd49faa6b7526$var$getElementRect(element));
        }
    }, [
        element,
        updateMethod
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($883fd49faa6b7526$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: onResize
        });
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $883fd49faa6b7526$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const [left, setLeft] = (0, $5uXOq.useState)(0);
    const [top, setTop] = (0, $5uXOq.useState)(0);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') {
            if ((0, $khO3w.fg)('scroll-lock-replacement')) // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
            // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
            setTimeout(()=>{
                const newBox = $883fd49faa6b7526$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }, 0);
            else {
                const newBox = $883fd49faa6b7526$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $5uXOq.useRef)();
    const previousUpdateTimeRef = (0, $5uXOq.useRef)();
    const animate = (0, $5uXOq.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $883fd49faa6b7526$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $883fd49faa6b7526$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $5uXOq.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $883fd49faa6b7526$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $883fd49faa6b7526$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $883fd49faa6b7526$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $883fd49faa6b7526$export$1b6719bd7aff3c00 = (props)=>{
    const box = $883fd49faa6b7526$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};

});

parcelRegister("bzd8m", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $73d4c53d366cd320$export$c983850c6c9d8b0e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $khO3w = parcelRequire("khO3w");
const $73d4c53d366cd320$var$duration = {
    enter: 0,
    exit: 100
};
const $73d4c53d366cd320$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
    const nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        in: hasEntered,
        timeout: $73d4c53d366cd320$var$duration,
        onExited: onExited,
        unmountOnExit: true,
        appear: true,
        ...(0, $khO3w.fg)('platform_design_system_team_transition_group_r18') && {
            nodeRef: nodeRef
        },
        children: (status)=>{
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            return children({
                transition: `opacity ${$73d4c53d366cd320$var$duration.exit}ms`,
                opacity: 0,
                ...status in anim ? anim[status] : {}
            });
        }
    });
};

});

parcelRegister("ahkPL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f860ff52eda2bb77$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8jYI4 = parcelRequire("8jYI4");

var $OBHXn = parcelRequire("OBHXn");
const $f860ff52eda2bb77$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $f860ff52eda2bb77$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $f860ff52eda2bb77$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $f860ff52eda2bb77$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $OBHXn.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $5uXOq.useMemo)(()=>$f860ff52eda2bb77$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8jYI4.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8jYI4.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
var $f860ff52eda2bb77$export$2e2bcd8739ae039 = $f860ff52eda2bb77$var$Clone;

});
parcelRegister("8jYI4", function(module, exports) {

$parcel$export(module.exports, "TargetInner", () => $fbec9a6423e4e6ec$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $fbec9a6423e4e6ec$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $fbec9a6423e4e6ec$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $fbec9a6423e4e6ec$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $fbec9a6423e4e6ec$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #8270DB)"}`;
const $fbec9a6423e4e6ec$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $fbec9a6423e4e6ec$var$pulseKeyframes = null;
const $fbec9a6423e4e6ec$var$animationStyles = null;
const $fbec9a6423e4e6ec$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? `${radius}px` : undefined
        },
        ...props,
        children: children
    });
const $fbec9a6423e4e6ec$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($fbec9a6423e4e6ec$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_y44v1si8 _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
const $fbec9a6423e4e6ec$var$targetOverlayStyles = null;
const $fbec9a6423e4e6ec$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        onClick: onClick,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _152tze3t _1e02ze3t"
        ])
    });
const $fbec9a6423e4e6ec$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($fbec9a6423e4e6ec$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            pulse && "",
            pulse && "_y44v1si8 _16qs1wx8",
            "_1bumglyw _sedtglyw",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });

});

parcelRegister("OBHXn", function(module, exports) {

$parcel$export(module.exports, "useElementObserver", () => $e46d517bc60a433d$export$729bafd4e621fba0);

var $5uXOq = parcelRequire("5uXOq");
function $e46d517bc60a433d$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $5uXOq.useState)(0);
    const mutationObserver = (0, $5uXOq.useRef)(undefined);
    const cancelIdleCallback1 = (0, $5uXOq.useRef)(undefined);
    const disposer = (0, $5uXOq.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $5uXOq.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $e46d517bc60a433d$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $e46d517bc60a433d$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    // eslint-disable-next-line compat/compat
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line compat/compat
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("45Saa", function(module, exports) {

$parcel$export(module.exports, "default", () => $215c5fe3b77df995$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dI393 = parcelRequire("dI393");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $215c5fe3b77df995$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: divRef,
        children: children
    });
};
var $215c5fe3b77df995$export$2e2bcd8739ae039 = $215c5fe3b77df995$var$NodeResolverSpotlightInner;

});

parcelRegister("i3wqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be712e0fa954f1d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $8hN1h = parcelRequire("8hN1h");

var $lL6cf = parcelRequire("lL6cf");

var $c9Zdw = parcelRequire("c9Zdw");

var $5rVGK = parcelRequire("5rVGK");

var $bE7J8 = parcelRequire("bE7J8");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $8be712e0fa954f1d$var$SpotlightDialogComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8hN1h.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bE7J8.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ao4Ml.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: {
                                ...style,
                                ...animationStyles
                            },
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5rVGK.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9Zdw.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8be712e0fa954f1d$export$2e2bcd8739ae039 = $8be712e0fa954f1d$var$SpotlightDialogComponent;

});
parcelRegister("c9Zdw", function(module, exports) {

$parcel$export(module.exports, "DialogImage", () => $1f9afe8c24768e54$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $1f9afe8c24768e54$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $1f9afe8c24768e54$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lL6cf = parcelRequire("lL6cf");
const $1f9afe8c24768e54$var$imageStyles = null;
const $1f9afe8c24768e54$var$actionItemContainerStyles = {
    root: "_1e0c1txw _2lx21sbv _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr"
};
const $1f9afe8c24768e54$var$actionItemStyles = {
    root: "_6rthze3t _1pfhze3t _12l21b66 _ahbq1b66"
};
const $1f9afe8c24768e54$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug"
        ])
    });
const $1f9afe8c24768e54$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
        xcss: $1f9afe8c24768e54$var$actionItemContainerStyles.root,
        children: children
    });
const $1f9afe8c24768e54$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lL6cf.default), {
        xcss: $1f9afe8c24768e54$var$actionItemStyles.root,
        children: children
    });

});

parcelRegister("5rVGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9b407c2655e267$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lrsUC = parcelRequire("lrsUC");
var $6elY5 = parcelRequire("6elY5");

var $jmVNy = parcelRequire("jmVNy");

var $kfIGo = parcelRequire("kfIGo");

var $3n0aQ = parcelRequire("3n0aQ");

var $lL6cf = parcelRequire("lL6cf");
var $28q17 = parcelRequire("28q17");

var $c9Zdw = parcelRequire("c9Zdw");

var $bJzOv = parcelRequire("bJzOv");
const $3a9b407c2655e267$var$bodyStyles = null;
const $3a9b407c2655e267$var$imageStyles = null;
const $3a9b407c2655e267$var$defaultHeaderStyles = null;
const $3a9b407c2655e267$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1q9y _1bah1yb4 _85i5u2gc"
        ]),
        children: children
    });
const $3a9b407c2655e267$var$defaultFooterStyles = null;
const $3a9b407c2655e267$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51u2gc"
        ]),
        children: children
    });
const $3a9b407c2655e267$var$containerStyles = {
    root: "_2rkoglpi _1reo1wug _18m91wug _4t3i1ns9 _syaz15cr _1ul91lit _p12f1ogm"
};
const $3a9b407c2655e267$var$containerShadowStyles = {
    root: "_16qszucj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 */ const $3a9b407c2655e267$var$SpotlightCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $3a9b407c2655e267$var$DefaultHeader, Footer: Footer = $3a9b407c2655e267$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $3n0aQ.useLayering)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6elY5.default).Provider, {
        value: (0, $bJzOv.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lL6cf.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $jmVNy.cx)($3a9b407c2655e267$var$containerStyles.root, !isFlat && $3a9b407c2655e267$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $bwpsq.default)([
                        "_1e0c1ule"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_1e0c1txw _2lx21bp4 _85i5pxbi _1q51pxbi _y4tiv47k _bozgv47k"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kfIGo.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $28q17.default), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $2OMIu.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $2OMIu.jsx)("span", {}),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9Zdw.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9Zdw.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrsUC.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$3a9b407c2655e267$var$SpotlightCard.displayName = 'SpotlightCard';
var $3a9b407c2655e267$export$2e2bcd8739ae039 = $3a9b407c2655e267$var$SpotlightCard;

});
parcelRegister("bJzOv", function(module, exports) {

$parcel$export(module.exports, "spotlightButtonTheme", () => $2d549149684ac6fa$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $2d549149684ac6fa$export$d131eb21ba4cbd16);
const $2d549149684ac6fa$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #091E4208)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CCE0FF)",
                dark: "var(--ds-background-selected-hovered, #CCE0FF)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #091E424F)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #5E4DB2)",
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $2d549149684ac6fa$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #6E5DC6)",
            hover: "var(--ds-background-discovery-bold-hovered, #5E4DB2)",
            active: "var(--ds-background-discovery-bold-pressed, #352C63)",
            disabled: {
                light: "var(--ds-background-disabled, #091E4208)",
                dark: "var(--ds-background-disabled, #091E4208)"
            },
            selected: "var(--ds-background-selected-hovered, #CCE0FF)",
            focus: "var(--ds-background-discovery-bold-hovered, #5E4DB2)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #091E424F)",
                dark: "var(--ds-text-disabled, #091E424F)"
            },
            selected: "var(--ds-text-selected, #0C66E4)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $2d549149684ac6fa$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $2d549149684ac6fa$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$2d549149684ac6fa$var$extract($2d549149684ac6fa$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $2d549149684ac6fa$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$2d549149684ac6fa$var$extract($2d549149684ac6fa$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("bE7J8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9ef555b9c53bad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
class $1f9ef555b9c53bad$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("70RAY", function(module, exports) {

$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $c2a88c7784d567d3$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $c2a88c7784d567d3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $c2a88c7784d567d3$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOpen: true,
    onExited: (0, $jp7wN.default)
});
// checks if children exist and are truthy
const $c2a88c7784d567d3$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ class $c2a88c7784d567d3$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $c2a88c7784d567d3$var$hasChildren(previousChildren) && !$c2a88c7784d567d3$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)($c2a88c7784d567d3$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $c2a88c7784d567d3$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $c2a88c7784d567d3$export$7d63b19b854c2fe8 = $c2a88c7784d567d3$var$SpotlightTransitionContext.Consumer;
var $c2a88c7784d567d3$export$2e2bcd8739ae039 = $c2a88c7784d567d3$var$SpotlightTransition;

});


parcelRegister("iI1Rn", function(module, exports) {

$parcel$export(module.exports, "TargetConsumer", () => $63a2a0f1d44f8260$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $63a2a0f1d44f8260$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $63a2a0f1d44f8260$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $63a2a0f1d44f8260$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $jp7wN = parcelRequire("jp7wN");

var $dmUF2 = parcelRequire("dmUF2");

var $g31tl = parcelRequire("g31tl");

var $bzd8m = parcelRequire("bzd8m");

var $6cAn5 = parcelRequire("6cAn5");
const { Consumer: $63a2a0f1d44f8260$export$f643dd64c1952cc8, Provider: $63a2a0f1d44f8260$var$TargetProvider } = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $63a2a0f1d44f8260$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $5uXOq.createContext)({
    opened: (0, $jp7wN.default),
    closed: (0, $jp7wN.default),
    targets: {}
});
const { Consumer: $63a2a0f1d44f8260$export$3503199acd121708, Provider: $63a2a0f1d44f8260$var$SpotlightStateProvider } = $63a2a0f1d44f8260$export$7b5aa0f5b37a336d;
const $63a2a0f1d44f8260$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: children
    });
class $63a2a0f1d44f8260$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $6cAn5;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($63a2a0f1d44f8260$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($63a2a0f1d44f8260$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)($63a2a0f1d44f8260$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bzd8m.Fade), {
                            hasEntered: this.state.spotlightCount > 0,
                            children: (animationStyles)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dmUF2.default), {
                                    zIndex: 700,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g31tl.default), {
                                        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: animationStyles,
                                        isTinted: blanketIsTinted,
                                        onBlanketClicked: onBlanketClicked
                                    })
                                })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, this.getTargetRef = (name)=>(element)=>{
                this.setState((state)=>({
                        targets: {
                            ...state.targets,
                            [name]: element || undefined
                        }
                    }));
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $8QpSo.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("g31tl", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc3dd155b574741$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ // IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $efc3dd155b574741$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $efc3dd155b574741$var$Blanket = ({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "presentation",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #091E427D)" : 'transparent'
        },
        onClick: onBlanketClicked,
        className: (0, $bwpsq.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0"
        ])
    });
};
var $efc3dd155b574741$export$2e2bcd8739ae039 = $efc3dd155b574741$var$Blanket;

});



parcelRegister("dnKDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71b26c1215d4072$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2qiW1 = parcelRequire("2qiW1");

var $6q45C = parcelRequire("6q45C");
const $a71b26c1215d4072$var$flexGrowMap = {
    hug: (0, $2qiW1.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2qiW1.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $a71b26c1215d4072$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $a71b26c1215d4072$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6q45C.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$a71b26c1215d4072$var$Stack.displayName = 'Stack';
var $a71b26c1215d4072$export$2e2bcd8739ae039 = $a71b26c1215d4072$var$Stack;

});

parcelRegister("1lQB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $385fb7b87c7ded09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $3rX7Z = parcelRequire("3rX7Z");

var $8q8Pm = parcelRequire("8q8Pm");

var $4QIJ8 = parcelRequire("4QIJ8");
function $385fb7b87c7ded09$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $385fb7b87c7ded09$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $385fb7b87c7ded09$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $385fb7b87c7ded09$var$strongStyles = {
    name: "zh3azs",
    styles: "font-weight:var(--ds-font-weight-bold, 700)"
};
const $385fb7b87c7ded09$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $385fb7b87c7ded09$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $385fb7b87c7ded09$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $385fb7b87c7ded09$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $385fb7b87c7ded09$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $8q8Pm.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $4QIJ8.inverseColorMap).hasOwnProperty(surface)) return (0, $4QIJ8.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $385fb7b87c7ded09$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $3joPi.default)($385fb7b87c7ded09$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $3rX7Z.useHasTextAncestor)();
    const color = $385fb7b87c7ded09$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        ref: ref,
        css: [
            $385fb7b87c7ded09$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $4QIJ8.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $4QIJ8.textColorStylesMap)[color],
            maxLines && $385fb7b87c7ded09$var$truncationStyles,
            maxLines === 1 && $385fb7b87c7ded09$var$wordBreakMap.breakAll,
            align && $385fb7b87c7ded09$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $4QIJ8.textWeightStylesMap)[weight],
            Component === 'em' && $385fb7b87c7ded09$var$emStyles,
            Component === 'strong' && $385fb7b87c7ded09$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3rX7Z.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $385fb7b87c7ded09$export$2e2bcd8739ae039 = $385fb7b87c7ded09$var$Text;

});

parcelRegister("igaNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d394f239f7fba$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $henai = parcelRequire("henai");

var $fq4Zh = parcelRequire("fq4Zh");

var $l8tgK = parcelRequire("l8tgK");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $ce7d394f239f7fba$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $henai.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                    type: "icon",
                    position: "before",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                        icon: iconBefore
                    })
                }),
                children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                    isLoading: isLoading,
                    children: children
                }),
                iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                    type: "icon",
                    position: "after",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                        icon: iconAfter
                    })
                })
            ]
        })
    });
}));
$ce7d394f239f7fba$var$Button.displayName = 'Button';
var $ce7d394f239f7fba$export$2e2bcd8739ae039 = $ce7d394f239f7fba$var$Button;

});

parcelRegister("eHLiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6147a2d52381451a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ahTMp = parcelRequire("ahTMp");

var $aHccd = parcelRequire("aHccd");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6147a2d52381451a$var$svgStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $aHccd.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ const $6147a2d52381451a$var$SVG = /*#__PURE__*/ (0, $5uXOq.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $ahTMp.getBackground)()
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $6147a2d52381451a$var$svgStyles,
            (0, $aHccd.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, children);
});
var $6147a2d52381451a$export$2e2bcd8739ae039 = $6147a2d52381451a$var$SVG;

});

parcelRegister("7JPr6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53f91109de7c85ca6ae82f80e81ebfee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a24a27f09d83a51$var$_react = $5a24a27f09d83a51$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a24a27f09d83a51$var$_checkCircle = $5a24a27f09d83a51$var$_interopRequireDefault((parcelRequire("52Xy0")));

var $5a24a27f09d83a51$var$_checkCircle2 = $5a24a27f09d83a51$var$_interopRequireDefault((parcelRequire("7Kivl")));
function $5a24a27f09d83a51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a24a27f09d83a51$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $5a24a27f09d83a51$var$_react.default.createElement($5a24a27f09d83a51$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $5a24a27f09d83a51$var$_checkCircle2.default
    }, props));
$5a24a27f09d83a51$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $5a24a27f09d83a51$var$_default = module.exports.default = $5a24a27f09d83a51$var$CheckCircleIcon;

});
parcelRegister("52Xy0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::748f85337bfdc39189d1ccb0fbfec926>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3acb548f15c30cd4$var$_react = $3acb548f15c30cd4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3acb548f15c30cd4$var$_baseNew = $3acb548f15c30cd4$var$_interopRequireDefault((parcelRequire("dznjK")));
function $3acb548f15c30cd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3acb548f15c30cd4$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $3acb548f15c30cd4$var$_react.default.createElement($3acb548f15c30cd4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m4.326 3.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$3acb548f15c30cd4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $3acb548f15c30cd4$var$_default = module.exports.default = $3acb548f15c30cd4$var$CheckCircleIcon;

});


parcelRegister("1FYKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dba27ff856842d0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $bLXk2 = parcelRequire("bLXk2");


var $jp7wN = parcelRequire("jp7wN");

var $84MxJ = parcelRequire("84MxJ");

var $MmgC6 = parcelRequire("MmgC6");

var $gqw9P = parcelRequire("gqw9P");

var $fulm9 = parcelRequire("fulm9");

var $6p44c = parcelRequire("6p44c");

var $d4DJx = parcelRequire("d4DJx");

var $4L0it = parcelRequire("4L0it");

var $3KnJI = parcelRequire("3KnJI");

var $cOR7z = parcelRequire("cOR7z");

var $eJSVZ = parcelRequire("eJSVZ");

var $oPD6C = parcelRequire("oPD6C");
const $7dba27ff856842d0$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $7dba27ff856842d0$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $oPD6C.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $5uXOq.createElement)(Component, {
                    ...props,
                    key: (0, $oPD6C.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $7dba27ff856842d0$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $bLXk2.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $84MxJ.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $jp7wN.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $jp7wN.default;
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $c80cbc27df0b968e$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $c80cbc27df0b968e$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$7dba27ff856842d0$var$getOverrides(overrides).MoreIndicator.render((0, $cOR7z.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gqw9P.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4L0it.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3KnJI.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MmgC6.default), {
                            children: data.slice(max).map((avatar, index)=>$7dba27ff856842d0$var$getOverrides(overrides).AvatarGroupItem.render((0, $6p44c.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $7dba27ff856842d0$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $eJSVZ.default) : (0, $d4DJx.default);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $7dba27ff856842d0$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $oPD6C.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $7dba27ff856842d0$export$2e2bcd8739ae039 = $7dba27ff856842d0$var$AvatarGroup;

});
parcelRegister("bLXk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb5e3f90139da7e$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d22NM = parcelRequire("d22NM");

var $lDwZR = parcelRequire("lDwZR");

var $bsxdW = parcelRequire("bsxdW");

var $7IEBN = parcelRequire("7IEBN");

var $dLkgG = parcelRequire("dLkgG");

var $d3sj0 = parcelRequire("d3sj0");

var $hrJ4L = parcelRequire("hrJ4L");

var $xgVBn = parcelRequire("xgVBn");
const $7cb5e3f90139da7e$var$packageName = "platform-pkg";
const $7cb5e3f90139da7e$var$packageVersion = "0.0.0-use.local";
const $7cb5e3f90139da7e$var$containerStyles = null; // eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $7cb5e3f90139da7e$var$Avatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const context = (0, $7IEBN.useAvatarContext)();
    const size = sizeProp || context?.size || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $5uXOq.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $5uXOq.useRef)(analyticsContext);
    const labelId = (0, $lDwZR.useId)();
    (0, $5uXOq.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $7cb5e3f90139da7e$var$packageName,
                packageVersion: $7cb5e3f90139da7e$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $7cb5e3f90139da7e$var$packageName,
            packageVersion: $7cb5e3f90139da7e$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7IEBN.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7IEBN.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $xgVBn.getCustomElement)(isDisabled, href, onClick),
                        appearance: appearance,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        avatarImage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dLkgG.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            size: size,
                            testId: testId
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bsxdW.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d3sj0.PresenceWrapper), {
                    appearance: appearance,
                    size: size,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrJ4L.StatusWrapper), {
                    appearance: appearance,
                    size: size,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$7cb5e3f90139da7e$var$Avatar.displayName = 'Avatar';
var $7cb5e3f90139da7e$export$2e2bcd8739ae039 = $7cb5e3f90139da7e$var$Avatar;

});
parcelRegister("bsxdW", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", () => $74024d9a6cb188b9$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $7IEBN = parcelRequire("7IEBN");
const $74024d9a6cb188b9$var$boxShadowCssVar = '--avatar-box-shadow';
const $74024d9a6cb188b9$var$bgColorCssVar = '--avatar-bg-color';
const $74024d9a6cb188b9$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk18uv _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1q5u _14mj1q5u",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
const $74024d9a6cb188b9$var$unboundStyles = {
    root: "_vchh18uv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpuw83z _ez1ykb7n _gcm11et6 _eeh8kb7n _jlxit94y"
};
const $74024d9a6cb188b9$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $74024d9a6cb188b9$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $74024d9a6cb188b9$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children }, ref)=>{
    (0, $7IEBN.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    borderColor = (0, $khO3w.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex } = (0, $7IEBN.useAvatarContent)();
    const isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Container, {
        style: {
            [$74024d9a6cb188b9$var$bgColorCssVar]: borderColor,
            [$74024d9a6cb188b9$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $bwpsq.default)([
            $74024d9a6cb188b9$var$unboundStyles.root,
            $74024d9a6cb188b9$var$styles.root,
            $74024d9a6cb188b9$var$borderRadiusMap[size],
            appearance === 'circle' && $74024d9a6cb188b9$var$styles.circle,
            $74024d9a6cb188b9$var$widthHeightMap[size],
            stackIndex !== undefined && $74024d9a6cb188b9$var$styles.positionRelative,
            isInteractive && !isDisabled && $74024d9a6cb188b9$var$unboundStyles.interactive,
            isDisabled && $74024d9a6cb188b9$var$styles.disabled
        ]),
        children: children || avatarImage
    });
});

});
parcelRegister("7IEBN", function(module, exports) {

$parcel$export(module.exports, "AvatarContext", () => $949318c51454caec$export$a20dad690e1279e2);
$parcel$export(module.exports, "useAvatarContext", () => $949318c51454caec$export$b50b87a1c4086b23);
$parcel$export(module.exports, "AvatarContentContext", () => $949318c51454caec$export$b983474ddd0b6d28);
$parcel$export(module.exports, "useAvatarContent", () => $949318c51454caec$export$79d078b69b7e4842);
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $949318c51454caec$export$6b4cbd90d24955ad);
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $949318c51454caec$export$7db5c57474082dd9);

var $5uXOq = parcelRequire("5uXOq");
const $949318c51454caec$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $949318c51454caec$export$b50b87a1c4086b23 = ()=>(0, $5uXOq.useContext)($949318c51454caec$export$a20dad690e1279e2);
const $949318c51454caec$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $949318c51454caec$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $5uXOq.createContext)($949318c51454caec$var$defaultAvatarContentProps);
const $949318c51454caec$export$79d078b69b7e4842 = ()=>(0, $5uXOq.useContext)($949318c51454caec$export$b983474ddd0b6d28);
const $949318c51454caec$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $949318c51454caec$export$7db5c57474082dd9 = ()=>{
    const context = (0, $5uXOq.useContext)($949318c51454caec$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("dLkgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0214b804186d627$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2W6xI = parcelRequire("2W6xI");

var $gT5OM = parcelRequire("gT5OM");

var $b7FX8 = parcelRequire("b7FX8");

var $lySr6 = parcelRequire("lySr6");

var $khO3w = parcelRequire("khO3w");

const $b0214b804186d627$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1q5u"
};
const $b0214b804186d627$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
const $b0214b804186d627$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $b0214b804186d627$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    // If src changes, reset state
    (0, $5uXOq.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b0214b804186d627$var$styles.icon,
            (0, $khO3w.fg)('platform-component-visual-refresh') ? $b0214b804186d627$var$styles.iconBGVisualRefresh : $b0214b804186d627$var$styles.iconBg,
            $b0214b804186d627$var$nestedSvgStylesMap[size]
        ]),
        children: appearance === 'circle' ? (0, $khO3w.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b7FX8))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2W6xI))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $3568e170f1ea17d7$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : (0, $khO3w.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lySr6))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gT5OM))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $3568e170f1ea17d7$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $bwpsq.default)([
            $b0214b804186d627$var$styles.image,
            $b0214b804186d627$var$borderRadiusMap[size],
            appearance === 'circle' && $b0214b804186d627$var$styles.circle
        ])
    });
};
var $b0214b804186d627$export$2e2bcd8739ae039 = $b0214b804186d627$var$AvatarImage;

});
parcelRegister("2W6xI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::325d0bc066f2b42d61e7c5ff0e093014>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $223612cd9836b8f5$var$_react = $223612cd9836b8f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $223612cd9836b8f5$var$_person = $223612cd9836b8f5$var$_interopRequireDefault((parcelRequire("b7FX8")));

var $223612cd9836b8f5$var$_person2 = $223612cd9836b8f5$var$_interopRequireDefault((parcelRequire("63N9X")));
function $223612cd9836b8f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $223612cd9836b8f5$var$PersonIcon = (props)=>/*#__PURE__*/ $223612cd9836b8f5$var$_react.default.createElement($223612cd9836b8f5$var$_person.default, Object.assign({
        LEGACY_fallbackIcon: $223612cd9836b8f5$var$_person2.default
    }, props));
$223612cd9836b8f5$var$PersonIcon.Name = 'PersonIconMigration';
var $223612cd9836b8f5$var$_default = module.exports.default = $223612cd9836b8f5$var$PersonIcon;

});

parcelRegister("gT5OM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df09611fb9f343ce3ed015b37269b5a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4b64bc2efa5051c$var$_react = $c4b64bc2efa5051c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c4b64bc2efa5051c$var$_release = $c4b64bc2efa5051c$var$_interopRequireDefault((parcelRequire("lySr6")));

var $c4b64bc2efa5051c$var$_ship = $c4b64bc2efa5051c$var$_interopRequireDefault((parcelRequire("3XbxJ")));
function $c4b64bc2efa5051c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4b64bc2efa5051c$var$ReleaseIcon = (props)=>/*#__PURE__*/ $c4b64bc2efa5051c$var$_react.default.createElement($c4b64bc2efa5051c$var$_release.default, Object.assign({
        LEGACY_fallbackIcon: $c4b64bc2efa5051c$var$_ship.default
    }, props));
$c4b64bc2efa5051c$var$ReleaseIcon.Name = 'ReleaseIconMigration';
var $c4b64bc2efa5051c$var$_default = module.exports.default = $c4b64bc2efa5051c$var$ReleaseIcon;

});


parcelRegister("d3sj0", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", () => $3a946e13a7ba5f82$export$972c5e90200fa0ef);
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $3oK2R = parcelRequire("3oK2R");
const $3a946e13a7ba5f82$var$BusyIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $3568e170f1ea17d7$export$4a7404f376229999)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $3a946e13a7ba5f82$var$FocusIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
    children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
        fill: `var(--ds-icon-discovery, ${(0, $3568e170f1ea17d7$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $3a946e13a7ba5f82$var$OfflineIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-text-subtlest, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`,
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$1ce2d1575d444ceb)})`,
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $3a946e13a7ba5f82$var$OnlineIndicator = /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
    fill: `var(--ds-icon-success, ${(0, $3568e170f1ea17d7$export$940e1f69e873f202)})`,
    cx: "4",
    cy: "4",
    r: "4"
});
function $3a946e13a7ba5f82$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $3a946e13a7ba5f82$var$BusyIndicator;
        case 'focus':
            return $3a946e13a7ba5f82$var$FocusIndicator;
        case 'offline':
            return $3a946e13a7ba5f82$var$OfflineIndicator;
        case 'online':
            return $3a946e13a7ba5f82$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $3a946e13a7ba5f82$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3oK2R.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $3a946e13a7ba5f82$var$getPresence(presence)
        }) : children
    });
var $3a946e13a7ba5f82$export$2e2bcd8739ae039 = $3a946e13a7ba5f82$var$AvatarPresence;
const $3a946e13a7ba5f82$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $3a946e13a7ba5f82$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $3a946e13a7ba5f82$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $3a946e13a7ba5f82$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $bwpsq.default)([
            $3a946e13a7ba5f82$var$styles.root,
            $3a946e13a7ba5f82$var$iconSizeMap[size],
            $3a946e13a7ba5f82$var$iconOffsetMap[size],
            appearance === 'square' && $3a946e13a7ba5f82$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($3a946e13a7ba5f82$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};

});
parcelRegister("3oK2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a95ecaac3a2724$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b5a95ecaac3a2724$var$styles = {
    root: "_2rko1q5u _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $b5a95ecaac3a2724$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $b5a95ecaac3a2724$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $bwpsq.default)([
            $b5a95ecaac3a2724$var$styles.root,
            $b5a95ecaac3a2724$var$unboundStyles.root
        ]),
        children: children
    });
var $b5a95ecaac3a2724$export$2e2bcd8739ae039 = $b5a95ecaac3a2724$var$IconWrapper;

});


parcelRegister("hrJ4L", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", () => $840f9b3ffab59a63$export$8045894f255f9726);
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $3oK2R = parcelRequire("3oK2R");
const $840f9b3ffab59a63$var$styles = {
    root: "_kqswstnw"
};
const $840f9b3ffab59a63$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $840f9b3ffab59a63$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
const $840f9b3ffab59a63$var$ApprovedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-success, ${(0, $3568e170f1ea17d7$export$a49394138f7b8e85)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $840f9b3ffab59a63$var$DeclinedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-icon-danger, ${(0, $3568e170f1ea17d7$export$2010d0fb4295b346)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $840f9b3ffab59a63$var$LockedIndicator = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
    children: [
        /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
            fill: `var(--ds-text-subtlest, ${(0, $3568e170f1ea17d7$export$1ce2d1575d444ceb)})`,
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$c39c0fe0f26207ae)})`,
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
function $840f9b3ffab59a63$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $840f9b3ffab59a63$var$ApprovedIndicator;
        case 'declined':
            return $840f9b3ffab59a63$var$DeclinedIndicator;
        case 'locked':
            return $840f9b3ffab59a63$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $840f9b3ffab59a63$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3oK2R.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $840f9b3ffab59a63$var$getStatus(status)
        }) : children
    });
var $840f9b3ffab59a63$export$2e2bcd8739ae039 = $840f9b3ffab59a63$var$AvatarStatus;
const $840f9b3ffab59a63$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $bwpsq.default)([
            $840f9b3ffab59a63$var$styles.root,
            $840f9b3ffab59a63$var$iconSizeMap[size],
            $840f9b3ffab59a63$var$iconOffsetMap[size],
            appearance === 'square' && $840f9b3ffab59a63$var$iconOffsetMap['square']
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($840f9b3ffab59a63$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};

});

parcelRegister("xgVBn", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", () => $3151a270cf0645f3$export$83ee468102cdf04c);
const $3151a270cf0645f3$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});


parcelRegister("84MxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd991080a3fac9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $ccd991080a3fac9b$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $5uXOq.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $5uXOq.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("MmgC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b20d7a9d4def11$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/ensure-design-token-usage/preview */ /**
                                                                                                                                   * @jsxRuntime classic
                                                                                                                                   * @jsx jsx
                                                                                                                                   */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");


var $bJRWK = parcelRequire("bJRWK");
function $39b20d7a9d4def11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $39b20d7a9d4def11$var$gridSize = 8;
const $39b20d7a9d4def11$var$itemHeadingTopMargin = $39b20d7a9d4def11$var$gridSize * 2.5;
const $39b20d7a9d4def11$var$itemHeadingBottomMargin = $39b20d7a9d4def11$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $39b20d7a9d4def11$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $39b20d7a9d4def11$var$skeletonHeadingHeight = $39b20d7a9d4def11$var$gridSize;
const $39b20d7a9d4def11$var$skeletonHeadingMarginOffset = 3;
const $39b20d7a9d4def11$var$skeletonHeadingTopMargin = $39b20d7a9d4def11$var$itemHeadingTopMargin + ($39b20d7a9d4def11$var$itemHeadingContentHeight - $39b20d7a9d4def11$var$skeletonHeadingHeight) - $39b20d7a9d4def11$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
const $39b20d7a9d4def11$var$skeletonHeadingBottomMargin = $39b20d7a9d4def11$var$itemHeadingBottomMargin + $39b20d7a9d4def11$var$skeletonHeadingMarginOffset;
const $39b20d7a9d4def11$var$sectionPaddingTopBottom = $39b20d7a9d4def11$var$gridSize * 0.75;
const $39b20d7a9d4def11$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
const $39b20d7a9d4def11$var$sectionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before, &::after': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $39b20d7a9d4def11$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $39b20d7a9d4def11$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $39b20d7a9d4def11$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $39b20d7a9d4def11$var$itemHeadingTopMargin - $39b20d7a9d4def11$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-ds--menu--skeleton-heading-item]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $39b20d7a9d4def11$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $39b20d7a9d4def11$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $39b20d7a9d4def11$var$skeletonHeadingTopMargin - $39b20d7a9d4def11$var$sectionPaddingTopBottom
        }
    },
    '&:focus': {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
const $39b20d7a9d4def11$var$scrollableStyles = {
    name: "qji62u",
    styles: "flex-shrink:1;overflow:auto"
};
const $39b20d7a9d4def11$var$unscrollableStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $39b20d7a9d4def11$var$thinSeparatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    borderBlockStart: `1px solid var(${$39b20d7a9d4def11$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)})`})`
});
const $39b20d7a9d4def11$var$noSeparatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-section] + &': {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $39b20d7a9d4def11$var$Section = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    const content = isList ? /*#__PURE__*/ (0, $f8Sb3.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $5uXOq.Children).map((0, $5uXOq.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bJRWK.default), {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: UNSAFE_headingOverrides,
        testId: testId && `${testId}--heading`,
        "aria-hidden": true
    }, title), content) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, content);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        css: [
            $39b20d7a9d4def11$var$sectionStyles,
            isScrollable ? $39b20d7a9d4def11$var$scrollableStyles : $39b20d7a9d4def11$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            $39b20d7a9d4def11$var$thinSeparatorStyles : $39b20d7a9d4def11$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $39b20d7a9d4def11$export$2e2bcd8739ae039 = $39b20d7a9d4def11$var$Section;

});
parcelRegister("bJRWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1784e3f29694f1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");

const $2a1784e3f29694f1$var$headingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$e2ef2124cf4024b1)})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)"
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2a1784e3f29694f1$var$HeadingItem = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $jp7wN.default), // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $2a1784e3f29694f1$var$headingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    }, children);
});
var $2a1784e3f29694f1$export$2e2bcd8739ae039 = $2a1784e3f29694f1$var$HeadingItem;

});


parcelRegister("6p44c", function(module, exports) {

$parcel$export(module.exports, "default", () => $259743782f4d3d89$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bLXk2 = parcelRequire("bLXk2");

var $h6LYg = parcelRequire("h6LYg");

var $Gg9wB = parcelRequire("Gg9wB");
var $lVSZF = parcelRequire("lVSZF");
var $cH0TX = parcelRequire("cH0TX");

var $3P3uF = parcelRequire("3P3uF");
const $259743782f4d3d89$var$AvatarGroupItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $3P3uF.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        }));
    };
    const AvatarIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bLXk2.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cH0TX.default), {
        ref: (0, $h6LYg.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Gg9wB.default), {
        ref: (0, $h6LYg.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lVSZF.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$259743782f4d3d89$export$2e2bcd8739ae039 = $259743782f4d3d89$var$AvatarGroupItem;

});
parcelRegister("Gg9wB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab87941454120c6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");

var $d1YtU = parcelRequire("d1YtU");

var $khO3w = parcelRequire("khO3w");

var $7WPEv = parcelRequire("7WPEv");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2ab87941454120c6$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, cssFn: cssFn = (0, $jp7wN.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7WPEv.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: (0, $khO3w.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $2ab87941454120c6$export$2e2bcd8739ae039 = $2ab87941454120c6$var$ButtonItem;

});
parcelRegister("7WPEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c2001254681147$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $dqeuE = parcelRequire("dqeuE");

var $khO3w = parcelRequire("khO3w");

var $jK3NV = parcelRequire("jK3NV");
var $dnKDi = parcelRequire("dnKDi");
var $2qiW1 = parcelRequire("2qiW1");


var $gHuJ1 = parcelRequire("gHuJ1");
function $86c2001254681147$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86c2001254681147$var$defaultRender = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props);
const $86c2001254681147$var$beforeAfterElementStylesOld = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $86c2001254681147$var$beforeAfterElementStyles = {
    name: "a10fmi",
    styles: "display:flex;min-width:24px;min-height:24px;align-items:center;justify-content:center;flex-shrink:0"
};
const $86c2001254681147$var$contentStyles = (0, $2qiW1.xcss)({
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'left'
});
const $86c2001254681147$var$truncateStyles = {
    name: "hdknak",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $86c2001254681147$var$titleStyles = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $86c2001254681147$var$wordBreakStyles = {
    name: "1sdjnkx",
    styles: "word-break:break-word"
};
const $86c2001254681147$var$descriptionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-subtlest, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $86c2001254681147$var$disabledDescriptionStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text-disabled, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`
});
const $86c2001254681147$var$positionRelativeStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $86c2001254681147$var$primitiveStyles = {
    name: "vfenhj",
    styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
};
const $86c2001254681147$var$spacingMapStyles = {
    cozy: {
        name: "1x13z0k",
        styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
    },
    compact: {
        name: "1xdhs5i",
        styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
    }
};
const $86c2001254681147$var$interactiveStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $86c2001254681147$var$unselectedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: 'currentColor',
    '&:visited': {
        color: 'currentColor'
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $3568e170f1ea17d7$export$9fdfb749e33cdf97)})`,
        color: 'currentColor'
    },
    '&:active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $3568e170f1ea17d7$export$3e51e8f1440314ba)})`,
        boxShadow: 'none',
        color: 'currentColor'
    }
});
const $86c2001254681147$var$disabledStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&, :hover, :active': {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: `var(--ds-text-disabled, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`
    }
});
const $86c2001254681147$var$selectedBorderStyles = {
    name: "1dgy7ry",
    styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
};
const $86c2001254681147$var$selectedNotchStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::before': {
        width: 4,
        position: 'absolute',
        background: "var(--ds-border-selected, transparent)",
        borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
const $86c2001254681147$var$selectedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    backgroundColor: `var(--ds-background-selected, ${(0, $3568e170f1ea17d7$export$9fdfb749e33cdf97)})`,
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    '&:visited': {
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${(0, $3568e170f1ea17d7$export$9fdfb749e33cdf97)})`,
        color: "var(--ds-text-selected, currentColor)"
    },
    '&:active': {
        backgroundColor: `var(--ds-background-selected-pressed, ${(0, $3568e170f1ea17d7$export$3e51e8f1440314ba)})`,
        color: "var(--ds-text-selected, currentColor)"
    }
});
const $86c2001254681147$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $86c2001254681147$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    const spacing = (0, $5uXOq.useContext)((0, $gHuJ1.SpacingContext));
    const selectionStyle = (0, $5uXOq.useContext)((0, $gHuJ1.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const renderTitle = overrides && overrides.Title && overrides.Title.render || $86c2001254681147$var$defaultRender;
    const UNSAFE_className = UNSAFE_externalClassName;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: cn, cx: cx })=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dqeuE.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $86c2001254681147$var$positionRelativeStyles,
                    $86c2001254681147$var$primitiveStyles,
                    $86c2001254681147$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $86c2001254681147$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $86c2001254681147$var$selectedStyles,
                        [
                            selectionStyle === 'border' && $86c2001254681147$var$selectedBorderStyles,
                            selectionStyle === 'notch' && $86c2001254681147$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $86c2001254681147$var$disabledStyles : $86c2001254681147$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jK3NV.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $86c2001254681147$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-elem-before": true,
                css: (0, $khO3w.fg)('platform_ads_component_no_icon_spacing_support') ? $86c2001254681147$var$beforeAfterElementStyles : $86c2001254681147$var$beforeAfterElementStylesOld,
                "data-testid": testId && `${testId}--icon-before`
            }, iconBefore), title && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dnKDi.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $86c2001254681147$var$contentStyles
            }, renderTitle('span', {
                children: title,
                className: cn($86c2001254681147$var$titleStyles, shouldTitleWrap ? $86c2001254681147$var$wordBreakStyles : $86c2001254681147$var$truncateStyles),
                'data-item-title': true
            }), description && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-description": true,
                css: [
                    $86c2001254681147$var$descriptionStyles,
                    isDisabled && $86c2001254681147$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $86c2001254681147$var$wordBreakStyles : $86c2001254681147$var$truncateStyles
                ]
            }, description)), iconAfter && /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
                "data-item-elem-after": true,
                css: (0, $khO3w.fg)('platform_ads_component_no_icon_spacing_support') ? $86c2001254681147$var$beforeAfterElementStyles : $86c2001254681147$var$beforeAfterElementStylesOld,
                "data-testid": testId && `${testId}--icon-after`
            }, iconAfter))
        }));
    });
};
var $86c2001254681147$export$2e2bcd8739ae039 = $86c2001254681147$var$MenuItemPrimitive;

});
parcelRegister("jK3NV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f0c2c10ffb13cd5$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2qiW1 = parcelRequire("2qiW1");

var $6q45C = parcelRequire("6q45C");
const $1f0c2c10ffb13cd5$var$flexGrowMap = {
    hug: (0, $2qiW1.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2qiW1.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $1f0c2c10ffb13cd5$var$separatorStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $1f0c2c10ffb13cd5$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1f0c2c10ffb13cd5$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $1f0c2c10ffb13cd5$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)($1f0c2c10ffb13cd5$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $1f0c2c10ffb13cd5$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6q45C.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$1f0c2c10ffb13cd5$var$Inline.displayName = 'Inline';
var $1f0c2c10ffb13cd5$export$2e2bcd8739ae039 = $1f0c2c10ffb13cd5$var$Inline;

});

parcelRegister("gHuJ1", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", () => $c794d31b1cb00bba$export$443076ec7ebce042);
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $c794d31b1cb00bba$export$9ca534b70725964d);

var $5uXOq = parcelRequire("5uXOq");
const $c794d31b1cb00bba$export$443076ec7ebce042 = /*#__PURE__*/ (0, $5uXOq.createContext)('cozy');
const $c794d31b1cb00bba$export$9ca534b70725964d = /*#__PURE__*/ (0, $5uXOq.createContext)('border');

});



parcelRegister("lVSZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $049ed8a69275e102$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");

var $d1YtU = parcelRequire("d1YtU");

var $khO3w = parcelRequire("khO3w");

var $7WPEv = parcelRequire("7WPEv");
const $049ed8a69275e102$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $049ed8a69275e102$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ component: Component, cssFn: cssFn = (0, $jp7wN.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7WPEv.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $049ed8a69275e102$var$preventEvent
            },
            onMouseDown: isDisabled ? $049ed8a69275e102$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $049ed8a69275e102$var$preventEvent : (0, $khO3w.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $049ed8a69275e102$export$2e2bcd8739ae039 = $049ed8a69275e102$var$CustomItem;

});

parcelRegister("cH0TX", function(module, exports) {

$parcel$export(module.exports, "default", () => $aabd90ab84041ecc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lpIMO = parcelRequire("lpIMO");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");

var $d1YtU = parcelRequire("d1YtU");

var $khO3w = parcelRequire("khO3w");

var $7WPEv = parcelRequire("7WPEv");
const $aabd90ab84041ecc$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $aabd90ab84041ecc$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $aabd90ab84041ecc$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $aabd90ab84041ecc$var$LinkItem = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
(props, ref)=>{
    const { children: children, href: href, cssFn: cssFn = (0, $jp7wN.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $lpIMO.default)();
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $aabd90ab84041ecc$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $aabd90ab84041ecc$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7WPEv.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // @ts-expect-error
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $aabd90ab84041ecc$var$preventEvent
            },
            onMouseDown: isDisabled ? $aabd90ab84041ecc$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $aabd90ab84041ecc$var$preventEvent : (0, $khO3w.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $aabd90ab84041ecc$export$2e2bcd8739ae039 = $aabd90ab84041ecc$var$LinkItem;

});

parcelRegister("3P3uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6088ed8650f36d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4L0it = parcelRequire("4L0it");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $d6088ed8650f36d8$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $4L0it.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $d6088ed8650f36d8$export$2e2bcd8739ae039 = $d6088ed8650f36d8$var$useRegisterItemWithFocusManager;

});
parcelRegister("4L0it", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $48c71877105007f5$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $48c71877105007f5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jp7wN = parcelRequire("jp7wN");

var $dMnwA = parcelRequire("dMnwA");
const $48c71877105007f5$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $jp7wN.default)
});
/**
 * Focus manager logic
 */ const $48c71877105007f5$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $5uXOq.useEffect)(()=>{
        (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $dMnwA.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: (0, $dMnwA.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($48c71877105007f5$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $48c71877105007f5$export$2e2bcd8739ae039 = $48c71877105007f5$var$FocusManager;

});
parcelRegister("dMnwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4339de22da721fa3$export$2e2bcd8739ae039);

const $4339de22da721fa3$var$actionMap = {
    [(0, $c80cbc27df0b968e$export$a80636c6f41931fe)]: 'next',
    [(0, $c80cbc27df0b968e$export$390330c10ff2b9a1)]: 'prev',
    [(0, $c80cbc27df0b968e$export$4af703091671bc)]: 'first',
    [(0, $c80cbc27df0b968e$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $4339de22da721fa3$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $4339de22da721fa3$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $4339de22da721fa3$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $4339de22da721fa3$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $4339de22da721fa3$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $4339de22da721fa3$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $4339de22da721fa3$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $4339de22da721fa3$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("d4DJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f4feed913171d5$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $65f4feed913171d5$var$gutter = "var(--ds-space-negative-050, -4px)";
const $65f4feed913171d5$var$listStyles = null;
const $65f4feed913171d5$var$listItemStyles = null;
const $65f4feed913171d5$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$65f4feed913171d5$export$2e2bcd8739ae039 = $65f4feed913171d5$var$Grid;

});

parcelRegister("3KnJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc59f412382df90e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $59kR5 = parcelRequire("59kR5");

var $4L0it = parcelRequire("4L0it");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $fc59f412382df90e$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $4L0it.FocusManagerContext));
    (0, $5uXOq.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $59kR5.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fc59f412382df90e$export$2e2bcd8739ae039 = $fc59f412382df90e$var$PopupAvatarGroup;

});
parcelRegister("59kR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $85664c56db77cbce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gHuJ1 = parcelRequire("gHuJ1");
function $85664c56db77cbce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $85664c56db77cbce$var$baseStyles = {
    name: "1u0qf12",
    styles: "display:flex;position:static;flex-direction:column;overflow:auto"
};
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $85664c56db77cbce$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHuJ1.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gHuJ1.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $85664c56db77cbce$var$baseStyles,
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest
    })));
var $85664c56db77cbce$export$2e2bcd8739ae039 = $85664c56db77cbce$var$MenuGroup;

});


parcelRegister("cOR7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2936c3d1e242105e$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");
const $2936c3d1e242105e$var$boxShadowCssVar = '--avatar-box-shadow';
const $2936c3d1e242105e$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $2936c3d1e242105e$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $2936c3d1e242105e$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $2936c3d1e242105e$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $2936c3d1e242105e$var$MAX_DISPLAY_COUNT = 99;
const $2936c3d1e242105e$var$MoreIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $khO3w.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        style: {
            [$2936c3d1e242105e$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $bwpsq.default)([
            $2936c3d1e242105e$var$styles.root,
            $2936c3d1e242105e$var$borderRadiusMap[size],
            appearance === 'circle' && $2936c3d1e242105e$var$styles.circle,
            $2936c3d1e242105e$var$widthHeightMap[size],
            $2936c3d1e242105e$var$fontMap[size],
            isActive && $2936c3d1e242105e$var$styles.active
        ]),
        children: [
            "+",
            count > $2936c3d1e242105e$var$MAX_DISPLAY_COUNT ? $2936c3d1e242105e$var$MAX_DISPLAY_COUNT : count
        ]
    });
});
$2936c3d1e242105e$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2936c3d1e242105e$export$2e2bcd8739ae039 = $2936c3d1e242105e$var$MoreIndicator;

});

parcelRegister("eJSVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfdb24f97fe30c70$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $bfdb24f97fe30c70$var$listStyles = null;
const $bfdb24f97fe30c70$var$listItemStyles = null;
const $bfdb24f97fe30c70$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $5uXOq.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                className: (0, $bwpsq.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfdb24f97fe30c70$export$2e2bcd8739ae039 = $bfdb24f97fe30c70$var$Stack;

});

parcelRegister("oPD6C", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $7385a4060315fba4$export$b067756944994c79);
const $7385a4060315fba4$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});


parcelRegister("2Ap2F", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", () => $f03e98fe46617346$export$9a270941bcff7e77);
$parcel$export(module.exports, "AVATAR_RADIUS", () => $f03e98fe46617346$export$e6da6efe4d1a5c9b);
$parcel$export(module.exports, "BORDER_WIDTH", () => $f03e98fe46617346$export$e2bd4c1faded7921);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $iknrn = parcelRequire("iknrn");
const $f03e98fe46617346$export$9a270941bcff7e77 = {
    xsmall: (0, $iknrn.gridSize)() * 2,
    small: (0, $iknrn.gridSize)() * 3,
    medium: (0, $iknrn.gridSize)() * 4,
    large: (0, $iknrn.gridSize)() * 5,
    xlarge: (0, $iknrn.gridSize)() * 12,
    xxlarge: (0, $iknrn.gridSize)() * 16
};
const $f03e98fe46617346$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
const $f03e98fe46617346$export$e2bd4c1faded7921 = 2;
const $f03e98fe46617346$export$89a980dfdf90df51 = 0.9;
const $f03e98fe46617346$export$3c061e31594ebabe = '--avatar-background-color';
const $f03e98fe46617346$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
const $f03e98fe46617346$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});

parcelRegister("cRdGe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bfb0623ded6462d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $4QIJ8 = parcelRequire("4QIJ8");

var $2qiW1 = parcelRequire("2qiW1");
function $6bfb0623ded6462d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6bfb0623ded6462d$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $6bfb0623ded6462d$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $6bfb0623ded6462d$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $6bfb0623ded6462d$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $6bfb0623ded6462d$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $6bfb0623ded6462d$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $6bfb0623ded6462d$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $6bfb0623ded6462d$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$6bfb0623ded6462d$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$6bfb0623ded6462d$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$6bfb0623ded6462d$var$gridTemplateRowsVar})`
});
const $6bfb0623ded6462d$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $6bfb0623ded6462d$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $2qiW1.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $5uXOq.useMemo)(()=>({
            [$6bfb0623ded6462d$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$6bfb0623ded6462d$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$6bfb0623ded6462d$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $6bfb0623ded6462d$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $4QIJ8.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $4QIJ8.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $4QIJ8.spaceStylesMap).rowGap[rowGap],
            alignItems && $6bfb0623ded6462d$var$alignItemsMap[alignItems],
            alignContent && $6bfb0623ded6462d$var$alignContentMap[alignContent],
            justifyContent && $6bfb0623ded6462d$var$justifyContentMap[justifyContent],
            autoFlow && $6bfb0623ded6462d$var$gridAutoFlowMap[autoFlow],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$6bfb0623ded6462d$var$Grid.displayName = 'Grid';
var $6bfb0623ded6462d$export$2e2bcd8739ae039 = $6bfb0623ded6462d$var$Grid;

});

parcelRegister("elUCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae47eae4093ca60$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fuXMX = parcelRequire("fuXMX");

var $7iEOO = parcelRequire("7iEOO");
const $4ae47eae4093ca60$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $4ae47eae4093ca60$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $5uXOq.useRef)(null);
    const providedColorMode = (0, $fuXMX.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $7iEOO.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $bwpsq.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});
parcelRegister("fuXMX", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $cd7757d810023825$export$ce91654eb9fea460);
$parcel$export(module.exports, "default", () => $cd7757d810023825$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $khO3w = parcelRequire("khO3w");

var $7ofFE = parcelRequire("7ofFE");
var $7CZK2 = parcelRequire("7CZK2");
var $9YCGA = parcelRequire("9YCGA");
const $cd7757d810023825$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: (0, $khO3w.fg)('platform-default-typography-modernized') ? 'typography-modernized' : undefined
    });
const $cd7757d810023825$var$ColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $cd7757d810023825$var$SetColorModeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $cd7757d810023825$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $cd7757d810023825$var$SetThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $cd7757d810023825$export$ce91654eb9fea460() {
    const value = (0, $5uXOq.useContext)($cd7757d810023825$var$ColorModeContext);
    return value;
}
function $cd7757d810023825$export$20f3076712c8dfa() {
    const value = (0, $5uXOq.useContext)($cd7757d810023825$var$ColorModeContext);
    if (!value) throw new Error('useColorMode must be used within AppProvider.');
    return value;
}
function $cd7757d810023825$export$e2afe7397c3d11c7() {
    const value = (0, $5uXOq.useContext)($cd7757d810023825$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $cd7757d810023825$export$93d4e7f90805808f() {
    const theme = (0, $5uXOq.useContext)($cd7757d810023825$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $5uXOq.useState)(theme || (0, $7ofFE.default)());
    (0, $5uXOq.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $9YCGA.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return resolvedTheme;
}
function $cd7757d810023825$export$501aa0dcd5527a48() {
    const value = (0, $5uXOq.useContext)($cd7757d810023825$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $cd7757d810023825$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $cd7757d810023825$var$prefersDarkModeMql = $cd7757d810023825$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $cd7757d810023825$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $cd7757d810023825$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $cd7757d810023825$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($cd7757d810023825$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $5uXOq.useState)(()=>({
            ...$cd7757d810023825$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($cd7757d810023825$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $7CZK2.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!$cd7757d810023825$var$prefersDarkModeMql) return;
        const unbindListener = (0, $cBeZP.bind)($cd7757d810023825$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($cd7757d810023825$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($cd7757d810023825$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cd7757d810023825$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($cd7757d810023825$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: children
                })
            })
        })
    });
}
var $cd7757d810023825$export$2e2bcd8739ae039 = $cd7757d810023825$var$ThemeProvider;

});
parcelRegister("7CZK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c7bd87c49dad0b$export$2e2bcd8739ae039);

var $khO3w = parcelRequire("khO3w");

var $jsxjA = parcelRequire("jsxjA");

var $ekXSC = parcelRequire("ekXSC");

var $c93cz = parcelRequire("c93cz");

var $59lJ0 = parcelRequire("59lJ0");

var $cWL3D = parcelRequire("cWL3D");

var $iPcUG = parcelRequire("iPcUG");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $58c7bd87c49dad0b$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $jsxjA.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $jsxjA.themeStateDefaults)['contrastMode'], dark: dark = (0, $jsxjA.themeStateDefaults)['dark'], light: light = (0, $jsxjA.themeStateDefaults)['light'], shape: shape = (0, $jsxjA.themeStateDefaults)['shape'], spacing: spacing = (0, $jsxjA.themeStateDefaults)['spacing'], typography: typography = (0, $jsxjA.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $jsxjA.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $khO3w.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $cWL3D.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $iPcUG.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $ekXSC.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
        const mode = colorMode || (0, $jsxjA.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $59lJ0.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("55gK9"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $cWL3D.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $c93cz.default)(themeState);
    return autoUnbind;
};
var $58c7bd87c49dad0b$export$2e2bcd8739ae039 = $58c7bd87c49dad0b$var$setGlobalTheme;

});
parcelRegister("ekXSC", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", () => $3abde2fbb63d86f0$export$53031ac1ecb71f44);
$parcel$export(module.exports, "rgbToHex", () => $3abde2fbb63d86f0$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $3abde2fbb63d86f0$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $3abde2fbb63d86f0$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $3abde2fbb63d86f0$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $3abde2fbb63d86f0$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $3abde2fbb63d86f0$export$e770b01b744f3745);
$parcel$export(module.exports, "getContrastRatio", () => $3abde2fbb63d86f0$export$d061e26956a60b0a);
$parcel$export(module.exports, "deltaE", () => $3abde2fbb63d86f0$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $3abde2fbb63d86f0$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $3abde2fbb63d86f0$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $3abde2fbb63d86f0$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $3abde2fbb63d86f0$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $3abde2fbb63d86f0$export$b36dbdb4f463f05c(hex) {
    if (!$3abde2fbb63d86f0$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $3abde2fbb63d86f0$export$1212645cf40ebf71(hex)
    ];
}
function $3abde2fbb63d86f0$export$5a544e13ad4e1fa5(hex) {
    if (!$3abde2fbb63d86f0$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $3abde2fbb63d86f0$export$47ea145a83f50dc0(hex) {
    if (!$3abde2fbb63d86f0$var$isValidHex(hex)) throw new Error('Invalid HEX');
    let r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $3abde2fbb63d86f0$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $3abde2fbb63d86f0$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $3abde2fbb63d86f0$export$d061e26956a60b0a(foreground, background) {
    if (!$3abde2fbb63d86f0$var$isValidHex(foreground) || !$3abde2fbb63d86f0$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $3abde2fbb63d86f0$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $3abde2fbb63d86f0$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $3abde2fbb63d86f0$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $3abde2fbb63d86f0$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $3abde2fbb63d86f0$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $3abde2fbb63d86f0$var$rgbToLab(rgbA);
    let labB = $3abde2fbb63d86f0$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $3abde2fbb63d86f0$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("c93cz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0481e68d94eed582$export$2e2bcd8739ae039);

var $khO3w = parcelRequire("khO3w");

var $aWAdb = parcelRequire("aWAdb");

var $ihq3s = parcelRequire("ihq3s");

var $9CyK2 = parcelRequire("9CyK2");
function $0481e68d94eed582$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $ihq3s.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $ihq3s.default).bind();
    } else (0, $ihq3s.default).unbind();
    if ((0, $khO3w.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $9CyK2.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $9CyK2.default).bind();
        } else (0, $9CyK2.default).unbind();
    }
    const themeAttributes = (0, $aWAdb.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $ihq3s.default).unbind();
        if ((0, $khO3w.fg)('platform_increased-contrast-themes')) (0, $9CyK2.default).unbind();
    };
}

});
parcelRegister("aWAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $df6fa854e9bca2b9$export$2e2bcd8739ae039);

var $khO3w = parcelRequire("khO3w");

var $c4e8W = parcelRequire("c4e8W");

var $jsxjA = parcelRequire("jsxjA");

var $jOwDM = parcelRequire("jOwDM");

var $ekXSC = parcelRequire("ekXSC");

var $4wngX = parcelRequire("4wngX");
const $df6fa854e9bca2b9$var$defaultColorMode = 'light';
const $df6fa854e9bca2b9$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $df6fa854e9bca2b9$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $jsxjA.themeStateDefaults)['colorMode'], dark: dark = (0, $jsxjA.themeStateDefaults)['dark'], light: light = (0, $jsxjA.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $jsxjA.themeStateDefaults)['contrastMode'], shape: shape = (0, $jsxjA.themeStateDefaults)['shape'], spacing: spacing = (0, $jsxjA.themeStateDefaults)['spacing'], typography: typography = (0, $jsxjA.themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $jsxjA.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $jOwDM.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $c4e8W.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $c4e8W.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $df6fa854e9bca2b9$var$defaultColorMode : colorMode
    };
    if ((0, $khO3w.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $c4e8W.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $df6fa854e9bca2b9$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $ekXSC.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $4wngX.hash)(optionString);
        result[0, $c4e8W.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $df6fa854e9bca2b9$export$2e2bcd8739ae039 = $df6fa854e9bca2b9$var$getThemeHtmlAttrs;

});
parcelRegister("4wngX", function(module, exports) {

$parcel$export(module.exports, "hash", () => $01e7adee2a359453$export$d6af199866bfb566);
const $01e7adee2a359453$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("ihq3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ae43f1c97ef861$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $c4e8W = parcelRequire("c4e8W");

var $iPcUG = parcelRequire("iPcUG");
const $11ae43f1c97ef861$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $11ae43f1c97ef861$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $c4e8W.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $11ae43f1c97ef861$var$darkModeMql = $11ae43f1c97ef861$var$isMatchMediaAvailable && window.matchMedia((0, $iPcUG.darkModeMediaQuery));
class $11ae43f1c97ef861$var$ColorModeObserver {
    getColorMode() {
        if (!$11ae43f1c97ef861$var$darkModeMql) return 'light';
        return $11ae43f1c97ef861$var$darkModeMql?.matches ? 'dark' : 'light';
    }
    bind() {
        if ($11ae43f1c97ef861$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $cBeZP.bind)($11ae43f1c97ef861$var$darkModeMql, {
            type: 'change',
            listener: $11ae43f1c97ef861$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $11ae43f1c97ef861$var$SingletonColorModeObserver = new $11ae43f1c97ef861$var$ColorModeObserver();
var $11ae43f1c97ef861$export$2e2bcd8739ae039 = $11ae43f1c97ef861$var$SingletonColorModeObserver;

});
parcelRegister("iPcUG", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", () => $fdfc2e28c39b9fcc$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "loadThemeCss", () => $fdfc2e28c39b9fcc$export$8a48286ed7df6720);
$parcel$export(module.exports, "darkModeMediaQuery", () => $fdfc2e28c39b9fcc$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $fdfc2e28c39b9fcc$export$8662df6937d86fcb);

var $khO3w = parcelRequire("khO3w");

var $jYBR7 = parcelRequire("jYBR7");

var $c4e8W = parcelRequire("c4e8W");
const $fdfc2e28c39b9fcc$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $c4e8W.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $c4e8W.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await $fdfc2e28c39b9fcc$export$8a48286ed7df6720(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $fdfc2e28c39b9fcc$export$8a48286ed7df6720 = async (themeId)=>{
    if ((themeId === 'light' || themeId === 'dark') && (0, $khO3w.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
    const { default: themeCss } = await (0, $jYBR7.default)[themeId]();
    return themeCss;
};
const $fdfc2e28c39b9fcc$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $fdfc2e28c39b9fcc$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("jYBR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b57b722551c35d53$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














const $b57b722551c35d53$var$themeImportsMap = {
    'light': ()=>(parcelRequire("apk3a")),
    'light-future': ()=>(parcelRequire("5AiLF")),
    'light-increased-contrast': ()=>(parcelRequire("hnSIs")),
    'dark': ()=>(parcelRequire("dUKDy")),
    'dark-future': ()=>(parcelRequire("7Zb09")),
    'dark-increased-contrast': ()=>(parcelRequire("kAPhU")),
    'legacy-light': ()=>(parcelRequire("4Kwkt")),
    'legacy-dark': ()=>(parcelRequire("26uGK")),
    'spacing': ()=>(parcelRequire("31psp")),
    'typography-adg3': ()=>(parcelRequire("lTGcz")),
    'shape': ()=>(parcelRequire("lSr3j")),
    'typography-modernized': ()=>(parcelRequire("5alnU")),
    'typography-refreshed': ()=>(parcelRequire("4xW17")),
    'light-brand-refresh': ()=>(parcelRequire("hyqqF")),
    'dark-brand-refresh': ()=>(parcelRequire("gcvfe"))
};
var $b57b722551c35d53$export$2e2bcd8739ae039 = $b57b722551c35d53$var$themeImportsMap;

});
parcelRegister("apk3a", function(module, exports) {

let $793bcabb999743a8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $793bcabb999743a8$var$load("lxHYR").then(()=>parcelRequire('6vn2F'));

});
parcelRegister("28QjX", function(module, exports) {
"use strict";


let $18f4e9fbd43d4c3b$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("kPuw4")).shardUrl((parcelRequire("dy9lH")).resolve(id), maxShards));
    };
module.exports = $18f4e9fbd43d4c3b$var$load;

});
parcelRegister("kPuw4", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2, (v) => $f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $f2a03df3e93d4e79$export$2bf9932c19d6a5d2;
var $f2a03df3e93d4e79$export$1d37a31d51d1e3ed;
var $f2a03df3e93d4e79$export$b4cd98d62f81485f;
var $f2a03df3e93d4e79$export$108ff8fc702e621f;
var $f2a03df3e93d4e79$export$f6f4188f9108e61;
"use strict";
let $f2a03df3e93d4e79$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $f2a03df3e93d4e79$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $f2a03df3e93d4e79$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $f2a03df3e93d4e79$var$removeTrailingShard(subdomain) {
    if (!$f2a03df3e93d4e79$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $f2a03df3e93d4e79$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$f2a03df3e93d4e79$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $f2a03df3e93d4e79$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $f2a03df3e93d4e79$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $f2a03df3e93d4e79$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $f2a03df3e93d4e79$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $f2a03df3e93d4e79$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$f2a03df3e93d4e79$var$globalKeyName]) return url;
    return $f2a03df3e93d4e79$var$shardUrlUnchecked(url, maxShards);
}
$f2a03df3e93d4e79$export$2bf9932c19d6a5d2 = $f2a03df3e93d4e79$var$shardUrl;
$f2a03df3e93d4e79$export$1d37a31d51d1e3ed = $f2a03df3e93d4e79$var$shardUrlUnchecked;
$f2a03df3e93d4e79$export$b4cd98d62f81485f = $f2a03df3e93d4e79$var$getDomainShardIndex;
$f2a03df3e93d4e79$export$108ff8fc702e621f = $f2a03df3e93d4e79$var$applyShardToDomain;
$f2a03df3e93d4e79$export$f6f4188f9108e61 = $f2a03df3e93d4e79$var$globalKeyName;

});

parcelRegister("dy9lH", function(module, exports) {

$parcel$export(module.exports, "register", () => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v) => $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v) => $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
"use strict";
var $9dd5b3e06d7b5702$var$mapping = new Map();
function $9dd5b3e06d7b5702$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $9dd5b3e06d7b5702$var$resolve(id) {
    var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;

});



parcelRegister("5AiLF", function(module, exports) {

let $010ca081dc965826$var$load = (parcelRequire("28QjX"))(4);
module.exports = $010ca081dc965826$var$load("jj97c").then(()=>parcelRequire('5hnEv'));

});

parcelRegister("hnSIs", function(module, exports) {

let $ca7f071e72f1a744$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca7f071e72f1a744$var$load("8gwll").then(()=>parcelRequire('6jzw4'));

});

parcelRegister("dUKDy", function(module, exports) {

let $a214ae75f0eb8826$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a214ae75f0eb8826$var$load("9oFyO").then(()=>parcelRequire('aXaiL'));

});

parcelRegister("7Zb09", function(module, exports) {

let $5d06c39688bee534$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5d06c39688bee534$var$load("eB4bT").then(()=>parcelRequire('fhOSk'));

});

parcelRegister("kAPhU", function(module, exports) {

let $efdef41eef7687b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $efdef41eef7687b0$var$load("kneKj").then(()=>parcelRequire('2fDdV'));

});

parcelRegister("4Kwkt", function(module, exports) {

let $375489322ce8990f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375489322ce8990f$var$load("6FrKI").then(()=>parcelRequire('7D8Kw'));

});

parcelRegister("26uGK", function(module, exports) {

let $1883f2610ed2db73$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1883f2610ed2db73$var$load("4KBMP").then(()=>parcelRequire('hTA13'));

});

parcelRegister("31psp", function(module, exports) {

let $2335365ca7b8effa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2335365ca7b8effa$var$load("kGA6m").then(()=>parcelRequire('7AVO9'));

});

parcelRegister("lTGcz", function(module, exports) {

let $ff0f786a8f143725$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ff0f786a8f143725$var$load("eNELi").then(()=>parcelRequire('hpQaU'));

});

parcelRegister("lSr3j", function(module, exports) {

let $fed3a03142e48873$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fed3a03142e48873$var$load("4Kqi2").then(()=>parcelRequire('gO8uB'));

});

parcelRegister("5alnU", function(module, exports) {

let $3c2e797b93a78b94$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c2e797b93a78b94$var$load("bs7yU").then(()=>parcelRequire('4QtcT'));

});

parcelRegister("4xW17", function(module, exports) {

let $34f73f7b11b2ae79$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34f73f7b11b2ae79$var$load("4I9XQ").then(()=>parcelRequire('iPPIF'));

});

parcelRegister("hyqqF", function(module, exports) {

let $cc7a1cefdc3192b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc7a1cefdc3192b5$var$load("gsVNL").then(()=>parcelRequire('9tVif'));

});

parcelRegister("gcvfe", function(module, exports) {

let $bcb600dcfb39b259$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bcb600dcfb39b259$var$load("ixfJL").then(()=>parcelRequire('bZOoM'));

});




parcelRegister("9CyK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c169ff28e817877d$export$2e2bcd8739ae039);

var $cBeZP = parcelRequire("cBeZP");

var $c4e8W = parcelRequire("c4e8W");

var $iPcUG = parcelRequire("iPcUG");
const $c169ff28e817877d$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $c169ff28e817877d$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $c4e8W.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $c169ff28e817877d$var$contrastModeMql = $c169ff28e817877d$var$isMatchMediaAvailable && window.matchMedia((0, $iPcUG.moreContrastMediaQuery));
class $c169ff28e817877d$var$ContrastModeObserver {
    getContrastMode() {
        if (!$c169ff28e817877d$var$contrastModeMql) return 'no-preference';
        return $c169ff28e817877d$var$contrastModeMql?.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($c169ff28e817877d$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $cBeZP.bind)($c169ff28e817877d$var$contrastModeMql, {
            type: 'change',
            listener: $c169ff28e817877d$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $c169ff28e817877d$var$SingletonContrastModeObserver = new $c169ff28e817877d$var$ContrastModeObserver();
var $c169ff28e817877d$export$2e2bcd8739ae039 = $c169ff28e817877d$var$SingletonContrastModeObserver;

});


parcelRegister("59lJ0", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", () => $907bdc4717d86be3$export$bd1ac9300b0e885a);
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", () => $907bdc4717d86be3$export$e7ae172320e03461);
$parcel$export(module.exports, "reduceTokenMap", () => $907bdc4717d86be3$export$e673f367da2ff23e);

var $kP7pg = parcelRequire("kP7pg");

var $c4e8W = parcelRequire("c4e8W");

var $4wngX = parcelRequire("4wngX");
function $907bdc4717d86be3$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $4wngX.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $c4e8W.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $c4e8W.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $907bdc4717d86be3$export$e7ae172320e03461(sizeThreshold) {
    const styleTags = [
        ...Array.from(document.head.querySelectorAll(`style[${(0, $c4e8W.CUSTOM_THEME_ATTRIBUTE)}][${(0, $c4e8W.THEME_DATA_ATTRIBUTE)}]`))
    ];
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
}
function $907bdc4717d86be3$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce((acc, [key, value])=>{
        const cssVar = (0, $kP7pg.default)[key];
        return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
    }, '');
}

});
parcelRegister("kP7pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $85adcd6ef6713d02$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ const $85adcd6ef6713d02$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body'
};
var $85adcd6ef6713d02$export$2e2bcd8739ae039 = $85adcd6ef6713d02$var$tokens;

});


parcelRegister("cWL3D", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", () => $f8f5790c3af2a85f$export$dd6aeb7c823fc03d);
$parcel$export(module.exports, "getThemeOverridePreferences", () => $f8f5790c3af2a85f$export$5d76d7014f4a5d08);

var $khO3w = parcelRequire("khO3w");

var $bNG9V = parcelRequire("bNG9V");
const $f8f5790c3af2a85f$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $khO3w.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $bNG9V.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $khO3w.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $bNG9V.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};
const $f8f5790c3af2a85f$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});
parcelRegister("bNG9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a92c92b32f70949$export$2e2bcd8739ae039);

var $jsxjA = parcelRequire("jsxjA");
function $5a92c92b32f70949$export$2e2bcd8739ae039(themeId) {
    return Object.entries((0, $jsxjA.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })?.[1].id;
}

});


parcelRegister("55gK9", function(module, exports) {

let $3b3a68458adfbf3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b3a68458adfbf3b$var$load("6vn11").then(()=>parcelRequire('iaimi'));

});




parcelRegister("hNGcy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56f9c413d8fbf4deb11215ad83bf4b70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf57bf9e3f25dc23$var$_react = $cf57bf9e3f25dc23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf57bf9e3f25dc23$var$_baseNew = $cf57bf9e3f25dc23$var$_interopRequireDefault((parcelRequire("dznjK")));
function $cf57bf9e3f25dc23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf57bf9e3f25dc23$var$CrossIcon = (props)=>/*#__PURE__*/ $cf57bf9e3f25dc23$var$_react.default.createElement($cf57bf9e3f25dc23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m7.06 6 3.47-3.47-1.06-1.06L6 4.94 2.53 1.47 1.47 2.53 4.94 6 1.47 9.47l1.06 1.06L6 7.06l3.47 3.47 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$cf57bf9e3f25dc23$var$CrossIcon.displayName = 'CrossIcon';
var $cf57bf9e3f25dc23$var$_default = module.exports.default = $cf57bf9e3f25dc23$var$CrossIcon;

});

parcelRegister("bboPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99f403a71ca48fc$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jmVNy = parcelRequire("jmVNy");

var $h6LYg = parcelRequire("h6LYg");

var $kTRe2 = parcelRequire("kTRe2");

var $khO3w = parcelRequire("khO3w");

var $g8Dn0 = parcelRequire("g8Dn0");

var $fq4Zh = parcelRequire("fq4Zh");

var $l8tgK = parcelRequire("l8tgK");
const $e99f403a71ca48fc$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc"
};
const $e99f403a71ca48fc$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $e99f403a71ca48fc$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $e99f403a71ca48fc$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
const $e99f403a71ca48fc$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
const $e99f403a71ca48fc$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $e99f403a71ca48fc$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $e99f403a71ca48fc$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $e99f403a71ca48fc$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $kTRe2.default)(localRef, autoFocus);
    const combinedRef = (0, $h6LYg.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g8Dn0.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $jmVNy.cx)($e99f403a71ca48fc$var$styles.base, appearance === 'default' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $e99f403a71ca48fc$var$defaultStyles.rootRefreshed : $e99f403a71ca48fc$var$defaultStyles.root), appearance === 'primary' && $e99f403a71ca48fc$var$primaryStyles.root, appearance === 'warning' && $e99f403a71ca48fc$var$warningStyles.root, appearance === 'danger' && $e99f403a71ca48fc$var$dangerStyles.root, appearance === 'discovery' && $e99f403a71ca48fc$var$discoveryStyles.root, appearance === 'subtle' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $e99f403a71ca48fc$var$subtleStyles.rootRefreshed : $e99f403a71ca48fc$var$subtleStyles.root), $e99f403a71ca48fc$var$styles.linkDecorationUnset, isSelected && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $e99f403a71ca48fc$var$selectedStyles.rootRefreshed : $e99f403a71ca48fc$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $e99f403a71ca48fc$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $e99f403a71ca48fc$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $e99f403a71ca48fc$var$selectedStyles.discovery, isDisabled && $e99f403a71ca48fc$var$styles.disabled, spacing === 'compact' && $e99f403a71ca48fc$var$styles.spacingCompact, hasIconBefore && $e99f403a71ca48fc$var$styles.buttonIconBefore, hasIconAfter && $e99f403a71ca48fc$var$styles.buttonIconAfter),
        children: [
            iconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fq4Zh.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $e99f403a71ca48fc$var$LinkButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)($e99f403a71ca48fc$var$LinkButtonBase);
$e99f403a71ca48fc$var$LinkButton.displayName = 'LinkButton';
var $e99f403a71ca48fc$export$2e2bcd8739ae039 = $e99f403a71ca48fc$var$LinkButton;

});

parcelRegister("3lN7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9f770b2abb9e9b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $igaNe = parcelRequire("igaNe");


var $h6LYg = parcelRequire("h6LYg");

var $jp7wN = parcelRequire("jp7wN");

var $iVkW9 = parcelRequire("iVkW9");

var $84MxJ = parcelRequire("84MxJ");

var $6kdSN = parcelRequire("6kdSN");

var $khO3w = parcelRequire("khO3w");

var $gqw9P = parcelRequire("gqw9P");

var $iknrn = parcelRequire("iknrn");

var $7pbC0 = parcelRequire("7pbC0");

var $ccoHf = parcelRequire("ccoHf");

var $jVzoz = parcelRequire("jVzoz");

var $bXfyl = parcelRequire("bXfyl");

var $cZFWf = parcelRequire("cZFWf");
const $ad9f770b2abb9e9b$var$gridSize = (0, $iknrn.gridSize)();
const $ad9f770b2abb9e9b$var$MAX_HEIGHT = `calc(100vh - ${$ad9f770b2abb9e9b$var$gridSize * 2}px)`;
const $ad9f770b2abb9e9b$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $ad9f770b2abb9e9b$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$ad9f770b2abb9e9b$var$opposites[crossAxis]}`,
            `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}-${crossAxis}`,
            `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}`,
            `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}-${$ad9f770b2abb9e9b$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}`,
        `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}-start`,
        `${$ad9f770b2abb9e9b$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $ad9f770b2abb9e9b$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $ad9f770b2abb9e9b$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $jp7wN.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $iknrn.layers).modal(), label: label, interactionName: interactionName, strategy: strategy })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $iVkW9.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const id = (0, $cZFWf.default)();
    const itemRef = (0, $bXfyl.default)();
    const fallbackPlacements = (0, $5uXOq.useMemo)(()=>$ad9f770b2abb9e9b$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $5uXOq.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $ad9f770b2abb9e9b$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $cZFWf.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($ad9f770b2abb9e9b$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $84MxJ.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $5uXOq.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $jp7wN.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $jp7wN.default;
        return (0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $cZFWf.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $c80cbc27df0b968e$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $c80cbc27df0b968e$export$e51a3576c045c8d5) || e.key === (0, $c80cbc27df0b968e$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $c80cbc27df0b968e$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jVzoz.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gqw9P.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $h6LYg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $igaNe.default), {
                    ...bindFocus,
                    ref: (0, $h6LYg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($6kdSN))),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    ...(0, $khO3w.fg)('platform_button_item-add-ufo-metrics') && {
                        interactionName: interactionName
                    },
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pbC0.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ccoHf.default), {
                        spacing: spacing,
                        maxHeight: $ad9f770b2abb9e9b$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        children: children
                    })
                })
        })
    });
};
var $ad9f770b2abb9e9b$export$2e2bcd8739ae039 = $ad9f770b2abb9e9b$var$DropdownMenu;

});
parcelRegister("iVkW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ce74add62bb7a6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $1ce74add62bb7a6a$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $5uXOq.useState)(getDefaultPropValue);
    const isControlledRef = (0, $5uXOq.useRef)(isControlled);
    (0, $5uXOq.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $5uXOq.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("6kdSN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a08e2cd9fd0eae78f18da4572f37370>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49af6126c316dd68$var$_react = $49af6126c316dd68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $49af6126c316dd68$var$_chevronDown = $49af6126c316dd68$var$_interopRequireDefault((parcelRequire("9Gsrw")));

var $49af6126c316dd68$var$_chevronDown2 = $49af6126c316dd68$var$_interopRequireDefault((parcelRequire("4ESF3")));
function $49af6126c316dd68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49af6126c316dd68$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $49af6126c316dd68$var$_react.default.createElement($49af6126c316dd68$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $49af6126c316dd68$var$_chevronDown2.default
    }, props));
$49af6126c316dd68$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $49af6126c316dd68$var$_default = module.exports.default = $49af6126c316dd68$var$ChevronDownIcon;

});

parcelRegister("7pbC0", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $59c9cbdbb5f304e4$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $59c9cbdbb5f304e4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jp7wN = parcelRequire("jp7wN");

var $3n0aQ = parcelRequire("3n0aQ");

var $l1uUA = parcelRequire("l1uUA");
const $59c9cbdbb5f304e4$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    menuItemRefs: [],
    registerRef: (0, $jp7wN.default)
});
/**
 * Focus manager logic.
 */ const $59c9cbdbb5f304e4$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $5uXOq.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $5uXOq.useState)(0);
    const registerMode = (0, $5uXOq.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $5uXOq.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $3n0aQ.useLayering)();
    // Intentionally rebinding on each render
    (0, $5uXOq.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $5uXOq.useEffect)(()=>(0, $cBeZP.bind)(window, {
            type: 'keydown',
            listener: (0, $l1uUA.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($59c9cbdbb5f304e4$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $59c9cbdbb5f304e4$export$2e2bcd8739ae039 = $59c9cbdbb5f304e4$var$FocusManager;

});
parcelRegister("l1uUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d357197b30033d$export$2e2bcd8739ae039);


var $khO3w = parcelRequire("khO3w");

var $cZFWf = parcelRequire("cZFWf");
const $14d357197b30033d$var$actionMap = {
    [(0, $c80cbc27df0b968e$export$a80636c6f41931fe)]: 'next',
    [(0, $c80cbc27df0b968e$export$390330c10ff2b9a1)]: 'prev',
    [(0, $c80cbc27df0b968e$export$4af703091671bc)]: 'first',
    [(0, $c80cbc27df0b968e$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $14d357197b30033d$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $khO3w.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx + 1 < refs.length){
        const { current: element } = refs[++currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $14d357197b30033d$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    if ((0, $khO3w.fg)('dropdown-menu-disabled-navigation-fix')) for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    else while(currentFocusedIdx > 0){
        const { current: element } = refs[--currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $14d357197b30033d$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $khO3w.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $cZFWf.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $c80cbc27df0b968e$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $c80cbc27df0b968e$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $14d357197b30033d$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $khO3w.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const nextFocusableElement = $14d357197b30033d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx < currentRefs.length - 1) {
                    const nextFocusableElement = $14d357197b30033d$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $14d357197b30033d$var$getNextFocusableElement(currentRefs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if ((0, $khO3w.fg)('dropdown-menu-disabled-navigation-fix')) {
                    const prevFocusableElement = $14d357197b30033d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                    break;
                }
                // Remove on FG cleanup dropdown-menu-disabled-navigation-fix
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $14d357197b30033d$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $14d357197b30033d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $14d357197b30033d$var$getNextFocusableElement(currentRefs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $14d357197b30033d$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("cZFWf", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $17a2ce95f953616a$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $17a2ce95f953616a$export$2e2bcd8739ae039);

var $lDwZR = parcelRequire("lDwZR");
const $17a2ce95f953616a$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $17a2ce95f953616a$export$2e2bcd8739ae039() {
    const id = (0, $lDwZR.useId)();
    return `${$17a2ce95f953616a$export$8a682ae47622dbb9}${id}`;
}

});



parcelRegister("ccoHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $471ff2d11e4ef1bc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $59kR5 = parcelRequire("59kR5");

var $hCfTW = parcelRequire("hCfTW");
var $2qiW1 = parcelRequire("2qiW1");

var $bYK7l = parcelRequire("bYK7l");

var $2POtV = parcelRequire("2POtV");

var $fhSk8 = parcelRequire("fhSk8");

var $7pbC0 = parcelRequire("7pbC0");
const $471ff2d11e4ef1bc$var$spinnerContainerStyles = (0, $2qiW1.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $471ff2d11e4ef1bc$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $hCfTW.default), {
        xcss: $471ff2d11e4ef1bc$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bYK7l.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $471ff2d11e4ef1bc$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, $7pbC0.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $2POtV.default)(menuItem) || (0, $fhSk8.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $5uXOq.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $59kR5.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $f8Sb3.jsx)($471ff2d11e4ef1bc$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $471ff2d11e4ef1bc$export$2e2bcd8739ae039 = $471ff2d11e4ef1bc$var$MenuWrapper;

});
parcelRegister("2POtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f1a3294c7887c76$export$2e2bcd8739ae039);
function $0f1a3294c7887c76$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("fhSk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dfd45b654557a1c$export$2e2bcd8739ae039);
function $6dfd45b654557a1c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("jVzoz", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $a01ce8c47af848b6$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $a01ce8c47af848b6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $a01ce8c47af848b6$export$756f795847463ebd = /*#__PURE__*/ (0, $5uXOq.createContext)({
    setItemState: (0, $jp7wN.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $jp7wN.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $a01ce8c47af848b6$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $5uXOq.useRef)({});
    const context = (0, $5uXOq.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($a01ce8c47af848b6$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $a01ce8c47af848b6$export$2e2bcd8739ae039 = $a01ce8c47af848b6$var$SelectionStore;

});

parcelRegister("bXfyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $140c7b7cfad4736d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $7pbC0 = parcelRequire("7pbC0");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $140c7b7cfad4736d$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, $7pbC0.FocusManagerContext));
    const itemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (hasPopup && (0, $khO3w.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $140c7b7cfad4736d$export$2e2bcd8739ae039 = $140c7b7cfad4736d$var$useRegisterItemWithFocusManager;

});


parcelRegister("gPYuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $28ef1803de31557f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $h6LYg = parcelRequire("h6LYg");

var $Gg9wB = parcelRequire("Gg9wB");

var $lVSZF = parcelRequire("lVSZF");

var $cH0TX = parcelRequire("cH0TX");

var $khO3w = parcelRequire("khO3w");

var $bXfyl = parcelRequire("bXfyl");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $28ef1803de31557f$var$DropdownMenuItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $bXfyl.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lVSZF.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $h6LYg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $khO3w.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cH0TX.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $h6LYg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $khO3w.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Gg9wB.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $h6LYg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $khO3w.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest,
        children: children
    });
});
var $28ef1803de31557f$export$2e2bcd8739ae039 = $28ef1803de31557f$var$DropdownMenuItem;

});

parcelRegister("cB3HF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13c16382c038153$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lDwZR = parcelRequire("lDwZR");

var $MmgC6 = parcelRequire("MmgC6");

var $1PK2G = parcelRequire("1PK2G");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $f13c16382c038153$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $lDwZR.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MmgC6.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PK2G.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $f13c16382c038153$export$2e2bcd8739ae039 = $f13c16382c038153$var$DropdownMenuItemGroup;

});
parcelRegister("1PK2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3422e4894964232a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hCfTW = parcelRequire("hCfTW");
var $2qiW1 = parcelRequire("2qiW1");
const $3422e4894964232a$var$headingStyles = (0, $2qiW1.xcss)({
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    paddingBlock: 'space.0',
    paddingInline: 'space.200'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $3422e4894964232a$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hCfTW.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $3422e4894964232a$var$headingStyles,
        children: title
    });
var $3422e4894964232a$export$2e2bcd8739ae039 = $3422e4894964232a$var$GroupTitle;

});


parcelRegister("flvYJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b775822095ff11ff1cfe3f316db8614>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2c19f6e00151a2c$var$_react = $b2c19f6e00151a2c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2c19f6e00151a2c$var$_showMoreHorizontal = $b2c19f6e00151a2c$var$_interopRequireDefault((parcelRequire("9hm3Z")));

var $b2c19f6e00151a2c$var$_more = $b2c19f6e00151a2c$var$_interopRequireDefault((parcelRequire("c8FIE")));
function $b2c19f6e00151a2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2c19f6e00151a2c$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b2c19f6e00151a2c$var$_react.default.createElement($b2c19f6e00151a2c$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $b2c19f6e00151a2c$var$_more.default
    }, props));
$b2c19f6e00151a2c$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $b2c19f6e00151a2c$var$_default = module.exports.default = $b2c19f6e00151a2c$var$ShowMoreHorizontalIcon;

});

parcelRegister("60zey", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::271d2db9eb5cbaef3f993286190920ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45fe12dbb533591f$var$_react = $45fe12dbb533591f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $45fe12dbb533591f$var$_clock = $45fe12dbb533591f$var$_interopRequireDefault((parcelRequire("lCsU2")));

var $45fe12dbb533591f$var$_recent = $45fe12dbb533591f$var$_interopRequireDefault((parcelRequire("cADlN")));
function $45fe12dbb533591f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "RecentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: recent, time input, sprint time remaining. Overdue task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $45fe12dbb533591f$var$ClockIcon = (props)=>/*#__PURE__*/ $45fe12dbb533591f$var$_react.default.createElement($45fe12dbb533591f$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $45fe12dbb533591f$var$_recent.default
    }, props));
$45fe12dbb533591f$var$ClockIcon.Name = 'ClockIconMigration';
var $45fe12dbb533591f$var$_default = module.exports.default = $45fe12dbb533591f$var$ClockIcon;

});

parcelRegister("eHphf", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $dab8977192892206$export$8a485e2e7ed91e8f);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $dab8977192892206$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $dab8977192892206$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $2sApg.defaultLogoParams).size, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        svg: $dab8977192892206$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("hwKfv", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", () => $c669b1c154998540$export$e23ae35269442b4f);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $c669b1c154998540$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $c669b1c154998540$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        svg: $c669b1c154998540$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iar49", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a92becedd4d209$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a9a92becedd4d209$var$shimmerKeyframes = null;
const $a9a92becedd4d209$var$skeletonStyles = null;
const $a9a92becedd4d209$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $a9a92becedd4d209$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $bwpsq.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq1y0p"
        ])
    });
};
var $a9a92becedd4d209$export$2e2bcd8739ae039 = $a9a92becedd4d209$var$Skeleton;

});

parcelRegister("3VJ45", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::52af1617dddfd09530e8f62747e987f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc9a6e9d0b08d18$var$_react = $2dc9a6e9d0b08d18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2dc9a6e9d0b08d18$var$_baseNew = $2dc9a6e9d0b08d18$var$_interopRequireDefault((parcelRequire("dznjK")));
function $2dc9a6e9d0b08d18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc9a6e9d0b08d18$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $2dc9a6e9d0b08d18$var$_react.default.createElement($2dc9a6e9d0b08d18$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2dc9a6e9d0b08d18$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $2dc9a6e9d0b08d18$var$_default = module.exports.default = $2dc9a6e9d0b08d18$var$StarUnstarredIcon;

});

parcelRegister("jL2NF", function(module, exports) {

$parcel$export(module.exports, "default", () => $72affcb7e171740e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");


var $iknrn = parcelRequire("iknrn");

var $gyL5O = parcelRequire("gyL5O");
function $72affcb7e171740e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $72affcb7e171740e$var$gridSize = (0, $iknrn.gridSize)();
const $72affcb7e171740e$var$borderRadius = (0, $iknrn.borderRadius)();
const $72affcb7e171740e$var$itemElemSpacing = $72affcb7e171740e$var$gridSize * 1.5;
const $72affcb7e171740e$var$itemExpectedElemSize = $72affcb7e171740e$var$gridSize * 3;
const $72affcb7e171740e$var$itemMinHeight = $72affcb7e171740e$var$gridSize * 5;
const $72affcb7e171740e$var$skeletonItemElemSize = $72affcb7e171740e$var$gridSize * 2.5;
const $72affcb7e171740e$var$itemElemSkeletonOffset = ($72affcb7e171740e$var$itemExpectedElemSize - $72affcb7e171740e$var$skeletonItemElemSize) / 2;
const $72affcb7e171740e$var$skeletonTextBorderRadius = 100;
const $72affcb7e171740e$var$skeletonContentHeight = 9;
const $72affcb7e171740e$var$skeletonColor = `var(--ds-skeleton, ${(0, $3568e170f1ea17d7$export$8d43898f60b96a82)})`;
const $72affcb7e171740e$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: $72affcb7e171740e$var$itemMinHeight,
    padding: `0 ${"var(--ds-space-250, 20px)"}`,
    alignItems: 'center',
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        height: $72affcb7e171740e$var$skeletonContentHeight,
        backgroundColor: $72affcb7e171740e$var$skeletonColor,
        borderRadius: $72affcb7e171740e$var$skeletonTextBorderRadius,
        content: '""',
        // This is a little bespoke but we need to push everything down 1px
        // because the skeleton content should align to the bottom of the text.
        // Confirm VR test failures before accepting a change.
        marginBlockStart: 1
    }
});
const $72affcb7e171740e$var$defaultWidthStyles = {
    name: "sljcv5",
    styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
};
const $72affcb7e171740e$var$customWidthStyles = {
    name: "nsk3fe",
    styles: "::after{flex-basis:var(--width);}"
};
const $72affcb7e171740e$var$beforeElementStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: $72affcb7e171740e$var$skeletonItemElemSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $72affcb7e171740e$var$skeletonItemElemSize,
        flexShrink: 0,
        backgroundColor: $72affcb7e171740e$var$skeletonColor,
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginInlineEnd: $72affcb7e171740e$var$itemElemSpacing + $72affcb7e171740e$var$itemElemSkeletonOffset,
        marginInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $72affcb7e171740e$var$avatarStyles = {
    name: "lz1zvf",
    styles: "::before{border-radius:100%;}"
};
const $72affcb7e171740e$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before': {
        borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $72affcb7e171740e$var$borderRadius
    }
});
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $72affcb7e171740e$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $jp7wN.default) })=>{
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn());
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gyL5O.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $72affcb7e171740e$var$skeletonStyles,
                (hasAvatar || hasIcon) && $72affcb7e171740e$var$beforeElementStyles,
                hasAvatar && $72affcb7e171740e$var$avatarStyles,
                hasIcon && $72affcb7e171740e$var$iconStyles,
                width ? $72affcb7e171740e$var$customWidthStyles : $72affcb7e171740e$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-testid": testId
        }));
};
var $72affcb7e171740e$export$2e2bcd8739ae039 = $72affcb7e171740e$var$SkeletonItem;

});
parcelRegister("gyL5O", function(module, exports) {

$parcel$export(module.exports, "default", () => $28c9fd13d2708d4f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

/**
 * These keyframes are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $28c9fd13d2708d4f$var$shimmerKeyframes = (0, $f8Sb3.keyframes)({
    from: {
        backgroundColor: `var(--ds-skeleton, ${(0, $3568e170f1ea17d7$export$8d43898f60b96a82)})`
    },
    to: {
        backgroundColor: `var(--ds-skeleton-subtle, ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)})`
    }
});
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 *
 * Please update both.
 */ const $28c9fd13d2708d4f$var$shimmerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::before, ::after': {
        animationDirection: 'alternate',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationName: `${$28c9fd13d2708d4f$var$shimmerKeyframes}`,
        animationTimingFunction: 'linear',
        backgroundColor: `var(--ds-skeleton, ${(0, $3568e170f1ea17d7$export$8d43898f60b96a82)})`
    }
});
/**
 * __Skeleton shimmer__
 *
 * A skeleton shimmer is the animation shown on loading skeletons for
 * perceived performance and user satisfaction.
 *
 * This component provides a `className` through render props. This value will
 * have type:
 * + `string`, when `isShimmering={true}`.
 * + `undefined`, when `isShimmering={false}`.
 *
 * @internal
 */ const $28c9fd13d2708d4f$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isShimmering ? css($28c9fd13d2708d4f$var$shimmerStyles) : undefined
        }));
};
var $28c9fd13d2708d4f$export$2e2bcd8739ae039 = $28c9fd13d2708d4f$var$SkeletonShimmer;

});


parcelRegister("fuBz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0d777e2e3698da$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $cBPtU = parcelRequire("cBPtU");

var $iI1Rn = parcelRequire("iI1Rn");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $6a0d777e2e3698da$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iI1Rn.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBPtU.default), {
                name: name,
                hasNodeResolver: !(0, $khO3w.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
var $6a0d777e2e3698da$export$2e2bcd8739ae039 = $6a0d777e2e3698da$var$SpotlightTarget;

});
parcelRegister("cBPtU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b857cb1cecd5e9bb$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dI393 = parcelRequire("dI393");
const $b857cb1cecd5e9bb$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $b857cb1cecd5e9bb$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dI393))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: divRef,
        className: (0, $bwpsq.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
var $b857cb1cecd5e9bb$export$2e2bcd8739ae039 = $b857cb1cecd5e9bb$var$NodeResolverSpotlightTarget;

});


parcelRegister("gxhCq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0f6dceac3b1541133f5e1afe0b271c5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c09d65215aba8f82$var$_react = $c09d65215aba8f82$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c09d65215aba8f82$var$_baseNew = $c09d65215aba8f82$var$_interopRequireDefault((parcelRequire("dznjK")));
function $c09d65215aba8f82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps plan.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c09d65215aba8f82$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $c09d65215aba8f82$var$_react.default.createElement($c09d65215aba8f82$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$c09d65215aba8f82$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $c09d65215aba8f82$var$_default = module.exports.default = $c09d65215aba8f82$var$RoadmapsPlanIcon;

});

parcelRegister("3480L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::552918135e976d59647ada829319b3a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23b7f5b661143817$var$_react = $23b7f5b661143817$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23b7f5b661143817$var$_baseNew = $23b7f5b661143817$var$_interopRequireDefault((parcelRequire("dznjK")));
function $23b7f5b661143817$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23b7f5b661143817$var$AppsIcon = (props)=>/*#__PURE__*/ $23b7f5b661143817$var$_react.default.createElement($23b7f5b661143817$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm8.25.75V9h1.5v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$23b7f5b661143817$var$AppsIcon.displayName = 'AppsIcon';
var $23b7f5b661143817$var$_default = module.exports.default = $23b7f5b661143817$var$AppsIcon;

});

parcelRegister("bYxQ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ecb88d563448af87338c1287afbb1bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b7f8bf1335fab96$var$_react = $8b7f8bf1335fab96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8b7f8bf1335fab96$var$_baseNew = $8b7f8bf1335fab96$var$_interopRequireDefault((parcelRequire("dznjK")));
function $8b7f8bf1335fab96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b7f8bf1335fab96$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $8b7f8bf1335fab96$var$_react.default.createElement($8b7f8bf1335fab96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.28 2.22a.75.75 0 1 0-1.06 1.06.75.75 0 0 0 1.06-1.06M1.16 1.159A2.25 2.25 0 0 1 4.781 3.72l1.695 1.695a3 3 0 0 1 3.048 0l1.695-1.695a2.251 2.251 0 1 1 1.06 1.06l-1.694 1.696a3 3 0 0 1 0 3.048l1.695 1.695a2.251 2.251 0 1 1-1.06 1.06l-1.696-1.694a3 3 0 0 1-3.048 0L4.78 12.28a2.251 2.251 0 1 1-1.06-1.06l1.694-1.696a3 3 0 0 1 0-3.048L3.72 4.78a2.25 2.25 0 0 1-2.56-3.621m12.621 1.06a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06M9.06 6.94a1.5 1.5 0 1 0-2.12 2.122A1.5 1.5 0 0 0 9.06 6.94m-5.78 5.78a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06m10.5 0a.75.75 0 1 0-1.06 1.061.75.75 0 0 0 1.06-1.06" clip-rule="evenodd"/>`
    }, props));
$8b7f8bf1335fab96$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $8b7f8bf1335fab96$var$_default = module.exports.default = $8b7f8bf1335fab96$var$AssetsGraphIcon;

});

parcelRegister("1QshI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04422a31fe921661fd3c15a462bdcae0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $158096882badd9d6$var$_react = $158096882badd9d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $158096882badd9d6$var$_baseNew = $158096882badd9d6$var$_interopRequireDefault((parcelRequire("dznjK")));
function $158096882badd9d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Globe".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $158096882badd9d6$var$GlobeIcon = (props)=>/*#__PURE__*/ $158096882badd9d6$var$_react.default.createElement($158096882badd9d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25h2.722c.073-1.784.403-3.413.92-4.663q.123-.294.26-.566A6.5 6.5 0 0 0 1.544 7.25M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c-.151 0-.364.07-.632.344-.27.276-.547.714-.796 1.316-.432 1.043-.733 2.47-.805 4.09h4.466c-.072-1.62-.373-3.047-.805-4.09-.249-.602-.526-1.04-.796-1.316C8.364 1.571 8.15 1.5 8 1.5m3.735 5.75c-.073-1.784-.403-3.413-.92-4.663a8 8 0 0 0-.26-.566 6.5 6.5 0 0 1 3.902 5.229zm-1.502 1.5H5.767c.072 1.62.373 3.047.805 4.09.249.602.526 1.04.796 1.316.268.273.481.344.632.344s.364-.07.632-.344c.27-.276.547-.714.796-1.316.432-1.043.733-2.47.805-4.09m.321 5.229q.14-.272.26-.566c.518-1.25.848-2.879.92-4.663h2.723a6.5 6.5 0 0 1-3.903 5.229m-5.108 0q-.14-.272-.26-.566c-.518-1.25-.848-2.879-.92-4.663H1.542a6.5 6.5 0 0 0 3.903 5.229" clip-rule="evenodd"/>`
    }, props));
$158096882badd9d6$var$GlobeIcon.displayName = 'GlobeIcon';
var $158096882badd9d6$var$_default = module.exports.default = $158096882badd9d6$var$GlobeIcon;

});

parcelRegister("V2ZU3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ab7a636fd7119b6$var$_react = $0ab7a636fd7119b6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0ab7a636fd7119b6$var$_baseNew = $0ab7a636fd7119b6$var$_interopRequireDefault((parcelRequire("dznjK")));
function $0ab7a636fd7119b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ab7a636fd7119b6$var$GoalIcon = (props)=>/*#__PURE__*/ $0ab7a636fd7119b6$var$_react.default.createElement($0ab7a636fd7119b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$0ab7a636fd7119b6$var$GoalIcon.displayName = 'GoalIcon';
var $0ab7a636fd7119b6$var$_default = module.exports.default = $0ab7a636fd7119b6$var$GoalIcon;

});

parcelRegister("5Ov0p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ed07350d21c7e2ad94ff4198361d506>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43b9ac58deb2a791$var$_react = $43b9ac58deb2a791$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $43b9ac58deb2a791$var$_baseNew = $43b9ac58deb2a791$var$_interopRequireDefault((parcelRequire("dznjK")));
function $43b9ac58deb2a791$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Marketplace".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Marketplace.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43b9ac58deb2a791$var$MarketplaceIcon = (props)=>/*#__PURE__*/ $43b9ac58deb2a791$var$_react.default.createElement($43b9ac58deb2a791$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.789 1.513A.75.75 0 0 1 2.5 1h11a.75.75 0 0 1 .711.513l1.502 4.5a.8.8 0 0 1 .038.237A3.08 3.08 0 0 1 14 9.032V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.031A3.08 3.08 0 0 1 .25 6.25q0-.12.038-.237zM3.5 9.329V13a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9.33a3.08 3.08 0 0 1-2.166-1.064A3.08 3.08 0 0 1 8 9.334a3.08 3.08 0 0 1-2.334-1.068A3.08 3.08 0 0 1 3.5 9.329M4.916 6.25v.03a1.584 1.584 0 0 1-3.163.08l.037-.11zm1.5.038.005-.038h3.158l.004.038a1.584 1.584 0 0 1-3.166 0M9.413 4.75H6.588l.25-2.25h2.324zm1.672 1.5a1.584 1.584 0 0 0 3.164.11l-.037-.11zm2.626-1.5h-2.788l-.25-2.25h2.288zM5.33 2.5l-.25 2.25H2.29l.75-2.25z" clip-rule="evenodd"/>`
    }, props));
$43b9ac58deb2a791$var$MarketplaceIcon.displayName = 'MarketplaceIcon';
var $43b9ac58deb2a791$var$_default = module.exports.default = $43b9ac58deb2a791$var$MarketplaceIcon;

});

parcelRegister("3KT51", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e48f30ce66033de9bc11d4e39ddc845f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bc064b5cac77d18$var$_react = $2bc064b5cac77d18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2bc064b5cac77d18$var$_baseNew = $2bc064b5cac77d18$var$_interopRequireDefault((parcelRequire("dznjK")));
function $2bc064b5cac77d18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bc064b5cac77d18$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $2bc064b5cac77d18$var$_react.default.createElement($2bc064b5cac77d18$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A5.5 5.5 0 0 0 2.5 7v.208A2.5 2.5 0 0 1 6 9.5v3.72A1.78 1.78 0 0 1 4.22 15 3.22 3.22 0 0 1 1 11.78V7a7 7 0 0 1 14 0v4.78A3.22 3.22 0 0 1 11.78 15 1.78 1.78 0 0 1 10 13.22V9.5a2.5 2.5 0 0 1 3.5-2.292V7A5.5 5.5 0 0 0 8 1.5m5.5 8a1 1 0 1 0-2 0v3.72c0 .155.125.28.28.28.95 0 1.72-.77 1.72-1.72zm-11 0v2.28c0 .95.77 1.72 1.72 1.72a.28.28 0 0 0 .28-.28V9.5a1 1 0 1 0-2 0" clip-rule="evenodd"/>`
    }, props));
$2bc064b5cac77d18$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $2bc064b5cac77d18$var$_default = module.exports.default = $2bc064b5cac77d18$var$HeadphonesIcon;

});

parcelRegister("3yvrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $296ceeea44b0232b$var$_react = $296ceeea44b0232b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $296ceeea44b0232b$var$_baseNew = $296ceeea44b0232b$var$_interopRequireDefault((parcelRequire("dznjK")));
function $296ceeea44b0232b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $296ceeea44b0232b$var$ProjectIcon = (props)=>/*#__PURE__*/ $296ceeea44b0232b$var$_react.default.createElement($296ceeea44b0232b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$296ceeea44b0232b$var$ProjectIcon.displayName = 'ProjectIcon';
var $296ceeea44b0232b$var$_default = module.exports.default = $296ceeea44b0232b$var$ProjectIcon;

});

parcelRegister("dfrZE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a5263fab7d4f946$var$_react = $9a5263fab7d4f946$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9a5263fab7d4f946$var$_baseNew = $9a5263fab7d4f946$var$_interopRequireDefault((parcelRequire("dznjK")));
function $9a5263fab7d4f946$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a5263fab7d4f946$var$TeamsIcon = (props)=>/*#__PURE__*/ $9a5263fab7d4f946$var$_react.default.createElement($9a5263fab7d4f946$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$9a5263fab7d4f946$var$TeamsIcon.displayName = 'TeamsIcon';
var $9a5263fab7d4f946$var$_default = module.exports.default = $9a5263fab7d4f946$var$TeamsIcon;

});

parcelRegister("g9tkO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc243de101ec15f3$var$_react = $bc243de101ec15f3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc243de101ec15f3$var$_baseNew = $bc243de101ec15f3$var$_interopRequireDefault((parcelRequire("dznjK")));
function $bc243de101ec15f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc243de101ec15f3$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $bc243de101ec15f3$var$_react.default.createElement($bc243de101ec15f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$bc243de101ec15f3$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $bc243de101ec15f3$var$_default = module.exports.default = $bc243de101ec15f3$var$ChartTrendIcon;

});

parcelRegister("aUhne", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30e149500cf1a05a183dbc43511b361c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f0c9c63d6acf1b8$var$_react = $7f0c9c63d6acf1b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7f0c9c63d6acf1b8$var$_baseNew = $7f0c9c63d6acf1b8$var$_interopRequireDefault((parcelRequire("dznjK")));
function $7f0c9c63d6acf1b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f0c9c63d6acf1b8$var$OperationsIcon = (props)=>/*#__PURE__*/ $7f0c9c63d6acf1b8$var$_react.default.createElement($7f0c9c63d6acf1b8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$7f0c9c63d6acf1b8$var$OperationsIcon.displayName = 'OperationsIcon';
var $7f0c9c63d6acf1b8$var$_default = module.exports.default = $7f0c9c63d6acf1b8$var$OperationsIcon;

});

parcelRegister("aQVED", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::052aa506253b4fa39b1a73c5776ea203>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e6b7ba7d0e9b1a5$var$_react = $7e6b7ba7d0e9b1a5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e6b7ba7d0e9b1a5$var$_baseNew = $7e6b7ba7d0e9b1a5$var$_interopRequireDefault((parcelRequire("dznjK")));
function $7e6b7ba7d0e9b1a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shield".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e6b7ba7d0e9b1a5$var$ShieldIcon = (props)=>/*#__PURE__*/ $7e6b7ba7d0e9b1a5$var$_react.default.createElement($7e6b7ba7d0e9b1a5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.53.22a.75.75 0 0 0-1.06 0C6.172 1.518 4.686 2.41 3.515 2.982a16 16 0 0 1-1.434.615 11 11 0 0 1-.51.174l-.023.007-.005.001A.75.75 0 0 0 1 4.5c0 4.338 1.651 7.176 3.334 8.926.836.87 1.672 1.463 2.304 1.842a9 9 0 0 0 .999.519l.066.027.02.008.006.002.003.001a.76.76 0 0 0 .535 0h.004l.006-.003.02-.008.066-.027q.083-.035.227-.103c.19-.09.456-.226.772-.416a11.3 11.3 0 0 0 2.304-1.842C13.349 11.676 15 8.838 15 4.5a.75.75 0 0 0-.544-.721l-.004-.001-.024-.007-.103-.033a11 11 0 0 1-.406-.141c-.35-.13-.85-.33-1.434-.615C11.314 2.412 9.828 1.518 8.53.22M8 1.783C6.69 2.963 5.286 3.788 4.172 4.33a17 17 0 0 1-1.663.707c.128 3.604 1.532 5.92 2.907 7.35a9.8 9.8 0 0 0 1.993 1.595c.24.144.443.25.591.322.148-.072.35-.178.59-.322a9.8 9.8 0 0 0 1.994-1.596c1.375-1.43 2.779-3.745 2.907-7.349l-.09-.032a17 17 0 0 1-1.573-.675C10.714 3.788 9.31 2.963 8 1.783" clip-rule="evenodd"/>`
    }, props));
$7e6b7ba7d0e9b1a5$var$ShieldIcon.displayName = 'ShieldIcon';
var $7e6b7ba7d0e9b1a5$var$_default = module.exports.default = $7e6b7ba7d0e9b1a5$var$ShieldIcon;

});

parcelRegister("egG5O", function(module, exports) {

$parcel$export(module.exports, "CommonActions", () => $bc0c8dd38fd98642$export$deb4c0713194b9f5);
/* common-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");
const $bc0c8dd38fd98642$var$styles = {
    root: "_zulpu2gc _yyhycs5v _1bsb1osq _4cvr1h6o",
    oldLayoutStyles: "_1e0c1txw _1bahh9n0 _1odf1h6o",
    newLayoutStyles: "_1e0c1txw _1bahh9n0 _181n11p5 _1j8b15b0 _lagd1bp4 _1t4c1ris _12e8h9n0"
};
const $bc0c8dd38fd98642$export$deb4c0713194b9f5 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $bc0c8dd38fd98642$var$styles.root,
            (0, $khO3w.fg)('platform_design_system_nav4_top_nav_columns') ? $bc0c8dd38fd98642$var$styles.newLayoutStyles : $bc0c8dd38fd98642$var$styles.oldLayoutStyles
        ]),
        children: children
    });

});

parcelRegister("bnQQN", function(module, exports) {

$parcel$export(module.exports, "HomeActions", () => $c456484ccc5807e3$export$ae2177c1f0d2b72c);
/* home-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $i1BVz = parcelRequire("i1BVz");
const $c456484ccc5807e3$var$styles = {
    root: "_zulp1b66 _yyhykb7n _4t3i1osq _4cvr1h6o _1e0c1txw",
    logoPaddingStyles: "_pwyo12x7",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi"
};
const $c456484ccc5807e3$export$ae2177c1f0d2b72c = ({ children: children, testId: testId })=>{
    const ref = (0, $5uXOq.useContext)((0, $i1BVz.HomeActionsAttachRef));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $c456484ccc5807e3$var$styles.root,
            (0, $khO3w.fg)('platform_design_system_nav4_top_nav_min_widths') ? $c456484ccc5807e3$var$styles.contentMinWidthStyles : // Removing the extra logo padding when applying the content min width
            $c456484ccc5807e3$var$styles.logoPaddingStyles
        ]),
        children: children
    });
};

});
parcelRegister("i1BVz", function(module, exports) {

$parcel$export(module.exports, "HomeActionsElement", () => $bc459ecc39c6c009$export$4128169e0878a41d);
$parcel$export(module.exports, "HomeActionsAttachRef", () => $bc459ecc39c6c009$export$762fcfeaa67873eb);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $bc459ecc39c6c009$export$4128169e0878a41d = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $bc459ecc39c6c009$export$762fcfeaa67873eb = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $jp7wN.default));

});


parcelRegister("lieQ4", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButton", () => $43f952eb50ed71ef$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $beKVD = parcelRequire("beKVD");

var $6tLwO = parcelRequire("6tLwO");

var $cSaPD = parcelRequire("cSaPD");

var $lEls4 = parcelRequire("lEls4");

var $83fqA = parcelRequire("83fqA");

var $62gU5 = parcelRequire("62gU5");
const $43f952eb50ed71ef$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $43f952eb50ed71ef$var$silentIconStyles = null;
const $43f952eb50ed71ef$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $83fqA.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $5uXOq.useState)(!defaultCollapsed);
    const ref = (0, $5uXOq.useContext)((0, $lEls4.SideNavToggleButtonAttachRef));
    (0, $5uXOq.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $62gU5.useToggleSideNav)();
    const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($beKVD))), {
                ...props
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6tLwO))), {
                ...props
            })
        });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: ref,
        tooltip: $43f952eb50ed71ef$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("beKVD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82e567917b1ed13d$var$_react = $82e567917b1ed13d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $82e567917b1ed13d$var$_baseNew = $82e567917b1ed13d$var$_interopRequireDefault((parcelRequire("dznjK")));
function $82e567917b1ed13d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82e567917b1ed13d$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $82e567917b1ed13d$var$_react.default.createElement($82e567917b1ed13d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$82e567917b1ed13d$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $82e567917b1ed13d$var$_default = module.exports.default = $82e567917b1ed13d$var$SidebarCollapseIcon;

});

parcelRegister("6tLwO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f4e0f9a7acbecae432a6a2607234087>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b7a519d0e787ace$var$_react = $4b7a519d0e787ace$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b7a519d0e787ace$var$_baseNew = $4b7a519d0e787ace$var$_interopRequireDefault((parcelRequire("dznjK")));
function $4b7a519d0e787ace$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b7a519d0e787ace$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $4b7a519d0e787ace$var$_react.default.createElement($4b7a519d0e787ace$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$4b7a519d0e787ace$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $4b7a519d0e787ace$var$_default = module.exports.default = $4b7a519d0e787ace$var$SidebarExpandIcon;

});

parcelRegister("cSaPD", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $e00fc765de2423f6$export$c25acd513dcc8062);
$parcel$export(module.exports, "Button", () => $e00fc765de2423f6$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $e00fc765de2423f6$export$29d11c0fe2fc51d8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $igaNe = parcelRequire("igaNe");
var $lPSnc = parcelRequire("lPSnc");
var $bboPA = parcelRequire("bboPA");
var $czCoM = parcelRequire("czCoM");

var $8lqOv = parcelRequire("8lqOv");

var $2yJmb = parcelRequire("2yJmb");
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $e00fc765de2423f6$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $8lqOv.ThemedIconButton) : (0, $lPSnc.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $e00fc765de2423f6$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $8lqOv.ThemedLinkIconButton) : (0, $czCoM.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $e00fc765de2423f6$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $8lqOv.ThemedButton) : (0, $igaNe.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $e00fc765de2423f6$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $8lqOv.ThemedLinkButton) : (0, $bboPA.default);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("czCoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $035b1babede3a757$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jmVNy = parcelRequire("jmVNy");

var $h6LYg = parcelRequire("h6LYg");

var $kTRe2 = parcelRequire("kTRe2");

var $khO3w = parcelRequire("khO3w");

var $g8Dn0 = parcelRequire("g8Dn0");

var $fulm9 = parcelRequire("fulm9");

var $dqnDV = parcelRequire("dqnDV");

var $fq4Zh = parcelRequire("fq4Zh");

var $l8tgK = parcelRequire("l8tgK");
const $035b1babede3a757$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r81 _1hmsagmp _ajmmvv82 _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t"
};
const $035b1babede3a757$var$defaultStyles = {
    root: "_bfhkiw92 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
const $035b1babede3a757$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
const $035b1babede3a757$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
const $035b1babede3a757$var$subtleStyles = {
    root: "_bfhk1w7a _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhk1w7a _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
const $035b1babede3a757$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
const $035b1babede3a757$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $5uXOq.useRef)(null);
    (0, $kTRe2.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8Dn0.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $h6LYg.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $jmVNy.cx)($035b1babede3a757$var$styles.base, appearance === 'default' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$defaultStyles.rootRefreshed : $035b1babede3a757$var$defaultStyles.root), appearance === 'primary' && $035b1babede3a757$var$primaryStyles.root, appearance === 'discovery' && $035b1babede3a757$var$discoveryStyles.root, appearance === 'subtle' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$subtleStyles.rootRefreshed : $035b1babede3a757$var$subtleStyles.root), $035b1babede3a757$var$styles.linkDecorationUnset, isSelected && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$selectedStyles.rootRefreshed : $035b1babede3a757$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
                isSelected && appearance === 'discovery' && $035b1babede3a757$var$selectedStyles.discovery, isDisabled && $035b1babede3a757$var$styles.disabled, spacing === 'compact' && $035b1babede3a757$var$styles.spacingCompact, $035b1babede3a757$var$styles.iconButton),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fq4Zh.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8Dn0.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $h6LYg.default)([
            localRef,
            ref
        ]),
        xcss: (0, $jmVNy.cx)($035b1babede3a757$var$styles.base, appearance === 'default' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$defaultStyles.rootRefreshed : $035b1babede3a757$var$defaultStyles.root), appearance === 'primary' && $035b1babede3a757$var$primaryStyles.root, appearance === 'discovery' && $035b1babede3a757$var$discoveryStyles.root, appearance === 'subtle' && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$subtleStyles.rootRefreshed : $035b1babede3a757$var$subtleStyles.root), $035b1babede3a757$var$styles.linkDecorationUnset, isSelected && ((0, $khO3w.fg)('platform-component-visual-refresh') ? $035b1babede3a757$var$selectedStyles.rootRefreshed : $035b1babede3a757$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $035b1babede3a757$var$selectedStyles.discovery, isDisabled && $035b1babede3a757$var$styles.disabled, $035b1babede3a757$var$styles.iconButton, spacing === 'compact' && $035b1babede3a757$var$styles.spacingCompact),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fq4Zh.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l8tgK.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $035b1babede3a757$var$WithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)($035b1babede3a757$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $035b1babede3a757$var$LinkIconButton = /*#__PURE__*/ (0, $5uXOq.memo)($035b1babede3a757$var$WithRef);
var $035b1babede3a757$export$2e2bcd8739ae039 = $035b1babede3a757$var$LinkIconButton;

});

parcelRegister("8lqOv", function(module, exports) {

$parcel$export(module.exports, "themedButtonBackground", () => $ced7410f20c2a1d0$export$b93b81aa41a8061a);
$parcel$export(module.exports, "themedButtonBackgroundHovered", () => $ced7410f20c2a1d0$export$96a2312c81489aa1);
$parcel$export(module.exports, "themedButtonBackgroundPressed", () => $ced7410f20c2a1d0$export$9db7a918ddfed23e);
$parcel$export(module.exports, "themedButtonBorder", () => $ced7410f20c2a1d0$export$2b00bded80635cbb);
$parcel$export(module.exports, "themedButtonPrimaryText", () => $ced7410f20c2a1d0$export$eca746d7c1a9cd6e);
$parcel$export(module.exports, "themedButtonPrimaryBackground", () => $ced7410f20c2a1d0$export$2c2bc298cddb8aca);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", () => $ced7410f20c2a1d0$export$6b28e650669cd3c7);
$parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", () => $ced7410f20c2a1d0$export$1656be06aad539b9);
$parcel$export(module.exports, "themedButtonSelectedText", () => $ced7410f20c2a1d0$export$c26a897d419ef487);
$parcel$export(module.exports, "themedButtonSelectedBackground", () => $ced7410f20c2a1d0$export$4e50e625ccffdb13);
$parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", () => $ced7410f20c2a1d0$export$55c84c90f36bda4d);
$parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", () => $ced7410f20c2a1d0$export$c5c0213472126c08);
$parcel$export(module.exports, "themedButtonSelectedBorder", () => $ced7410f20c2a1d0$export$22928007ff541429);
$parcel$export(module.exports, "themedButtonDisabledText", () => $ced7410f20c2a1d0$export$787ad93d0f2276af);
$parcel$export(module.exports, "themedButtonDisabledBackground", () => $ced7410f20c2a1d0$export$5e774f44b77335d6);
$parcel$export(module.exports, "ThemedButton", () => $ced7410f20c2a1d0$export$f67fb575035cc7d0);
$parcel$export(module.exports, "ThemedLinkButton", () => $ced7410f20c2a1d0$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedIconButton", () => $ced7410f20c2a1d0$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $ced7410f20c2a1d0$export$a1ab08e79d264ec8);
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $h6LYg = parcelRequire("h6LYg");

var $g8Dn0 = parcelRequire("g8Dn0");
var $b1nnO = parcelRequire("b1nnO");

var $fulm9 = parcelRequire("fulm9");

var $dqnDV = parcelRequire("dqnDV");

var $lObk6 = parcelRequire("lObk6");
/**
 * Returns the spread props to pass through to underlying primitive components.
 *
 * It removes the props which apply styles.
 */ function $ced7410f20c2a1d0$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
const $ced7410f20c2a1d0$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $ced7410f20c2a1d0$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $ced7410f20c2a1d0$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $ced7410f20c2a1d0$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $ced7410f20c2a1d0$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $ced7410f20c2a1d0$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $ced7410f20c2a1d0$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $ced7410f20c2a1d0$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $ced7410f20c2a1d0$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $ced7410f20c2a1d0$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $ced7410f20c2a1d0$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $ced7410f20c2a1d0$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $ced7410f20c2a1d0$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $ced7410f20c2a1d0$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $ced7410f20c2a1d0$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $ced7410f20c2a1d0$var$styles = {
    root: "_zulp12x7 _11c82smr _2rkosqtm _v5649dqc _4bfu18uv _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm18uv _1a3b18uv _9oik18uv _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m3acm _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $ced7410f20c2a1d0$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $ced7410f20c2a1d0$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
};
/**
 * Intentionally an almost-duplicate of `ThemedAnchor` - make sure to update both.
 *
 * See `ThemedAnchor` for more context.
 */ const $ced7410f20c2a1d0$var$ThemedPressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1nnO.default), {
        ...$ced7410f20c2a1d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($ced7410f20c2a1d0$var$styles.root, $ced7410f20c2a1d0$var$shapeStyles[shape], hasBorder && $ced7410f20c2a1d0$var$styles.border, $ced7410f20c2a1d0$var$appearanceStyles[appearance], isSelected && $ced7410f20c2a1d0$var$styles.selected, isDisabled && $ced7410f20c2a1d0$var$styles.disabled),
        isDisabled: isDisabled
    });
});
/**
 * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
 *
 * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
 *
 * Polymorphism had many typing issues and required sacrificing type safety.
 *
 * Render props had problems passing down styles through `xcss` to the `children` function.
 */ const $ced7410f20c2a1d0$var$ThemedAnchor = (0, $lObk6.forwardRefWithGeneric)(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g8Dn0.default), {
        ...$ced7410f20c2a1d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $DEWI6.cx)($ced7410f20c2a1d0$var$styles.root, $ced7410f20c2a1d0$var$shapeStyles[shape], hasBorder && $ced7410f20c2a1d0$var$styles.border, $ced7410f20c2a1d0$var$appearanceStyles[appearance], isSelected && $ced7410f20c2a1d0$var$styles.selected, isDisabled && $ced7410f20c2a1d0$var$styles.disabled)
    });
});
const $ced7410f20c2a1d0$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $ced7410f20c2a1d0$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($ced7410f20c2a1d0$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $ced7410f20c2a1d0$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $ced7410f20c2a1d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $ced7410f20c2a1d0$export$b0b5aeed52623827 = (0, $lObk6.forwardRefWithGeneric)(function ThemedLinkButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($ced7410f20c2a1d0$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $ced7410f20c2a1d0$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    $ced7410f20c2a1d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
const $ced7410f20c2a1d0$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($ced7410f20c2a1d0$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $h6LYg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                        children: label
                    })
                ]
            })
    });
});
const $ced7410f20c2a1d0$export$a1ab08e79d264ec8 = (0, $lObk6.forwardRefWithGeneric)(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $2OMIu.jsxs)($ced7410f20c2a1d0$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $h6LYg.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqnDV.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("lObk6", function(module, exports) {

$parcel$export(module.exports, "forwardRefWithGeneric", () => $d27362a7b1fe1142$export$8ab756e06c5d9001);

var $5uXOq = parcelRequire("5uXOq");
const $d27362a7b1fe1142$export$8ab756e06c5d9001 = (0, $5uXOq.forwardRef);

});


parcelRegister("2yJmb", function(module, exports) {

$parcel$export(module.exports, "HasCustomThemeContext", () => $62cb682405032610$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $62cb682405032610$export$abfcaeeca4ae7a55);

var $5uXOq = parcelRequire("5uXOq");
const $62cb682405032610$export$d158fa15757a1890 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $62cb682405032610$export$abfcaeeca4ae7a55() {
    return (0, $5uXOq.useContext)($62cb682405032610$export$d158fa15757a1890);
}

});


parcelRegister("lEls4", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonElement", () => $f5c6610de344075b$export$9c1768094bef896);
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $f5c6610de344075b$export$fb8fa9a80240785e);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $f5c6610de344075b$export$9c1768094bef896 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $f5c6610de344075b$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $jp7wN.default));

});

parcelRegister("83fqA", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $4eea36be63d648f5$export$4a602ad7e09bdb2c);

var $5uXOq = parcelRequire("5uXOq");

var $cJcMz = parcelRequire("cJcMz");
const $4eea36be63d648f5$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $5uXOq.useContext)((0, $cJcMz.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});
parcelRegister("cJcMz", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", () => $24d2d80433843122$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $24d2d80433843122$export$f6b496b07d1ea493);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $24d2d80433843122$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $24d2d80433843122$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $jp7wN.default));

});


parcelRegister("62gU5", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $d94d508ac6026707$export$477ee35601a0a8ce);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $cJcMz = parcelRequire("cJcMz");
function $d94d508ac6026707$export$477ee35601a0a8ce() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $cJcMz.SetSideNavVisibilityState));
    const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("3d64X", function(module, exports) {

$parcel$export(module.exports, "UserActions", () => $dfcc074ed6804df3$export$2fb70d5e506c6bc2);
/* user-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $8EwzU = parcelRequire("8EwzU");

var $9hm3Z = parcelRequire("9hm3Z");

var $khO3w = parcelRequire("khO3w");

var $gqw9P = parcelRequire("gqw9P");

var $1Gt8L = parcelRequire("1Gt8L");

var $bW0ov = parcelRequire("bW0ov");

var $2yJmb = parcelRequire("2yJmb");

var $cSaPD = parcelRequire("cSaPD");
const $dfcc074ed6804df3$var$containerStyles = {
    root: "_yyhy11wp _1e0c1txw _1bahh9n0 _1ul9zwfg",
    newLayoutStyles: "_1d2y1ris",
    contentMinWidthStyles: "_glte1ris _15ri1mjv _1gs5usvi _ndwch9n0"
};
const $dfcc074ed6804df3$var$listStyles = {
    root: "_zulp1b66 _4cvr1h6o _1e0c1txw",
    hideOnSmallViewport: "_1e0cglyw _181n1txw",
    popupContainer: "_1yt4u2gc"
};
const $dfcc074ed6804df3$export$2fb70d5e506c6bc2 = ({ children: children, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $5uXOq.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $1Gt8L.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $8EwzU.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $dfcc074ed6804df3$var$containerStyles.root,
            (0, $khO3w.fg)('platform_design_system_nav4_top_nav_columns') && $dfcc074ed6804df3$var$containerStyles.newLayoutStyles,
            (0, $khO3w.fg)('platform_design_system_nav4_top_nav_min_widths') && $dfcc074ed6804df3$var$containerStyles.contentMinWidthStyles
        ]),
        children: isMobile ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gqw9P.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2yJmb.HasCustomThemeContext).Provider, {
                    value: false,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bW0ov.List), {
                        xcss: (0, $DEWI6.cx)($dfcc074ed6804df3$var$listStyles.root, $dfcc074ed6804df3$var$listStyles.popupContainer),
                        children: children
                    })
                }),
            trigger: (triggerProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.IconButton), {
                    ...triggerProps,
                    label: showMoreButtonLabel,
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9hm3Z))),
                    isTooltipDisabled: false
                })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bW0ov.List), {
            xcss: (0, $DEWI6.cx)($dfcc074ed6804df3$var$listStyles.root, $dfcc074ed6804df3$var$listStyles.hideOnSmallViewport),
            children: children
        })
    });
};

});
parcelRegister("8EwzU", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $cbdb4c8221500c0a$export$e5c5a5f917a5871c);

var $5uXOq = parcelRequire("5uXOq");
const $cbdb4c8221500c0a$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);

});

parcelRegister("bW0ov", function(module, exports) {

$parcel$export(module.exports, "List", () => $864717c1c686ad87$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $864717c1c686ad87$var$_List({ children: children, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        children: children
    }));
}
const $864717c1c686ad87$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($864717c1c686ad87$var$_List);

});


parcelRegister("2V5Bn", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $9ec91b3859250060$export$5120f2d0b8d4cab8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eE1NA = parcelRequire("eE1NA");
const $9ec91b3859250060$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$9ec91b3859250060$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("eE1NA", function(module, exports) {

$parcel$export(module.exports, "IconButton", () => $755c4b1a55b8eabd$export$c25acd513dcc8062);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lrsUC = parcelRequire("lrsUC");

var $fulm9 = parcelRequire("fulm9");

var $bbRE0 = parcelRequire("bbRE0");

var $9I92I = parcelRequire("9I92I");
const $755c4b1a55b8eabd$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $bbRE0.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrsUC.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $9I92I.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fulm9.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});

});
parcelRegister("bbRE0", function(module, exports) {

$parcel$export(module.exports, "useTheme", () => $52e52d3262f3b6db$export$93d4e7f90805808f);

var $5uXOq = parcelRequire("5uXOq");

var $1L1pK = parcelRequire("1L1pK");
const $52e52d3262f3b6db$export$93d4e7f90805808f = ()=>(0, $5uXOq.useContext)((0, $1L1pK.ThemeContext));

});
parcelRegister("1L1pK", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $f584128e33de101a$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeProvider", () => $f584128e33de101a$export$d8964aec282183a3);

var $5uXOq = parcelRequire("5uXOq");

var $2kaNg = parcelRequire("2kaNg");
const $f584128e33de101a$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5uXOq.createContext)((0, $2kaNg.defaultTheme));
const $f584128e33de101a$export$d8964aec282183a3 = $f584128e33de101a$export$2c657da244d00bd6.Provider;

});
parcelRegister("2kaNg", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $44c643590c882e5f$export$164de7ab8df77ef0);


var $7S9WW = parcelRequire("7S9WW");

var $e0dIA = parcelRequire("e0dIA");
const $44c643590c882e5f$export$eeee8619e1b91cb0 = (0, $e0dIA.generateTheme)({
    name: (0, $7S9WW.DEFAULT_THEME_NAME),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $3568e170f1ea17d7$export$29a4f05edc054374),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)
});
const $44c643590c882e5f$export$164de7ab8df77ef0 = $44c643590c882e5f$export$eeee8619e1b91cb0;

});
parcelRegister("7S9WW", function(module, exports) {

$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $e6843ca8b175f94d$export$77823bc9863eaa03);
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $e6843ca8b175f94d$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $e6843ca8b175f94d$export$2e2bcd8739ae039);


var $fQOFE = parcelRequire("fQOFE");
const $e6843ca8b175f94d$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$b3de0ae08da2ce64), 0.8)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
                backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$b3de0ae08da2ce64), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.6)})`,
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: `var(--ds-surface, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
            color: `var(--ds-text-subtlest, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`
        },
        productHome: {
            backgroundColor: `var(--ds-text-brand, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
            color: `var(--ds-text, ${(0, $3568e170f1ea17d7$export$ad0bacf983b7ddaa)})`,
            borderRight: `1px solid ${`var(--ds-border, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$f563ee71e9ee74cd), 0.3)})`}`,
            // TODO: replace with token after brand refresh
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: '#357DE8',
            textColor: `var(--ds-text, ${(0, $3568e170f1ea17d7$export$ad0bacf983b7ddaa)})`
        },
        primaryButton: {
            active: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.7)})`,
                boxShadow: ''
            },
            default: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$7090862dc3038a9f)})`,
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$7090862dc3038a9f)})`,
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.9)})`,
                boxShadow: ''
            },
            selected: {
                color: `var(--ds-text-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.7)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`
            },
            selectedHover: {
                color: `var(--ds-text-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`,
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $fQOFE.hexToRGBA)((0, $3568e170f1ea17d7$export$226de0355ed012f8), 0.6)})`,
                boxShadow: '',
                borderColor: `var(--ds-border-selected, ${(0, $3568e170f1ea17d7$export$b3de0ae08da2ce64)})`
            }
        },
        search: {
            default: {
                backgroundColor: `var(--ds-background-input, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`,
                borderColor: `var(--ds-border-input, ${(0, $3568e170f1ea17d7$export$d6447c357493214f)})`
            },
            focus: {
                borderColor: `var(--ds-border-focused, ${(0, $3568e170f1ea17d7$export$215b7063051591f1)})`
            },
            hover: {
                backgroundColor: `var(--ds-background-input-hovered, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`
            }
        },
        skeleton: {
            backgroundColor: `var(--ds-background-neutral, ${(0, $3568e170f1ea17d7$export$9fdfb749e33cdf97)})`,
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $e6843ca8b175f94d$var$defaultThemeCopy = JSON.parse(JSON.stringify($e6843ca8b175f94d$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$e6843ca8b175f94d$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$e6843ca8b175f94d$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $e6843ca8b175f94d$export$77823bc9863eaa03 = $e6843ca8b175f94d$var$defaultThemeCopy;
const $e6843ca8b175f94d$export$2491e13b198e597d = 'atlassian';
var $e6843ca8b175f94d$export$2e2bcd8739ae039 = $e6843ca8b175f94d$var$defaultTheme;

});
parcelRegister("fQOFE", function(module, exports) {

$parcel$export(module.exports, "hexToRGBA", () => $bf5f490638df6d9f$export$7229be6d7219ee6a);
$parcel$export(module.exports, "getBoxShadow", () => $bf5f490638df6d9f$export$bba5a971afe05444);
$parcel$export(module.exports, "generateTextColor", () => $bf5f490638df6d9f$export$10a10e7cd1193377);
$parcel$export(module.exports, "getContrastColor", () => $bf5f490638df6d9f$export$77a1051494882576);

var $dBl98 = parcelRequire("dBl98");
const $bf5f490638df6d9f$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $dBl98.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
const $bf5f490638df6d9f$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
const $bf5f490638df6d9f$var$hex = '[a-z0-9]';
const $bf5f490638df6d9f$var$shortHandHexColorPattern = new RegExp(`#(${$bf5f490638df6d9f$var$hex})(${$bf5f490638df6d9f$var$hex})(${$bf5f490638df6d9f$var$hex})`, 'i');
const $bf5f490638df6d9f$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $bf5f490638df6d9f$var$isShortHexColor = (color)=>color && color.length === 4;
const $bf5f490638df6d9f$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$bf5f490638df6d9f$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $bf5f490638df6d9f$var$completeTriplet = (colors)=>`#${$bf5f490638df6d9f$var$repeat(colors[1], 6)}`;
const $bf5f490638df6d9f$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $bf5f490638df6d9f$export$db8d2130677f868c = (color)=>{
    if ($bf5f490638df6d9f$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($bf5f490638df6d9f$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($bf5f490638df6d9f$var$isTriplet(colors)) return $bf5f490638df6d9f$var$completeTriplet(colors);
            else return $bf5f490638df6d9f$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
const $bf5f490638df6d9f$export$10a10e7cd1193377 = (color)=>{
    const converted = $bf5f490638df6d9f$export$db8d2130677f868c(color);
    return (0, $dBl98.default).contrastRatio(converted).hex;
};
const $bf5f490638df6d9f$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$bf5f490638df6d9f$export$7229be6d7219ee6a((0, $dBl98.default).contrast(contrastValue, color).hex, opacityValue);

});


parcelRegister("e0dIA", function(module, exports) {

$parcel$export(module.exports, "generateTheme", () => $44df5fef8e0ee1b3$export$2e4ecffaca289a18);

var $khO3w = parcelRequire("khO3w");

var $7S9WW = parcelRequire("7S9WW");

var $fQOFE = parcelRequire("fQOFE");
const $44df5fef8e0ee1b3$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $44df5fef8e0ee1b3$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $44df5fef8e0ee1b3$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $fQOFE.hexToRGBA)(backgroundColor, 0.65) : (0, $fQOFE.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $fQOFE.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $fQOFE.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $fQOFE.hexToRGBA)(backgroundColor, 0.8) : (0, $fQOFE.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $fQOFE.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $fQOFE.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $fQOFE.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $fQOFE.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $fQOFE.getBoxShadow)('transparent')
        }
    };
};
const $44df5fef8e0ee1b3$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $fQOFE.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $44df5fef8e0ee1b3$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $fQOFE.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $7S9WW.DEFAULT_THEME_NAME)) return (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? (0, $7S9WW.defaultThemeBrandRefresh) : (0, $7S9WW.default);
    return {
        mode: {
            create: $44df5fef8e0ee1b3$var$generateButtonCSSStates($44df5fef8e0ee1b3$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $44df5fef8e0ee1b3$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $44df5fef8e0ee1b3$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                textColor: (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? color : undefined,
                backgroundColor: highlightColor,
                borderRight: `1px solid ${(0, $fQOFE.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $fQOFE.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $fQOFE.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $fQOFE.getBoxShadow)((0, $fQOFE.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $fQOFE.getContrastColor)(0.1, $44df5fef8e0ee1b3$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});




parcelRegister("9I92I", function(module, exports) {

$parcel$export(module.exports, "getIconButtonTheme", () => $279801a43eb98412$export$f32bddcb857301f3);
const $279801a43eb98412$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("ecLCQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::87e7af881897ed302561350d986556a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a577211f4f2bf4a9$var$_react = $a577211f4f2bf4a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a577211f4f2bf4a9$var$_personAvatar = $a577211f4f2bf4a9$var$_interopRequireDefault((parcelRequire("luP7Q")));

var $a577211f4f2bf4a9$var$_userAvatarCircle = $a577211f4f2bf4a9$var$_interopRequireDefault((parcelRequire("5P7lu")));
function $a577211f4f2bf4a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "UserAvatarCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a577211f4f2bf4a9$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $a577211f4f2bf4a9$var$_react.default.createElement($a577211f4f2bf4a9$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $a577211f4f2bf4a9$var$_userAvatarCircle.default
    }, props));
$a577211f4f2bf4a9$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $a577211f4f2bf4a9$var$_default = module.exports.default = $a577211f4f2bf4a9$var$PersonAvatarIcon;

});

parcelRegister("hBEbz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd15106027c0cad2$var$_react = $cd15106027c0cad2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cd15106027c0cad2$var$_baseNew = $cd15106027c0cad2$var$_interopRequireDefault((parcelRequire("dznjK")));
function $cd15106027c0cad2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd15106027c0cad2$var$LogOutIcon = (props)=>/*#__PURE__*/ $cd15106027c0cad2$var$_react.default.createElement($cd15106027c0cad2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$cd15106027c0cad2$var$LogOutIcon.displayName = 'LogOutIcon';
var $cd15106027c0cad2$var$_default = module.exports.default = $cd15106027c0cad2$var$LogOutIcon;

});

parcelRegister("fgQ2m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95792f9115c7157853016297128836bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1e0b71c09ad99ee$var$_react = $b1e0b71c09ad99ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b1e0b71c09ad99ee$var$_settings = $b1e0b71c09ad99ee$var$_interopRequireDefault((parcelRequire("35kHP")));

var $b1e0b71c09ad99ee$var$_settings2 = $b1e0b71c09ad99ee$var$_interopRequireDefault((parcelRequire("2EMkH")));
function $b1e0b71c09ad99ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "SettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1e0b71c09ad99ee$var$SettingsIcon = (props)=>/*#__PURE__*/ $b1e0b71c09ad99ee$var$_react.default.createElement($b1e0b71c09ad99ee$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $b1e0b71c09ad99ee$var$_settings2.default
    }, props));
$b1e0b71c09ad99ee$var$SettingsIcon.Name = 'SettingsIconMigration';
var $b1e0b71c09ad99ee$var$_default = module.exports.default = $b1e0b71c09ad99ee$var$SettingsIcon;

});

parcelRegister("5G33C", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba81665ca216d8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1hBxB = parcelRequire("1hBxB");
const $aba81665ca216d8b$var$PeopleIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PeopleIcon__
 */ const $aba81665ca216d8b$var$PeopleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1hBxB.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $aba81665ca216d8b$var$PeopleIconGlyph
    });
var $aba81665ca216d8b$export$2e2bcd8739ae039 = $aba81665ca216d8b$var$PeopleIcon;

});

parcelRegister("2CYL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $064e27ce9fa97b9e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1hBxB = parcelRequire("1hBxB");
const $064e27ce9fa97b9e$var$PersonIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
/**
 * __PersonIcon__
 */ const $064e27ce9fa97b9e$var$PersonIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1hBxB.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $064e27ce9fa97b9e$var$PersonIconGlyph
    });
var $064e27ce9fa97b9e$export$2e2bcd8739ae039 = $064e27ce9fa97b9e$var$PersonIcon;

});

parcelRegister("jMtG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc44b196ca8ddedc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1hBxB = parcelRequire("1hBxB");
const $fc44b196ca8ddedc$var$SignOutIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        })
    });
/**
 * __SignOutIcon__
 */ const $fc44b196ca8ddedc$var$SignOutIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1hBxB.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $fc44b196ca8ddedc$var$SignOutIconGlyph
    });
var $fc44b196ca8ddedc$export$2e2bcd8739ae039 = $fc44b196ca8ddedc$var$SignOutIcon;

});

parcelRegister("2KGps", function(module, exports) {

$parcel$export(module.exports, "default", () => $b54b86740d5eb3d2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");

var $gHuJ1 = parcelRequire("gHuJ1");

var $Gg9wB = parcelRequire("Gg9wB");

var $khO3w = parcelRequire("khO3w");

var $7OC81 = parcelRequire("7OC81");

var $84eOv = parcelRequire("84eOv");

var $bXfyl = parcelRequire("bXfyl");

var $cFEwY = parcelRequire("cFEwY");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ const $b54b86740d5eb3d2$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $jp7wN.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $84eOv.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $bXfyl.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHuJ1.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Gg9wB.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7OC81.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, $cFEwY.default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            // Thanks to spread props, this attribute are passed to ButtonItem, even though
            // it's not in the component's prop types.
            // @ts-expect-error
            title: title,
            ...(0, $khO3w.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $b54b86740d5eb3d2$export$2e2bcd8739ae039 = $b54b86740d5eb3d2$var$DropdownItemRadio;

});
parcelRegister("7OC81", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b576f62968de9c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eHLiZ = parcelRequire("eHLiZ");

var $khO3w = parcelRequire("khO3w");

/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ const $86b576f62968de9c$var$RadioIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eHLiZ.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $3568e170f1ea17d7$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $3568e170f1ea17d7$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $3568e170f1ea17d7$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $khO3w.fg)('platform-visual-refresh-icons') && (0, $khO3w.fg)('platform-icon-control-migration') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "7.5",
                        fill: "currentColor",
                        stroke: checked ? `var(--ds-border-selected, ${0, $3568e170f1ea17d7$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $3568e170f1ea17d7$export$d6447c357493214f})`,
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "3",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "currentColor",
                        cx: "12",
                        cy: "12",
                        r: "6",
                        stroke: checked ? `var(--ds-border-selected, ${0, $3568e170f1ea17d7$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $3568e170f1ea17d7$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                        fill: "inherit",
                        cx: "12",
                        cy: "12",
                        r: "2"
                    })
                ]
            })
        })
    });
};
var $86b576f62968de9c$export$2e2bcd8739ae039 = $86b576f62968de9c$var$RadioIcon;

});

parcelRegister("84eOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8951a1f0d84b4c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $62gqy = parcelRequire("62gqy");

var $jVzoz = parcelRequire("jVzoz");

var $gmuZ0 = parcelRequire("gmuZ0");
function $ca8951a1f0d84b4c$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $jVzoz.SelectionStoreContext));
    const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $5uXOq.useContext)((0, $62gqy.RadioGroupContext));
    const persistedIsSelected = radioGroupState[id];
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        if (!persistedIsSelected) {
            const nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
	 * - radio state changes any time a radio child is changed
	 * - when it changes we want all radio buttons to update their local state
	 * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
	 */ (0, $5uXOq.useEffect)(()=>{
        setLocalIsSelected(()=>{
            const existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    if (persistedIsSelected === undefined) {
        const existing = getGroupState(group);
        setGroupState(group, {
            ...(0, $gmuZ0.default)(existing || {}),
            [id]: defaultSelected || false
        });
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $ca8951a1f0d84b4c$export$2e2bcd8739ae039 = $ca8951a1f0d84b4c$var$useRadioState;

});
parcelRegister("62gqy", function(module, exports) {

$parcel$export(module.exports, "RadioGroupContext", () => $1842a4ee069fdacf$export$a79eda4ff50e30b6);
$parcel$export(module.exports, "default", () => $1842a4ee069fdacf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");

var $lDwZR = parcelRequire("lDwZR");

var $MmgC6 = parcelRequire("MmgC6");

var $1PK2G = parcelRequire("1PK2G");

var $jVzoz = parcelRequire("jVzoz");

var $gmuZ0 = parcelRequire("gmuZ0");
const $1842a4ee069fdacf$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    id: '',
    radioGroupState: {},
    selectRadioItem: (0, $jp7wN.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ const $1842a4ee069fdacf$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, $jVzoz.SelectionStoreContext));
    const uid = (0, $lDwZR.useId)();
    const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
    /**
	 *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
	 *  - we flush a render by updating this local radio group state
	 */ const [radioGroupState, setRadioGroupState] = (0, $5uXOq.useState)(()=>getGroupState(id));
    const selectRadioItem = (childId, value)=>{
        const newValue = {
            ...(0, $gmuZ0.default)(getGroupState(id)),
            [childId]: value
        };
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($1842a4ee069fdacf$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MmgC6.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PK2G.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $1842a4ee069fdacf$export$2e2bcd8739ae039 = $1842a4ee069fdacf$var$DropdownItemRadioGroup;

});
parcelRegister("gmuZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e709986d73ef876$export$2e2bcd8739ae039);
const $7e709986d73ef876$var$resetOptionsInGroup = (group)=>{
    return Object.keys(group || {}).reduce((accumulator, current)=>({
            ...accumulator,
            [current]: typeof group[current] === 'undefined' ? undefined : false
        }), {});
};
var $7e709986d73ef876$export$2e2bcd8739ae039 = $7e709986d73ef876$var$resetOptionsInGroup;

});



parcelRegister("cFEwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ce66ff7bdd2ff58$export$2e2bcd8739ae039);
const $1ce66ff7bdd2ff58$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ const $1ce66ff7bdd2ff58$var$isVoiceOverSupported = ()=>/Mac OS X/.test($1ce66ff7bdd2ff58$var$canUseDOM() ? navigator.userAgent : '');
var $1ce66ff7bdd2ff58$export$2e2bcd8739ae039 = $1ce66ff7bdd2ff58$var$isVoiceOverSupported;

});


parcelRegister("6T86J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16f3e8522976fe7001db436c90d9bf8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $503e2b1d928264a2$var$_react = $503e2b1d928264a2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $503e2b1d928264a2$var$_baseNew = $503e2b1d928264a2$var$_interopRequireDefault((parcelRequire("dznjK")));
function $503e2b1d928264a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Theme".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing themes and theme switching.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $503e2b1d928264a2$var$ThemeIcon = (props)=>/*#__PURE__*/ $503e2b1d928264a2$var$_react.default.createElement($503e2b1d928264a2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25-5H8a5 5 0 0 1 0 10h-.75z" clip-rule="evenodd"/>`
    }, props));
$503e2b1d928264a2$var$ThemeIcon.displayName = 'ThemeIcon';
var $503e2b1d928264a2$var$_default = module.exports.default = $503e2b1d928264a2$var$ThemeIcon;

});

parcelRegister("5ekJe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::202475837f81ea9047d0b06aafdb41ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cee56d4a6b8888f$var$_react = $3cee56d4a6b8888f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cee56d4a6b8888f$var$_chevronRight = $3cee56d4a6b8888f$var$_interopRequireDefault((parcelRequire("ehTA6")));

var $3cee56d4a6b8888f$var$_chevronRight2 = $3cee56d4a6b8888f$var$_interopRequireDefault((parcelRequire("lt5Id")));
function $3cee56d4a6b8888f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cee56d4a6b8888f$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $3cee56d4a6b8888f$var$_react.default.createElement($3cee56d4a6b8888f$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $3cee56d4a6b8888f$var$_chevronRight2.default
    }, props));
$3cee56d4a6b8888f$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $3cee56d4a6b8888f$var$_default = module.exports.default = $3cee56d4a6b8888f$var$ChevronRightIcon;

});

parcelRegister("8qeBX", function(module, exports) {

$parcel$export(module.exports, "default", () => $36adf92de159ab62$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1hBxB = parcelRequire("1hBxB");
const $36adf92de159ab62$var$ThemeIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        })
    });
/**
 * __ThemeIcon__
 */ const $36adf92de159ab62$var$ThemeIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1hBxB.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $36adf92de159ab62$var$ThemeIconGlyph
    });
var $36adf92de159ab62$export$2e2bcd8739ae039 = $36adf92de159ab62$var$ThemeIcon;

});

parcelRegister("8b5ek", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8757186054f9d759a1f776986ffd32d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f436862b56c9464$var$_react = $5f436862b56c9464$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5f436862b56c9464$var$_backlog = $5f436862b56c9464$var$_interopRequireDefault((parcelRequire("kvRuP")));

var $5f436862b56c9464$var$_backlog2 = $5f436862b56c9464$var$_interopRequireDefault((parcelRequire("hXDbC")));
function $5f436862b56c9464$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BacklogIcon.
 * This component is BacklogIcon, with `UNSAFE_fallbackIcon` set to "BacklogIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f436862b56c9464$var$BacklogIcon = (props)=>/*#__PURE__*/ $5f436862b56c9464$var$_react.default.createElement($5f436862b56c9464$var$_backlog.default, Object.assign({
        LEGACY_fallbackIcon: $5f436862b56c9464$var$_backlog2.default
    }, props));
$5f436862b56c9464$var$BacklogIcon.Name = 'BacklogIconMigration';
var $5f436862b56c9464$var$_default = module.exports.default = $5f436862b56c9464$var$BacklogIcon;

});

parcelRegister("bu7F6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d6de69f6e8d23d80c647d0a6d3ecd7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85c8708de8abd696$var$_react = $85c8708de8abd696$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $85c8708de8abd696$var$_board = $85c8708de8abd696$var$_interopRequireDefault((parcelRequire("j3rn0")));

var $85c8708de8abd696$var$_board2 = $85c8708de8abd696$var$_interopRequireDefault((parcelRequire("3UmH1")));
function $85c8708de8abd696$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardIcon.
 * This component is BoardIcon, with `UNSAFE_fallbackIcon` set to "BoardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85c8708de8abd696$var$BoardIcon = (props)=>/*#__PURE__*/ $85c8708de8abd696$var$_react.default.createElement($85c8708de8abd696$var$_board.default, Object.assign({
        LEGACY_fallbackIcon: $85c8708de8abd696$var$_board2.default
    }, props));
$85c8708de8abd696$var$BoardIcon.Name = 'BoardIconMigration';
var $85c8708de8abd696$var$_default = module.exports.default = $85c8708de8abd696$var$BoardIcon;

});

parcelRegister("1X7F6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e406a416cb0a4f8d2c2370983b384961>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16c13ea2d312fc8d$var$_react = $16c13ea2d312fc8d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $16c13ea2d312fc8d$var$_listBulleted = $16c13ea2d312fc8d$var$_interopRequireDefault((parcelRequire("9TJnh")));

var $16c13ea2d312fc8d$var$_bulletList = $16c13ea2d312fc8d$var$_interopRequireDefault((parcelRequire("az70d")));
function $16c13ea2d312fc8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ListBulletedIcon.
 * This component is ListBulletedIcon, with `UNSAFE_fallbackIcon` set to "BulletListIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16c13ea2d312fc8d$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $16c13ea2d312fc8d$var$_react.default.createElement($16c13ea2d312fc8d$var$_listBulleted.default, Object.assign({
        LEGACY_fallbackIcon: $16c13ea2d312fc8d$var$_bulletList.default
    }, props));
$16c13ea2d312fc8d$var$ListBulletedIcon.Name = 'ListBulletedIconMigration';
var $16c13ea2d312fc8d$var$_default = module.exports.default = $16c13ea2d312fc8d$var$ListBulletedIcon;

});

parcelRegister("c3exJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::540b588acaf0422e358accf8cfb04725>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c610bcf3cc9654d$var$_react = $8c610bcf3cc9654d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c610bcf3cc9654d$var$_issues = $8c610bcf3cc9654d$var$_interopRequireDefault((parcelRequire("8wVbo")));

var $8c610bcf3cc9654d$var$_issues2 = $8c610bcf3cc9654d$var$_interopRequireDefault((parcelRequire("hkwMh")));
function $8c610bcf3cc9654d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for IssuesIcon.
 * This component is IssuesIcon, with `UNSAFE_fallbackIcon` set to "IssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c610bcf3cc9654d$var$IssuesIcon = (props)=>/*#__PURE__*/ $8c610bcf3cc9654d$var$_react.default.createElement($8c610bcf3cc9654d$var$_issues.default, Object.assign({
        LEGACY_fallbackIcon: $8c610bcf3cc9654d$var$_issues2.default
    }, props));
$8c610bcf3cc9654d$var$IssuesIcon.Name = 'IssuesIconMigration';
var $8c610bcf3cc9654d$var$_default = module.exports.default = $8c610bcf3cc9654d$var$IssuesIcon;

});

parcelRegister("oM9OO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::478474977414af6f20354d0841ac3249>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04a7990e189d3467$var$_react = $04a7990e189d3467$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $04a7990e189d3467$var$_roadmap = $04a7990e189d3467$var$_interopRequireDefault((parcelRequire("4H1dp")));

var $04a7990e189d3467$var$_roadmap2 = $04a7990e189d3467$var$_interopRequireDefault((parcelRequire("BDPoy")));
function $04a7990e189d3467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RoadmapIcon.
 * This component is RoadmapIcon, with `UNSAFE_fallbackIcon` set to "RoadmapIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04a7990e189d3467$var$RoadmapIcon = (props)=>/*#__PURE__*/ $04a7990e189d3467$var$_react.default.createElement($04a7990e189d3467$var$_roadmap.default, Object.assign({
        LEGACY_fallbackIcon: $04a7990e189d3467$var$_roadmap2.default
    }, props));
$04a7990e189d3467$var$RoadmapIcon.Name = 'RoadmapIconMigration';
var $04a7990e189d3467$var$_default = module.exports.default = $04a7990e189d3467$var$RoadmapIcon;

});

parcelRegister("azt7J", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d9845af4c347638$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $2Kcun = parcelRequire("2Kcun");

var $jp7wN = parcelRequire("jp7wN");

var $d1YtU = parcelRequire("d1YtU");

var $4QIJ8 = parcelRequire("4QIJ8");

var $2qiW1 = parcelRequire("2qiW1");
function $1d9845af4c347638$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $1d9845af4c347638$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $4QIJ8.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $4QIJ8.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4QIJ8.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $1d9845af4c347638$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $1d9845af4c347638$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $1d9845af4c347638$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $1d9845af4c347638$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $jp7wN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2qiW1.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $1d9845af4c347638$var$baseStyles,
            $1d9845af4c347638$var$focusRingStyles,
            isDisabled ? $1d9845af4c347638$var$disabledStyles : $1d9845af4c347638$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4QIJ8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4QIJ8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4QIJ8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4QIJ8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4QIJ8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4QIJ8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4QIJ8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4QIJ8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children));
});
var $1d9845af4c347638$export$2e2bcd8739ae039 = $1d9845af4c347638$var$Pressable;

});

parcelRegister("6Rw1j", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $c1215ae072506f2d$export$b2ad68b9bc407b80);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2gkpZ = parcelRequire("2gkpZ");
const $c1215ae072506f2d$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo((props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2gkpZ.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $c1215ae072506f2d$export$2e2bcd8739ae039 = $c1215ae072506f2d$export$b2ad68b9bc407b80;

});
parcelRegister("2gkpZ", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $ce6a89482ad7863b$export$ff983d2a2b6112ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3E4mK = parcelRequire("3E4mK");
const $ce6a89482ad7863b$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $3E4mK.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("3E4mK", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $3a1dcff277a77c7d$export$2f62ee6831462844);

var $5uXOq = parcelRequire("5uXOq");
function $3a1dcff277a77c7d$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("iax10", function(module, exports) {

$parcel$export(module.exports, "media", () => $26651c68cd45a2dd$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $26651c68cd45a2dd$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $26651c68cd45a2dd$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $26651c68cd45a2dd$export$c881183ca713c214 = $26651c68cd45a2dd$export$987d49ffe1b0900f;

});

parcelRegister("3kqWs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6526ba72ad9bbb4f9b91ad0dbd2f69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26c8237117df884a$var$_react = $26c8237117df884a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $26c8237117df884a$var$_appSwitcher = $26c8237117df884a$var$_interopRequireDefault((parcelRequire("8cCze")));

var $26c8237117df884a$var$_appSwitcher2 = $26c8237117df884a$var$_interopRequireDefault((parcelRequire("8ONtg")));
function $26c8237117df884a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "AppSwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26c8237117df884a$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $26c8237117df884a$var$_react.default.createElement($26c8237117df884a$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $26c8237117df884a$var$_appSwitcher2.default
    }, props));
$26c8237117df884a$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $26c8237117df884a$var$_default = module.exports.default = $26c8237117df884a$var$AppSwitcherIcon;

});

parcelRegister("hl5gR", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $30b3fcf137c17311$export$21bfbeb62fdcce8d);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $30b3fcf137c17311$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $30b3fcf137c17311$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        svg: $30b3fcf137c17311$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lySgk", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", () => $8c498c3b265a6b2b$export$3c6158790f5e01c4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $8c498c3b265a6b2b$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $8c498c3b265a6b2b$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        svg: $8c498c3b265a6b2b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bkwRL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5383881e67158e6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");

var $jkH3D = parcelRequire("jkH3D");
const $f5383881e67158e6$var$bannerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $65dd50f173d37652$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $65dd50f173d37652$export$238d30785c4bca84)
});
const $f5383881e67158e6$var$bannerFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $65dd50f173d37652$export$750459958906793),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $65dd50f173d37652$export$f963aecf2d4465bd)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $f5383881e67158e6$var$Banner = (props)=>{
    const { children: children, height: height = (0, $65dd50f173d37652$export$be83e7118304b28e), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$bcd94a6a792e7f96), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$bcd94a6a792e7f96)]: bannerHeight
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$bcd94a6a792e7f96)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $f5383881e67158e6$var$bannerStyles,
                isFixed && $f5383881e67158e6$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
            variableName: (0, $65dd50f173d37652$export$bcd94a6a792e7f96),
            value: bannerHeight
        }), children));
};
var $f5383881e67158e6$export$2e2bcd8739ae039 = $f5383881e67158e6$var$Banner;

});
// dimension vars
const $65dd50f173d37652$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $65dd50f173d37652$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $65dd50f173d37652$export$c103b605cd368aed = 'rightSidebarWidth';
const $65dd50f173d37652$export$fa34f417972d6341 = 'rightPanelWidth';
const $65dd50f173d37652$export$3a6a779d9181047c = 'topNavigationHeight';
const $65dd50f173d37652$export$bcd94a6a792e7f96 = 'bannerHeight';
const $65dd50f173d37652$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $65dd50f173d37652$export$344062f7cfc9528e = 'left-panel';
const $65dd50f173d37652$export$c7139cc2d6110b5f = 'right-panel';
const $65dd50f173d37652$export$238d30785c4bca84 = 'banner';
const $65dd50f173d37652$export$bec6dca2e63de4ae = 'top-navigation';
const $65dd50f173d37652$export$d1213e82613ff4df = 'content';
const $65dd50f173d37652$export$be83e7118304b28e = 56;
const $65dd50f173d37652$export$4a98ee0bd1ae362 = 56;
const $65dd50f173d37652$export$539e68c09584883a = 240;
const $65dd50f173d37652$export$b92df8810d2fcd01 = 280;
const $65dd50f173d37652$export$c3e41153b9288bcf = 368;
const $65dd50f173d37652$export$c4d6152f86ea28f6 = 368;
const $65dd50f173d37652$export$46acf8758e9e2636 = 20;
const $65dd50f173d37652$export$70740f5ad8360a78 = 16;
const $65dd50f173d37652$export$991d5285ad765a3d = 240;
const $65dd50f173d37652$export$6949d4f32b161684 = 200;
const $65dd50f173d37652$export$d6e7e8af042815bb = 350;
const $65dd50f173d37652$export$3749e1104328fde4 = 300;
const $65dd50f173d37652$export$1074d925b0b82be5 = 200;
const $65dd50f173d37652$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $65dd50f173d37652$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $65dd50f173d37652$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $65dd50f173d37652$export$70c702a8c5895f03 = 'data-grab-area-line';
const $65dd50f173d37652$export$48a43f91e4becf4e = 'data-grab-area';
const $65dd50f173d37652$export$dac2fb31a9f6844d = 'data-resize-button';
const $65dd50f173d37652$export$9ecd22db14e6c70e = 'data-resize-control';
const $65dd50f173d37652$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $65dd50f173d37652$export$206a08f7f8beb554 = 'Skip to:';
const $65dd50f173d37652$export$659ee746b31b360d = 'data-layout-container';
const $65dd50f173d37652$export$f963aecf2d4465bd = `var(--${$65dd50f173d37652$export$cbfb0f5b2869b17b}, 0px)`;
const $65dd50f173d37652$export$750459958906793 = `var(--${$65dd50f173d37652$export$fa34f417972d6341}, 0px)`;
const $65dd50f173d37652$export$f897e1ed9f8ed251 = `var(--${$65dd50f173d37652$export$a30f2e00489a8957}, 0px)`;
const $65dd50f173d37652$export$b44ab66843c05a69 = `var(--${$65dd50f173d37652$export$c103b605cd368aed}, 0px)`;
const $65dd50f173d37652$export$aeff86a16f13529 = `var(--${$65dd50f173d37652$export$3a6a779d9181047c}, 0px)`;
const $65dd50f173d37652$export$ed7cc0d417ee89e = `var(--${$65dd50f173d37652$export$bcd94a6a792e7f96}, 0px)`;
const $65dd50f173d37652$export$d2fa14f05b61e66 = `var(--${$65dd50f173d37652$export$b6744d31294864fd}, ${$65dd50f173d37652$export$991d5285ad765a3d}px)`;

parcelRegister("gzUCw", function(module, exports) {

$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $ba2b6f37965691f9$export$f8355a2df0f4a946);
$parcel$export(module.exports, "getGridStateFromStorage", () => $ba2b6f37965691f9$export$d95e99d8116d17dc);
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $ba2b6f37965691f9$export$17e3760e0b35f1cd);
$parcel$export(module.exports, "resolveDimension", () => $ba2b6f37965691f9$export$74732e47915c7839);
$parcel$export(module.exports, "getLeftPanelWidth", () => $ba2b6f37965691f9$export$b089e01213f07bd);
$parcel$export(module.exports, "getLeftSidebarPercentage", () => $ba2b6f37965691f9$export$2bca58b6ee823bf7);
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $ba2b6f37965691f9$export$e895e3e8b708ae2a);
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $ba2b6f37965691f9$export$218ece2c32b7db0e);


var $f15aM = parcelRequire("f15aM");
const $ba2b6f37965691f9$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $f15aM.default)().getItem((0, $65dd50f173d37652$export$451e84a45a9e4a75)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $f15aM.default)().setItem((0, $65dd50f173d37652$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $ba2b6f37965691f9$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $f15aM.default)().getItem((0, $65dd50f173d37652$export$451e84a45a9e4a75)) || '{}');
    return storageValue[key];
};
const $ba2b6f37965691f9$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $f15aM.default)().getItem((0, $65dd50f173d37652$export$451e84a45a9e4a75)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $f15aM.default)().setItem((0, $65dd50f173d37652$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
const $ba2b6f37965691f9$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = $ba2b6f37965691f9$export$d95e99d8116d17dc('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
const $ba2b6f37965691f9$export$b089e01213f07bd = ()=>{
    if (typeof window === 'undefined') return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $65dd50f173d37652$export$f963aecf2d4465bd)}`), 10) || 0;
};
const $ba2b6f37965691f9$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
    const total = (currentWidth - (0, $65dd50f173d37652$export$539e68c09584883a)) / (maxWidth - (0, $65dd50f173d37652$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
const $ba2b6f37965691f9$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $65dd50f173d37652$export$5253dd9707b8c3ba)]: slotName
    });
const $ba2b6f37965691f9$export$218ece2c32b7db0e = (slotName)=>`[${0, $65dd50f173d37652$export$5253dd9707b8c3ba}='${slotName}']`;

});
parcelRegister("f15aM", function(module, exports) {

$parcel$export(module.exports, "default", () => $78550fa6ee48403d$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $78550fa6ee48403d$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
const $78550fa6ee48403d$var$safeLocalStorage = ()=>{
    if ($78550fa6ee48403d$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $78550fa6ee48403d$export$2e2bcd8739ae039 = $78550fa6ee48403d$var$safeLocalStorage;

});


parcelRegister("is9Ay", function(module, exports) {

$parcel$export(module.exports, "default", () => $0491823ecdd739d7$export$2e2bcd8739ae039);

var $gzUCw = parcelRequire("gzUCw");
const $0491823ecdd739d7$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $gzUCw.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $gzUCw.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $0491823ecdd739d7$export$2e2bcd8739ae039 = $0491823ecdd739d7$var$publishGridState;

});

parcelRegister("2TSPS", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $f50ccb973aad6c79$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinks", () => $f50ccb973aad6c79$export$c9d9cb2ee9590f87);
$parcel$export(module.exports, "useSkipLink", () => $f50ccb973aad6c79$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $f50ccb973aad6c79$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $jp7wN.default),
    unregisterSkipLink: (0, $jp7wN.default)
});
const $f50ccb973aad6c79$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($f50ccb973aad6c79$export$4c5cc3b14c7678a);
const $f50ccb973aad6c79$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $f50ccb973aad6c79$export$c9d9cb2ee9590f87();
    (0, $5uXOq.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("33OjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf4f0a12893a502$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $4cf4f0a12893a502$var$focusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $3568e170f1ea17d7$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $4cf4f0a12893a502$var$sidebarFocusStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $3568e170f1ea17d7$export$ecfc1dff386a3e7a)})`}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $4cf4f0a12893a502$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($4cf4f0a12893a502$var$sidebarFocusStyles) : css($4cf4f0a12893a502$var$focusStyles)
        }));
};
var $4cf4f0a12893a502$export$2e2bcd8739ae039 = $4cf4f0a12893a502$var$SlotFocusRing;

});

parcelRegister("jkH3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed8ef94ce1d56ce$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iax10 = parcelRequire("iax10");
/**
 * Hoists slot dimension styles to the root element.
 */ const $1ed8ef94ce1d56ce$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $iax10.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};
var $1ed8ef94ce1d56ce$export$2e2bcd8739ae039 = $1ed8ef94ce1d56ce$var$SlotDimensions;

});


parcelRegister("kEDjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea5713752f60a6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

const $7ea5713752f60a6f$var$contentStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $65dd50f173d37652$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $7ea5713752f60a6f$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: $7ea5713752f60a6f$var$contentStyles
    }, children);
};
var $7ea5713752f60a6f$export$2e2bcd8739ae039 = $7ea5713752f60a6f$var$Content;

});

parcelRegister("7SqEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $61c4a2e67798e8ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");

var $jkH3D = parcelRequire("jkH3D");
const $61c4a2e67798e8ab$var$leftPanelStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $65dd50f173d37652$export$344062f7cfc9528e)
});
const $61c4a2e67798e8ab$var$leftPanelFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$f963aecf2d4465bd),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: 0
});
/**
 * __Left panel__
 *
 * Provides a slot for a left panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $61c4a2e67798e8ab$var$LeftPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $65dd50f173d37652$export$c4d6152f86ea28f6), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const leftPanelWidth = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$cbfb0f5b2869b17b), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$cbfb0f5b2869b17b)]: leftPanelWidth
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$cbfb0f5b2869b17b)]: 0
            });
        };
    }, [
        leftPanelWidth
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $61c4a2e67798e8ab$var$leftPanelStyles,
                isFixed && $61c4a2e67798e8ab$var$leftPanelFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('left-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
            variableName: (0, $65dd50f173d37652$export$cbfb0f5b2869b17b),
            value: leftPanelWidth
        }), children));
};
var $61c4a2e67798e8ab$export$2e2bcd8739ae039 = $61c4a2e67798e8ab$var$LeftPanel;

});

parcelRegister("bCiK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b5ab143e8eb170$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $d5MPO = parcelRequire("d5MPO");


var $khO3w = parcelRequire("khO3w");

var $c9ebd = parcelRequire("c9ebd");



var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $hYIym = parcelRequire("hYIym");
var $2TSPS = parcelRequire("2TSPS");

var $6tUgj = parcelRequire("6tUgj");

var $7jdIl = parcelRequire("7jdIl");

var $fM115 = parcelRequire("fM115");

var $gqODm = parcelRequire("gqODm");

var $jkH3D = parcelRequire("jkH3D");
const $41b5ab143e8eb170$var$openBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $3568e170f1ea17d7$export$486ab785e4bac3c6)})`,
    opacity: 1
});
const $41b5ab143e8eb170$var$hiddenBackdropStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $41b5ab143e8eb170$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $5uXOq.useRef)();
    const mouseOverEventRef = (0, $5uXOq.useRef)();
    const leftSideBarRef = (0, $5uXOq.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $hYIym.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $5uXOq.useRef)(isLocked);
    const mouseXRef = (0, $5uXOq.useRef)(0);
    const handlerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $65dd50f173d37652$export$539e68c09584883a));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$b6744d31294864fd), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $65dd50f173d37652$export$46acf8758e9e2636);
    else leftSidebarWidthOnMount = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$a30f2e00489a8957), _width, !width || !collapsedStateOverrideOpen && (0, $gzUCw.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $5uXOq.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $gzUCw.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $gzUCw.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $65dd50f173d37652$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $65dd50f173d37652$export$b6744d31294864fd], (0, $65dd50f173d37652$export$539e68c09584883a)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $65dd50f173d37652$export$b6744d31294864fd] ? Math.max(cachedGridState[0, $65dd50f173d37652$export$b6744d31294864fd], (0, $65dd50f173d37652$export$539e68c09584883a)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $65dd50f173d37652$export$46acf8758e9e2636);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $65dd50f173d37652$export$b6744d31294864fd)]: lastLeftSidebarWidth
            });
            (0, $gzUCw.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $65dd50f173d37652$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $65dd50f173d37652$export$dac2fb31a9f6844d)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $65dd50f173d37652$export$1074d925b0b82be5));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $65dd50f173d37652$export$dac2fb31a9f6844d)}]`) || event.target.matches(`[${(0, $65dd50f173d37652$export$dac2fb31a9f6844d)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $65dd50f173d37652$export$1074d925b0b82be5));
    };
    const mobileMediaQuery = (0, $c9ebd.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $c9ebd.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $65dd50f173d37652$export$46acf8758e9e2636),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $65dd50f173d37652$export$539e68c09584883a)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $d5MPO.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    // We use both the state and our effect-based ref to protect animation until initialized fully
    const isReady = (0, $khO3w.fg)('platform_dst_concurrent_left_sidebar_width') ? hasInit && notFirstRun.current : notFirstRun.current;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $41b5ab143e8eb170$var$hiddenBackdropStyles,
            isFlyoutOpen && $41b5ab143e8eb170$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fM115.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
        variableName: (0, $65dd50f173d37652$export$a30f2e00489a8957),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $65dd50f173d37652$export$70740f5ad8360a78)
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7jdIl.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gqODm.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6tUgj.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $41b5ab143e8eb170$export$2e2bcd8739ae039 = $41b5ab143e8eb170$var$LeftSidebar;

});
parcelRegister("c9ebd", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $71c6ae1be81a9620$export$49e55ae2c03d6045);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $8EwzU = parcelRequire("8EwzU");

var $iax10 = parcelRequire("iax10");
const $71c6ae1be81a9620$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $iax10.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $71c6ae1be81a9620$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $71c6ae1be81a9620$var$queries[queryString];
    (0, $8EwzU.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $cBeZP.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});

parcelRegister("hYIym", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $4e282b214e1e5e02$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $4e282b214e1e5e02$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $4e282b214e1e5e02$export$94561f6055639ef7);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $4e282b214e1e5e02$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $4e282b214e1e5e02$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $jp7wN.default),
    collapseLeftSidebar: (0, $jp7wN.default),
    leftSidebarState: $4e282b214e1e5e02$var$leftSidebarState,
    setLeftSidebarState: (0, $jp7wN.default),
    toggleLeftSidebar: (0, $jp7wN.default)
});
const $4e282b214e1e5e02$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($4e282b214e1e5e02$export$aa5a712eea4c2ae8);
    return context;
};
const $4e282b214e1e5e02$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($4e282b214e1e5e02$export$aa5a712eea4c2ae8);
    (0, $5uXOq.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});

parcelRegister("6tUgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $26eaee630fdf579d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $c9ebd = parcelRequire("c9ebd");


var $gzUCw = parcelRequire("gzUCw");

var $hYIym = parcelRequire("hYIym");

var $91696 = parcelRequire("91696");

var $bYO5m = parcelRequire("bYO5m");

var $7h28P = parcelRequire("7h28P");
function $26eaee630fdf579d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26eaee630fdf579d$var$cssSelector = {
    [(0, $65dd50f173d37652$export$9ecd22db14e6c70e)]: true
};
const $26eaee630fdf579d$var$resizeControlStyles = {
    name: "ow3ovp",
    styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
};
const $26eaee630fdf579d$var$showResizeButtonStyles = {
    name: "1a6byq5",
    styles: "--ds--resize-button--opacity:1"
};
// @ts-expect-error adding `!important` to style rules is currently a type error
const $26eaee630fdf579d$var$globalResizingStyles = {
    name: "e4avm6",
    styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
};
const $26eaee630fdf579d$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, $hYIym.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, $65dd50f173d37652$export$a30f2e00489a8957]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $5uXOq.useRef)(0);
    const keyboardEventTimeout = (0, $5uXOq.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
    const unbindEvents = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $c9ebd.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
    (0, $5uXOq.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $65dd50f173d37652$export$a30f2e00489a8957] - (0, $gzUCw.getLeftPanelWidth)();
        unbindEvents.current = (0, $cBeZP.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $65dd50f173d37652$export$46acf8758e9e2636));
                        document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $65dd50f173d37652$export$802bb2c050f3db5c), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $65dd50f173d37652$export$802bb2c050f3db5c));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, $7nRxN.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $gzUCw.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $65dd50f173d37652$export$46acf8758e9e2636) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $65dd50f173d37652$export$46acf8758e9e2636));
            document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $65dd50f173d37652$export$802bb2c050f3db5c));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $65dd50f173d37652$export$6949d4f32b161684)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${(0, $65dd50f173d37652$export$46acf8758e9e2636)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $65dd50f173d37652$export$6949d4f32b161684) && sidebarWidth.current < (0, $65dd50f173d37652$export$539e68c09584883a)) {
            document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${(0, $65dd50f173d37652$export$539e68c09584883a)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: (0, $65dd50f173d37652$export$539e68c09584883a),
                lastLeftSidebarWidth: (0, $65dd50f173d37652$export$539e68c09584883a)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $gzUCw.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $65dd50f173d37652$export$539e68c09584883a)) {
                width = (0, $65dd50f173d37652$export$539e68c09584883a);
                document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${(0, $65dd50f173d37652$export$539e68c09584883a) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $65dd50f173d37652$export$539e68c09584883a);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $65dd50f173d37652$export$a30f2e00489a8957)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $5uXOq.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $gzUCw.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $gzUCw.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$26eaee630fdf579d$var$cssSelector,
        css: [
            $26eaee630fdf579d$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $26eaee630fdf579d$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7h28P.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $91696.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $bYO5m.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.Global), {
        styles: $26eaee630fdf579d$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26eaee630fdf579d$export$2e2bcd8739ae039 = $26eaee630fdf579d$var$ResizeControl;

});
parcelRegister("91696", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3811db9845c700$export$2e2bcd8739ae039);
/* eslint-disable react/react-in-jsx-scope */ /**
                                               * @jsxRuntime classic
                                               * @jsx jsx
                                               */ 
var $f8Sb3 = parcelRequire("f8Sb3");


function $8a3811db9845c700$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $8a3811db9845c700$var$varLineColor = '--ds-line';
const $8a3811db9845c700$var$grabAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$8a3811db9845c700$var$varLineColor]: `var(--ds-border-selected, ${(0, $3568e170f1ea17d7$export$215b7063051591f1)})`
    }
});
const $8a3811db9845c700$var$grabAreaCollapsedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $8a3811db9845c700$var$lineStyles = {
    name: "w4swnc",
    styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
};
const $8a3811db9845c700$var$grabAreaLineSelector = {
    [(0, $65dd50f173d37652$export$70c702a8c5895f03)]: true
};
const $8a3811db9845c700$var$grabAreaSelector = {
    [(0, $65dd50f173d37652$export$48a43f91e4becf4e)]: true
};
const $8a3811db9845c700$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$8a3811db9845c700$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $8a3811db9845c700$var$grabAreaStyles,
            isLeftSidebarCollapsed && $8a3811db9845c700$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $8a3811db9845c700$var$lineStyles,
        ...$8a3811db9845c700$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a3811db9845c700$export$2e2bcd8739ae039 = $8a3811db9845c700$var$GrabArea;

});

parcelRegister("bYO5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $88976c4c155cac91$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
                                                                                                                                                 * @jsxRuntime classic
                                                                                                                                                 * @jsx jsx
                                                                                                                                                 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $5ekJe = parcelRequire("5ekJe");


var $8xP8U = parcelRequire("8xP8U");

var $iax10 = parcelRequire("iax10");


function $88976c4c155cac91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88976c4c155cac91$var$increaseHitAreaStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $88976c4c155cac91$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $88976c4c155cac91$var$resizeIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- TODO: https://product-fabric.atlassian.net/browse/DSP-3392; this boxShadow needs further investigation, along with the hover and active background colors.
    boxShadow: `0 0 0 1px ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)}`,
    color: `var(--ds-text-subtle, ${(0, $3568e170f1ea17d7$export$f563ee71e9ee74cd)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $8xP8U.durations).small}ms linear,
    color ${(0, $8xP8U.durations).small}ms linear,
    opacity ${(0, $8xP8U.durations).medium}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $3568e170f1ea17d7$export$ecfc1dff386a3e7a)})`,
        color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $3568e170f1ea17d7$export$215b7063051591f1)})`,
        color: `var(--ds-text-inverse, ${(0, $3568e170f1ea17d7$export$29a4f05edc054374)})`,
        opacity: 1
    }
});
const $88976c4c155cac91$var$resizeIconButtonExpandedStyles = {
    name: "1bl2513",
    styles: "transform:rotate(180deg);transform-origin:7px"
};
const $88976c4c155cac91$var$preventDefault = (event)=>event.preventDefault();
const $88976c4c155cac91$var$cssSelector = {
    [(0, $65dd50f173d37652$export$dac2fb31a9f6844d)]: true
};
const $88976c4c155cac91$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        ...$88976c4c155cac91$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $88976c4c155cac91$var$resizeIconButtonStyles,
            $88976c4c155cac91$var$mobileStyles,
            !isLeftSidebarCollapsed && $88976c4c155cac91$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $88976c4c155cac91$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5ekJe))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $88976c4c155cac91$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$88976c4c155cac91$export$2e2bcd8739ae039 = $88976c4c155cac91$var$ResizeButton;

});

parcelRegister("7h28P", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d604aaab0ea939f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $vM5OW = parcelRequire("vM5OW");
const $4d604aaab0ea939f$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $4d604aaab0ea939f$var$direction = 'to left';
const $4d604aaab0ea939f$var$transitionDuration = '0.22s';
const $4d604aaab0ea939f$var$shadowStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$4d604aaab0ea939f$var$direction}, ${$4d604aaab0ea939f$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $4d604aaab0ea939f$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)
});
const $4d604aaab0ea939f$var$draggingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$4d604aaab0ea939f$var$direction}, ${$4d604aaab0ea939f$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $4d604aaab0ea939f$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $vM5OW.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        "data-testid": testId,
        css: [
            $4d604aaab0ea939f$var$shadowStyles,
            isDragging && $4d604aaab0ea939f$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4d604aaab0ea939f$export$2e2bcd8739ae039 = $4d604aaab0ea939f$var$Shadow;

});
parcelRegister("vM5OW", function(module, exports) {

$parcel$export(module.exports, "default", () => $38d9c361f9a28d74$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $38d9c361f9a28d74$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $65dd50f173d37652$export$802bb2c050f3db5c)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $38d9c361f9a28d74$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $5uXOq.useState)($38d9c361f9a28d74$var$getIsDragging);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($38d9c361f9a28d74$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $65dd50f173d37652$export$802bb2c050f3db5c)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $38d9c361f9a28d74$export$2e2bcd8739ae039 = $38d9c361f9a28d74$var$useIsSidebarDragging;

});



parcelRegister("7jdIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5da456aee6ba443$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1H1cG = parcelRequire("1H1cG");

var $iax10 = parcelRequire("iax10");


var $vM5OW = parcelRequire("vM5OW");
function $c5da456aee6ba443$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c5da456aee6ba443$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $1H1cG.prefersReducedMotion)());
const $c5da456aee6ba443$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $65dd50f173d37652$export$70740f5ad8360a78)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $65dd50f173d37652$export$ed7cc0d417ee89e)} + ${(0, $65dd50f173d37652$export$aeff86a16f13529)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $65dd50f173d37652$export$f963aecf2d4465bd)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`
    }
});
const $c5da456aee6ba443$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $65dd50f173d37652$export$d6e7e8af042815bb)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $65dd50f173d37652$export$d6e7e8af042815bb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $c5da456aee6ba443$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $65dd50f173d37652$export$f897e1ed9f8ed251)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $65dd50f173d37652$export$ed7cc0d417ee89e)} + ${(0, $65dd50f173d37652$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $65dd50f173d37652$export$f963aecf2d4465bd)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`
});
const $c5da456aee6ba443$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$d2fa14f05b61e66)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $c5da456aee6ba443$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $c5da456aee6ba443$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $c5da456aee6ba443$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $vM5OW.default)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            // mobile viewport styles
            $c5da456aee6ba443$var$mobileStyles,
            isFlyoutOpen && $c5da456aee6ba443$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $c5da456aee6ba443$var$staticInnerStyles,
            isFixed && $c5da456aee6ba443$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $c5da456aee6ba443$var$fixedInnerFlyoutStyles,
            isDragging && $c5da456aee6ba443$var$draggingStyles,
            $c5da456aee6ba443$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c5da456aee6ba443$export$2e2bcd8739ae039 = $c5da456aee6ba443$var$LeftSidebarInner;

});

parcelRegister("fM115", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5e3a1600acbf95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1H1cG = parcelRequire("1H1cG");

var $iax10 = parcelRequire("iax10");


var $vM5OW = parcelRequire("vM5OW");

var $gzUCw = parcelRequire("gzUCw");

var $hYIym = parcelRequire("hYIym");

var $33OjM = parcelRequire("33OjM");
function $dd5e3a1600acbf95$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $dd5e3a1600acbf95$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $1H1cG.prefersReducedMotion)());
const $dd5e3a1600acbf95$var$mobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $65dd50f173d37652$export$70740f5ad8360a78),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $65dd50f173d37652$export$d6e7e8af042815bb),
            content: "''"
        }
    }
});
const $dd5e3a1600acbf95$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $dd5e3a1600acbf95$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$f897e1ed9f8ed251),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $dd5e3a1600acbf95$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $dd5e3a1600acbf95$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $65dd50f173d37652$export$f897e1ed9f8ed251)}`,
        content: "''"
    }
});
const $dd5e3a1600acbf95$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$d2fa14f05b61e66)
});
const $dd5e3a1600acbf95$var$flyoutFixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$46acf8758e9e2636)
});
const $dd5e3a1600acbf95$var$selector = (0, $gzUCw.getPageLayoutSlotSelector)('left-sidebar');
const $dd5e3a1600acbf95$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $vM5OW.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, $hYIym.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                // mobile viewport styles
                $dd5e3a1600acbf95$var$mobileStyles,
                isFlyoutOpen && $dd5e3a1600acbf95$var$mobileFlyoutStyles,
                // generic styles
                $dd5e3a1600acbf95$var$outerStyles,
                isFixed && $dd5e3a1600acbf95$var$fixedStyles,
                isFlyoutOpen && $dd5e3a1600acbf95$var$flyoutStyles,
                isFlyoutOpen && isFixed && $dd5e3a1600acbf95$var$flyoutFixedStyles,
                isDragging && $dd5e3a1600acbf95$var$draggingStyles,
                $dd5e3a1600acbf95$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$dd5e3a1600acbf95$var$selector
        }, children));
};
const $dd5e3a1600acbf95$var$LeftSidebarOuter = /*#__PURE__*/ (0, $5uXOq.forwardRef)($dd5e3a1600acbf95$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd5e3a1600acbf95$export$2e2bcd8739ae039 = $dd5e3a1600acbf95$var$LeftSidebarOuter;

});

parcelRegister("gqODm", function(module, exports) {

$parcel$export(module.exports, "default", () => $848afaa256fbf0a5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $1H1cG = parcelRequire("1H1cG");


var $dhx4m = parcelRequire("dhx4m");
function $848afaa256fbf0a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $848afaa256fbf0a5$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $1H1cG.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $848afaa256fbf0a5$var$hideLeftSidebarContentsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $65dd50f173d37652$export$3749e1104328fde4) - 100}ms`,
    visibility: 'hidden'
});
const $848afaa256fbf0a5$var$resizableChildrenWrapperStyles = {
    name: "xz78rr",
    styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
};
const $848afaa256fbf0a5$var$fixedChildrenWrapperStyles = {
    name: "ax3w45",
    styles: "min-width:240px;height:100%"
};
const $848afaa256fbf0a5$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $dhx4m.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $848afaa256fbf0a5$var$resizableChildrenWrapperStyles,
            isHidden && $848afaa256fbf0a5$var$hideLeftSidebarContentsStyles,
            $848afaa256fbf0a5$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $848afaa256fbf0a5$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$848afaa256fbf0a5$export$2e2bcd8739ae039 = $848afaa256fbf0a5$var$ResizableChildrenWrapper;

});
parcelRegister("dhx4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a88fe699ac45f493$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $a88fe699ac45f493$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $65dd50f173d37652$export$5e5e1875c3fd8f4f)) === 'true';
};
const $a88fe699ac45f493$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($a88fe699ac45f493$var$getIsCollapsing);
    (0, $5uXOq.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($a88fe699ac45f493$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $65dd50f173d37652$export$5e5e1875c3fd8f4f)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $a88fe699ac45f493$export$2e2bcd8739ae039 = $a88fe699ac45f493$var$useIsSidebarCollapsing;

});



parcelRegister("bL8Bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6615ef0c0615294f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $7jdIl = parcelRequire("7jdIl");

var $fM115 = parcelRequire("fM115");

var $jkH3D = parcelRequire("jkH3D");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $6615ef0c0615294f$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$a30f2e00489a8957), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: leftSidebarWidth
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$a30f2e00489a8957)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fM115.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
        variableName: (0, $65dd50f173d37652$export$a30f2e00489a8957),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7jdIl.default), {
        isFixed: isFixed
    }, children));
};
var $6615ef0c0615294f$export$2e2bcd8739ae039 = $6615ef0c0615294f$var$LeftSidebarWithoutResize;

});

parcelRegister("BWstY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5c33c8ec02d5cc1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $1H1cG = parcelRequire("1H1cG");



var $vM5OW = parcelRequire("vM5OW");

var $gzUCw = parcelRequire("gzUCw");

var $hYIym = parcelRequire("hYIym");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");
function $b5c33c8ec02d5cc1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b5c33c8ec02d5cc1$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $1H1cG.prefersReducedMotion)());
const $b5c33c8ec02d5cc1$var$mainStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $65dd50f173d37652$export$3749e1104328fde4)}ms ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)} 0s`
});
const $b5c33c8ec02d5cc1$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $b5c33c8ec02d5cc1$var$flyoutStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $65dd50f173d37652$export$b6744d31294864fd)}, ${(0, $65dd50f173d37652$export$991d5285ad765a3d)}px) + ${(0, $65dd50f173d37652$export$46acf8758e9e2636)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $b5c33c8ec02d5cc1$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $vM5OW.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, $hYIym.SidebarResizeContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("main", {
            "data-testid": testId,
            css: [
                $b5c33c8ec02d5cc1$var$mainStyles,
                isDragging && $b5c33c8ec02d5cc1$var$draggingStyles,
                isFlyoutOpen && !isFixed && $b5c33c8ec02d5cc1$var$flyoutStyles,
                $b5c33c8ec02d5cc1$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('main')
        }, children));
};
var $b5c33c8ec02d5cc1$export$2e2bcd8739ae039 = $b5c33c8ec02d5cc1$var$Main;

});

parcelRegister("fajHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced24151ae6c91a1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $iax10 = parcelRequire("iax10");


var $bBgvW = parcelRequire("bBgvW");
var $6jK4d = parcelRequire("6jK4d");

var $cHdIS = parcelRequire("cHdIS");
const $ced24151ae6c91a1$var$pageLayoutSelector = {
    [(0, $65dd50f173d37652$export$659ee746b31b360d)]: true
};
const $ced24151ae6c91a1$var$gridTemplateAreasMobile = `
${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$238d30785c4bca84)}"
  ${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$bec6dca2e63de4ae)}"
  ${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$d1213e82613ff4df)}"
 `;
const $ced24151ae6c91a1$var$gridTemplateAreas = `
${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$238d30785c4bca84)} ${(0, $65dd50f173d37652$export$c7139cc2d6110b5f)}"
  ${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$bec6dca2e63de4ae)} ${(0, $65dd50f173d37652$export$c7139cc2d6110b5f)}"
${''}
  "${(0, $65dd50f173d37652$export$344062f7cfc9528e)} ${(0, $65dd50f173d37652$export$d1213e82613ff4df)} ${(0, $65dd50f173d37652$export$c7139cc2d6110b5f)}"
 `;
const $ced24151ae6c91a1$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $ced24151ae6c91a1$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $65dd50f173d37652$export$f963aecf2d4465bd)} minmax(0, 1fr) ${(0, $65dd50f173d37652$export$750459958906793)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $65dd50f173d37652$export$ed7cc0d417ee89e)} ${(0, $65dd50f173d37652$export$aeff86a16f13529)} auto`,
    outline: 'none'
});
const $ced24151ae6c91a1$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $iax10.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $ced24151ae6c91a1$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $65dd50f173d37652$export$f963aecf2d4465bd)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $ced24151ae6c91a1$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $65dd50f173d37652$export$206a08f7f8beb554), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6jK4d.SkipLinksController), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cHdIS.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...$ced24151ae6c91a1$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $ced24151ae6c91a1$var$gridStyles,
            $ced24151ae6c91a1$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bBgvW.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $ced24151ae6c91a1$export$2e2bcd8739ae039 = $ced24151ae6c91a1$var$PageLayout;

});
parcelRegister("bBgvW", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $4d05c4542298b13a$export$850bd1bba41f1448);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $jp7wN = parcelRequire("jp7wN");

var $1H1cG = parcelRequire("1H1cG");

var $c9ebd = parcelRequire("c9ebd");


var $gzUCw = parcelRequire("gzUCw");

var $hYIym = parcelRequire("hYIym");
const $4d05c4542298b13a$var$handleDataAttributesAndCb = (callback = (0, $jp7wN.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $65dd50f173d37652$export$5e5e1875c3fd8f4f));
    callback(leftSidebarState);
};
const $4d05c4542298b13a$var$leftSidebarSelector = (0, $gzUCw.getPageLayoutSlotCSSSelector)('left-sidebar');
const $4d05c4542298b13a$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $5uXOq.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $5uXOq.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $5uXOq.useRef)(null);
    const mobileMediaQuery = (0, $c9ebd.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $65dd50f173d37652$export$46acf8758e9e2636),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $4d05c4542298b13a$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $65dd50f173d37652$export$539e68c09584883a));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4d05c4542298b13a$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($4d05c4542298b13a$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $1H1cG.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $65dd50f173d37652$export$46acf8758e9e2636),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $4d05c4542298b13a$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $65dd50f173d37652$export$5e5e1875c3fd8f4f), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $65dd50f173d37652$export$46acf8758e9e2636),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $4d05c4542298b13a$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($4d05c4542298b13a$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $1H1cG.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $cBeZP.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $5uXOq.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $5uXOq.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hYIym.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("6jK4d", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $4dda01d2dd4cd7b1$export$da7be99d6a868f3d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");


var $2TSPS = parcelRequire("2TSPS");
const $4dda01d2dd4cd7b1$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $65dd50f173d37652$export$5253dd9707b8c3ba)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $4dda01d2dd4cd7b1$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($4dda01d2dd4cd7b1$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2TSPS.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("cHdIS", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $bae1de0e91c48a98$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9ywyf = parcelRequire("9ywyf");

var $1H1cG = parcelRequire("1H1cG");



var $2TSPS = parcelRequire("2TSPS");
function $bae1de0e91c48a98$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bae1de0e91c48a98$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $1H1cG.prefersReducedMotion)());
const $bae1de0e91c48a98$var$skipLinkStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)}, 0 2px 10px ${(0, $3568e170f1ea17d7$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $3568e170f1ea17d7$export$d2d3bedfb276cac0)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $bd0d8a12aecb8cfa$export$57636bb43b1ccbb0)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $bae1de0e91c48a98$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $bae1de0e91c48a98$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $bae1de0e91c48a98$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $bae1de0e91c48a98$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $bae1de0e91c48a98$var$assignIndex(num + 1, arr);
};
const $bae1de0e91c48a98$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $2TSPS.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $bae1de0e91c48a98$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $65dd50f173d37652$export$659ee746b31b360d)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $65dd50f173d37652$export$206a08f7f8beb554);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $bae1de0e91c48a98$var$skipLinkStyles,
            $bae1de0e91c48a98$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $f8Sb3.jsx)("p", {
        css: $bae1de0e91c48a98$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("ol", {
        css: $bae1de0e91c48a98$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $f8Sb3.jsx)($bae1de0e91c48a98$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $bae1de0e91c48a98$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $bae1de0e91c48a98$var$handleBlur);
};
const $bae1de0e91c48a98$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $bae1de0e91c48a98$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $bae1de0e91c48a98$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("li", {
        css: $bae1de0e91c48a98$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9ywyf.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $bae1de0e91c48a98$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("aHJyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ecdb5b8072541b2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");

var $jkH3D = parcelRequire("jkH3D");
const $8ecdb5b8072541b2$var$baseStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $65dd50f173d37652$export$c7139cc2d6110b5f)
});
const $8ecdb5b8072541b2$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$750459958906793),
    position: 'fixed',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineEnd: 0
});
/**
 * __Right panel__
 *
 * Provides a slot for a right panel within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $8ecdb5b8072541b2$var$RightPanel = (props)=>{
    const { children: children, isFixed: isFixed, width: width = (0, $65dd50f173d37652$export$c3e41153b9288bcf), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightPanelWidth = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$fa34f417972d6341), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$fa34f417972d6341)]: rightPanelWidth
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$fa34f417972d6341)]: 0
            });
        };
    }, [
        rightPanelWidth
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $8ecdb5b8072541b2$var$baseStyles,
                isFixed && $8ecdb5b8072541b2$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('right-panel')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
            variableName: (0, $65dd50f173d37652$export$fa34f417972d6341),
            value: rightPanelWidth
        }), children));
};
var $8ecdb5b8072541b2$export$2e2bcd8739ae039 = $8ecdb5b8072541b2$var$RightPanel;

});

parcelRegister("1hvnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10a7ceab4d2ca35$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");

var $jkH3D = parcelRequire("jkH3D");
function $b10a7ceab4d2ca35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $b10a7ceab4d2ca35$var$fixedInnerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $65dd50f173d37652$export$b44ab66843c05a69),
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $65dd50f173d37652$export$ed7cc0d417ee89e)} + ${(0, $65dd50f173d37652$export$aeff86a16f13529)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: `calc(${(0, $65dd50f173d37652$export$750459958906793)})`
});
const $b10a7ceab4d2ca35$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $b10a7ceab4d2ca35$var$outerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: (0, $65dd50f173d37652$export$b44ab66843c05a69)
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $b10a7ceab4d2ca35$var$fixedOuterStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $65dd50f173d37652$export$b44ab66843c05a69),
        content: "''"
    }
});
/**
 * __Right sidebar__
 *
 * Provides a slot for a right sidebar within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $b10a7ceab4d2ca35$var$RightSidebar = (props)=>{
    const { children: children, width: width = (0, $65dd50f173d37652$export$b92df8810d2fcd01), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const rightSidebarWidth = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$c103b605cd368aed), width, shouldPersistWidth);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$c103b605cd368aed)]: rightSidebarWidth
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$c103b605cd368aed)]: 0
            });
        };
    }, [
        rightSidebarWidth,
        id
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), {
        isSidebar: true
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            "data-testid": testId,
            css: [
                $b10a7ceab4d2ca35$var$outerStyles,
                isFixed && $b10a7ceab4d2ca35$var$fixedOuterStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('right-sidebar')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
            variableName: (0, $65dd50f173d37652$export$c103b605cd368aed),
            value: rightSidebarWidth
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                isFixed && $b10a7ceab4d2ca35$var$fixedInnerStyles,
                !isFixed && $b10a7ceab4d2ca35$var$staticInnerStyles
            ]
        }, children)));
};
var $b10a7ceab4d2ca35$export$2e2bcd8739ae039 = $b10a7ceab4d2ca35$var$RightSidebar;

});

parcelRegister("dBPf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f927e5d80c74aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");


var $gzUCw = parcelRequire("gzUCw");

var $is9Ay = parcelRequire("is9Ay");
var $2TSPS = parcelRequire("2TSPS");

var $33OjM = parcelRequire("33OjM");

var $jkH3D = parcelRequire("jkH3D");
const $13f927e5d80c74aa$var$topNavigationStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $65dd50f173d37652$export$aeff86a16f13529),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $65dd50f173d37652$export$bec6dca2e63de4ae)
});
const $13f927e5d80c74aa$var$fixedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $65dd50f173d37652$export$ed7cc0d417ee89e),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $65dd50f173d37652$export$750459958906793),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $65dd50f173d37652$export$f963aecf2d4465bd)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $13f927e5d80c74aa$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $65dd50f173d37652$export$4a98ee0bd1ae362), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $gzUCw.resolveDimension)((0, $65dd50f173d37652$export$3a6a779d9181047c), height, shouldPersistHeight);
    (0, $5uXOq.useEffect)(()=>{
        (0, $is9Ay.default)({
            [(0, $65dd50f173d37652$export$3a6a779d9181047c)]: topNavigationHeight
        });
        return ()=>{
            (0, $is9Ay.default)({
                [(0, $65dd50f173d37652$export$3a6a779d9181047c)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $2TSPS.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $33OjM.default), null, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: [
                $13f927e5d80c74aa$var$topNavigationStyles,
                isFixed && $13f927e5d80c74aa$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $gzUCw.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jkH3D.default), {
            variableName: (0, $65dd50f173d37652$export$3a6a779d9181047c),
            value: topNavigationHeight
        }), children));
};
var $13f927e5d80c74aa$export$2e2bcd8739ae039 = $13f927e5d80c74aa$var$TopNavigation;

});

parcelRegister("6WkqX", function(module, exports) {

$parcel$export(module.exports, "useCustomSkipLink", () => $381b9ce151224e53$export$ee6b12c2613bdf8e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $2TSPS = parcelRequire("2TSPS");
const $381b9ce151224e53$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $2TSPS.useSkipLinks)();
    (0, $5uXOq.useEffect)(()=>{
        registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle,
            listIndex: listIndex
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        listIndex,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});

parcelRegister("iyWoe", function(module, exports) {

$parcel$export(module.exports, "Aside", () => $3a71726ebb8452d5$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kpUo7 = parcelRequire("kpUo7");

var $khO3w = parcelRequire("khO3w");

var $iax10 = parcelRequire("iax10");

var $5wdx2 = parcelRequire("5wdx2");

var $aH3xI = parcelRequire("aH3xI");

var $5RLyk = parcelRequire("5RLyk");

var $hA9Sj = parcelRequire("hA9Sj");

var $f2BWk = parcelRequire("f2BWk");

var $fetp2 = parcelRequire("fetp2");
const $3a71726ebb8452d5$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $3a71726ebb8452d5$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $3a71726ebb8452d5$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $3a71726ebb8452d5$var$getResizeBounds() {
    return $3a71726ebb8452d5$var$asideWidthResizeBounds;
}
const $3a71726ebb8452d5$var$styles = {
    root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8",
    fullHeight: "_4t3i1osq"
};
function $3a71726ebb8452d5$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $5RLyk.DangerouslyHoistSlotSizes));
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5wdx2.useSkipLinkInternal)({
        id: CID,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 && (0, $khO3w.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $kpUo7.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $5uXOq.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$3a71726ebb8452d5$var$asideWidthSlotBounds.min}, ${width}px, ${$3a71726ebb8452d5$var$asideWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("aside", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $3a71726ebb8452d5$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $aH3xI.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aH3xI.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: (0, $iax10.media).above.md,
                responsiveValue: asideVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2BWk.PanelSplitterProvider), {
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $3a71726ebb8452d5$var$getResizeBounds,
                resizingCssVar: $3a71726ebb8452d5$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        (0, $khO3w.fg)('platform_dst_aside_scroll_container_full_height') && $3a71726ebb8452d5$var$styles.fullHeight,
                        isFixed && $3a71726ebb8452d5$var$styles.fixedContentArea
                    ]),
                    children: children
                })
            })
        ]
    });
}

});
parcelRegister("5wdx2", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContext", () => $50e7e9fd57986b8a$export$4c5cc3b14c7678a);
$parcel$export(module.exports, "useSkipLinkInternal", () => $50e7e9fd57986b8a$export$707b94c26b8b75aa);
$parcel$export(module.exports, "useSkipLink", () => $50e7e9fd57986b8a$export$89d9323301efc7d6);

var $5uXOq = parcelRequire("5uXOq");

var $jp7wN = parcelRequire("jp7wN");
const $50e7e9fd57986b8a$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerSkipLink: (0, $jp7wN.default),
    unregisterSkipLink: (0, $jp7wN.default)
});
const $50e7e9fd57986b8a$var$useSkipLinks = ()=>(0, $5uXOq.useContext)($50e7e9fd57986b8a$export$4c5cc3b14c7678a);
const $50e7e9fd57986b8a$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $50e7e9fd57986b8a$var$useSkipLinks();
    (0, $5uXOq.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};
const $50e7e9fd57986b8a$export$89d9323301efc7d6 = (id, label, listIndex)=>{
    $50e7e9fd57986b8a$export$707b94c26b8b75aa({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("aH3xI", function(module, exports) {

$parcel$export(module.exports, "sideNavVar", () => $655996f0e4f141ce$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $655996f0e4f141ce$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $655996f0e4f141ce$export$db0c2e1d744fb281);
$parcel$export(module.exports, "bannerMountedVar", () => $655996f0e4f141ce$export$515a0b1baafe906c);
$parcel$export(module.exports, "topBarMountedVar", () => $655996f0e4f141ce$export$a96e934b2a1eeee);
$parcel$export(module.exports, "UNSAFE_topBarVar", () => $655996f0e4f141ce$export$f4afb213f937404c);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $655996f0e4f141ce$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $655996f0e4f141ce$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $655996f0e4f141ce$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $655996f0e4f141ce$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $655996f0e4f141ce$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $655996f0e4f141ce$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $655996f0e4f141ce$export$166d8fd766c3eb92);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ // These are "compressed" to discourage usage.
const $655996f0e4f141ce$export$951bf5156e86d974 = '--n_sNvw';
const $655996f0e4f141ce$export$594e6a30db7c057e = '--n_asDw';
const $655996f0e4f141ce$export$db0c2e1d744fb281 = '--n_pnlW';
const $655996f0e4f141ce$export$515a0b1baafe906c = '--n_bnrM';
const $655996f0e4f141ce$export$a96e934b2a1eeee = '--n_tbrM';
const $655996f0e4f141ce$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
const $655996f0e4f141ce$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
const $655996f0e4f141ce$export$f4afb213f937404c = '--topNavigationHeight';
const $655996f0e4f141ce$export$26354f9814213292 = '--bannerHeight';
const $655996f0e4f141ce$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $655996f0e4f141ce$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $655996f0e4f141ce$export$753bf7651b25db91 = '--rightPanelWidth';
const $655996f0e4f141ce$export$6460bd6a2446260 = `calc(var(${$655996f0e4f141ce$export$26354f9814213292}, 0px) + var(${$655996f0e4f141ce$export$f4afb213f937404c}, 0px))`;
const $655996f0e4f141ce$export$3055529fab2b4edf = `var(${$655996f0e4f141ce$export$6bfc931a04ec5741}, 0px)`;
const $655996f0e4f141ce$export$166d8fd766c3eb92 = `calc(var(${$655996f0e4f141ce$export$bbbace2ff0c7ae1b}, 0px) + var(${$655996f0e4f141ce$export$753bf7651b25db91}, 0px))`;
const $655996f0e4f141ce$export$61156ceb1a99f6a0 = {
    topBar: 4,
    banner: 4,
    topBarBorder: 3,
    sideNav: 2,
    contentBlockBorder: 2,
    contentInlineBorder: 1,
    panelSmallViewports: 1
};

});

parcelRegister("5RLyk", function(module, exports) {

$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $b47edb3910925688$export$66e2c1a0115af861);

var $5uXOq = parcelRequire("5uXOq");
const $b47edb3910925688$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});

parcelRegister("hA9Sj", function(module, exports) {

$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $d1a1501988c746b3$export$cfa3cd08d675e56e);
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $d1a1501988c746b3$export$9f45a1325e3cdfb8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cySqR = parcelRequire("cySqR");
const $d1a1501988c746b3$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: `#${(0, $cySqR.gridRootId)} { ${variableName}: ${value}px }`
    });
const $d1a1501988c746b3$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $d1a1501988c746b3$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$d1a1501988c746b3$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$d1a1501988c746b3$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $2OMIu.jsx)("style", {
        children: style
    }));
};

});
parcelRegister("cySqR", function(module, exports) {

$parcel$export(module.exports, "gridRootId", () => $fa27b88b82290792$export$a6d827031bcb31d1);
$parcel$export(module.exports, "Root", () => $fa27b88b82290792$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $yuFPF = parcelRequire("yuFPF");

var $khO3w = parcelRequire("khO3w");

var $cFw2M = parcelRequire("cFw2M");

var $3PSYo = parcelRequire("3PSYo");

var $4fveb = parcelRequire("4fveb");

var $5RLyk = parcelRequire("5RLyk");

var $iNX7f = parcelRequire("iNX7f");

var $h0UAG = parcelRequire("h0UAG");
const $fa27b88b82290792$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $fa27b88b82290792$var$styles = {
    root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
};
function $fa27b88b82290792$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        var child;
    }, []);
    // OpenLayerObserver is only added when the feature flag is enabled. When disabled, it is only around `SideNav`.
    const OpenLayerObserverIfEnabled = (0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $yuFPF.OpenLayerObserver) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h0UAG.SideNavVisibilityProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iNX7f.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3PSYo.HomeActionsProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(OpenLayerObserverIfEnabled, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5RLyk.DangerouslyHoistSlotSizes).Provider, {
                        value: UNSAFE_dangerouslyHoistSlotSizes,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4fveb.SkipLinksProvider), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFw2M.SkipLinksContainer), {
                                    label: skipLinksLabel,
                                    testId: testId
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    ref: ref,
                                    className: (0, $bwpsq.default)([
                                        $fa27b88b82290792$var$styles.root,
                                        xcss
                                    ]),
                                    id: $fa27b88b82290792$export$a6d827031bcb31d1,
                                    "data-testid": testId,
                                    children: children
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("yuFPF", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserver", () => $0041f4c8fcc0f74e$export$97afddda23bcd287);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $khO3w = parcelRequire("khO3w");

var $86pCB = parcelRequire("86pCB");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $0041f4c8fcc0f74e$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $0041f4c8fcc0f74e$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $0041f4c8fcc0f74e$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $0041f4c8fcc0f74e$var$createInternalAPI() {
    /**
	 * The previous data structures are still used if fg('platform_dst_open_layer_observer_close_layers')
	 * is disabled.
	 */ let openLayerCountLegacy = 0;
    const changeListenerRegistryLegacy = new Set();
    /**
	 * These are the new data structures that will be used if fg('platform_dst_open_layer_observer_close_layers')
	 * is enabled.
	 */ /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The `onClose` listeners for each namespace.
	 * Each layer provides an `onClose` callback. **When the layer is open**, its `onClose`
	 * callback is registered in this set.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerCloseListenerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($0041f4c8fcc0f74e$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $0041f4c8fcc0f74e$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * If a namespace is provided, the count for that namespace is returned.
	 * Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace } = {}) {
        if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) return openLayerCountLegacy;
        if (namespace) return namespaceToLayerCloseListenerRegistry.get(namespace)?.size ?? 0;
        // A specific namespace was not requested, so we return the sum across all namespaces.
        return $0041f4c8fcc0f74e$var$getTotalOpenLayerCount(namespaceToLayerCloseListenerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) {
            changeListenerRegistryLegacy.add(wrapped);
            return function unsubscribe() {
                changeListenerRegistryLegacy.delete(wrapped);
            };
        }
        const namespace = providedNamespace ?? $0041f4c8fcc0f74e$var$noNamespaceSymbol;
        const listenersForNamespace = $0041f4c8fcc0f74e$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function increment() {
        if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy += 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * This function will be removed with fg('platform_dst_open_layer_observer_close_layers')
	 */ function decrement() {
        if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) {
            openLayerCountLegacy -= 1;
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(changeListenerRegistryLegacy).forEach((listener)=>listener({
                    count: openLayerCountLegacy
                }));
            return;
        }
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace }) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onClose` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onClose`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped() {
            listener();
        }
        const namespace = providedNamespace ?? $0041f4c8fcc0f74e$var$noNamespaceSymbol;
        const listenersForNamespace = $0041f4c8fcc0f74e$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerCloseListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerCloseListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerCloseListenerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach((listener)=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        increment: increment,
        decrement: decrement,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $0041f4c8fcc0f74e$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $5uXOq.useState)(()=>$0041f4c8fcc0f74e$var$createInternalAPI());
    const parentContext = (0, $5uXOq.useContext)((0, $86pCB.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $3joPi.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $86pCB.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}

});

parcelRegister("cFw2M", function(module, exports) {

$parcel$export(module.exports, "SkipLinksContainer", () => $be3c6f2d544f2525$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $1lQB4 = parcelRequire("1lQB4");

var $aZzuG = parcelRequire("aZzuG");

var $iP9lH = parcelRequire("iP9lH");
const $be3c6f2d544f2525$var$styles = {
    root: "_2rkoglpi _1rjcu2gc _18zr12x7 _kqsw1n9t _1e02v47k _152tv47k _bfhk1bhr _16qs1cd0 _1pby1mrw _tzy4idpf _lcxvglyw _1digjh3g _1mygkb7n _18eu1wug",
    rootToAdd: "_zulp1b66 _1rjcutpp _18zrutpp _1e0c1txw _2lx21bp4",
    skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t",
    skipLinkListToAdd: "_zulp1b66 _1e0c1txw _2lx21bp4 _1pfhze3t"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them if you press TAB it will reopen the list and move to the next one...
 */ const $be3c6f2d544f2525$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $be3c6f2d544f2525$var$isOnlyWhitespaceRegex = /^\s*$/;
const $be3c6f2d544f2525$export$fce25a0c32fbc1e1 = ({ label: label, testId: testId })=>{
    const sortedSkipLinks = (0, $aZzuG.useSortedSkipLinks)();
    if (sortedSkipLinks.length === 0) return null;
    const isEmptyLabel = $be3c6f2d544f2525$var$isOnlyWhitespaceRegex.test(label);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        onKeyDown: $be3c6f2d544f2525$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $bwpsq.default)([
            $be3c6f2d544f2525$var$styles.root,
            (0, $khO3w.fg)('platform_design_system_nav4_skip_link_styling') && $be3c6f2d544f2525$var$styles.rootToAdd
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lQB4.default), {
                weight: (0, $khO3w.fg)('platform_design_system_nav4_skip_link_styling') ? 'bold' : 'medium',
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("ol", {
                className: (0, $bwpsq.default)([
                    $be3c6f2d544f2525$var$styles.skipLinkList,
                    (0, $khO3w.fg)('platform_design_system_nav4_skip_link_styling') && $be3c6f2d544f2525$var$styles.skipLinkListToAdd
                ]),
                children: sortedSkipLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iP9lH.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
};

});
parcelRegister("aZzuG", function(module, exports) {

$parcel$export(module.exports, "SkipLinksDataContext", () => $ffce20d5a41e0f6f$export$e9ab38ce6147d3d2);
$parcel$export(module.exports, "useSortedSkipLinks", () => $ffce20d5a41e0f6f$export$b0b0d4fc1b356759);

var $5uXOq = parcelRequire("5uXOq");
const $ffce20d5a41e0f6f$export$e9ab38ce6147d3d2 = /*#__PURE__*/ (0, $5uXOq.createContext)([]);
const $ffce20d5a41e0f6f$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $ffce20d5a41e0f6f$var$assignIndex(num + 1, arr);
};
const $ffce20d5a41e0f6f$var$sortSkipLinks = (arr)=>{
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
        const listIndex = $ffce20d5a41e0f6f$var$assignIndex(idx, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIdx
    ].sort((a, b)=>a.listIndex - b.listIndex);
};
const $ffce20d5a41e0f6f$export$b0b0d4fc1b356759 = ()=>{
    const skipLinksData = (0, $5uXOq.useContext)($ffce20d5a41e0f6f$export$e9ab38ce6147d3d2);
    return (0, $5uXOq.useMemo)(()=>{
        return $ffce20d5a41e0f6f$var$sortSkipLinks(skipLinksData);
    }, [
        skipLinksData
    ]);
};

});

parcelRegister("iP9lH", function(module, exports) {

$parcel$export(module.exports, "SkipLink", () => $5749fae1874e23dd$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $j8VBM = parcelRequire("j8VBM");
const $5749fae1874e23dd$var$styles = {
    skipLinkListItem: "_1pfhze3t"
};
/**
 * Used for moving focus to the corresponding slot or custom target after clicking on a skip link.
 */ function $5749fae1874e23dd$var$focusElement(element) {
    /**
   * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
   * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
   *
   * Our slots are not interactive, so this is required.
   *
   * In the future we may want to check if there is an existing `tabindex` attribute,
   * as custom skip linked elements might already have one.
   */ element.setAttribute('tabindex', '-1');
    /**
   * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
   */ (0, $cBeZP.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
   * Move focus to the slot or custom target.
   *
   * Calling `.focus()` will also scroll the element into view:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
   */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        // @ts-expect-error - new and not in types yet
        focusVisible: true
    });
}
const $5749fae1874e23dd$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate })=>{
    const href = `#${id}`;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
        const target = document.getElementById(id);
        if (!target) return;
        /**
     * Internal slots can attach an `onBeforeNavigate` callback.
     *
     * Side nav uses this to ensure it is expanded.
     */ onBeforeNavigate?.();
        $5749fae1874e23dd$var$focusElement(target);
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("li", {
        className: (0, $bwpsq.default)([
            $5749fae1874e23dd$var$styles.skipLinkListItem
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j8VBM.default), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: onClick,
            children: children
        })
    });
};

});
parcelRegister("j8VBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $64db75ac9d59f74a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3joPi = parcelRequire("3joPi");

var $2Kcun = parcelRequire("2Kcun");

var $lpIMO = parcelRequire("lpIMO");

var $jp7wN = parcelRequire("jp7wN");

var $lDwZR = parcelRequire("lDwZR");

var $d1YtU = parcelRequire("d1YtU");

var $dqnDV = parcelRequire("dqnDV");

var $4QIJ8 = parcelRequire("4QIJ8");

var $2qiW1 = parcelRequire("2qiW1");
function $64db75ac9d59f74a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $64db75ac9d59f74a$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $4QIJ8.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $4QIJ8.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $4QIJ8.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $64db75ac9d59f74a$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $64db75ac9d59f74a$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $64db75ac9d59f74a$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $64db75ac9d59f74a$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $64db75ac9d59f74a$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $jp7wN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $d1YtU.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $lDwZR.useId)();
    const onClick = (0, $2Kcun.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2qiW1.parseXcss)(xcss);
    const RouterLink = (0, $lpIMO.default)();
    const isExternal = typeof href === 'string' && $64db75ac9d59f74a$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $64db75ac9d59f74a$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $64db75ac9d59f74a$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $64db75ac9d59f74a$var$baseStyles,
            $64db75ac9d59f74a$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $4QIJ8.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $4QIJ8.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $4QIJ8.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $4QIJ8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $4QIJ8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $4QIJ8.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $4QIJ8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $4QIJ8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dqnDV.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $64db75ac9d59f74a$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $64db75ac9d59f74a$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)($64db75ac9d59f74a$var$AnchorNoRef);
var $64db75ac9d59f74a$export$2e2bcd8739ae039 = $64db75ac9d59f74a$var$Anchor;

});



parcelRegister("3PSYo", function(module, exports) {

$parcel$export(module.exports, "HomeActionsProvider", () => $13e31dd45ae6c738$export$8b9089606266983e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i1BVz = parcelRequire("i1BVz");
const $13e31dd45ae6c738$export$8b9089606266983e = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i1BVz.HomeActionsElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i1BVz.HomeActionsAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("4fveb", function(module, exports) {

$parcel$export(module.exports, "SkipLinksProvider", () => $cee04328de6dfaf1$export$fe514f9f7b03d46f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5wdx2 = parcelRequire("5wdx2");

var $aZzuG = parcelRequire("aZzuG");
const $cee04328de6dfaf1$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
const $cee04328de6dfaf1$export$fe514f9f7b03d46f = ({ children: children })=>{
    const [links, setLinks] = (0, $5uXOq.useState)([]);
    const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($cee04328de6dfaf1$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wdx2.SkipLinksContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aZzuG.SkipLinksDataContext).Provider, {
            value: links,
            children: children
        })
    });
};

});

parcelRegister("iNX7f", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $36fd67f7c9dfefbb$export$ceb8e60e9790fc0f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lEls4 = parcelRequire("lEls4");
const $36fd67f7c9dfefbb$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEls4.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEls4.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};

});

parcelRegister("h0UAG", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityProvider", () => $136b02f3a9ca1286$export$aac8e996360f6ad9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cJcMz = parcelRequire("cJcMz");
const $136b02f3a9ca1286$export$aac8e996360f6ad9 = ({ children: children })=>{
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $5uXOq.useState)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJcMz.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJcMz.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};

});



parcelRegister("f2BWk", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterProvider", () => $646e3687a75c2830$export$f662bfb764348932);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i45yb = parcelRequire("i45yb");
const $646e3687a75c2830$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
    const portalRef = (0, $5uXOq.useRef)(null);
    const context = (0, $5uXOq.useMemo)(()=>({
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            getResizeBounds: getResizeBounds,
            portalRef: portalRef,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            isEnabled: isEnabled
        }), [
        isEnabled,
        onCompleteResize,
        panelRef,
        panelWidth,
        position,
        getResizeBounds,
        resizingCssVar
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i45yb.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};

});
parcelRegister("i45yb", function(module, exports) {

$parcel$export(module.exports, "PanelSplitterContext", () => $77304382dd22ec7e$export$7a4054f2c546f2cd);

var $5uXOq = parcelRequire("5uXOq");
const $77304382dd22ec7e$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("fetp2", function(module, exports) {

$parcel$export(module.exports, "usePrefixedUID", () => $dd3f8df75cbc49ad$export$86433d4fd18455f4);

var $lDwZR = parcelRequire("lDwZR");
const $dd3f8df75cbc49ad$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, $lDwZR.useId)()}`;

});


parcelRegister("g1xGJ", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $fa7c9032dd08f0e8$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $5wdx2 = parcelRequire("5wdx2");

var $aH3xI = parcelRequire("aH3xI");

var $5RLyk = parcelRequire("5RLyk");

var $hA9Sj = parcelRequire("hA9Sj");

var $fetp2 = parcelRequire("fetp2");
const $fa7c9032dd08f0e8$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
};
function $fa7c9032dd08f0e8$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: id }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $5RLyk.DangerouslyHoistSlotSizes));
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    /**
   * Don't show the skip link if the slot has 0 height.
   */ (0, $5wdx2.useSkipLinkInternal)({
        id: CID,
        label: skipLinkLabel,
        isHidden: UNSAFE_height === 0 && (0, $khO3w.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: CID,
        "data-layout-slot": true,
        className: (0, $bwpsq.default)([
            $fa7c9032dd08f0e8$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.HoistCssVarToLocalGrid), {
                variableName: (0, $aH3xI.bannerMountedVar),
                value: UNSAFE_height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aH3xI.UNSAFE_bannerVar),
                value: UNSAFE_height
            }),
            children
        ]
    });
}

});

parcelRegister("dnXMT", function(module, exports) {

$parcel$export(module.exports, "Main", () => $ebb06c22951205cd$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5wdx2 = parcelRequire("5wdx2");

var $fetp2 = parcelRequire("fetp2");

var $1im8U = parcelRequire("1im8U");
const $ebb06c22951205cd$var$mainElementStyles = {
    root: "_nd5l1gzg _19121cl4 _qwfh1wug",
    fixedContentArea: "_1reo1wug _18m91wug _152t1l7u _165t1run _13wn1if8"
};
function $ebb06c22951205cd$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, skipLinkLabel: skipLinkLabel = 'Main Content', testId: testId, id: id }) {
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $5wdx2.useSkipLink)(CID, skipLinkLabel);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: CID,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $ebb06c22951205cd$var$mainElementStyles.root,
                isFixed && $ebb06c22951205cd$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1im8U.MainStickyContext).Provider, {
                value: Boolean(isFixed),
                children: children
            })
        })
    });
}

});
parcelRegister("1im8U", function(module, exports) {

$parcel$export(module.exports, "MainStickyContext", () => $a940c0134e336e48$export$3b369e2c6c1ec840);

var $5uXOq = parcelRequire("5uXOq");
const $a940c0134e336e48$export$3b369e2c6c1ec840 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);

});


parcelRegister("dr1JF", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $c20a99b0de658952$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $iax10 = parcelRequire("iax10");

var $5wdx2 = parcelRequire("5wdx2");

var $aH3xI = parcelRequire("aH3xI");

var $5RLyk = parcelRequire("5RLyk");

var $hA9Sj = parcelRequire("hA9Sj");

var $f2BWk = parcelRequire("f2BWk");

var $fetp2 = parcelRequire("fetp2");
const $c20a99b0de658952$var$panelSplitterResizingVar = '--n_pnlRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $c20a99b0de658952$var$panelWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $c20a99b0de658952$var$panelWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $c20a99b0de658952$var$getResizeBounds() {
    return $c20a99b0de658952$var$panelWidthResizeBounds;
}
const $c20a99b0de658952$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
};
function $c20a99b0de658952$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: id, xcss: xcss }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $5RLyk.DangerouslyHoistSlotSizes));
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5wdx2.useSkipLinkInternal)({
        id: CID,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 && (0, $khO3w.fg)('platform_design_system_nav4_hide_empty_skip_links')
    });
    const ref = (0, $5uXOq.useRef)(null);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $5uXOq.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const panelVariableWidth = `clamp(${$c20a99b0de658952$var$panelWidthSlotBounds.min}, ${width}px, ${$c20a99b0de658952$var$panelWidthSlotBounds.max})`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        id: CID,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $bwpsq.default)([
            $c20a99b0de658952$var$styles.root,
            defaultWidth === 0 && $c20a99b0de658952$var$styles.hidden,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $aH3xI.panelVar)]: panelVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aH3xI.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $iax10.media).above.lg,
                responsiveValue: panelVariableWidth
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2BWk.PanelSplitterProvider), {
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $c20a99b0de658952$var$getResizeBounds,
                resizingCssVar: $c20a99b0de658952$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $c20a99b0de658952$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}

});

parcelRegister("cjYeH", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $eb26a1d7f7b00be4$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $yuFPF = parcelRequire("yuFPF");
var $hpxxo = parcelRequire("hpxxo");
var $gxBKw = parcelRequire("gxBKw");

var $khO3w = parcelRequire("khO3w");

var $jDeIq = parcelRequire("jDeIq");

var $iax10 = parcelRequire("iax10");

var $i1BVz = parcelRequire("i1BVz");

var $5wdx2 = parcelRequire("5wdx2");

var $aH3xI = parcelRequire("aH3xI");

var $5RLyk = parcelRequire("5RLyk");

var $hA9Sj = parcelRequire("hA9Sj");

var $f2BWk = parcelRequire("f2BWk");

var $fetp2 = parcelRequire("fetp2");


var $lEls4 = parcelRequire("lEls4");

var $2jQJ3 = parcelRequire("2jQJ3");

var $83fqA = parcelRequire("83fqA");

var $8Ry0n = parcelRequire("8Ry0n");

var $62gU5 = parcelRequire("62gU5");

var $cJcMz = parcelRequire("cJcMz");
const $eb26a1d7f7b00be4$var$panelSplitterResizingVar = '--n_snvRsz';
const $eb26a1d7f7b00be4$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $eb26a1d7f7b00be4$var$getResizeBounds() {
    return $eb26a1d7f7b00be4$var$widthResizeBounds;
}
const $eb26a1d7f7b00be4$var$openLayerObserverSideNavNamespace = 'side-nav';
const $eb26a1d7f7b00be4$var$styles = {
    root: "_nd5l1b6c _t51zzgxb _bfhk1bhr _16qs1cd0 _vchhusvi _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $eb26a1d7f7b00be4$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: id }) {
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    const expandSideNav = (0, $2jQJ3.useExpandSideNav)();
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   */ const synchronouslyExpandSideNav = (0, $5uXOq.useCallback)(()=>{
        (0, $7nsd3.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $5wdx2.useSkipLinkInternal)({
        id: CID,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $5uXOq.useContext)((0, $cJcMz.SideNavVisibilityState));
    const setSideNavState = (0, $5uXOq.useContext)((0, $cJcMz.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $83fqA.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $5uXOq.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
    const clampedWidth = `clamp(${$eb26a1d7f7b00be4$var$widthResizeBounds.min}, ${width}px, ${$eb26a1d7f7b00be4$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $5RLyk.DangerouslyHoistSlotSizes));
    const navRef = (0, $5uXOq.useRef)(null);
    const toggleButtonElement = (0, $5uXOq.useContext)((0, $lEls4.SideNavToggleButtonElement));
    const homeActionsElement = (0, $5uXOq.useContext)((0, $i1BVz.HomeActionsElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $gxBKw.useOpenLayerObserver)();
    const flyoutStateRef = (0, $5uXOq.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $5uXOq.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $0d1087cf1696adbb$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $eb26a1d7f7b00be4$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $62gU5.useToggleSideNav)();
    (0, $5uXOq.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        });
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        });
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $8Ry0n.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $5uXOq.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $5uXOq.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        if (!(0, $khO3w.fg)('platform_design_system_side_nav_click_out_to_close')) // Checking the gate quite early for the best safety + perf measurements
        return;
        return (0, $cBeZP.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                toggleVisibility();
            }
        });
    }, [
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $cBeZP.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $cBeZP.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $jDeIq.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement || !toggleButtonElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === homeActionsElement) {
                    // The mouse is directly over the home actions container, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the home actions container that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!homeActionsElement) return;
        return (0, $cBeZP.bind)(homeActionsElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the home actions container, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        homeActionsElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, top bar home actions element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $eb26a1d7f7b00be4$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("nav", {
        id: CID,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $aH3xI.sideNavVar)]: clampedWidth
        },
        ref: navRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            $eb26a1d7f7b00be4$var$styles.root,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $eb26a1d7f7b00be4$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $eb26a1d7f7b00be4$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $eb26a1d7f7b00be4$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $eb26a1d7f7b00be4$var$styles.flyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $eb26a1d7f7b00be4$var$styles.flyoutAnimateClosed
        ]),
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $aH3xI.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $iax10.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2BWk.PanelSplitterProvider), {
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $eb26a1d7f7b00be4$var$getResizeBounds,
                resizingCssVar: $eb26a1d7f7b00be4$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $eb26a1d7f7b00be4$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $eb26a1d7f7b00be4$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    // OpenLayerObserver is moving to `Root` when the feature flag is enabled.
    const Wrapper = (0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers') ? (0, $5uXOq.Fragment) : (0, $yuFPF.OpenLayerObserver);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hpxxo.OpenLayerObserverNamespaceProvider), {
            namespace: $eb26a1d7f7b00be4$var$openLayerObserverSideNavNamespace,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($eb26a1d7f7b00be4$var$SideNavInternal, {
                defaultCollapsed: defaultCollapsed,
                defaultWidth: defaultWidth,
                testId: testId,
                label: label,
                skipLinkLabel: skipLinkLabel,
                onExpand: onExpand,
                onCollapse: onCollapse,
                id: id,
                children: children
            })
        })
    });
}

});
parcelRegister("hpxxo", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $13f16cc3e5a39ebc$export$327d0d2a7ae6f7cc);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $ukFB3 = parcelRequire("ukFB3");

var $6mqnT = parcelRequire("6mqnT");
function $13f16cc3e5a39ebc$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $6mqnT.useOpenLayerObserverNamespace)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $3joPi.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ukFB3.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

parcelRegister("gxBKw", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserver", () => $f629573ea538eb7a$export$750f5b0d6c51617e);
$parcel$export(module.exports, "useOpenLayerObserverBehindFG", () => $f629573ea538eb7a$export$e9cbca62806a89c8);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $khO3w = parcelRequire("khO3w");

var $86pCB = parcelRequire("86pCB");
function $f629573ea538eb7a$export$750f5b0d6c51617e() {
    const context = (0, $5uXOq.useContext)((0, $86pCB.OpenLayerObserverContext));
    (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
    const publicAPI = (0, $5uXOq.useMemo)(()=>({
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        }), [
        context.getCount,
        context.onChange,
        context.closeLayers
    ]);
    return publicAPI;
}
function $f629573ea538eb7a$export$e9cbca62806a89c8() {
    const context = (0, $5uXOq.useContext)((0, $86pCB.OpenLayerObserverContext));
    const publicAPI = (0, $5uXOq.useMemo)(()=>{
        if (!(0, $khO3w.fg)('platform_dst_open_layer_observer_close_layers')) return null;
        if (!context) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context
    ]);
    return publicAPI;
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $0d1087cf1696adbb$export$a7801e29f563faad = 400;

parcelRegister("2jQJ3", function(module, exports) {

$parcel$export(module.exports, "useExpandSideNav", () => $b055c8b600aab7d0$export$e44b4744d8ff971a);

var $5uXOq = parcelRequire("5uXOq");

var $3joPi = parcelRequire("3joPi");

var $cJcMz = parcelRequire("cJcMz");
function $b055c8b600aab7d0$export$e44b4744d8ff971a() {
    const setSideNavState = (0, $5uXOq.useContext)((0, $cJcMz.SetSideNavVisibilityState));
    const expandSideNav = (0, $5uXOq.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $3joPi.default)(currentState, 'Side nav state should not be null');
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return expandSideNav;
}

});

parcelRegister("8Ry0n", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $d06df4b205b1af26$export$1904b8f2577aba9a);

var $5uXOq = parcelRequire("5uXOq");

var $kpUo7 = parcelRequire("kpUo7");
function $d06df4b205b1af26$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $5uXOq.useRef)(onExpand);
    const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
    (0, $5uXOq.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $kpUo7.default)(isExpandedOnDesktop);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $kpUo7.default)(isExpandedOnMobile);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});


parcelRegister("4azvS", function(module, exports) {

$parcel$export(module.exports, "TopBar", () => $0519ff50f4366511$export$c4e96258f3b6511);
/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $5wdx2 = parcelRequire("5wdx2");

var $2yJmb = parcelRequire("2yJmb");

var $h7zad = parcelRequire("h7zad");

var $aH3xI = parcelRequire("aH3xI");

var $5RLyk = parcelRequire("5RLyk");

var $hA9Sj = parcelRequire("hA9Sj");

var $fetp2 = parcelRequire("fetp2");
const $0519ff50f4366511$var$styles = {
    root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
    oldLayoutStyles: "_1rqtc57g",
    newLayoutStyles: "_1j8b18ax"
};
function $0519ff50f4366511$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
    const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, $5RLyk.DangerouslyHoistSlotSizes));
    const UID = (0, $fetp2.usePrefixedUID)();
    const CID = id ? id : UID;
    (0, $5wdx2.useSkipLink)(CID, skipLinkLabel);
    const customTheme = (0, $h7zad.useCustomTheme)(UNSAFE_theme);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2yJmb.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("header", {
            id: CID,
            "data-layout-slot": true,
            className: (0, $bwpsq.default)([
                $0519ff50f4366511$var$styles.root,
                (0, $khO3w.fg)('platform_design_system_nav4_top_nav_columns') ? $0519ff50f4366511$var$styles.newLayoutStyles : $0519ff50f4366511$var$styles.oldLayoutStyles,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.HoistCssVarToLocalGrid), {
                    variableName: (0, $aH3xI.topBarMountedVar),
                    value: UNSAFE_height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hA9Sj.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $aH3xI.UNSAFE_topBarVar),
                    value: UNSAFE_height
                }),
                children
            ]
        })
    });
}

});
parcelRegister("h7zad", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $b3da0727c586d991$export$c0c5f5b297b77726);

var $5uXOq = parcelRequire("5uXOq");

var $cHLK3 = parcelRequire("cHLK3");
function $b3da0727c586d991$export$c0c5f5b297b77726(theme) {
    const value = (0, $5uXOq.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $cHLK3.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("cHLK3", function(module, exports) {

$parcel$export(module.exports, "getCustomThemeStyles", () => $3045bff23ef91634$export$3986d75fe2da3239);

var $4jzOr = parcelRequire("4jzOr");

var $8lqOv = parcelRequire("8lqOv");

var $2OkQy = parcelRequire("2OkQy");

var $bEGB1 = parcelRequire("bEGB1");

var $9i3JF = parcelRequire("9i3JF");

var $gTf3F = parcelRequire("gTf3F");
function $3045bff23ef91634$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $3045bff23ef91634$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $3045bff23ef91634$var$buttonStyles = {
    light: {
        [(0, $8lqOv.themedButtonBackground)]: 'transparent',
        [(0, $8lqOv.themedButtonBackgroundHovered)]: (0, $9i3JF.palette).Neutral200A,
        [(0, $8lqOv.themedButtonBackgroundPressed)]: (0, $9i3JF.palette).Neutral300A,
        [(0, $8lqOv.themedButtonBorder)]: (0, $9i3JF.palette).Neutral300A,
        [(0, $8lqOv.themedButtonSelectedBackground)]: (0, $9i3JF.palette).Neutral300A,
        [(0, $8lqOv.themedButtonSelectedBackgroundHovered)]: (0, $9i3JF.palette).Neutral400A,
        [(0, $8lqOv.themedButtonSelectedBackgroundPressed)]: (0, $9i3JF.palette).Neutral500A,
        [(0, $8lqOv.themedButtonDisabledText)]: (0, $9i3JF.palette).Neutral400A,
        [(0, $8lqOv.themedButtonDisabledBackground)]: (0, $9i3JF.palette).Neutral100A
    },
    dark: {
        [(0, $8lqOv.themedButtonBackground)]: 'transparent',
        [(0, $8lqOv.themedButtonBackgroundHovered)]: (0, $9i3JF.palette).DarkNeutral200A,
        [(0, $8lqOv.themedButtonBackgroundPressed)]: (0, $9i3JF.palette).DarkNeutral300A,
        [(0, $8lqOv.themedButtonBorder)]: (0, $9i3JF.palette).DarkNeutral300A,
        [(0, $8lqOv.themedButtonSelectedBackground)]: (0, $9i3JF.palette).DarkNeutral300A,
        [(0, $8lqOv.themedButtonSelectedBackgroundHovered)]: (0, $9i3JF.palette).DarkNeutral400A,
        [(0, $8lqOv.themedButtonSelectedBackgroundPressed)]: (0, $9i3JF.palette).DarkNeutral500A,
        [(0, $8lqOv.themedButtonDisabledText)]: (0, $9i3JF.palette).DarkNeutral400A,
        [(0, $8lqOv.themedButtonDisabledBackground)]: (0, $9i3JF.palette).DarkNeutral100A
    }
};
const $3045bff23ef91634$var$logoStyles = {
    light: {
        [(0, $4jzOr.themedLogoIcon)]: (0, $9i3JF.palette).DarkNeutral0,
        [(0, $4jzOr.themedLogoText)]: (0, $9i3JF.palette).DarkNeutral0
    },
    dark: {
        [(0, $4jzOr.themedLogoIcon)]: (0, $9i3JF.palette).Neutral0,
        [(0, $4jzOr.themedLogoText)]: (0, $9i3JF.palette).Neutral0
    }
};
function $3045bff23ef91634$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $bEGB1.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $bEGB1.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $2OkQy.getTextColor)(backgroundRgb);
    const colorMode = (0, $2OkQy.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $2OkQy.getTextColor)(highlightRgb);
    return {
        backgroundColor: $3045bff23ef91634$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$3045bff23ef91634$var$buttonStyles[colorMode],
        ...$3045bff23ef91634$var$logoStyles[colorMode],
        ...$3045bff23ef91634$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $gTf3F.themedSearchBorder)]: $3045bff23ef91634$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $gTf3F.themedSearchBorderFocused)]: $3045bff23ef91634$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ [(0, $8lqOv.themedButtonPrimaryBackground)]: $3045bff23ef91634$var$toRGBString(highlightRgb),
        [(0, $8lqOv.themedButtonPrimaryBackgroundHovered)]: $3045bff23ef91634$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        [(0, $8lqOv.themedButtonPrimaryBackgroundPressed)]: $3045bff23ef91634$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        [(0, $8lqOv.themedButtonPrimaryText)]: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $3045bff23ef91634$var$selectedBackgroundRGBA = {
    light: (0, $9i3JF.paletteRgba).Neutral300A,
    dark: (0, $9i3JF.paletteRgba).DarkNeutral300A
};
function $3045bff23ef91634$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $3045bff23ef91634$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $2OkQy.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        [(0, $8lqOv.themedButtonSelectedText)]: (0, $2OkQy.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        [(0, $8lqOv.themedButtonSelectedBorder)]: (0, $2OkQy.isLight)(blendedBackground) ? (0, $9i3JF.palette).Neutral1100 : (0, $9i3JF.palette).DarkNeutral1100
    };
}

});
parcelRegister("4jzOr", function(module, exports) {

$parcel$export(module.exports, "themedLogoIcon", () => $6f1b5bbaa317f477$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $6f1b5bbaa317f477$export$91b0830f8f4ab279);
$parcel$export(module.exports, "NavLogo", () => $6f1b5bbaa317f477$export$b6394419753329e);
/* nav-logo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $khO3w = parcelRequire("khO3w");

var $j8VBM = parcelRequire("j8VBM");

var $2yJmb = parcelRequire("2yJmb");
const $6f1b5bbaa317f477$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $6f1b5bbaa317f477$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
const $6f1b5bbaa317f477$var$navLogoStyles = {
    root: "_2rkoiti9 _1e0c1txw _4cvr1h6o _4t3izwfg",
    icon: "_18zr1b66 _1e0c1txw _p12f1tcg _vchh18uv _10y4glyw",
    logo: "_18zru2gc _1e0cglyw _p12fnklw _vchh18uv _10y41txw",
    imageContainer: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51",
    iconLogoPaddingFlagged: "_18zr1b66"
};
const $6f1b5bbaa317f477$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        return;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j8VBM.default), {
        ref: ref,
        "aria-label": label,
        href: href,
        xcss: $6f1b5bbaa317f477$var$navLogoStyles.root,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $6f1b5bbaa317f477$var$navLogoStyles.imageContainer,
                    $6f1b5bbaa317f477$var$navLogoStyles.icon,
                    (0, $khO3w.fg)('platform-team25-app-icon-tiles') && $6f1b5bbaa317f477$var$navLogoStyles.iconLogoPaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($6f1b5bbaa317f477$var$NavLogoRenderer, {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $6f1b5bbaa317f477$var$navLogoStyles.imageContainer,
                    $6f1b5bbaa317f477$var$navLogoStyles.logo,
                    (0, $khO3w.fg)('platform-team25-app-icon-tiles') && $6f1b5bbaa317f477$var$navLogoStyles.iconLogoPaddingFlagged
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($6f1b5bbaa317f477$var$NavLogoRenderer, {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
function $6f1b5bbaa317f477$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        iconColor: `var(${$6f1b5bbaa317f477$export$24328117f1132113})`,
        textColor: `var(${$6f1b5bbaa317f477$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}

});

parcelRegister("2OkQy", function(module, exports) {

$parcel$export(module.exports, "isLight", () => $325083aa25b7bf8e$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $325083aa25b7bf8e$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $325083aa25b7bf8e$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $325083aa25b7bf8e$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $325083aa25b7bf8e$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $325083aa25b7bf8e$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $325083aa25b7bf8e$var$linearizeRGBChannel(normal.r),
        g: $325083aa25b7bf8e$var$linearizeRGBChannel(normal.g),
        b: $325083aa25b7bf8e$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $325083aa25b7bf8e$var$flipLuminance = 0.179129;
function $325083aa25b7bf8e$export$44af652f4cca9039(color) {
    return $325083aa25b7bf8e$var$relativeLuminanceW3C(color) >= $325083aa25b7bf8e$var$flipLuminance;
}
function $325083aa25b7bf8e$export$5573a5bab3e074b5(backgroundColor) {
    if ($325083aa25b7bf8e$var$relativeLuminanceW3C(backgroundColor) >= $325083aa25b7bf8e$var$flipLuminance) return 'light';
    return 'dark';
}
const $325083aa25b7bf8e$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $325083aa25b7bf8e$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $325083aa25b7bf8e$export$5573a5bab3e074b5(backgroundColor);
    return $325083aa25b7bf8e$var$textColor[colorMode];
}
function $325083aa25b7bf8e$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("bEGB1", function(module, exports) {

$parcel$export(module.exports, "parseHex", () => $8bd7784ac5741e6a$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $8bd7784ac5741e6a$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $8bd7784ac5741e6a$export$103711ef09c6edec(color) {
    if (!$8bd7784ac5741e6a$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("9i3JF", function(module, exports) {

$parcel$export(module.exports, "palette", () => $61f5622bdf69977a$export$eaad8caa32d2521d);
$parcel$export(module.exports, "paletteRgba", () => $61f5622bdf69977a$export$c9b84419dae66a82);
/**
 * Copied from the brand refresh palette.
 *
 * Ideally we'd codegen this but the brand refresh palette isn't exposed
 * through public API and we shouldn't use the private API of another package.
 */ const $61f5622bdf69977a$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};
const $61f5622bdf69977a$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("gTf3F", function(module, exports) {

$parcel$export(module.exports, "themedSearchBorder", () => $bc49edc96e791572$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $bc49edc96e791572$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $bc49edc96e791572$export$18a29b1ed2212823);

var $8lqOv = parcelRequire("8lqOv");

var $2yJmb = parcelRequire("2yJmb");
const $bc49edc96e791572$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $bc49edc96e791572$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $bc49edc96e791572$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$bc49edc96e791572$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #172B4D)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$bc49edc96e791572$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$bc49edc96e791572$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(${(0, $8lqOv.themedButtonBackgroundHovered)})`
    }
};
function $bc49edc96e791572$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $2yJmb.useHasCustomTheme)();
    if (hasCustomTheme) return $bc49edc96e791572$var$legacySearchTheme;
    return undefined;
}

});




parcelRegister("2VAS6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5529c459ee2c2df402232a3b7b74525>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $221d819655423577$var$_react = $221d819655423577$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $221d819655423577$var$_information = $221d819655423577$var$_interopRequireDefault((parcelRequire("k5qp4")));

var $221d819655423577$var$_panel = $221d819655423577$var$_interopRequireDefault((parcelRequire("1TurE")));
function $221d819655423577$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $221d819655423577$var$InformationIcon = (props)=>/*#__PURE__*/ $221d819655423577$var$_react.default.createElement($221d819655423577$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $221d819655423577$var$_panel.default
    }, props));
$221d819655423577$var$InformationIcon.Name = 'InformationIconMigration';
var $221d819655423577$var$_default = module.exports.default = $221d819655423577$var$InformationIcon;

});

parcelRegister("7VXpk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b4f7ab8b5658b8ac17876b86421aa64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c6bf064709756c8$var$_react = $5c6bf064709756c8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c6bf064709756c8$var$_questionCircle = $5c6bf064709756c8$var$_interopRequireDefault((parcelRequire("6QXwr")));

var $5c6bf064709756c8$var$_questionCircle2 = $5c6bf064709756c8$var$_interopRequireDefault((parcelRequire("jXq6Y")));
function $5c6bf064709756c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c6bf064709756c8$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $5c6bf064709756c8$var$_react.default.createElement($5c6bf064709756c8$var$_questionCircle.default, Object.assign({
        LEGACY_fallbackIcon: $5c6bf064709756c8$var$_questionCircle2.default
    }, props));
$5c6bf064709756c8$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
var $5c6bf064709756c8$var$_default = module.exports.default = $5c6bf064709756c8$var$QuestionCircleIcon;

});

parcelRegister("aaCbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f853135af1897d$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $khO3w = parcelRequire("khO3w");

var $1lQB4 = parcelRequire("1lQB4");

var $fz7da = parcelRequire("fz7da");
const $59f853135af1897d$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhk1bay",
    default: "_bfhklecj",
    important: "_bfhk1v7l",
    primary: "_bfhkomb0",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhktaeo"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $59f853135af1897d$var$neutral300 = '#DDDEE1';
const $59f853135af1897d$var$red300 = '#FD9891';
const $59f853135af1897d$var$blue300 = '#8FB8F6';
const $59f853135af1897d$var$neutral1000 = '#292A2E';
const $59f853135af1897d$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $59f853135af1897d$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    if ((0, $khO3w.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $fz7da.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $fz7da.formatValue)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $59f853135af1897d$var$Badge = /*#__PURE__*/ (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $khO3w.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $59f853135af1897d$var$styles.root,
            $59f853135af1897d$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lQB4.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $59f853135af1897d$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $bwpsq.default)([
            $59f853135af1897d$var$boxStyles.root,
            $59f853135af1897d$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1lQB4.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $59f853135af1897d$var$textColors[appearance],
            children: $59f853135af1897d$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$59f853135af1897d$var$Badge.displayName = 'Badge';
var $59f853135af1897d$export$2e2bcd8739ae039 = $59f853135af1897d$var$Badge;
const $59f853135af1897d$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("fz7da", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $25ac99ab053fc6d3$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $25ac99ab053fc6d3$export$7c4d25c0c3217d8c);
function $25ac99ab053fc6d3$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $25ac99ab053fc6d3$export$4b844743568d5983(value, max) {
    const safeValue = $25ac99ab053fc6d3$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $25ac99ab053fc6d3$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $25ac99ab053fc6d3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $25ac99ab053fc6d3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $25ac99ab053fc6d3$var$getSafeValue(value);
    const safeMax = $25ac99ab053fc6d3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("8UnLj", function(module, exports) {

$parcel$export(module.exports, "NestedContext", () => $e05068c6cf2964e5$export$46b2c2071c8c725a);
$parcel$export(module.exports, "useNestedContext", () => $e05068c6cf2964e5$export$f24166abe9ed712b);
$parcel$export(module.exports, "useShouldNestedElementRender", () => $e05068c6cf2964e5$export$37e8646a1abfc3e6);

var $5uXOq = parcelRequire("5uXOq");
const $e05068c6cf2964e5$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
const $e05068c6cf2964e5$export$f24166abe9ed712b = ()=>{
    const context = (0, $5uXOq.useContext)($e05068c6cf2964e5$export$46b2c2071c8c725a);
    if (!context) {
        let error = '';
        throw new Error(error);
    }
    return context;
};
const $e05068c6cf2964e5$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $5uXOq.useContext)($e05068c6cf2964e5$export$46b2c2071c8c725a);
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});

parcelRegister("b5Ofv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ddb2a0e6c8a33d7611a427658d95f19>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $813723c6abf93de5$var$_react = $813723c6abf93de5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $813723c6abf93de5$var$_lightbulb = $813723c6abf93de5$var$_interopRequireDefault((parcelRequire("4tT4b")));

var $813723c6abf93de5$var$_lightbulbFilled = $813723c6abf93de5$var$_interopRequireDefault((parcelRequire("3noC7")));
function $813723c6abf93de5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LightbulbIcon.
 * This component is LightbulbIcon, with `UNSAFE_fallbackIcon` set to "LightbulbFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $813723c6abf93de5$var$LightbulbIcon = (props)=>/*#__PURE__*/ $813723c6abf93de5$var$_react.default.createElement($813723c6abf93de5$var$_lightbulb.default, Object.assign({
        LEGACY_fallbackIcon: $813723c6abf93de5$var$_lightbulbFilled.default
    }, props));
$813723c6abf93de5$var$LightbulbIcon.Name = 'LightbulbIconMigration';
var $813723c6abf93de5$var$_default = module.exports.default = $813723c6abf93de5$var$LightbulbIcon;

});

parcelRegister("g6dxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8dbd8d9850b83e4eb37f60fa877444d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb87b53338c6124f$var$_react = $bb87b53338c6124f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb87b53338c6124f$var$_crossCircle = $bb87b53338c6124f$var$_interopRequireDefault((parcelRequire("ca9aW")));

var $bb87b53338c6124f$var$_crossCircle2 = $bb87b53338c6124f$var$_interopRequireDefault((parcelRequire("cYxfb")));
function $bb87b53338c6124f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "CrossCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb87b53338c6124f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $bb87b53338c6124f$var$_react.default.createElement($bb87b53338c6124f$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $bb87b53338c6124f$var$_crossCircle2.default
    }, props));
$bb87b53338c6124f$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $bb87b53338c6124f$var$_default = module.exports.default = $bb87b53338c6124f$var$CrossCircleIcon;

});

parcelRegister("MOF6v", function(module, exports) {

$parcel$export(module.exports, "OverflowProvider", () => $fa79daf1a312fa3c$export$a3a2def3937905a0);
$parcel$export(module.exports, "useOverflowStatus", () => $fa79daf1a312fa3c$export$3fcfc71fab3314f2);
$parcel$export(module.exports, "useOverflowController", () => $fa79daf1a312fa3c$export$705aa66a39c35bf7);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $34ck9 = parcelRequire("34ck9");

var $jp7wN = parcelRequire("jp7wN");
// Prevent width detector from triggering too many re-renders
const $fa79daf1a312fa3c$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
const $fa79daf1a312fa3c$var$ITEM_APPROX_MINWIDTH = 70;
const $fa79daf1a312fa3c$var$calculateHash = (w, n)=>w + '#' + n;
const $fa79daf1a312fa3c$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $fa79daf1a312fa3c$var$OverflowContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $jp7wN.default),
    closeOverflowMenu: (0, $jp7wN.default)
});
const $fa79daf1a312fa3c$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const { Provider: Provider } = $fa79daf1a312fa3c$var$OverflowContext;
    const value = (0, $5uXOq.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: value,
        children: children
    });
};
const $fa79daf1a312fa3c$export$3fcfc71fab3314f2 = ()=>(0, $5uXOq.useContext)($fa79daf1a312fa3c$var$OverflowContext);
const $fa79daf1a312fa3c$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(nodes);
    const [width, setWidth] = (0, $5uXOq.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $5uXOq.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $5uXOq.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $5uXOq.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $5uXOq.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, $fa79daf1a312fa3c$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $fa79daf1a312fa3c$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $fa79daf1a312fa3c$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $fa79daf1a312fa3c$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $fa79daf1a312fa3c$var$ITEM_APPROX_MINWIDTH * 2), $fa79daf1a312fa3c$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $fa79daf1a312fa3c$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $fa79daf1a312fa3c$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $fa79daf1a312fa3c$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
		 * This is not necessarily equal to `lastItemWidth` because the
		 * ```js
		 * if (wasJustLimited) {}
		 * ```
		 * branch above modifies `itemsWidths`.
		 *
		 * Using `lastItemWidth` here can cause collapsing behavior to fail,
		 * such as the issue reported in DSP-7329.
		 */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $fa79daf1a312fa3c$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $fa79daf1a312fa3c$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $fa79daf1a312fa3c$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$fa79daf1a312fa3c$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("iwLM2", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", () => $678614f5254cf257$export$17d3acb0b4379d02);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $678614f5254cf257$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $678614f5254cf257$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $678614f5254cf257$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("83rte", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", () => $cef8f6162a06c63b$export$dabef2be6cd28c20);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $cef8f6162a06c63b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $cef8f6162a06c63b$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $cef8f6162a06c63b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hffZR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cc8d44dd44920ffd526686a9e2bd3636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c8e03f0701dd7a3b$var$_react = $c8e03f0701dd7a3b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c8e03f0701dd7a3b$var$_baseNew = $c8e03f0701dd7a3b$var$_interopRequireDefault((parcelRequire("dznjK")));
function $c8e03f0701dd7a3b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c8e03f0701dd7a3b$var$EditionsIcon = (props)=>/*#__PURE__*/ $c8e03f0701dd7a3b$var$_react.default.createElement($c8e03f0701dd7a3b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$c8e03f0701dd7a3b$var$EditionsIcon.displayName = 'EditionsIcon';
var $c8e03f0701dd7a3b$var$_default = module.exports.default = $c8e03f0701dd7a3b$var$EditionsIcon;

});

parcelRegister("bN0q2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e4382cd4db66693d3c799807338c8cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89549880c21471b4$var$_react = $89549880c21471b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $89549880c21471b4$var$_creditCard = $89549880c21471b4$var$_interopRequireDefault((parcelRequire("jZYkm")));

var $89549880c21471b4$var$_creditcardFilled = $89549880c21471b4$var$_interopRequireDefault((parcelRequire("592N2")));
function $89549880c21471b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CreditCardIcon.
 * This component is CreditCardIcon, with `UNSAFE_fallbackIcon` set to "CreditcardFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89549880c21471b4$var$CreditCardIcon = (props)=>/*#__PURE__*/ $89549880c21471b4$var$_react.default.createElement($89549880c21471b4$var$_creditCard.default, Object.assign({
        LEGACY_fallbackIcon: $89549880c21471b4$var$_creditcardFilled.default
    }, props));
$89549880c21471b4$var$CreditCardIcon.Name = 'CreditCardIconMigration';
var $89549880c21471b4$var$_default = module.exports.default = $89549880c21471b4$var$CreditCardIcon;

});

parcelRegister("dtvxd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::49812071d6f0a774fd1a4306f3d0718e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf671ec377ec8cf$var$_react = $9cf671ec377ec8cf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9cf671ec377ec8cf$var$_baseNew = $9cf671ec377ec8cf$var$_interopRequireDefault((parcelRequire("dznjK")));
function $9cf671ec377ec8cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf671ec377ec8cf$var$WarningIcon = (props)=>/*#__PURE__*/ $9cf671ec377ec8cf$var$_react.default.createElement($9cf671ec377ec8cf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9cf671ec377ec8cf$var$WarningIcon.displayName = 'WarningIcon';
var $9cf671ec377ec8cf$var$_default = module.exports.default = $9cf671ec377ec8cf$var$WarningIcon;

});

parcelRegister("flfkC", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $bcad6b710bbb0908$export$c49a2b642fe9eef4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $bcad6b710bbb0908$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $bcad6b710bbb0908$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $bcad6b710bbb0908$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jN0nL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b007f69ad81895a86b02f3ac63c0846>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e682e3d87e39bf70$var$_react = $e682e3d87e39bf70$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e682e3d87e39bf70$var$_premium = $e682e3d87e39bf70$var$_interopRequireDefault((parcelRequire("7R8ss")));

var $e682e3d87e39bf70$var$_premium2 = $e682e3d87e39bf70$var$_interopRequireDefault((parcelRequire("ksMVP")));
function $e682e3d87e39bf70$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PremiumIcon.
 * This component is PremiumIcon, with `UNSAFE_fallbackIcon` set to "PremiumIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e682e3d87e39bf70$var$PremiumIcon = (props)=>/*#__PURE__*/ $e682e3d87e39bf70$var$_react.default.createElement($e682e3d87e39bf70$var$_premium.default, Object.assign({
        LEGACY_fallbackIcon: $e682e3d87e39bf70$var$_premium2.default
    }, props));
$e682e3d87e39bf70$var$PremiumIcon.Name = 'PremiumIconMigration';
var $e682e3d87e39bf70$var$_default = module.exports.default = $e682e3d87e39bf70$var$PremiumIcon;

});

parcelRegister("iXChi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2acc08ab6395d499b2798249d78c49fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcdb6de065776010$var$_react = $dcdb6de065776010$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dcdb6de065776010$var$_arrowUpRight = $dcdb6de065776010$var$_interopRequireDefault((parcelRequire("9GjE9")));

var $dcdb6de065776010$var$_open = $dcdb6de065776010$var$_interopRequireDefault((parcelRequire("fL3eH")));
function $dcdb6de065776010$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpRightIcon.
 * This component is ArrowUpRightIcon, with `UNSAFE_fallbackIcon` set to "OpenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dcdb6de065776010$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $dcdb6de065776010$var$_react.default.createElement($dcdb6de065776010$var$_arrowUpRight.default, Object.assign({
        LEGACY_fallbackIcon: $dcdb6de065776010$var$_open.default
    }, props));
$dcdb6de065776010$var$ArrowUpRightIcon.Name = 'ArrowUpRightIconMigration';
var $dcdb6de065776010$var$_default = module.exports.default = $dcdb6de065776010$var$ArrowUpRightIcon;

});

parcelRegister("d587r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc9ca86dc3d7916919414cea3f7ddc7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98620a3dc670f5a3$var$_react = $98620a3dc670f5a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98620a3dc670f5a3$var$_linkExternal = $98620a3dc670f5a3$var$_interopRequireDefault((parcelRequire("1FMGD")));

var $98620a3dc670f5a3$var$_shortcut = $98620a3dc670f5a3$var$_interopRequireDefault((parcelRequire("eyLM9")));
function $98620a3dc670f5a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98620a3dc670f5a3$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $98620a3dc670f5a3$var$_react.default.createElement($98620a3dc670f5a3$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $98620a3dc670f5a3$var$_shortcut.default
    }, props));
$98620a3dc670f5a3$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
var $98620a3dc670f5a3$var$_default = module.exports.default = $98620a3dc670f5a3$var$LinkExternalIcon;

});

parcelRegister("1zl6f", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa501adbace966b726e3581e51103297>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12496d4fca9677bc$var$_react = $12496d4fca9677bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $12496d4fca9677bc$var$_search = $12496d4fca9677bc$var$_interopRequireDefault((parcelRequire("ajK26")));

var $12496d4fca9677bc$var$_search2 = $12496d4fca9677bc$var$_interopRequireDefault((parcelRequire("1dhTk")));
function $12496d4fca9677bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "SearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12496d4fca9677bc$var$SearchIcon = (props)=>/*#__PURE__*/ $12496d4fca9677bc$var$_react.default.createElement($12496d4fca9677bc$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $12496d4fca9677bc$var$_search2.default
    }, props));
$12496d4fca9677bc$var$SearchIcon.Name = 'SearchIconMigration';
var $12496d4fca9677bc$var$_default = module.exports.default = $12496d4fca9677bc$var$SearchIcon;

});

parcelRegister("jhsXP", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $61be461f94456be5$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8cCze = parcelRequire("8cCze");

var $3kqWs = parcelRequire("3kqWs");

var $eE1NA = parcelRequire("eE1NA");
const $61be461f94456be5$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3kqWs))), {
            color: "currentColor",
            spacing: "spacious",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $61be461f94456be5$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8cCze))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
$61be461f94456be5$export$2e2bcd8739ae039 = (props)=>{};

});

parcelRegister("lHrXi", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $4a46c77f8aae0777$export$9923361bd43fa030);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8cCze = parcelRequire("8cCze");

var $cSaPD = parcelRequire("cSaPD");
const $4a46c77f8aae0777$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $4a46c77f8aae0777$export$9923361bd43fa030 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8cCze))),
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $4a46c77f8aae0777$var$toggleButtonTooltipOptions,
        isSelected: isSelected
    }));

});

parcelRegister("iqZTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b713cce3a8a609e$export$2e2bcd8739ae039);



var $kP7pg = parcelRequire("kP7pg");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $8b713cce3a8a609e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $kP7pg.default)[tokenId];
    let tokenValue = fallback;
    typeof $6cAn5;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $8b713cce3a8a609e$export$2e2bcd8739ae039 = $8b713cce3a8a609e$var$getTokenValue;

});

parcelRegister("LPq5h", function(module, exports) {

$parcel$export(module.exports, "AtlassianNavigation", () => $9fb14c63fb98ae26$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $81JNC = parcelRequire("81JNC");



var $2kaNg = parcelRequire("2kaNg");
var $1L1pK = parcelRequire("1L1pK");

var $aAMdQ = parcelRequire("aAMdQ");
function $9fb14c63fb98ae26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9fb14c63fb98ae26$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $49600dcffa9fbe7e$export$30fa7cc5f2690a43),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $3568e170f1ea17d7$export$3e51e8f1440314ba)})`}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $9fb14c63fb98ae26$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $9fb14c63fb98ae26$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $9fb14c63fb98ae26$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $9fb14c63fb98ae26$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $9fb14c63fb98ae26$export$f66ccb39f60980e5 = (props)=>{
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $2kaNg.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1L1pK.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $81JNC.NavigationAnalyticsContext), {
        data: $9fb14c63fb98ae26$var$analyticsData
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $9fb14c63fb98ae26$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("nav", {
        css: $9fb14c63fb98ae26$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $f8Sb3.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $f8Sb3.jsx)(ProductHome, null), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aAMdQ.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $9fb14c63fb98ae26$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $f8Sb3.jsx)(Search, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "list",
        css: [
            $9fb14c63fb98ae26$var$rightStyles,
            $9fb14c63fb98ae26$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $f8Sb3.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $f8Sb3.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $f8Sb3.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $f8Sb3.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $f8Sb3.jsx)(Profile, null))))));
};

});
const $49600dcffa9fbe7e$export$30fa7cc5f2690a43 = 56;
const $49600dcffa9fbe7e$export$4033a111ca79977d = 1280;
const $49600dcffa9fbe7e$export$24ec62cee78b7042 = 1130;
const $49600dcffa9fbe7e$export$d8bde68ac946124f = '--ds--ans--fbc';
const $49600dcffa9fbe7e$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $49600dcffa9fbe7e$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $49600dcffa9fbe7e$export$d81606c1fc5119bc = '--ds--ans--c';
const $49600dcffa9fbe7e$export$65f656ad520ea71 = '--ds--ans--bc';

parcelRegister("aAMdQ", function(module, exports) {

$parcel$export(module.exports, "PrimaryItemsContainer", () => $05b8eb9445fcb63f$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gqw9P = parcelRequire("gqw9P");


var $6Rw1j = parcelRequire("6Rw1j");

var $MOF6v = parcelRequire("MOF6v");

var $j66VK = parcelRequire("j66VK");
function $05b8eb9445fcb63f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05b8eb9445fcb63f$var$containerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $05b8eb9445fcb63f$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $05b8eb9445fcb63f$var$overflowItemsStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    color: `var(--ds-text, ${(0, $3568e170f1ea17d7$export$ad0bacf983b7ddaa)})`
});
const $05b8eb9445fcb63f$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $MOF6v.useOverflowController)(items);
    const onMoreClick = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $5uXOq.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $j66VK.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $MOF6v.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $05b8eb9445fcb63f$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $05b8eb9445fcb63f$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $MOF6v.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gqw9P.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $f8Sb3.jsx)(Create, null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $05b8eb9445fcb63f$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6Rw1j.WidthObserver), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("j66VK", function(module, exports) {

$parcel$export(module.exports, "PrimaryDropdownButton", () => $973f168cf2cef338$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9Gsrw = parcelRequire("9Gsrw");

var $6kdSN = parcelRequire("6kdSN");

var $khO3w = parcelRequire("khO3w");

var $lqPDT = parcelRequire("lqPDT");
const $973f168cf2cef338$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lqPDT.PrimaryButton), {
        component: component,
        iconAfter: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $khO3w.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Gsrw))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6kdSN))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
            color: "currentColor",
            label: ""
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("lqPDT", function(module, exports) {

$parcel$export(module.exports, "PrimaryButton", () => $3d3b0ce8b967bc7b$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lrsUC = parcelRequire("lrsUC");

var $fulm9 = parcelRequire("fulm9");

var $bbRE0 = parcelRequire("bbRE0");

var $gXcBJ = parcelRequire("gXcBJ");
function $3d3b0ce8b967bc7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $3d3b0ce8b967bc7b$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $3d3b0ce8b967bc7b$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $3d3b0ce8b967bc7b$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const themeFromContext = (0, $bbRE0.useTheme)();
    const button = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$3d3b0ce8b967bc7b$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $3d3b0ce8b967bc7b$var$buttonBaseStyles,
            isHighlighted && $3d3b0ce8b967bc7b$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lrsUC.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $gXcBJ.getPrimaryButtonTheme)(themeFromContext),
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fulm9.default), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});

});
parcelRegister("gXcBJ", function(module, exports) {

$parcel$export(module.exports, "getPrimaryButtonTheme", () => $d177e33cbd6f02bf$export$14dd6915caf431fe);
const $d177e33cbd6f02bf$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("7K8OW", function(module, exports) {

$parcel$export(module.exports, "SkeletonSwitcherButton", () => $4b71da9ce4b26291$export$41b1bb24b7702cc2);
$parcel$export(module.exports, "Nav4SkeletonSwitcherButton", () => $4b71da9ce4b26291$export$68afc1d9d20a7bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $8cCze = parcelRequire("8cCze");

var $3kqWs = parcelRequire("3kqWs");

var $3djrp = parcelRequire("3djrp");

var $bbRE0 = parcelRequire("bbRE0");
const $4b71da9ce4b26291$var$skeletonSwitcherButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
    marginRight: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:only-of-type': {
        // eslint-disable-next-line @atlaskit/design-system/no-physical-properties
        marginRight: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $4b71da9ce4b26291$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
    const theme = (0, $bbRE0.useTheme)();
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $4b71da9ce4b26291$var$skeletonSwitcherButtonStyles,
        type: "button"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3kqWs))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    })));
};
const $4b71da9ce4b26291$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3djrp.SkeletonIconButton), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8cCze))), {
        label: label,
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }));

});
parcelRegister("3djrp", function(module, exports) {

$parcel$export(module.exports, "SkeletonIconButton", () => $beb948cf88d44994$export$7b398af37f6177e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bbRE0 = parcelRequire("bbRE0");
function $beb948cf88d44994$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $beb948cf88d44994$var$skeletonIconButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: 0,
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 100%)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        width: 24,
        height: 24,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        verticalAlign: 'middle'
    }
});
const $beb948cf88d44994$var$buttonWrapperStyles = {
    name: "khzvr",
    styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
};
const $beb948cf88d44994$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
    const theme = (0, $bbRE0.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $beb948cf88d44994$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.iconButton.default,
        "data-testid": testId,
        css: $beb948cf88d44994$var$skeletonIconButtonStyles,
        type: "button"
    }, children));
};

});


parcelRegister("kxMlJ", function(module, exports) {

$parcel$export(module.exports, "Create", () => $b48377f5f8b70507$export$8ade6fcbf3a7de5d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $lrsUC = parcelRequire("lrsUC");

var $iconh = parcelRequire("iconh");

var $fulm9 = parcelRequire("fulm9");


var $bbRE0 = parcelRequire("bbRE0");

var $eE1NA = parcelRequire("eE1NA");

var $jZMnk = parcelRequire("jZMnk");
const $b48377f5f8b70507$var$wrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-smallscreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${(0, $49600dcffa9fbe7e$export$24ec62cee78b7042) - 1}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& [data-hide-on-largescreens]': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (min-width: ${0, $49600dcffa9fbe7e$export$24ec62cee78b7042}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'none !important'
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $b48377f5f8b70507$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $fulm9.default), {
        content: buttonTooltip,
        hideTooltipOnClick: true
    }, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, children);
const $b48377f5f8b70507$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
    const theme = (0, $bbRE0.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $b48377f5f8b70507$var$wrapperStyles,
        role: "listitem",
        "data-testid": "create-button-wrapper"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($b48377f5f8b70507$var$TooltipSwitch, {
        buttonTooltip: buttonTooltip
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lrsUC.default), {
        id: "createGlobalItem",
        "aria-label": label,
        onClick: onClick,
        href: href,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: (0, $jZMnk.getCreateButtonTheme)(theme),
        testId: testId && `${testId}-button`,
        "data-hide-on-smallscreens": true
    }, text)), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eE1NA.IconButton), {
        id: "createGlobalItemIconButton",
        testId: testId && `${testId}-icon-button`,
        icon: /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iconh))), {
            color: "currentColor",
            spacing: "spacious",
            label: text
        }),
        onClick: onClick,
        href: href,
        tooltip: iconButtonTooltip,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: (0, $jZMnk.getCreateButtonTheme)(theme),
        "aria-label": text,
        "data-hide-on-largescreens": true
    }));
};

});
parcelRegister("iconh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbaf72704b8a24398cb5b76f6fe1dbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3fc413c63726f21$var$_react = $d3fc413c63726f21$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d3fc413c63726f21$var$_add = $d3fc413c63726f21$var$_interopRequireDefault((parcelRequire("lvnBm")));

var $d3fc413c63726f21$var$_add2 = $d3fc413c63726f21$var$_interopRequireDefault((parcelRequire("7uuO9")));
function $d3fc413c63726f21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "EditorAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3fc413c63726f21$var$AddIcon = (props)=>/*#__PURE__*/ $d3fc413c63726f21$var$_react.default.createElement($d3fc413c63726f21$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $d3fc413c63726f21$var$_add2.default
    }, props));
$d3fc413c63726f21$var$AddIcon.Name = 'AddIconMigration';
var $d3fc413c63726f21$var$_default = module.exports.default = $d3fc413c63726f21$var$AddIcon;

});

parcelRegister("jZMnk", function(module, exports) {

$parcel$export(module.exports, "getCreateButtonTheme", () => $9796e662e15c7078$export$256eebed8e934f30);
const $9796e662e15c7078$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...create.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': create.hover,
                ':focus': create.focus,
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && create.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("fcoRe", function(module, exports) {

$parcel$export(module.exports, "SkeletonCreateButton", () => $0cadcc6ea626d860$export$e321b2260435e302);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bbRE0 = parcelRequire("bbRE0");
function $0cadcc6ea626d860$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0cadcc6ea626d860$var$skeletonCreateButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    height: 32,
    padding: `0 ${"var(--ds-space-150, 12px)"}`,
    alignSelf: 'center',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginInlineStart: "var(--ds-space-150, 12px)"
    }
});
const $0cadcc6ea626d860$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $0cadcc6ea626d860$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
    const theme = (0, $bbRE0.useTheme)();
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $0cadcc6ea626d860$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.create.default,
        css: $0cadcc6ea626d860$var$skeletonCreateButtonStyles,
        "data-testid": testId,
        type: "button"
    }, text));
};

});

parcelRegister("1CvK7", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $94af161b9919b980$export$6d3c345ce7c38fd9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lvnBm = parcelRequire("lvnBm");

var $cSaPD = parcelRequire("cSaPD");
const $94af161b9919b980$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId, interactionName: interactionName })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.Button), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lvnBm))),
        onClick: onClick,
        testId: testId,
        interactionName: interactionName,
        children: children
    });

});

parcelRegister("d21z7", function(module, exports) {

$parcel$export(module.exports, "Help", () => $77f9f42361c70e4f$export$1be7516c0280bee8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VXpk = parcelRequire("7VXpk");

var $bbRE0 = parcelRequire("bbRE0");

var $lz2TY = parcelRequire("lz2TY");

var $eE1NA = parcelRequire("eE1NA");
const $77f9f42361c70e4f$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $77f9f42361c70e4f$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    const { mode: { navigation: navigation } } = (0, $bbRE0.useTheme)();
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7VXpk))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            color: "currentColor",
            spacing: "spacious",
            LEGACY_secondaryColor: navigation.backgroundColor
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    });
    return badge ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lz2TY.BadgeContainer), {
        id: $77f9f42361c70e4f$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: button
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: button
    });
});

});
parcelRegister("lz2TY", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $a9659e0105009920$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $a9659e0105009920$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9659e0105009920$var$badgeContainerStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $a9659e0105009920$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $a9659e0105009920$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a9659e0105009920$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $a9659e0105009920$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Badge, null)));
};

});


parcelRegister("fQ0de", function(module, exports) {

$parcel$export(module.exports, "SkeletonHelpButton", () => $6a876dae25c79d33$export$9ee5d6e291d4e456);
$parcel$export(module.exports, "Nav4SkeletonHelpButton", () => $6a876dae25c79d33$export$c25bc9ca782b25f4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VXpk = parcelRequire("7VXpk");

var $6QXwr = parcelRequire("6QXwr");

var $3djrp = parcelRequire("3djrp");

var $bbRE0 = parcelRequire("bbRE0");
const $6a876dae25c79d33$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
    const { mode: { navigation: navigation } } = (0, $bbRE0.useTheme)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7VXpk))), {
            label: label,
            color: "currentColor",
            LEGACY_secondaryColor: navigation.backgroundColor
        })
    });
};
const $6a876dae25c79d33$export$c25bc9ca782b25f4 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6QXwr))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("b6KJF", function(module, exports) {

$parcel$export(module.exports, "Help", () => $b281037bcbee9848$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $6QXwr = parcelRequire("6QXwr");

var $eIrjm = parcelRequire("eIrjm");

var $1l3Hq = parcelRequire("1l3Hq");

var $cSaPD = parcelRequire("cSaPD");
const $b281037bcbee9848$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $b281037bcbee9848$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>{
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSaPD.IconButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6QXwr))),
        label: label,
        onClick: onClick,
        appearance: "subtle",
        isSelected: isSelected,
        ref: forwardedRef,
        isTooltipDisabled: false,
        testId: testId,
        interactionName: interactionName
    });
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1l3Hq.ListItem), null, button);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eIrjm.BadgeContainer), {
        id: $b281037bcbee9848$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button);
});

});
parcelRegister("eIrjm", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $e05e783b64cd6d2f$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e05e783b64cd6d2f$var$styles = {
    root: "_kqswh2mm _1e0c1txw",
    badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
};
const $e05e783b64cd6d2f$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: role,
        className: (0, $bwpsq.default)([
            $e05e783b64cd6d2f$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $bwpsq.default)([
                    $e05e783b64cd6d2f$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Badge, {})
            })
        ]
    });

});

parcelRegister("1l3Hq", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $abb5f295ebe727ae$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $abb5f295ebe727ae$var$_ListItem({ children: children, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        children: children
    });
}
const $abb5f295ebe727ae$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $5uXOq.forwardRef)($abb5f295ebe727ae$var$_ListItem);

});


parcelRegister("b0mt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f640f55efe6f595$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");



var $bbRE0 = parcelRequire("bbRE0");

var $gHdKi = parcelRequire("gHdKi");
function $8f640f55efe6f595$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $8f640f55efe6f595$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $49600dcffa9fbe7e$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $8f640f55efe6f595$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $8f640f55efe6f595$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $49600dcffa9fbe7e$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $8f640f55efe6f595$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $3568e170f1ea17d7$export$215b7063051591f1)})`}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $49600dcffa9fbe7e$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $49600dcffa9fbe7e$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $8f640f55efe6f595$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Custom product home__
 *
 * Use `CustomProductHome` to provide a custom logo and icon with URLs.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#custom-product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $8f640f55efe6f595$var$CustomProductHome = (props)=>{
    const { href: href, iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoMaxWidth: logoMaxWidth = 260, logoUrl: logoUrl, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest } = props;
    const theme = (0, $bbRE0.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const Tag = (0, $gHdKi.getTag)(onClick, href);
    const preventFocusRing = (event)=>{
        event.preventDefault();
        onMouseDown && onMouseDown(event);
    };
    const productHomeButtonDynamicStyles = {
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$8f640f55efe6f595$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $8f640f55efe6f595$var$productHomeButtonStyles,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        ...rest
    }, logoUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $8f640f55efe6f595$var$customMaxHeightStyles,
            $8f640f55efe6f595$var$productLogoStyles
        ],
        src: logoUrl,
        alt: logoAlt,
        "data-testid": testId && `${testId}-logo`,
        "data-vc": "custom-product-home-logo"
    }), iconUrl && /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        style: {
            maxWidth: logoMaxWidth
        },
        css: [
            $8f640f55efe6f595$var$customMaxHeightStyles,
            $8f640f55efe6f595$var$productIconStyles
        ],
        src: iconUrl,
        alt: iconAlt,
        "data-testid": testId && `${testId}-icon`,
        "data-vc": "custom-product-home-icon"
    })), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $8f640f55efe6f595$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $8f640f55efe6f595$export$2e2bcd8739ae039 = $8f640f55efe6f595$var$CustomProductHome;

});
parcelRegister("gHdKi", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $b0e43031ca1f60d3$export$dad497fe1f6e27c0);
const $b0e43031ca1f60d3$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("bNv2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeac227cc005d9e7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $khO3w = parcelRequire("khO3w");



var $bbRE0 = parcelRequire("bbRE0");

var $1nryR = parcelRequire("1nryR");

var $gHdKi = parcelRequire("gHdKi");
function $eeac227cc005d9e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $eeac227cc005d9e7$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $eeac227cc005d9e7$var$productHomeButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $49600dcffa9fbe7e$export$4033a111ca79977d) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $49600dcffa9fbe7e$export$4033a111ca79977d}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $eeac227cc005d9e7$var$productLogoStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$eeac227cc005d9e7$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$eeac227cc005d9e7$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $49600dcffa9fbe7e$export$4033a111ca79977d) - 0.1}px)`]: {
        display: 'none'
    }
});
const $eeac227cc005d9e7$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $eeac227cc005d9e7$var$productIconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $49600dcffa9fbe7e$export$4033a111ca79977d}px)`]: {
        display: 'none'
    }
});
const $eeac227cc005d9e7$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ const $eeac227cc005d9e7$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $bbRE0.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    // After the brand refresh, iconColor and textColor should be set to 'undefined' to allow the original
    // multi-color logo tile colors to be visible, rather than a hardcoded blue.
    let { iconColor: iconColor = (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? undefined : 'inherit', textColor: textColor = (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? undefined : theme.mode.productHome.color } = theme.mode.productHome;
    // The default theme is set at module scope and immediately used in context.
    // To allow the feature flag to switch the logo color at runtime, we also detect the original hardcoded
    // values and override them to undefined.
    if (iconColor === '#357DE8' && textColor === `var(--ds-text, ${0, $3568e170f1ea17d7$export$ad0bacf983b7ddaa})` && (0, $khO3w.fg)('platform-team25-app-icon-tiles')) {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $gHdKi.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $1nryR.stripEmptyProperties)({
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$eeac227cc005d9e7$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$eeac227cc005d9e7$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $eeac227cc005d9e7$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $eeac227cc005d9e7$var$customMaxHeightStyles,
            $eeac227cc005d9e7$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    })), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $eeac227cc005d9e7$var$customMaxHeightStyles,
            $eeac227cc005d9e7$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Icon, {
        iconColor: iconColor,
        size: (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? 'small' : undefined,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: (0, $khO3w.fg)('platform-team25-app-icon-tiles') ? 'brand' : undefined
    }))), siteTitle && /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $eeac227cc005d9e7$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $eeac227cc005d9e7$export$2e2bcd8739ae039 = $eeac227cc005d9e7$var$ProductHome;

});
parcelRegister("1nryR", function(module, exports) {

$parcel$export(module.exports, "stripEmptyProperties", () => $3d8645dccb4c3de6$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $3d8645dccb4c3de6$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});


parcelRegister("6sDfR", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", () => $98c29a83f152fa23$export$765cacec8b0843f3);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7iEOO = parcelRequire("7iEOO");

var $2sApg = parcelRequire("2sApg");

var $jAjMG = parcelRequire("jAjMG");

var $9Y1hm = parcelRequire("9Y1hm");
const $98c29a83f152fa23$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $jAjMG.getColorsFromAppearance)(appearance, colorMode);
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">
      <path fill=${colors.iconColor} d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>
      <path fill=${colors.atlassianLogoTextColor} d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>
    </svg>`;
};
const $98c29a83f152fa23$export$765cacec8b0843f3 = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $2sApg.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $2sApg.defaultLogoParams).iconColor, textColor: textColor = (0, $2sApg.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $7iEOO.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Y1hm.default), {
        appearance: appearance,
        label: label,
        svg: $98c29a83f152fa23$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8wh1N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f847d1cd9da5a4c2f8db9579d329d66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0199c857f0d2f51a$var$_react = $0199c857f0d2f51a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0199c857f0d2f51a$var$_app = $0199c857f0d2f51a$var$_interopRequireDefault((parcelRequire("kmzMI")));

var $0199c857f0d2f51a$var$_addon = $0199c857f0d2f51a$var$_interopRequireDefault((parcelRequire("jHuix")));
function $0199c857f0d2f51a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppIcon.
 * This component is AppIcon, with `UNSAFE_fallbackIcon` set to "AddonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0199c857f0d2f51a$var$AppIcon = (props)=>/*#__PURE__*/ $0199c857f0d2f51a$var$_react.default.createElement($0199c857f0d2f51a$var$_app.default, Object.assign({
        LEGACY_fallbackIcon: $0199c857f0d2f51a$var$_addon.default
    }, props));
$0199c857f0d2f51a$var$AppIcon.Name = 'AppIconMigration';
var $0199c857f0d2f51a$var$_default = module.exports.default = $0199c857f0d2f51a$var$AppIcon;

});

parcelRegister("6SHfM", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $c3a8b542eb9f37d2$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $35kHP = parcelRequire("35kHP");

var $eonYp = parcelRequire("eonYp");
const $c3a8b542eb9f37d2$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eonYp.UserAction), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($35kHP)))
    }));

});
parcelRegister("eonYp", function(module, exports) {

$parcel$export(module.exports, "UserAction", () => $f6fa99ea6c403a78$export$d344b04822cd68e8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1l3Hq = parcelRequire("1l3Hq");

var $cSaPD = parcelRequire("cSaPD");
const $f6fa99ea6c403a78$export$d344b04822cd68e8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $1l3Hq.ListItem) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })
    });
});

});


parcelRegister("i2ELV", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $a09c41cf37fbbe16$export$c72f6eaae7b9adff);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fgQ2m = parcelRequire("fgQ2m");

var $eE1NA = parcelRequire("eE1NA");
const $a09c41cf37fbbe16$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgQ2m))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});

parcelRegister("fErPd", function(module, exports) {

$parcel$export(module.exports, "SkeletonSettingsButton", () => $19a1c7a518dd8ae1$export$914093d4d181ff4d);
$parcel$export(module.exports, "Nav4SkeletonSettingsButton", () => $19a1c7a518dd8ae1$export$beac98f336d7b14f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fgQ2m = parcelRequire("fgQ2m");

var $35kHP = parcelRequire("35kHP");

var $3djrp = parcelRequire("3djrp");
const $19a1c7a518dd8ae1$export$914093d4d181ff4d = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgQ2m))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $19a1c7a518dd8ae1$export$beac98f336d7b14f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35kHP))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("bieW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $593b68d5182ad05b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $9ByY1 = parcelRequire("9ByY1");

var $jp7wN = parcelRequire("jp7wN");


var $gyL5O = parcelRequire("gyL5O");
function $593b68d5182ad05b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $593b68d5182ad05b$var$skeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'block',
        width: '30%',
        height: "var(--ds-space-100, 8px)",
        backgroundColor: `var(--ds-skeleton, ${(0, $3568e170f1ea17d7$export$8d43898f60b96a82)})`,
        borderRadius: 100,
        content: '""'
    }
});
const $593b68d5182ad05b$var$defaultWidthStyles = {
    name: "me8tg7",
    styles: "::after{width:30%;}"
};
const $593b68d5182ad05b$var$customWidthStyles = {
    name: "ms0ivw",
    styles: "::after{width:var(--width);}"
};
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $593b68d5182ad05b$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $jp7wN.default) })=>{
    (0, $9ByY1.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $jp7wN.default), '' // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const UNSAFE_overrides = /*#__PURE__*/ (0, $f8Sb3.css)(cssFn(undefined));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gyL5O.default), {
        isShimmering: isShimmering
    }, ({ className: className })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                '--width': width
            },
            css: [
                $593b68d5182ad05b$var$skeletonStyles,
                width ? $593b68d5182ad05b$var$customWidthStyles : $593b68d5182ad05b$var$defaultWidthStyles,
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                UNSAFE_overrides
            ],
            "data-ds--menu--skeleton-heading-item": true,
            "data-testid": testId
        }));
};
var $593b68d5182ad05b$export$2e2bcd8739ae039 = $593b68d5182ad05b$var$SkeletonHeadingItem;

});

parcelRegister("7MakI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c753ece5041b181498943e0fe8bd9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a95080f95aeebd7$var$_react = $5a95080f95aeebd7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a95080f95aeebd7$var$_dashboard = $5a95080f95aeebd7$var$_interopRequireDefault((parcelRequire("beo2i")));

var $5a95080f95aeebd7$var$_activity = $5a95080f95aeebd7$var$_interopRequireDefault((parcelRequire("geGxZ")));
function $5a95080f95aeebd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "ActivityIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a95080f95aeebd7$var$DashboardIcon = (props)=>/*#__PURE__*/ $5a95080f95aeebd7$var$_react.default.createElement($5a95080f95aeebd7$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $5a95080f95aeebd7$var$_activity.default
    }, props));
$5a95080f95aeebd7$var$DashboardIcon.Name = 'DashboardIconMigration';
var $5a95080f95aeebd7$var$_default = module.exports.default = $5a95080f95aeebd7$var$DashboardIcon;

});

parcelRegister("absi6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2f90a428e27c19a23210f4827b99818>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76a0e0771095a516$var$_react = $76a0e0771095a516$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76a0e0771095a516$var$_folderClosed = $76a0e0771095a516$var$_interopRequireDefault((parcelRequire("fILNN")));

var $76a0e0771095a516$var$_folder = $76a0e0771095a516$var$_interopRequireDefault((parcelRequire("k8Mc3")));
function $76a0e0771095a516$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FolderClosedIcon.
 * This component is FolderClosedIcon, with `UNSAFE_fallbackIcon` set to "FolderIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76a0e0771095a516$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $76a0e0771095a516$var$_react.default.createElement($76a0e0771095a516$var$_folderClosed.default, Object.assign({
        LEGACY_fallbackIcon: $76a0e0771095a516$var$_folder.default
    }, props));
$76a0e0771095a516$var$FolderClosedIcon.Name = 'FolderClosedIconMigration';
var $76a0e0771095a516$var$_default = module.exports.default = $76a0e0771095a516$var$FolderClosedIcon;

});

parcelRegister("hgKOK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d92ee8885a3bd0486e697aace29ae839>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9283f42ec94248f$var$_react = $c9283f42ec94248f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9283f42ec94248f$var$_screen = $c9283f42ec94248f$var$_interopRequireDefault((parcelRequire("95SCX")));

var $c9283f42ec94248f$var$_screen2 = $c9283f42ec94248f$var$_interopRequireDefault((parcelRequire("lGPHF")));
function $c9283f42ec94248f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ScreenIcon.
 * This component is ScreenIcon, with `UNSAFE_fallbackIcon` set to "ScreenIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9283f42ec94248f$var$ScreenIcon = (props)=>/*#__PURE__*/ $c9283f42ec94248f$var$_react.default.createElement($c9283f42ec94248f$var$_screen.default, Object.assign({
        LEGACY_fallbackIcon: $c9283f42ec94248f$var$_screen2.default
    }, props));
$c9283f42ec94248f$var$ScreenIcon.Name = 'ScreenIconMigration';
var $c9283f42ec94248f$var$_default = module.exports.default = $c9283f42ec94248f$var$ScreenIcon;

});

parcelRegister("gvbcs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11af61bf1d5e1e60e3ad123179be896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0383aa7526fb460$var$_react = $c0383aa7526fb460$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c0383aa7526fb460$var$_personAvatar = $c0383aa7526fb460$var$_interopRequireDefault((parcelRequire("luP7Q")));

var $c0383aa7526fb460$var$_personCircle = $c0383aa7526fb460$var$_interopRequireDefault((parcelRequire("cxU0q")));
function $c0383aa7526fb460$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "PersonCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0383aa7526fb460$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $c0383aa7526fb460$var$_react.default.createElement($c0383aa7526fb460$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $c0383aa7526fb460$var$_personCircle.default
    }, props));
$c0383aa7526fb460$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $c0383aa7526fb460$var$_default = module.exports.default = $c0383aa7526fb460$var$PersonAvatarIcon;

});

parcelRegister("7lWmw", function(module, exports) {

$parcel$export(module.exports, "SkeletonPrimaryButton", () => $d94f0dddaff01ea5$export$4a3049f952d3f130);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $bbRE0 = parcelRequire("bbRE0");

var $1nryR = parcelRequire("1nryR");
function $d94f0dddaff01ea5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
const $d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
const $d94f0dddaff01ea5$var$primaryButtonSkeletonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    margin: `0 ${"var(--ds-space-075, 6px)"}`,
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    position: 'relative',
    appearance: 'none',
    border: 0,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    pointerEvents: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus, :active, :hover': {
        appearance: 'none',
        border: 0,
        outline: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::-moz-focus-inner': {
        border: 0
    }
});
const $d94f0dddaff01ea5$var$isHighlightedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineStart: "var(--ds-space-025, 2px)"
    }
});
const $d94f0dddaff01ea5$var$isHighlightedAndDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        insetInlineEnd: -10
    }
});
const $d94f0dddaff01ea5$var$isHighlightedNotDropdownButtonStyles = {
    name: "1sue5tp",
    styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
};
const $d94f0dddaff01ea5$var$isDropdownButtonStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginInlineEnd: 18,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        display: 'inline-block',
        width: 4,
        height: 4,
        position: 'absolute',
        borderBlockEnd: '2px solid',
        borderColor: `var(${$d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
        borderInlineEnd: '2px solid',
        borderRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockStart: 'calc(50% - 4px)',
        insetInlineStart: 'calc(100% - 3px)',
        marginInlineStart: "var(--ds-space-050, 4px)",
        transform: 'rotate(45deg) scale(1.05)',
        verticalAlign: 'middle'
    }
});
const $d94f0dddaff01ea5$var$buttonWrapperStyles = {
    name: "rfxc55",
    styles: "display:flex;margin:0"
};
const $d94f0dddaff01ea5$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
    const theme = (0, $bbRE0.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    const dynamicStyles = (0, $1nryR.stripEmptyProperties)({
        ...primaryButton.default,
        ...isHighlighted && {
            color: primaryButton.selected.color
        },
        [$d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
        [$d94f0dddaff01ea5$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        role: "listitem",
        css: $d94f0dddaff01ea5$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: dynamicStyles,
        css: [
            $d94f0dddaff01ea5$var$primaryButtonSkeletonStyles,
            isHighlighted && $d94f0dddaff01ea5$var$isHighlightedStyles,
            isDropdownButton && $d94f0dddaff01ea5$var$isDropdownButtonStyles,
            isHighlighted && (isDropdownButton ? $d94f0dddaff01ea5$var$isHighlightedAndDropdownButtonStyles : $d94f0dddaff01ea5$var$isHighlightedNotDropdownButtonStyles)
        ],
        "data-testid": testId
    }, text || children));
};

});

parcelRegister("3gfQ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f14ae2593cbb89c3cab1b7918f4611>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25ff26ed6b8bbe64$var$_react = $25ff26ed6b8bbe64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25ff26ed6b8bbe64$var$_baseNew = $25ff26ed6b8bbe64$var$_interopRequireDefault((parcelRequire("dznjK")));
function $25ff26ed6b8bbe64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starred or favourited objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25ff26ed6b8bbe64$var$StarStarredIcon = (props)=>/*#__PURE__*/ $25ff26ed6b8bbe64$var$_react.default.createElement($25ff26ed6b8bbe64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 0a.75.75 0 0 1 .7.48l1.288 3.35 3.32.256a.75.75 0 0 1 .422 1.324L9.182 7.533l.945 3.523a.75.75 0 0 1-1.148.813L6 9.825l-2.979 2.042a.75.75 0 0 1-1.148-.812l.945-3.523L.27 5.41a.75.75 0 0 1 .422-1.324l3.32-.256L5.3.48A.75.75 0 0 1 6 0m0 2.84-.928 2.413-2.423.186 1.866 1.556-.667 2.488L6 8.007l2.152 1.476-.667-2.488L9.35 5.439l-2.423-.186z" clip-rule="evenodd"/><path fill="currentcolor" d="M5.072 5.253 6 2.84l.928 2.414 2.423.186-1.866 1.556.667 2.488L6 8.007 3.848 9.483l.667-2.488L2.65 5.439z"/>`,
        type: 'utility'
    }, props));
$25ff26ed6b8bbe64$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $25ff26ed6b8bbe64$var$_default = module.exports.default = $25ff26ed6b8bbe64$var$StarStarredIcon;

});

parcelRegister("hi1Fq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c965692fc4cf0fae$var$_react = $c965692fc4cf0fae$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c965692fc4cf0fae$var$_filter = $c965692fc4cf0fae$var$_interopRequireDefault((parcelRequire("64zjN")));

var $c965692fc4cf0fae$var$_filter2 = $c965692fc4cf0fae$var$_interopRequireDefault((parcelRequire("61Bd0")));
function $c965692fc4cf0fae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c965692fc4cf0fae$var$FilterIcon = (props)=>/*#__PURE__*/ $c965692fc4cf0fae$var$_react.default.createElement($c965692fc4cf0fae$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $c965692fc4cf0fae$var$_filter2.default
    }, props));
$c965692fc4cf0fae$var$FilterIcon.Name = 'FilterIconMigration';
var $c965692fc4cf0fae$var$_default = module.exports.default = $c965692fc4cf0fae$var$FilterIcon;

});

parcelRegister("lLmgO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7183201509c40b5c08006bcaf851f797>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd7f432539864c28$var$_react = $fd7f432539864c28$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fd7f432539864c28$var$_dashboard = $fd7f432539864c28$var$_interopRequireDefault((parcelRequire("beo2i")));

var $fd7f432539864c28$var$_dashboard2 = $fd7f432539864c28$var$_interopRequireDefault((parcelRequire("2Dnrb")));
function $fd7f432539864c28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "DashboardIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd7f432539864c28$var$DashboardIcon = (props)=>/*#__PURE__*/ $fd7f432539864c28$var$_react.default.createElement($fd7f432539864c28$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $fd7f432539864c28$var$_dashboard2.default
    }, props));
$fd7f432539864c28$var$DashboardIcon.Name = 'DashboardIconMigration';
var $fd7f432539864c28$var$_default = module.exports.default = $fd7f432539864c28$var$DashboardIcon;

});

parcelRegister("3Q8cf", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $c0e1b376f190b2a0$export$36ba2f559d49a8f6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7fyy1 = parcelRequire("7fyy1");

var $lz2TY = parcelRequire("lz2TY");

var $eE1NA = parcelRequire("eE1NA");
const $c0e1b376f190b2a0$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $c0e1b376f190b2a0$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lz2TY.BadgeContainer), {
        id: $c0e1b376f190b2a0$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eE1NA.IconButton), {
            "aria-describedby": $c0e1b376f190b2a0$var$NOTIFICATIONS_BADGE_ID,
            component: component,
            href: href,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fyy1))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});

});
parcelRegister("7fyy1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01602fb49c3451f8884e2ed4b4e67e9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5474bb944def497e$var$_react = $5474bb944def497e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5474bb944def497e$var$_notification = $5474bb944def497e$var$_interopRequireDefault((parcelRequire("kUL65")));

var $5474bb944def497e$var$_notification2 = $5474bb944def497e$var$_interopRequireDefault((parcelRequire("5gDrk")));
function $5474bb944def497e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5474bb944def497e$var$NotificationIcon = (props)=>/*#__PURE__*/ $5474bb944def497e$var$_react.default.createElement($5474bb944def497e$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $5474bb944def497e$var$_notification2.default
    }, props));
$5474bb944def497e$var$NotificationIcon.Name = 'NotificationIconMigration';
var $5474bb944def497e$var$_default = module.exports.default = $5474bb944def497e$var$NotificationIcon;

});


parcelRegister("fZVTm", function(module, exports) {

$parcel$export(module.exports, "SkeletonNotificationButton", () => $4caaef4c86675ef9$export$a14f01df37978534);
$parcel$export(module.exports, "Nav4SkeletonNotificationButton", () => $4caaef4c86675ef9$export$6df5583c56de301f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7fyy1 = parcelRequire("7fyy1");

var $kUL65 = parcelRequire("kUL65");

var $3djrp = parcelRequire("3djrp");
const $4caaef4c86675ef9$export$a14f01df37978534 = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fyy1))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })
    });
const $4caaef4c86675ef9$export$6df5583c56de301f = ({ label: label = '' })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3djrp.SkeletonIconButton), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUL65))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        })
    });

});

parcelRegister("GBwnA", function(module, exports) {

$parcel$export(module.exports, "Notifications", () => $9c329ad4e05fa3af$export$36ba2f559d49a8f6);
/* notifications.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kUL65 = parcelRequire("kUL65");

var $eIrjm = parcelRequire("eIrjm");

var $cSaPD = parcelRequire("cSaPD");
const $9c329ad4e05fa3af$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $9c329ad4e05fa3af$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eIrjm.BadgeContainer), {
        id: $9c329ad4e05fa3af$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cSaPD.IconButton), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kUL65))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        })
    }));

});

parcelRegister("6uABS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::27adf6ccfa0da2e986d1468bec1512ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ba1f166dab9adc7$var$_react = $4ba1f166dab9adc7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4ba1f166dab9adc7$var$_notification = $4ba1f166dab9adc7$var$_interopRequireDefault((parcelRequire("kUL65")));

var $4ba1f166dab9adc7$var$_notificationDirect = $4ba1f166dab9adc7$var$_interopRequireDefault((parcelRequire("4g1wN")));
function $4ba1f166dab9adc7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for NotificationIcon.
 * This component is NotificationIcon, with `UNSAFE_fallbackIcon` set to "NotificationDirectIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ba1f166dab9adc7$var$NotificationIcon = (props)=>/*#__PURE__*/ $4ba1f166dab9adc7$var$_react.default.createElement($4ba1f166dab9adc7$var$_notification.default, Object.assign({
        LEGACY_fallbackIcon: $4ba1f166dab9adc7$var$_notificationDirect.default
    }, props));
$4ba1f166dab9adc7$var$NotificationIcon.Name = 'NotificationIconMigration';
var $4ba1f166dab9adc7$var$_default = module.exports.default = $4ba1f166dab9adc7$var$NotificationIcon;

});

const $17dc8c3b6744943e$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $17dc8c3b6744943e$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $17dc8c3b6744943e$export$13f57c02915787b3 = 'atlaskit-portal';

const $fb14547f508b7aec$export$ed5835cc67e87f72 = 'akPortalMount';
const $fb14547f508b7aec$export$80816bd900e5bd00 = 'akPortalUnmount';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $30d5329c4969c5f3$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $13648c00a83f3c51$export$a1562d08625f5d7e = 'ui';
const $13648c00a83f3c51$export$947dac6c72b26f81 = 'track';
const $13648c00a83f3c51$export$f1d537d508d2945a = 'screen';
const $13648c00a83f3c51$export$12346a674644c156 = 'operational';
const $13648c00a83f3c51$export$b055de0e665cb20c = 'unknown';

const $c221f976f3a43e84$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("bYT2S")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.cea3b653.js.map
